'use strict'; 
angular.module("iconoglobe")
    .controller('MapCtrl', ["$state", '$window', '$scope', "$rootScope", "ParentCat", "$filter", "$sce", "$location", "CategoryFilterService", "$http", '$compile', "localStorageService", "UserLocation", "$document", "$timeout", "$uibModal", "countriesData", "strategicSearch", "$anchorScroll", "cookieStore", "LOCALES", "$q", "$stateParams", "$upload", "MetaUtilService", "AdddressGeoService", "MapboxGeoService", "CategoryFilterService", "metaHelper", "debounce", "notify", function($state, $window, $scope, $rootScope, ParentCat, $filter, $sce, $location, categoryfilter, $http, $compile, localStorageService, UserLocation, $document, $timeout, $uibModal, countriesData, strategicSearch, $anchorScroll, cookieStore, LOCALES, $q, $stateParams, $upload, metadatautil, AdddressGeoService, mapboxgeocode, CategoryFilterService, metaHelper, debounce, notify) {
       // traceLog("tn-mapctrl-siteload", "MapCtrl-> started loading");
        // Map-scoped media lifecycle: release every HLS engine on route exit.
        var igMapDisposed = false;
        var igCardCleanup = [];
        function igReleaseMapMedia() {
            if (igMapDisposed) return;
            igMapDisposed = true;
            igCardCleanup.forEach(function(cleanup) { try { cleanup(); } catch (e) {} });
            igCardCleanup.length = 0;
            window.buildStreamCards = null;
            if (window.hlsInstances) {
                window.hlsInstances.forEach(function(hls) {
                    if (!hls) return;
                    try { hls.stopLoad(); } catch (e) {}
                    try { hls.destroy(); } catch (e) {}
                });
                window.hlsInstances = [];
            }
            document.querySelectorAll('.stream-card video, #stream_Card video').forEach(function(video) {
                try {
                    video.pause();
                    video.removeAttribute('src');
                    video.querySelectorAll('source').forEach(function(source) { source.removeAttribute('src'); });
                    video.load();
                } catch (e) {}
            });
            if ($scope.hls) {
                try { $scope.hls.stopLoad(); } catch (e) {}
                try { $scope.hls.destroy(); } catch (e) {}
                $scope.hls = null;
            }
            if (window.hls) {
                try { window.hls.stopLoad(); } catch (e) {}
                try { window.hls.destroy(); } catch (e) {}
                window.hls = null;
            }
        }
        $scope.$on('$destroy', igReleaseMapMedia);
        var igRouteCleanup = $rootScope.$on('$stateChangeStart', function(event, toState) {
            if (toState && toState.name && toState.name.indexOf('maps.') !== 0 && toState.name !== 'maps') {
                igReleaseMapMedia();
            }
        });
        $scope.$on('$destroy', igRouteCleanup);
        $scope.LOCALES = LOCALES;
        $scope.isSharedLinkActive = $location.search().data ? true : false;
        $scope.isPosterView = false;
          $scope.mapReady = false;
         $scope.map_map = null; 
		 var socket;
	window.socket = window.socket || null;
 
if (!window.socket && window.io) {
    window.socket = window.io("https://iconoglobe.com");
}
 function getHlsUrl(url) {
    if (url && url.indexOf('http://') === 0) {
        return '/hls-proxy/?url=' + encodeURIComponent(url);
    }

    return url;
}



 

(function () {
    const loading = document.getElementById("loading");

    if (!loading) return;

    let pending = 0;
    let delayTimer;

    window.showLoading = function () {
        pending++;

        if (pending === 1) {
            delayTimer = setTimeout(() => {
                if (pending > 0) {
                    loading.classList.remove("hide");
                }
            }, 180);
        }
    };

    window.hideLoading = function () {
        pending = Math.max(0, pending - 1);

        if (pending === 0) {
            clearTimeout(delayTimer);
            loading.classList.add("hide");
        }
    };

    // Show when an internal link navigates to another page.
    document.addEventListener("click", function (event) {
        const link = event.target.closest("a[href]");

        if (!link || event.defaultPrevented) return;

        if (
            event.button !== 0 ||
            event.ctrlKey || event.metaKey ||
            event.shiftKey || event.altKey ||
            link.target === "_blank" ||
            link.hasAttribute("download")
        ) return;

        const url = new URL(link.href, location.href);

        if (url.origin !== location.origin) return;

        // Ignore same-page anchors.
        if (
            url.pathname === location.pathname &&
            url.search === location.search &&
            url.hash
        ) return;

        window.showLoading();
    });

    // Show on ordinary form submissions.
    document.addEventListener("submit", function (event) {
        if (!event.defaultPrevented) window.showLoading();
    });

    // Reset when this page finishes loading or is restored.
    window.addEventListener("pageshow", function () {
        pending = 0;
        clearTimeout(delayTimer);
        loading.classList.add("hide");
    });
})();

$scope.toggleMobileModePanel = function() {
    var panel = document.getElementById('igmode-mobile-popup');
    if (!panel) return;

    if (panel.matches(':popover-open')) {
        panel.hidePopover();
        $scope.igModeMobileOpen = false;
    } else {
        panel.showPopover();
        $scope.igModeMobileOpen = true;
    }
};

$scope.closeMobileModePanel = function() {
    var panel = document.getElementById('igmode-mobile-popup');

    if (panel && panel.matches(':popover-open')) {
        panel.hidePopover();
    }

    $scope.igModeMobileOpen = false;
};





var socket = window.socket; 
if (!socket) {
    console.warn("Socket connection delayed. Creating a temporary event proxy...");
    socket = {
        on: function(event, callback) {
            // Queue up the listeners if the window library is trailing behind
            document.addEventListener('socketReady', function() {
                if (window.socket) window.socket.on(event, callback);
            });
        },
        emit: function(event, data) {
            if (window.socket) window.socket.emit(event, data);
        }
    };
}
 
if (window.io && !window.socketInitialized) {
    window.socketInitialized = true;
    document.dispatchEvent(new Event('socketReady'));
}
        var langPref = cookieStore.getCookie("lang_pref");
        var query = $location.search(); 
        $scope.showPromo = function(e, slideName, slideImages) {
 
            if (slideName && slideImages && slideImages.length > 0) {
                $scope.popupSlider = slideImages;
                $scope.popupHeading = slideName;
            }
            document.addEventListener("DOMContentLoaded", function(event) {
                document.querySelectorAll('img').forEach(function(img) {
                    img.onerror = function() {
                        this.style.display = 'none'; // Hides the broken image
                    };
                })
            });

function isOverflow(el) {
  return el.scrollWidth > el.clientWidth;
}
    $scope.currentInnerView = $state.current.name;
$scope.goto = function(page) {
    switch(page) {
        case 'signup':
            $state.go('base.signup');
            break;
        case 'login':
            $state.go('base.login');
            break;
        case 'contactus':
            $state.go('base.contactus');
            break;
        default:
            $state.go('base');
    }
};
(function() {
    // Check if ?data is in the URL query string
    var urlParams = new URLSearchParams(window.location.search);
    var sharedData = urlParams.get('data');

    // If `data` exists, trigger the existing function
    if (sharedData) {
        processSharedDataFromURL();
    }

    // other controller logic...
})();
document.addEventListener("visibilitychange", function () {

    if (document.visibilityState === 'visible') {

        location.reload(true);

    }

});

 
function updateOrientation(video) {
  if (!video.videoWidth || !video.videoHeight) return;

  const streamCard = angular.element(video).closest(".stream-card");

  if (video.videoHeight > video.videoWidth) {
    video.classList.add("portrait");
    video.classList.remove("landscape");
    document.querySelector("#playerContainer").classList.add("portrait");
	document.querySelector("#playerContainer").classList.remove("landscape");
    streamCard.addClass("portrait");
    streamCard.removeClass("landscape");

  } else {
    video.classList.add("landscape");
    video.classList.remove("portrait");
	document.querySelector("#playerContainer").classList.add("landscape");
    document.querySelector("#playerContainer").classList.remove("portrait");
    streamCard.addClass("landscape");
    streamCard.removeClass("portrait");
  }
}

function attachVideoEvents(video) {
  if (video.dataset.orientationBound) return;
  video.dataset.orientationBound = "true";

  const handler = () => updateOrientation(video);

  video.addEventListener("loadedmetadata", handler);
  video.addEventListener("playing", handler);

  handler();
}

// Initial pass
document.querySelectorAll("video").forEach(attachVideoEvents);

// Watch for new videos
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.tagName === "VIDEO") {
        attachVideoEvents(node);
      } else if (node.querySelectorAll) {
        node.querySelectorAll("video").forEach(attachVideoEvents);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

















document.querySelectorAll('.stnm12, .stnm15, .stnm16').forEach(span => {
  if (isOverflow(span)) {
    span.classList.add('ovrflw');
  }
});
            clickPosition = {
                pos: $(e.currentTarget).offset(),
                width: $(e.currentTarget).width(),
                height: $(e.currentTarget).height(),
            };
            $scope.promotionPos = {
                "left": clickPosition.pos.left,
                "top": clickPosition.pos.top
            };
            $scope.promotionCardStyle = {
                "width": clickPosition.width,
                "padding-bottom": clickPosition.height
            };
            $scope.loadingPromotionDetails = true;
            galleryImage = 0;
            bannerImage = 0;
            $scope.sliderData = {
                "banner": "f2f51229-ecee-48ec-a60d-88920c70c803.png",
                "smallbanner": "ccfa9d08-aab5-4f4f-aaa8-b3c351739a7e.png",
                "title": "Atlantis Adventure Waterpark",
                "id": "8a796b50-e78f-4e43-b922-f15a65921dbb",
                "description": "Lose yourself to next level entertainment at Atlantis Dubai, where the party never stops. From the region's first fire and water spectacle, to the trendiest bars and beach clubs and never-ending family fun, experience the extraordinary at the city's most vibrant entertainment spot.",
                "on_click": 2,
                "center_screen": null,
                "show_location": false,
                "photos": [
                    "5d307093-9153-4c09-bd3f-2606c90ebcdc-dolphinencounterfamilytridenttower.jpg", "a97bfd02-7d56-4037-824b-f2ff13b9eda5-aquaventurelifestyleaquacondagroupfriends.jpg", "2c111964-1939-4abd-ab00-c701594e02e8-aquaventurewaterpark.jpg", "b91ff1f2-5fe8-467c-b2af-ae2fde686a57-attraction332main633f5ece6f86e.jpg", "37139c5b-afe7-4487-81f1-4d5327aa518f-aquaventurewaterparklifestyletridenttowermedusalair.jpg", "1e24c9c3-180e-4525-911c-3b7bb96dee41-images.jpg", "5d87c871-46fc-4d21-9e8e-384eb8199013-dmggzx9hsboq4k78iayp.jpg", "b2164fa1-eadd-46ac-858f-e77726291eb4-1375979271846408266948864178161875243025031n.jpg", "9f2cdd4d-15e0-42a8-9559-ccb73dca1d46-bv.jpg", "6712a2fa-6101-4457-9099-c4f714b3e47e-download.jpg", "02791f41-c223-439b-b086-079bb449f04b-hydraracerguinness2.jpg", "5092300c-9be9-48d0-8f73-cf1d3ee2540c-aquaventurewaterparksplasherscovetwisters.jpg", "dbd31d4b-5892-4903-8ff5-ea5f4148d7be-fa.jpg"
                ],
                "brand": [],
                "email": "dxb-info@atlantisdubai.com",
                "latitude": 25.132988,
                "longitude": 55.118805,
                "social": [{

                    "social": "facebook",
                    "url": "",
                    "id": 0
                }],
                "phone_number": "+971 4 426 0000",
                "esta_id": "28f998dc-1fb4-4a2c-99a5-a8989b611a44",
                "name": "Atlantis Aquaventure Waterpark",
                "first_start_day": "Monday",
                "first_end_day": "Saturday",
                "first_open_time": "09:00",
                "first_close_time": "21:00",
                "second_start_day": "Monday",
                "second_end_day": "Saturday",
                "second_open_time": "09:00",
                "second_close_time": "21:00",
                "site_link": "https://www.atlantis.com/dubai/atlantis-aquaventure/aquaventure-waterpark",
                "type": "esta",
                "phonecode": "+971",
                "address": "Atlantis Aquaventure Monorail Station, Atlantis Aquaventure, Dubai, Dubai, United Arab Emirates, Dubai, Dubai, ",
                "is_brand": "0"
            };
            // console.log('sliderData--', $scope.sliderData);
            $('body').css({
                height: '100vh',
                overflow: 'hidden'
            });
            $('#promotion-detail .card__container').css({
                display: "block"
            });
            $('#card-content').animate({
                scrollTop: 0
            }, 1);
            $('#promotionwrap').animate({
                scrollTop: 0
            }, 1);
            $('#promotion-detail').css({
                'display': "block",
                'opacity': 1,
                'z-index': 999999999
            });
        }
var coorObj;
        if (query.at) {

            var coordinates = query.at.split(",");
            coorObj = {
                latitude: coordinates[1],
                longitude: coordinates[0]
            };
        }
        var map;
if (!window._mapboxVisibilityFixAdded) {
    document.addEventListener("visibilitychange", function () {
        if (!document.hidden && $scope.map_map) {
            // Use requestAnimationFrame to ensure the DOM is ready to be painted
            requestAnimationFrame(() => {
                // console.log("Tab active → Refreshing MapBox context");
                
                // 1. Recalculate size
                $scope.map_map.resize();

                // 2. Force a style re-sync (helps with the "alphabet" glitch)
                const center = $scope.map_map.getCenter();
                $scope.map_map.setCenter(center); 

                // 3. Trigger a full redraw
                $scope.map_map.triggerRepaint();
            });
        }
    });
    window._mapboxVisibilityFixAdded = true;
}
        var accessToken = "pk.eyJ1IjoibG91aXNwIiwiYSI6ImNpeHVvd3ZxYzAwM2szMnQ5N2Q1cjB0Z2oifQ.1aIlYGHSc1LXrvhI2GXA9w";
        // map box style layers
        var styleLayers = {
            arabic: {
                default: 'mapbox://styles/louisp/cmujivwxo00c201qo1trm19ai?optimize=true',
                satellite: 'mapbox://styles/louisp/cmu64sg5o005901rygj3h7r3a?optimize=true'
            },
            chinese: {
                default: 'mapbox://styles/louisp/clnj1oj82046301r72tp0appc?optimize=true',
                satellite: 'mapbox://styles/louisp/clnj1ofjw006g01nu59p44k87?optimize=true'
            },
            german: {
                default: 'mapbox://styles/louisp/clnj1540o00e501o0dyz244wc?optimize=true',
                satellite: 'mapbox://styles/louisp/clnj158x3044p01qx24f7f1w5?optimize=true'
            },
            english: {
                 default: 'mapbox://styles/louisp/cmvli0fyk003h01s6b6rnf9lk?optimize=true',
                satellite: 'mapbox://styles/louisp/cmvli0fyk003h01s6b6rnf9lk?optimize=true'
            },
            spanish: {
                default: 'mapbox://styles/louisp/cmvedcdgs001i01ql35wu1bj7?optimize=true',
                satellite: 'mapbox://styles/louisp/clniy7qgd041f01r43zir3du9?optimize=true'
            },
            french: {
                default: 'mapbox://styles/louisp/cljtlk1m901h401o49i3u8b0r?optimize=true',
                satellite: 'mapbox://styles/louisp/cliabrym802wp01qy7mog3hls?optimize=true'
            },
            russian: {
                default: 'mapbox://styles/louisp/cmvaoauyk008501s8hz2v8lka?optimize=true',
                satellite: 'mapbox://styles/louisp/clniyhobf041i01r4bft12u3y?optimize=true'
            },
            portuguese: {
                default: 'mapbox://styles/louisp/cljtlv4b801i001qy24tq2xk9?optimize=true',
                satellite: 'mapbox://styles/louisp/cl7hw4884001714t6ln20we35?optimize=true'
            },
            vietnamese: {
                default: 'mapbox://styles/louisp/cljtlzadb01iy01pjbwr1gjk9?optimize=true',
                satellite: 'mapbox://styles/louisp/cljwnc9nv022b01p54xpid0rt?optimize=true'
            },
            korean: {
                default: 'mapbox://styles/louisp/cljtm33nj01gp01qwex8u55eu?optimize=true',
                satellite: 'mapbox://styles/louisp/cliac11rj02sy01qucavp064r?optimize=true'
            },
            japanese: {
                default: 'mapbox://styles/louisp/cljtm6n8t01hu01p5733ee54j?optimize=true',
                satellite: 'mapbox://styles/louisp/clj9vy7lk00bb01pi2gfv1k4u?optimize=true'
            },
            italian: {
                default: 'mapbox://styles/louisp/cljtmbq8t01iu01pkcptx4tg4?optimize=true',
                satellite: 'mapbox://styles/louisp/clj9vpipf000i01qk0pwi3ezg?optimize=true'
            }
        };
$scope.scrollBelowFold = function () {

 window.scrollBy({
        top: window.innerHeight,
        left: 0,
        behavior: 'smooth'
    });


};
$scope.scrollFold = function () {

    var body = document.getElementById('body');
    var wrapper = document.querySelector('.mpwrp');

    body.scrollTo({
        top: wrapper.offsetHeight,
        behavior: 'smooth'
    });

};
    $scope.getMapLanguageByHost = function() {
    var host = window.location.hostname.toLowerCase();

    var languages = {
        "fr.iconoglobe.com": "fr",
        "es.iconoglobe.com": "es",
        "pt.iconoglobe.com": "pt",
        "de.iconoglobe.com": "de",
        "it.iconoglobe.com": "it",
        "no.iconoglobe.com": "no",
        "pl.iconoglobe.com": "pl",
        "tr.iconoglobe.com": "tr",
        "af.iconoglobe.com": "af",
        "ar.iconoglobe.com": "ar",
        "bg.iconoglobe.com": "bg",
        "bs.iconoglobe.com": "bs",
        "zh.iconoglobe.com": "zh-Hans",
        "ch.iconoglobe.com": "zh-Hans",
        "iconoglobe.cn": "zh-Hans",
        "www.iconoglobe.cn": "zh-Hans",
        "hk.iconoglobe.cn": "zh-Hant",
        "tw.iconoglobe.cn": "zh-Hant",
        "cs.iconoglobe.com": "cs",
        "da.iconoglobe.com": "da",
        "el.iconoglobe.com": "el",
        "fa.iconoglobe.com": "fa",
        "fi.iconoglobe.com": "fi",
        "he.iconoglobe.com": "he",
        "hi.iconoglobe.com": "hi",
        "hr.iconoglobe.com": "hr",
        "hu.iconoglobe.com": "hu",
        "id.iconoglobe.com": "id",
        "ja.iconoglobe.com": "ja",
        "km.iconoglobe.com": "km",
        "ko.iconoglobe.com": "ko",
        "lt.iconoglobe.com": "lt",
        "nl.iconoglobe.com": "nl",
        "ro.iconoglobe.com": "ro",
        "ru.iconoglobe.com": "ru",
        "sl.iconoglobe.com": "sl",
        "sr.iconoglobe.com": "sr",
        "sv.iconoglobe.com": "sv",
        "uk.iconoglobe.com": "uk",
        "vi.iconoglobe.com": "vi"
    };

    return languages[host] || "en";
};
    
    
        window.onload = function() {
            var images = document.getElementsByTagName('img');
            for (var i = 0; i < images.length; i++) {
                if (images[i].naturalWidth > images[i].naturalHeight) {
                    $(images[i]).addClass('landscape');

                } else {
                    if (images[i].naturalWidth < images[i].naturalHeight) {
                        $(images[i]).addClass('portrait');
                    }
                }
            }
        }
        window.onscroll = scroll;

        $scope.userToggledMap = false;
        
        
    $scope.mapIsMini = !!(document.getElementById('pst4') && document.getElementById('pst4').classList.contains('mini-map'));
$scope.setMapMode = function(wantMini) {
    var el = document.getElementById('pst4');
    if (!el) return;

    var isMini = el.classList.contains('mini-map');

    if (isMini !== wantMini) {
        $scope.expandMap();
    }

    $scope.mapIsMini = el.classList.contains('mini-map');
};  
        
        
        
        
        
        
        
        
        
   $scope.expandMap = function() {
            // Main map container
            var el = document.getElementById('pst4');
            if (!el) return;

            // Elements with IDs
            var elPst5 = document.getElementById('pst5');
            var elScenes = document.querySelectorAll('.stream-card');
            var elPst6 = document.getElementById('pst6');
            var elSceneP = document.getElementById('scene1'); 
            var elPst7 = document.getElementById('pst7');
            var eltitlescroll = document.getElementById('titlescroll');
            var elminibackp = document.getElementById('minibackp');
            
            $scope.userToggledMap = true;

            // Toggle mini-map class on main container
            var isMini = el.classList.toggle('mini-map');
            $scope.mapIsMini = isMini;
            // Toggle mini-map on pst5 if it exists
            if (elPst5) {
                elPst5.classList.toggle('mini-map'); 
            }
            if (elSceneP) {
                elSceneP.classList.toggle('mini-map'); 
            }
            if (elPst6) {
                elPst6.classList.toggle('mini-map'); 
            }
               if (elPst7) {
                elPst7.classList.toggle('active'); 
            }
               if (eltitlescroll) {
                eltitlescroll.classList.toggle('mini-map'); 
            }
               if (elminibackp) {
                elminibackp.classList.toggle('mini-map'); 
            }

            // Toggle mini-map on scene1 if it exists
 
			 if (elScenes && elScenes.length) {
                elScenes.forEach(function(el) {
			    el.classList.toggle('mini-map');
				 });
			 }

            // ✅ ADD: Reset zoom when entering mini-map (same logic as your working button)
            if (isMini && $scope.map_map) {
                var zoomLevel;

                if (typeof isMobile !== "undefined" && isMobile) {
                    zoomLevel = 0.85;
                } else {
                    zoomLevel = 1.5; // your desired desktop default
                }

                $scope.map_map.setZoom(zoomLevel);
                $location.search("zoom", zoomLevel);

                // console.log('Zoom reset to:', zoomLevel);
            }

            // ✅ ADD: Ensure map resizes correctly after layout change
            if ($scope.map_map) {
                setTimeout(function() {
                    $scope.map_map.resize();
                }, 300);
            }
        }; 
   $scope.expandMaps = function() {

    var defaultZoom = window.innerWidth <= 768 ? .85 : 1.3;

    $scope.map_map.flyTo({
        center: [userlocation.long, userlocation.lat],
        zoom: defaultZoom,
        pitch: 0,
        bearing: 0,
        curve: 1,
        essential: true
    });

};
   $scope.expandMap2 = function() {
            var el = document.getElementById('pst4');
            if (!el) return;

            var elPst5 = document.getElementById('pst5');
            var elScenes = document.querySelectorAll('.stream-card');
            var elPst6 = document.getElementById('pst6');
            var elSceneP = document.getElementById('scene1'); 

            // If already expanded (no mini-map) → do NOTHING
           // if (!el.classList.contains('mini-map')) {
                // console.log('Already expanded — no action taken');
           //     return;
           // }

            // console.log('Expanding map (one-way only)');

            $scope.userToggledMap = true;

            // REMOVE mini-map to expand
            el.classList.remove('mini-map');

            if (elPst5) elPst5.classList.remove('mini-map');
            if (elPst6) elPst6.classList.remove('mini-map');
             if (elSceneP) elSceneP.classList.remove('mini-map');
            if (elScenes && elScenes.length) {
                elScenes.forEach(function(el) {
			    el.classList.remove('mini-map');
				 });
			 }
}

		 $scope.homecategories = [{

                    "category_id": 7,
                    "iconimg": "i-i/adventures.svg",
                    "category_name": "Adventures/<br>Tours"
                }, {
                    "category_id": 6,
                    "iconimg": "i-i/Festivals.svg",
                    "category_name": "Festivals/<br>Exhibitions"
                }, {
                    "category_id": 5,
                    "iconimg": "i-i/Gaming.svg",
                    "category_name": "Gaming/<br>Amusement"
                }, {
                    "category_id": 4,
                    "iconimg": "i-i/Museums.svg",
                    "category_name": "Museums/<br>Cinemas"
                }, {
                    "category_id": 3,
                    "iconimg": "i-i/Music.svg",
                    "category_name": "Music/<br>Performances"
                }, {
                    "category_id": 2,
                    "iconimg": "i-i/Nature.svg",
                    "category_name": "Nature/<br>Sites"
                }, {
                    "category_id": 283,
                    "iconimg": "i-i/Sports.svg",
                    "category_name": "Sports/<br>Competitions"
                }, {
                    "category_id": 147,
                    "iconimg": "i-i/Children.svg",
                    "category_name": "Children"
                }];



























// Unified in-card profile: the card itself scrolls; no detached overlay.
$scope.igup = { isOpen: false };
$scope.igupActive = 'profile';
$scope.igupScrollTo = function(section, event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    var source = event && event.currentTarget;
    var card = source && source.closest('.stream-card, .stream_Card');
    if (!card) return;
    var target = card.querySelector('[data-igup-section="' + section + '"]');
    if (!target) return;
    $scope.igupActive = section;
    // Scroll the card, not the document. Works when card has moved to body.
    var cardTop = card.getBoundingClientRect().top;
    var targetTop = target.getBoundingClientRect().top;
    card.scrollTo({ top: card.scrollTop + targetTop - cardTop - 18, behavior: 'smooth' });
};
$scope.igupShare = function(data, event) {
    return $scope.shareChannel(data, event);
};
$scope.igupMediaUrl = function(item) {
    var path = typeof item === 'string' ? item : (item && (item.thumbnail_path || item.path || item.url || item.image || item.photo || item.filename || item.file_name || item.name));
    if (!path || typeof path !== 'string') return '';
    if (/^(https?:)?\/\//i.test(path) || path.charAt(0) === '/') return path;
    return 'https://iconoglobe.com/i-i/' + path.replace(/^i-i\//, '');
};
// Resolve the profile image by entity type without changing the player area.
$scope.igupProfilePhoto = function(entity) {
    if (!entity) return '';
    var photo = entity.profile_pic || entity.profilePic || entity.esta_main_photo || entity.user_pic || entity.profile_image;
    if (!photo || /^(undefined|null)$/i.test(String(photo))) return '';
    return $scope.igupMediaUrl(photo);
};
// Channel gallery lightbox. Mounted on body to avoid clipping by expanded stream cards.
var igupLightboxScope = null;
var igupLightboxElement = null;
var igupLightboxKeyHandler = null;
function igupIsVideoItem(item) {
    var type = item && typeof item === 'object' ? String(item.type || item.media_type || item.mime_type || item.mimetype || '').toLowerCase() : '';
    var url = $scope.igupMediaUrl(item);
    return type.indexOf('video') !== -1 || /\.(mp4|webm|ogv|ogg|mov)(?:[?#]|$)/i.test(url);
}
function igupCloseLightbox() {
    if (igupLightboxKeyHandler) document.removeEventListener('keydown', igupLightboxKeyHandler);
    igupLightboxKeyHandler = null;
    if (igupLightboxElement) igupLightboxElement.remove();
    igupLightboxElement = null;
    if (igupLightboxScope) igupLightboxScope.$destroy();
    igupLightboxScope = null;
}
$scope.igupOpenGallery = function(stream, index, event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    var items = $scope.igupGetPhotos(stream);
    if (!Array.isArray(items) || !items.length) return;
    igupCloseLightbox();
    var lightbox = $scope.$new();
    lightbox.items = items.filter(function(item) { return !!$scope.igupMediaUrl(item); });
    if (!lightbox.items.length) { lightbox.$destroy(); return; }
    var selected = items[index];
    lightbox.index = Math.max(0, lightbox.items.indexOf(selected));
    lightbox.mediaUrl = $scope.igupMediaUrl;
    lightbox.isVideo = igupIsVideoItem;
    lightbox.close = igupCloseLightbox;
    lightbox.go = function(i) {
        lightbox.index = (i + lightbox.items.length) % lightbox.items.length;
    };
    lightbox.step = function(delta) { lightbox.go(lightbox.index + delta); };
    var markup = '<div class="igup-lightbox" role="dialog" aria-modal="true" aria-label="Channel media gallery" ng-click="close()">' +
        '<div class="igup-lightbox-top"><span>{{index + 1}} / {{items.length}}</span><button type="button" ng-click="close(); $event.stopPropagation()" aria-label="Close gallery">&times;</button></div>' +
        '<button type="button" class="igup-lightbox-prev" ng-click="step(-1); $event.stopPropagation()" aria-label="Previous media">&#10094;</button>' +
        '<div class="igup-lightbox-stage" ng-click="$event.stopPropagation()">' +
        '<video ng-if="isVideo(items[index])" ng-src="{{mediaUrl(items[index])}}" controls playsinline preload="metadata"></video>' +
        '<img ng-if="!isVideo(items[index])" ng-src="{{mediaUrl(items[index])}}" alt="Channel gallery image">' +
        '</div><button type="button" class="igup-lightbox-next" ng-click="step(1); $event.stopPropagation()" aria-label="Next media">&#10095;</button>' +
        '<div class="igup-lightbox-strip" ng-click="$event.stopPropagation()">' +
        '<button type="button" ng-repeat="item in items track by $index" ng-class="{active:$index===index}" ng-click="go($index)" aria-label="Show gallery item {{$index+1}}">' +
        '<span ng-if="isVideo(item)" class="igup-lightbox-video-mark">&#9654;</span>' +
        '<img ng-if="!isVideo(item)" ng-src="{{mediaUrl(item)}}" alt="Gallery thumbnail" loading="lazy">' +
        '</button></div></div>';
    igupLightboxScope = lightbox;
    igupLightboxElement = $compile(markup)(lightbox);
    angular.element(document.body).append(igupLightboxElement);
    igupLightboxKeyHandler = function(e) {
        if (e.key === 'Escape') { e.preventDefault(); $scope.$evalAsync(igupCloseLightbox); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
            lightbox.$evalAsync(function() { lightbox.step(e.key === 'ArrowRight' ? 1 : -1); });
        }
    };
    document.addEventListener('keydown', igupLightboxKeyHandler);
};
$scope.$on('$destroy', igupCloseLightbox);
// Public social links only. Individual channels have socurl1..7;
// establishments store an array in social_urls.
$scope.igupSocialLinks = function(entity) {
    if (!entity) return [];
    // Keep the same array reference across AngularJS digest passes.
    // Rebuild only when the entity's saved social-link values change.
    var socialSignature;
    try {
        socialSignature = JSON.stringify([
            entity.socurl1, entity.socurl2, entity.socurl3, entity.socurl4,
            entity.socurl5, entity.socurl6, entity.socurl7,
            entity.social_urls, entity.socials
        ]);
    } catch (e) {
        socialSignature = null;
    }
    if (socialSignature !== null &&
        entity._igupSocialLinksSignature === socialSignature &&
        Array.isArray(entity._igupSocialLinksCache)) {
        return entity._igupSocialLinksCache;
    }
    var raw = [];
    for (var i = 1; i <= 7; i++) if (entity['socurl' + i]) raw.push(entity['socurl' + i]);
    var saved = entity.social_urls || entity.socials || [];
    if (typeof saved === 'string') {
        try { saved = JSON.parse(saved); } catch (e) { saved = []; }
    }
    if (Array.isArray(saved)) raw = raw.concat(saved);
    var icons = {facebook:'facebook',instagram:'instagram',youtube:'youtube',tiktok:'tiktok',x:'x',twitter:'x',linkedin:'linkedin',pinterest:'pinterest',snapchat:'snapchat',twitch:'twitch',discord:'discord',reddit:'reddit',telegram:'telegram',whatsapp:'whatsapp',vk:'vk',vkontakte:'vk',weibo:'sinaweibo',bilibili:'bilibili',threads:'threads',bluesky:'bluesky'};
    var output = [], seen = {};
    raw.forEach(function(entry) {
        var url = '', platform = '';
        if (typeof entry === 'string') {
            try { var parsed = JSON.parse(entry); if (parsed && typeof parsed === 'object') entry = parsed; } catch (e) {}
        }
        if (typeof entry === 'string') url = entry.trim();
        else if (entry && typeof entry === 'object') {
            url = String(entry.url || entry.link || entry.value || entry.href || '').trim();
            platform = String(entry.social || entry.platform || entry.type || entry.name || '').toLowerCase();
        }
        if (!/^https?:\/\//i.test(url)) return;
        var host;
        try { host = new URL(url).hostname.toLowerCase().replace(/^www\./, ''); } catch (e) { return; }
        if (!platform) platform = host.split('.')[0];
        if (host === 'x.com' || host === 'twitter.com') platform = 'x';
        if (host === 'youtu.be') platform = 'youtube';
        if (seen[url]) return;
        seen[url] = true;
        var key = platform.replace(/[^a-z0-9]/g, '');
        output.push({ url: url, name: platform || 'Website', icon: icons[key] ? 'https://cdn.jsdelivr.net/npm/simple-icons@v15/icons/' + icons[key] + '.svg' : '' });
    });
    var links = output.slice(0, 7);
    if (socialSignature !== null) {
        entity._igupSocialLinksSignature = socialSignature;
        entity._igupSocialLinksCache = links;
    }
    return links;
};
$scope.igupMatchesEstablishment = function(stream) {
    if (!stream || !$scope.establishmentDetails) return false;
    var a = stream.esta_id || stream.establishment_id || stream.estaId;
    var b = $scope.establishmentDetails.estaId || $scope.establishmentDetails.id || $scope.establishmentDetails.esta_id;
    return !!a && !!b && String(a) === String(b);
};
// Public broadcaster galleries: load only when a card opens, and reuse in-flight/cached results.
var igGalleryCache = Object.create(null);
$scope.igupGalleryLoading = false;
$scope.igupGalleryError = false;
$scope.igupGetPhotos = function(stream) {
    if (!stream) return [];
    // Advertisement-opened establishment profiles already contain getEEProfile photos.
    if (stream._igEEProfilePhotos && Array.isArray(stream.photos)) return stream.photos;
    if (Array.isArray(stream._igPublicPhotos)) return stream._igPublicPhotos;
    if ($scope.igupMatchesEstablishment(stream)) return $scope.estaPhotos || [];
    return stream.photos || stream.gallery || [];
};
$scope.igupLoadGallery = function(stream) {
    if (!stream) return;
    // getEEProfile is the authoritative gallery for advertisement-linked establishments.
    if (stream._igEEProfilePhotos && Array.isArray(stream.photos)) return;
    var isIndividual = String(stream.stream_type) === '1';
    var ownerId = isIndividual
        ? (stream.user_id || stream.userId || stream.userid || stream.individual_id || stream.id)
        : (stream.esta_id || stream.establishment_id || stream.estaId || stream.id);
    if (!ownerId) return;
    var kind = isIndividual ? 'user' : 'establishment';
    var key = kind + ':' + String(ownerId);
    var cached = igGalleryCache[key];
    if (cached && cached.photos) {
        stream._igPublicPhotos = cached.photos;
        return;
    }
    if (cached && cached.promise) {
        cached.promise.then(function(photos) { stream._igPublicPhotos = photos; });
        return;
    }
    $scope.igupGalleryLoading = true;
    $scope.igupGalleryError = false;
    var request = $http.get('/api/publicgallery/' + kind + '/' + encodeURIComponent(ownerId))
        .then(function(response) {
            var photos = Array.isArray(response.data) ? response.data : [];
            igGalleryCache[key] = { photos: photos };
            stream._igPublicPhotos = photos;
            return photos;
        }, function(error) {
            delete igGalleryCache[key];
            $scope.igupGalleryError = true;
            console.warn('Could not load public gallery:', key, error);
            return [];
        }).finally(function() { $scope.igupGalleryLoading = false; });
    igGalleryCache[key] = { promise: request };
};
$scope.igupGetEvents = function(stream) {
    if ($scope.igupMatchesEstablishment(stream)) return $scope.up_events || [];
    return (stream && stream.up_events) || [];
};
$scope.igupGetDescription = function(stream) {
    // ABOUT describes this live video, not the broadcaster's general biography.
    return (stream && (stream.local_description || stream.en_description)) || '';
};
$scope.igupNotify = function(stream, event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    var id = stream && (stream.esta_id || stream.establishment_id || stream.estaId);
    if (id && typeof $scope.saveToNotification === 'function') {
        return $scope.saveToNotification(id);
    }
    // Do not claim to subscribe when the broadcaster notification API is not wired.
    window.alert('Notifications for this channel are not connected yet.');
};
$scope.openUnifiedProfile = function(data, event) {
    $scope.igupScrollTo('profile', event);
};
$scope.closeUnifiedProfile = function() { $scope.igup.isOpen = false; };

$scope.requireLogin = function() {

    if (localStorageService.get('name')) {
        return true;
    }

    if (!$scope.PopupModal) {

        $scope.modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'sign_in_modal.html',
            windowClass: 'zindexModal int125',
            scope: $scope,
			appendTo: angular.element(document.body)
        });

        $scope.modalInstance.result.then(function() {
            $scope.closeModal();
        }, function() {
            $scope.closeModal();
        });

        $scope.PopupModal = true;
    }

    return false;
};

 
// 1. Send chat message function (unchanged)
// --- INITIAL STATE VARIABLES ---
$scope.showMediaPanel = false;
$scope.activeTab = 'emojis';
$scope.gifSearchQuery = '';
$scope.gifResults = [];

// --- CHAT MESSAGE SENDER ---
$scope.sendChatMessage = function(e, pressed, stream) {
  var code = (e && e.keyCode ? e.keyCode : 0);
var medpanl = angular.element(document.querySelector('.medpanl'));
if (!medpanl.hasClass('ng-hide')) {
    medpanl.addClass('ng-hide');
}
    // get message
    var message = stream.chatMessage;

    // 1. If NOT logged in → open modal
    if (!localStorageService.get('name') && (code == 13 || pressed)) {

        if (!$scope.PopupModal) {
            $scope.modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'sign_in_modal.html',
                windowClass: 'zindexModal int125',
                scope: $scope,
				appendTo: angular.element(document.body)
            });

            $scope.modalInstance.result.then(function() {
                $scope.closeModal();
            }, function() {
                $scope.closeModal();
            });

            $scope.PopupModal = true;
        }

        return;
    }

    // 2. If logged in → send chat message
    if (localStorageService.get('name') && (code == 13 || pressed)) {

        if (!message) return;
        message = message.trim();
        if (!message) return;

        var chatObj = {
            streamId: stream.stream_id || stream.id,
            userId: $rootScope.user.id,
            username: $rootScope.user.first_name + " " + $rootScope.user.last_name,
            user_pic: $rootScope.user.profile_pic,
            message: message,
            created_at: new Date()
        };

        // clear input immediately
        stream.chatMessage = "";

        // send via socket
        socket.emit('sendMessage', chatObj);
    }
};
 


// Initialize the emoji picker only inside the currently visible chat panel.
// Stream cards may have duplicate IDs while an expanded card is also rendered.
function igVisibleChatPanel() {
    var panels = document.querySelectorAll('.medpanl');
    for (var i = 0; i < panels.length; i++) {
        var rect = panels[i].getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return panels[i];
    }
    return null;
}

function igInitializeVisibleEmojiPicker() {
    if (!$scope.showMediaPanel || $scope.activeTab !== 'emojis') return;
    var panel = igVisibleChatPanel();
    if (!panel || !window.EmojiMart || typeof window.EmojiMart.Picker !== 'function') return;
    var container = panel.querySelector('[id^="emojiPickerContainer_"]');
    if (!container || container.querySelector('em-emoji-picker')) return;

    // Never move a picker initialized while hidden: create it in the visible panel.
    var picker = new window.EmojiMart.Picker({
        onEmojiSelect: function(emoji) {
            if (!$scope.requireLogin()) return;
            $scope.$evalAsync(function() {
                var stream = $scope.currentEmojiStream;
                if (stream) stream.chatMessage = (stream.chatMessage || '') + emoji.native;
            });
        }
    });
    container.appendChild(picker);
}

$scope.toggleMediaPanel = function(stream) {
    if (!$scope.requireLogin()) return;
    $scope.currentEmojiStream = stream;
    $scope.showMediaPanel = !$scope.showMediaPanel;
    if ($scope.showMediaPanel) {
        $timeout(igInitializeVisibleEmojiPicker, 0);
        if ($scope.gifResults.length === 0) $scope.searchGifs();
    }
};

// The tab buttons use activeTab directly, so initialize when switching back to Emojis.
$scope.$watch('activeTab', function(tab) {
    if (tab === 'emojis' && $scope.showMediaPanel) {
        $timeout(igInitializeVisibleEmojiPicker, 0);
    }
});

// Read the input from the visible repeated card. AngularJS primitive ng-model
// bindings can otherwise be shadowed by the ng-repeat child scope.
var igGifSearchTimer = null;
var igGifRequestNumber = 0;
$scope.searchGifs = function() {
    var panel = igVisibleChatPanel();
    var input = panel && panel.querySelector('input[ng-model="gifSearchQuery"]');
    var query = input ? input.value.trim() : String($scope.gifSearchQuery || '').trim();
    $scope.gifSearchQuery = query;
    if (igGifSearchTimer) $timeout.cancel(igGifSearchTimer);
    var requestNumber = ++igGifRequestNumber;
    igGifSearchTimer = $timeout(function() {
        var apiKey = 'GW18NAhdALb2pacYlpwoJS8Kv7q6KDgI';
        var url = query
            ? 'https://api.giphy.com/v1/gifs/search?api_key=' + apiKey + '&q=' + encodeURIComponent(query) + '&limit=50'
            : 'https://api.giphy.com/v1/gifs/trending?api_key=' + apiKey + '&limit=50';
        $http.get(url).then(function(response) {
            if (requestNumber === igGifRequestNumber) {
                $scope.gifResults = Array.isArray(response.data.data) ? response.data.data : [];
            }
        }, function(error) {
            if (requestNumber === igGifRequestNumber) console.warn('Giphy search failed:', error);
        });
    }, query ? 250 : 0);
};

// Sends selected GIF link directly to database socket stream
$scope.sendGifMessage = function(gifUrl,stream) { 
  if (!$scope.requireLogin()) {
        return;
    }
    var chatObj = {
        streamId: stream.stream_id || stream.id,
        userId: $rootScope.user.id,
        username: $rootScope.user.first_name + " " + $rootScope.user.last_name,
        user_pic: $rootScope.user.profile_pic,
        message: gifUrl, 
        created_at: new Date()
    };

    $scope.showMediaPanel = false;
    $scope.gifSearchQuery = '';
    socket.emit('sendMessage', chatObj);
};

 

function scrollIfNeeded(chatDiv) {
    if (!chatDiv) return;

    const threshold = 50; // px from bottom to consider “near bottom”
    const atBottom = chatDiv.scrollHeight - chatDiv.scrollTop - chatDiv.clientHeight < threshold;

    if (atBottom) {
        chatDiv.scrollTop = chatDiv.scrollHeight;
    }
}

 
socket.on('chatMessage', function(msg) {
    $scope.$apply(function() {
        $scope.messages.push(msg);
    });

    const chatDiv = document.getElementById('chatDiv_' + msg.streamId);
    scrollIfNeeded(chatDiv); // uses helper for smooth scrolling
});

// --- Chat history on join listener ---
socket.on('chatHistory', function(messages) { 
    $scope.$apply(function() {
        $scope.messages = messages;
    });
var msg = messages;
    const chatDiv = document.getElementById('chatDiv_' + msg.streamId);
    if (chatDiv) chatDiv.scrollTop = chatDiv.scrollHeight; // always scroll to bottom on history load
});




 








        var userlocation = JSON.parse(localStorageService.get("userlocation"));
        var requestInfo = {
            lat: userlocation.lat,
            long: userlocation.long,
        };
        $scope.toggleMaps = function() {
            if (angular.element('#mappost').hasClass('active')) {
                angular.element('#mappost').removeClass('active');
                angular.element('#pst7').removeClass('active');
                angular.element('#pst8').removeClass('active');
                angular.element("#pst1").css("z-index", "1");
                angular.element("#pst2").css("z-index", "3");
                angular.element("#pst3").css("z-index", "100");
                angular.element("#pst4").css("z-index", "2");
                angular.element("#pst5").css("z-index", "4");
                angular.element("#pst6").css("z-index", "3");
            };
        }




        $rootScope.resetInput = function(ev) {
            var elm = ev.target;
            angular.element(elm).val("");
        }
$scope.getStyleLayersByHost = function() {
    return styleLayers.english;
};


$scope.setAppBodyVisible = function() {
            angular.element('.intro-loader').hide();
            angular.element('.page-loader').remove();
            angular.element('.intro-buttons').show();
            // $rootScope.$emit('primaryResourcesLoaded', 'true');
            angular.element('#app-body').css('visibility', 'visible');
            angular.element('#app-body').css('overflow', 'hidden');
            angular.element('.intro-wrapper').hide();
        }
        //map gl code
$scope.initMapBoxJS = function(cr, zoom) {
    angular.element("#map").css("opacity", 1);
    
    if (!cr) {
        cr = {
            latitude: 0,
            longitude: 0
        };
    }
    
    var styleLayer = $scope.getStyleLayersByHost().default;
    mapboxgl.accessToken = accessToken;

    var mapContainer = document.getElementById('map');

    if (mapContainer && typeof ResizeObserver !== 'undefined') {
        var structuralObserver = new ResizeObserver(function(entries) {
            if (entries && entries.length > 0) {
                var rect = entries[0].contentRect;
                
                if (rect.height > 0 && rect.width > 0) {
                    
                    if (!map && !$scope.map_map) {
                        
                        console.log('--- DEFINITIVE SINGLE INITIALIZATION RUNNING ---');
                        
                        // 1. Establish layout parameters
                        var mapZoom = 3.2;
                        var mapCenter = [180, 0];
                        var mapStyle = (typeof styleLayer !== 'undefined') ? styleLayer : 'mapbox://styles/louisp/cmvli0fyk003h01s6b6rnf9lk';

                        // 2. Resolve viewports and zoom dependencies
                        if (typeof zoom !== 'undefined' && zoom) {
                            mapZoom = zoom;
                            console.log('Using URL Zoom Override: ' + mapZoom);
                        } else {
                            if (isMobile) {
                                mapZoom = 1.2;
                                console.log('No URL Zoom. Detected Mobile Frame. Setting Zoom: 1.2');
                            } else {
                                console.log('No URL Zoom. Detected Desktop Frame. Setting Zoom: 1.2');
                            }
                            
                            if (typeof initialZoom !== 'undefined') { mapZoom = initialZoom; }
                            if (typeof initialCenter !== 'undefined') { mapCenter = initialCenter; }
                        }

                        // 3. Fire the map initialization exactly ONCE
        var instance = new mapboxgl.Map({
    container: 'map',
    style: mapStyle,
    zoom: mapZoom,
    center: mapCenter,
    pitch: 0,
    projection: 'globe',
    language: $scope.getMapLanguageByHost()
});


 
instance.on('load', function () {

  instance.addSource('points-source', {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: []
    }
  })

 /* instance.addLayer({
    id: 'points-layer',
    type: 'symbol',
    source: 'points-source',
    layout: {
      'icon-image': ['get', 'iconName'],
      'icon-allow-overlap': true,
	  'icon-anchor': 'bottom',
	  'icon-size': 0.5

    },
	paint: {
  'icon-opacity': 1, 
}
  })*/

  var popup = new mapboxgl.Popup({
    closeButton: false,
    closeOnClick: false,
    offset: 25
  })

  instance.on('mouseenter', 'points-layer', function (e) {

    instance.getCanvas().style.cursor = 'pointer'
 
    var coordinates = e.features[0].geometry.coordinates.slice()

    var popupContent = e.features[0].properties.popupContent

    popup
      .setLngLat(coordinates)
      .setHTML(popupContent)
      .addTo(instance)

  })
 // instance.on('mouseleave', 'points-layer', function () {
//
//    instance.getCanvas().style.cursor = ''
// 
//    popup.remove()
//
//  })
  instance.on('click', 'points-layer', function (e) {

    var feature = e.features[0];
    var props = feature.properties;
    if (typeof props.icon === 'string') {
        props.icon = JSON.parse(props.icon);
    }
    var stream_type = props.stream_type;
    var id = props.id;
	var is_live = (typeof props.is_live !== 'undefined') ? props.is_live : false;
	console.log('click resultid', id);
	console.log('click resultis_live', is_live);
	console.log('click resultstream_type', stream_type);
    if (is_live === true || is_live === 1 || is_live === "true" || is_live === "1") {
         result = (String(stream_type) === "0" || stream_type === undefined)
             ? $scope.openEntityFromMapOrSlider(props, null)
             : $scope.openLiveStreamPopup(stream_type,id,props);
    }
 

 if ((String(props.stream_type) === "0" || props.stream_type === undefined) && !(is_live === true || is_live === 1 || is_live === "true" || is_live === "1"))  {
          result = $scope.openEntityFromMapOrSlider(props, null);
    } 

    if (!$scope.$$phase) {
        $scope.$apply();
    }
	 
});

 

    // parse stringified json


   







})
  
function updatePoints(features) {

    var source = instance.getSource('points-source');

    if (!source) {
        return; // map not ready yet
    }

    source.setData({
        type: 'FeatureCollection',
        features: features
    });
}












  // 4. Map references right away
                        map = instance;
                        $scope.map_map = instance;

                        // 5. SAFELY MOVE ALL MAP CONFIGURATION CODES HERE:
                        map.scrollZoom.enable({
                            around: 'cursor'
                        });
                        map.doubleClickZoom.disable();
                        
                        // --- INTEGRATED 3D BUILDINGS AND TERRAIN STYLING LOADER ---
                        map.on('style.load', function () {
                            // Mapbox Standard imported basemap: localize its labels.
                            // The single style URL is shared by all language subdomains.
                            if (typeof map.setConfigProperty === 'function') {
                                try {
                                    map.setConfigProperty('basemap', 'language', $scope.getMapLanguageByHost());
                                } catch (languageError) {
                                    console.warn('Mapbox basemap language could not be set:', languageError);
                                }
                            }

						  if (!map.getSource('mapbox-dem')) {
									map.addSource('mapbox-dem', {
										type: 'raster-dem',
										url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
										tileSize: 512
									});
								}

                            map.once('idle', function () {
                                $scope.mapReady = true; 
                                $scope.setAppBodyVisible(); 
                                
                                map.setTerrain({
                                    source: 'mapbox-dem',
                                    exaggeration: 1.5
                                });

                                if (!map.getLayer('3d-buildings')) {
                                    map.addLayer({
                                        id: '3d-buildings',
                                        source: 'composite',
                                        'source-layer': 'building',
                                        type: 'fill-extrusion',
                                        paint: {
                                            'fill-extrusion-color': '#aaa',
                                            'fill-extrusion-height': ['get', 'height']
                                        }
                                    });
                                }
                                
                                map.resize();
                                // Startup splash: signal only after Mapbox is usable.
                                requestAnimationFrame(function () {
                                    requestAnimationFrame(function () {
                                        window.dispatchEvent(new Event('ig:map-ready'));
                                    });
                                });
                            });
                        });

                     map.on('load', function() {
                            // Run resize calculations naturally
                            map.resize();

                            // Fire markers if they were postponed
                            if ($scope.runMarkersWhenMapReady) {
                                $scope.initMarkerGL();
                                $scope.runMarkersWhenMapReady = false;
                            }

                            // RIGHT HERE: Trigger the flyTo and mini-map layout transition!
                            if ($scope.runLayoutWhenMapReady) {
                                console.log('Map element fully ready. Initiating layout flyTo sequence...');
                                $scope.runMapFlyAndLayoutSequence();
                                $scope.runLayoutWhenMapReady = false; // Reset queue state
                            }
                        });

                        // 6. Handle local storage checks
                        if (localStorageService.get('upcoming') == 1) {
                            var bounds = map.getBounds();
                            var ne = bounds.getNorthEast();
                            var sw = bounds.getSouthWest();
                            localStorageService.set('neLat', ne.lat);
                            localStorageService.set('neLong', ne.lng);
                            localStorageService.set('swLat', sw.lat);
                            localStorageService.set('swLong', sw.lng);
                        }

                        // Force canvas layout synchronization frame
                        if (typeof map.resize === 'function') {
                            map.resize();
                        }
                    }

                    structuralObserver.disconnect();
                    console.log('Structural Observer safely disconnected.');
                }
            }
        });
        
        structuralObserver.observe(mapContainer);
    }

    // Assign scope state safely independent of asynchronous generation tracking
    $scope.webGl = true;
};

 $scope.initMapBoxJS(coorObj, query.zoom ? query.zoom : '');
       $scope.getMapBoundBox = function(zoom, centerLatLng, projection) {
            var latDiff = 0;
            var lngDiff = 0;
            
            if (zoom < 2) {
                latDiff = 60;
                lngDiff = 90;
            } else if (zoom < 3) {
                latDiff = 50;
                lngDiff = 50;
            } else if (zoom < 4) {
                latDiff = 35;
                lngDiff = 40;
            } else if (zoom < 5) {
                latDiff = 20;
                lngDiff = 40;
            } else {
                // SAFETY CHECK: Only try to read live bounds if the map object actually exists
                if ($scope.map_map && typeof $scope.map_map.getBounds === 'function') {
                    var bounds = $scope.map_map.getBounds();
                    var northEast = bounds.getNorthEast();
                    var southWest = bounds.getSouthWest();
                    return {
                        southWest: southWest,
                        northEast: northEast
                    };
                } else {
                    // Fallback bounds if map isn't ready on high zooms
                    latDiff = 20;
                    lngDiff = 40;
                }
            }
            
            // SAFETY CHECK: Handle center fallback safely if map isn't fully ready
            var defaultCenter = { lng: 180, lat: 0 };
            if ($scope.map_map && typeof $scope.map_map.getCenter === 'function') {
                defaultCenter = $scope.map_map.getCenter();
            }
            
            var center = centerLatLng || defaultCenter;
            
            var sw = {
                lng: center.lng - lngDiff,
                lat: center.lat - latDiff
            };
            var ne = {
                lng: center.lng + lngDiff,
                lat: center.lat + latDiff
            };
            return {
                southWest: sw,
                northEast: ne
            };
        };

        $scope.getEstablishmentUrl = function(center) {
            // SAFETY CHECK: Resolve safe fallback zoom factor based on query string or device parameters
            var zoom = (isMobile ? 1.2 : 1.2);
            if (query && query.zoom) {
               zoom = parseFloat(query.zoom);
            } else if ($scope.map_map && typeof $scope.map_map.getZoom === 'function') {
                zoom = $scope.map_map.getZoom();
           }
        
 
            var bounds = $scope.getMapBoundBox(zoom, center);
            var northEast = bounds.northEast;
            var southWest = bounds.southWest;
            var api = '/api/establishmentsByQuery'; // Unified safe baseline API fallback
            
            if (query.zoom === undefined || query.cat === undefined || query.rD === undefined) {
                api = '/api/establishmentsByQuery';
            }
            
            var url = api + '?neLat=' + northEast.lat + '&swLat=' + southWest.lat + '&neLng=' + northEast.lng + '&swLng=' + southWest.lng + '&minZoom=' + zoom;
            return url;
        };
 $scope.setFirstLoadFlag = function(flag) {
            $scope.isFirstLoad = flag;
        }
        var canceller;
        $scope.currentMapGLGeoJson = [];
        $scope.currentMapGLMarkers = [];
        if (query.at === undefined) {
            $scope.loadEstablishment = function(userlocation) {
                let url = $scope.getEstablishmentUrl({
                    lat: userlocation.lat,
                    lng: userlocation.long
                });
                // url = $scope.constructUrl(url);
                canceller = $q.defer();
                $http.get(url, {
                    timeout: canceller.promise
                }).then(function(res) {
                   // traceLog('initial-load', "fetching details for the first load");
                    $scope.currentMapGLGeoJson = res.data.features;
                    // $scope.loadMapGLIconMarker(res.data.features);
                    $rootScope.$emit('primaryResourcesLoaded', 'true'); 
				   $scope.homecategories = [{

                        "category_id": 7,
                        "iconimg": "i-i/adventures.svg",
                        "category_name": "Adventures/<br>Tours"
                    }, {
                        "category_id": 6,
                        "iconimg": "i-i/Festivals.svg",
                        "category_name": "Festivals/<br>Exhibitions"
                    }, {
                        "category_id": 5,
                        "iconimg": "i-i/Gaming.svg",
                        "category_name": "Gaming/<br>Amusement"
                    }, {
                        "category_id": 4,
                        "iconimg": "i-i/Museums.svg",
                        "category_name": "Museums/<br>Cinemas"
                    }, {
                        "category_id": 3,
                        "iconimg": "i-i/Music.svg",
                        "category_name": "Music/<br>Performances"
                    }, {
                        "category_id": 2,
                        "iconimg": "i-i/Nature.svg",
                        "category_name": "Nature/<br>Sites"
                    }, {
                        "category_id": 283,
                        "iconimg": "i-i/Sports.svg",
                        "category_name": "Sports/<br>Competitions"
                    }, {
                        "category_id": 147,
                        "iconimg": "i-i/Children.svg",
                        "category_name": "Children"
                    }];
   $scope.homecategories2 = [{
                        "category_id": 329,
                        "iconimg": "i-i/news-politics.svg",
                        "category_name": "News/<br>Politics"
                    }, {
                        "category_id": 331,
                        "iconimg": "i-i/local-scene.svg",
                        "category_name": "Local Scene"
                    }, {
                     
						  "category_id": 332,
                        "iconimg": "i-i/nature-environment.svg",
                        "category_name": "Nature/<br>Environment"
                    }, {
                        "category_id": 333,
                        "iconimg": "i-i/education-exploration.svg",
                        "category_name": "Education/<br>Exploration"
                    }, {
                        "category_id": 328,
                        "iconimg": "i-i/personal-human-stories.svg",
                        "category_name": "Personal/<br>Human Stories"
                    }, {
                        "category_id": 330,
                        "iconimg": "i-i/conflicts.svg",
                        "category_name": "Conflicts"
                    }, {
                      
						                        "category_id": 327,
                        "iconimg": "i-i/spirituality-supernatural.svg",
                        "category_name": "Spirituality/<br>Supernatural"
                    }];     

	 var requestInfo = {
                        lat: $scope.currentUserlocation.lat,
                        long: $scope.currentUserlocation.long,
                    };
                    /*$scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');

                    $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');*/
                });
               // traceLog('initMarkerGL', 'called - fly to user location');
       var mapIsReady = (typeof map !== 'undefined' && map && typeof map.isMoving === 'function');
                
                if (mapIsReady) {
                    if (!map.isMoving()) {
                        map.flyTo({
                            center: [userlocation.long, userlocation.lat],
                            bearing: 0,
                            curve: 1,
                            essential: true
                        });
                    }
                } else {
                    console.log('Map element structural build is in progress. Postponing flyTo frame adjustment.');
                }
            }
        }
  
      $scope.movingToUserLocationForFirstLoad = function() {
            var userlocation = JSON.parse(localStorageService.get("userlocation"));
           // traceLog('initial-load', "movingToUserLocationForFirstLoad", userlocation);
            if (userlocation != null && query.at === undefined) {
                $scope.currentUserlocation = userlocation;
                $scope.loadEstablishment(userlocation);
            } else {
                var newInterval = setInterval(function() {
                    var userlocationAgain = JSON.parse(localStorageService.get("userlocation"));
                    if (userlocationAgain != null) {
                        clearInterval(newInterval);
                        $scope.movingToUserLocationForFirstLoad();
                    }
                }, 100);
            }
        }
        //// traceLog('initial-load', "user location", userlocation);
        // $scope.currentUserlocation = [userlocation.long , userlocation.lat];
        $scope.isFirstLoad = true;
        $scope.isLoadCompleted = false;
        if (query.at === undefined) {
            $scope.movingToUserLocationForFirstLoad();
        }
        if (langPref) {
            var langArray = langPref.split('_');
            $scope.establish_locale = langArray[0];
            // $scope.establish_locale = LOCALES.locales[langPref];
        } else {
            $scope.establish_locale = "en";
        }
/////----------------------------------Categories Begin-----------------------------------------------------------------------/////////




/////----------------------------------Categories End-----------------------------------------------------------------------/////////
        function getScrollbarWidth() {
            // Creating invisible container
            const outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.overflow = 'scroll'; // forcing scrollbar to appear
            outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
            document.body.appendChild(outer);
            // Creating inner element and placing it in the container
            const inner = document.createElement('div');
            outer.appendChild(inner);
            // Calculating difference between container's full width and the child width
            const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
            // Removing temporary elements from the DOM
            outer.parentNode.removeChild(outer);
            return scrollbarWidth;
        }
       // traceLog("the ScrollbarWidth is ...", getScrollbarWidth());
        $scope.loadMoreSlider = function() {
           // traceLog("discover-refreshmarkers16", "called-> loadMoreSlider() with filterIcons as ", filterIcons, $scope.filtered_temp_slider_data.length, $scope.temp_right_slider_data.length);
            var temp;
            (filterIcons) ? temp = $scope.filtered_temp_slider_data: temp = $scope.temp_right_slider_data;
            var count = $scope.right_slider_data.length;
            var limit;
            (count + 19 <= temp.length) ? limit = count + 19: limit = temp.length;
            for (var i = count; i < limit; i++) {
                $scope.right_slider_data.push(temp[i]);
            }
            $scope.right_slider_data.sort(() => Math.random() - Math.random());
        };
        // L.mapbox.accessToken = accessToken;
        // var geocoder = L.mapbox.geocoder('mapbox.places');
        //Here your view content is fully loaded !!
        $rootScope.page = "maps";
        $scope.map_genres = [];
        var userLatLong = undefined
        $anchorScroll.yOffset = 94;
        var isFirstLoad = window.sessionStorage.getItem('first_load_info');
        if (isFirstLoad == null && currStateName == "maps.world") {
            window.sessionStorage.setItem('first_load_info', 'true');
            // $scope.openUserinfoModal();
        } else {
            window.sessionStorage.setItem('first_load', 'false');
        }
        var siteBaseUrl = window.location.host;
        var facebookAppId = '1260352757425721';
        var googleAppId = '309894020134-49bfbquor3b3isd25052p8ttkadtd2ni.apps.googleusercontent.com';
        var vkAppId = '6118142';
        var weiboAppId = '1746413473';
        if (siteBaseUrl == "iconoglobe.ccn.us" || siteBaseUrl == "www.iconoglobe.cn") {
            facebookAppId = '1923085841248777';
        }
        var enabled;
        var currStateName = $state.$current.name;
        $scope.isMobile = isMobileDevice();
        if (!$scope.selected || !$scope.bool) {
            $scope.selected = {};
            $scope.bool = {};
        }
        $rootScope.allCategoriesSelected = true;
        $scope.showUpcomingEvents = false;
        $scope.showUpcomingEventSlider = false;
        $scope.slickAdventures = [];
        $scope.slickFestivals = [];
        $scope.slickGaming = [];
        $scope.slickMuseums = [];
        $scope.slickMusic = [];
        $scope.slickNature = [];
        $scope.slickSports = [];
        $scope.slickChildrens = [];
        $scope.hangingPromotion = [];
        

$scope.hangingPromotionCount = 0;
$scope.hangingPromotionLoading = false;

$scope.loadMapHangingPromotion = function () {
    if ($scope.hangingPromotionLoading) return;

    var lat = Number(userlocation && userlocation.lat);
    var lng = Number(userlocation && userlocation.long);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        console.warn('[HANGING PROMO] Visitor location unavailable');
        return;
    }

    $scope.hangingPromotionLoading = true;

    $http.post('/data/hangingOrSkyScrapperPromotionsForLocation', {
        lat: lat,
        long: lng,
        promotionType: 'is_hanging',
        locationType: 'homePage'
    }).then(function (response) {
        var promotions = Array.isArray(response.data)
            ? response.data
            : [];

        // Temporary: use the closest promotion returned by the server.
        // Later the server will return the rotated selection.
        $scope.hangingPromotion = promotions.slice(0, 1);
        $scope.hangingPromotionCount = $scope.hangingPromotion.length;

        console.log('[HANGING PROMO] Selected:', $scope.hangingPromotion[0] || null);
    }).catch(function (error) {
        console.error('[HANGING PROMO] Load failed:', error);
        $scope.hangingPromotion = [];
        $scope.hangingPromotionCount = 0;
    }).finally(function () {
        $scope.hangingPromotionLoading = false;
    });
};

$scope.loadMapHangingPromotion();
 
        $scope.skyscrappperPromotion = {};
        $scope.loadPromotionsCalledOnce = false;
        $scope.hasChildCategories = false;

        function loadPromotions() {
           // traceLog("promotion-slider", "loadPromotions() called")
           // traceLog("tn-mapctrl-siteload", "Load promotions called");
           // traceLog("tn-mapctrl-siteload", "calling-> UserLocation.silently()");
           // traceLog("promotion-slider", "UserLocation.siently() called")
            UserLocation.silently().then(function(data) {
               // traceLog("tn-mapctrl-siteload", "response -> UserLocation.silently()", data);
                if (!data) {
                    data = {
                        lat: 0,
                        long: 0
                    }
                }
                if (!data.lat || !data.long) {
                    data.lat = 0;
                    data.long = 0;
                }
                var startDate = JSON.stringify($filter('date')(new Date(), "yyyy-MM-dd"));
                // var params = {"latitude":data.lat,"longitude":data.long, start_date: startDate};
                data.start_date = startDate;
               // traceLog("tn-mapctrl-siteload", "calling-> /data/skyscapperspromotions ", data);
               // traceLog("tn-mapctrl-siteload", "calling-> /data/promotionslider: data: ", data);
                if (data) {
                   // traceLog("currStateName is ", $state.$current.name)

                }
                UserLocation.getUserCountry().then(function(data) {
                   // traceLog("tn-mapctrl-siteload", "response -> UserLocation.getUserCountry()", data);
                })
            });
        }
        $scope.showMap = function() {
            // console.log('ghgfhfghfh');
        }
        $scope.geocodeThis = function() {
            // console.log('jjjjj');
            var text = document.getElementById('geocoder').value;
            // console.log(text);
            if (text.length >= 5) {
                geocoder.query(text, showMap);
            }
        }
        $scope.redirecttoLive = function() {
            var url = window.location.href;
            var arr = url.split("/");
            var result = arr[0] + "//" + arr[2];
            window.open(`${result}/stmr/stream?action=watch`, '_blank');
        }
       
       
        $rootScope.$on('worldMapLoaded', function() {
           // traceLog("tn-mapctrl", "$on[worldMapLoaded]");
            $scope.setAppBodyVisible();
            loadPromotions();
        });
        if (!window.homePageVisited) {
           // traceLog("tn-mapctrl-siteload", "this is not home page load promotions");
            //loadPromotions();
        }

        $scope.renderHtml = function(html_code) {
            html_code = $filter('translate')(html_code);
            return $sce.trustAsHtml(html_code);
        };

        $scope.checkUrlMatch = function(categoryName) {
            // 1. Get the current URL parameters
            var currentQuery = $location.search();

            // 2. If there's no 'cat' in the URL, don't highlight anything extra
            if (!currentQuery.cat || !categoryName) {
                return false;
            }
            // 3. Clean the Category Name (Remove <br> tags and extra spaces)
            var cleanDbName = categoryName.replace(/<br\s*\/?>/gi, ' ').replace(/\s+/g, ' ').toLowerCase().trim();
            // 4. Clean the URL Name (Handle %20 and + signs)
            var cleanUrlName = decodeURIComponent(currentQuery.cat).replace(/\+/g, ' ').replace(/\s+/g, ' ').toLowerCase().trim();
            // 5. Return true if they match!
            return cleanDbName === cleanUrlName;
        };

        $scope.removeBr = function(str) {
            if (str)
                return str.replace('<br>', ' ');
            return '';
        };
        $scope.updateQueryString = function(cat, sub, child, genre) {
            var currStateName = $state.$current.name;
            if (currStateName == "maps.world") {
                // Url would only be changed for regional map layout so that it can be copied and shared
                /* there can be three values to every parameter
                name - In that case that parameter would be set to that name
                null - In that case parameter would be removed from url
                false - In that can parameter would not be changed and would have same value as it had earlier
                */
                if (cat != false) {
                    $location.search("cat", cat);
                   // traceLog("tn-mapctrl-urlchange", "mapctrl->updateQueryString() cat has value, url parameters: ", { "cat": cat });
                }
                if (sub != false) {
                   // traceLog("tn-mapctrl-urlchange", "mapctrl->updateQueryString() subcat has value, url parameters: ", {                        "subcat": sub                    });
                    $location.search("subcat", sub);
                }
                if (child != false) {
                   // traceLog("tn-mapctrl-urlchange", "mapctrl->updateQueryString() childcat has value, url parameters: ", {                        "childcat": child                    });
                    $location.search("childcat", child);
                }
                if (genre != false) {
                   // traceLog("tn-mapctrl-urlchange", "mapctrl->updateQueryString() genre has value, url parameters: ", {                        "genre": genre                    });
                    $location.search("genre", genre);
                }
            }
        };
  

        $scope.makeMenuSelections = function(catName, subCatName, childCatName, genre, callback) {
           // traceLog("mapctrl-seo", "$scope.makeMenuSelections called ", catName, subCatName, childCatName, genre);
            categoryfilter.getMenuHierarchy(catName, subCatName, childCatName, genre).then(function(response) {
                callback();
               // traceLog("mapctrl-refreshmarkers", "response menu hierarchy ", response);
                $scope.selected.category_id = response.category_id;
                $scope.selected.subcategory_id = response.subcategory_id;
                $scope.selected.childcategory_id = response.childcategory_id;
                $scope.selected.genre_id = response.genre_id;
                if (response.subcats && response.subcats.length > 0) {
                    $scope.subcategories = response.subcats;
                    if (response.subcategory_id) {
                        $scope.toggleSubCategory(response.subcategory_id, subCatName);
                    }
                    /*
                    else
                    $scope.bool.genremask = true;
                    */
                    $rootScope.showAllCategory = false;
                    // Show menu of sub-category
                    $scope.showSubCategoryMenu = true;
                    if (response.childcats && response.childcats.length > 0) {
                        $scope.childCategories = response.childcats;
                        if (response.childcategory_id) {
                            $scope.toggleChildCategory(response.childcategory_id, childCatName);
                        }
                        if (response.genres && response.genres.length > 0) {
                            $scope.map_genres = response.genres;
                            $scope.showGenreMenu = true;
                            $scope.isCheck = true;
                            if (response.genre_id) {
                                $scope.isCheck = false;
                                $scope.toggleGenre();
                            }
                        }
                    } else if (response.genres && response.genres.length > 0) {
                        $scope.map_genres = response.genres;
                        if (response.genre_id)
                            $scope.toggleGenre();
                        else
                            $scope.isCheck = true;
                        $scope.showGenreMenu = true;
                    }
                }
               // traceLog("mapctrl-refreshmarkers", "$scope.selected is ", JSON.parse(JSON.stringify($scope.selected)));
               // traceLog("mapctrl-refreshmarkers", "makeMenuSelections(): calling->$scope.refreshMapMarkers()");
                $scope.refreshMapMarkers();
            });
        };
 
        $scope.selectScroll = function() {
            $("html, body").animate({

                scrollTop: 0,
            }, "slow");
        }
        $scope.proCategory = function(id, name, index) {
            
            angular.element("#keyword_search_mobile").val("");
            angular.element("#keyword_search").val("");
            $scope.toggleSubCategory('', '');
            if ($scope.bool.showUpcomingEvents) {
               // traceLog('mapctrl-catgenreselection-upcomingevents', '$scope.bool.showUpcomingEvents == true');
                if (typeof index == 'number' && index >= 0) {
                  
                    $scope.$broadcast('toggleUpcomingCategory', {
                        index: index
                    });
                }
                var newHash = 'maincategory_' + id;
                if ($location.hash() !== newHash) {
                    // set the $location.hash to `newHash` and
                    // $anchorScroll will automatically scroll to it
                    $location.hash(newHash);
                } else {
                    // call $anchorScroll() explicitly,   // since $location.hash hasn't changed
                    $anchorScroll();
                }
            }
            // deselect all categories as one of the category is selected
            $rootScope.allCategoriesSelected = false;
            var currStateName = $state.$current.name;
            $scope.categoryName = name;
            var category_name = name.toString().replace(/<br\s*\/?>/gi, ' ');
            delete $scope.selected.subcategory_id;
            delete $scope.selected.childcategory_id;
            delete $scope.selected.genre_id;
            delete $scope.selected.keyword;
            $scope.childCategories = [];
            $scope.map_genres = [];
            $scope.selected.category_id = id;
            $scope.selected.category_name = category_name;
           // traceLog("mapctrl-querystring", " calling->updateQueryString('" + category_name + "', null, null, null)");
            $scope.updateQueryString(category_name, null, null, null);
            if (currStateName !== "maps.world") {
                $scope.bool.selectCityPopup = true;
            }
            if ($state.$current.name == "maps.world") {
                $scope.bool.bannerAds = true;
            }
            // Fet sub-categories of this category and show on menu
            categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
               // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                $scope.subcategories = data.subcats;
                $scope.selected.subcategory_ids = [];
                if (data.subcats && data.subcats.length > 0) {
                   // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                    angular.forEach(data.subcats, function(v) {
                        /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                        $scope.selected.subcategory_ids.push(v.category_id);
                    });
                }
                $rootScope.showAllCategory = true;
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
             
                $scope.refreshMapMarkers(); //{ categorySelected : true}
                $scope.select = [];
            });
            var currStateName = $state.$current.name;
            UserLocation.silently().then(function(user) {
                if (currStateName == "maps.world") {
                   // traceLog("tn-mapctrl-urlchange", "mapctrl->showMyLocation() current state name is 'maps.world', url parameters: ", {                        "at": user.long + "," + user.lat,                    });
                    $location.search({
                        "at": user.long + "," + user.lat,
                    });
                    localStorageService.set('city_lat', user.lat);
                    localStorageService.set('city_lng', user.long);
                    var coor = {
                        latitude: user.lat,
                        longitude: user.long,
                        zoom: 6
                    };
                    $scope.$broadcast('loadLocationMap', coor);
                } else {
                    localStorageService.set('geo_search', 1);
                    $location.path('/').search({
                        "at": user.long + "," + user.lat,
                    });
                }
            });
            $scope.right_slider = true;
            $scope.showEstaEventSlider = true;
        };
$scope.selectCategory = function(id, name, index) {
    $scope.igAllClicked = false;

    // Toggle category
    // If this category is already selected, turn it off and show all categories
    if ($scope.selected.category_id == id) {
        delete $scope.selected.category_id;
        $scope.selectAllCategories();
        return;
    }

    // Otherwise select this category
    $scope.selected.category_id = id;


    angular.element('#sbctsc').css('opacity', '1');
    angular.element('#pst2').css('display', 'block');
    angular.element("#keyword_search_mobile").val("");
    angular.element("#keyword_search").val("");

    $scope.toggleSubCategory('', '');

    // reset selections
    delete $scope.selected.subcategory_id;
    delete $scope.selected.childcategory_id;
    delete $scope.selected.genre_id;
    delete $scope.selected.keyword;

    $scope.childCategories = [];
    $scope.map_genres = [];


    var category_name = name.toString().replace(/<br\s*\/?>/gi, ' ');
    $scope.selected.category_name = category_name;

    $scope.updateQueryString(category_name, null, null, null);


    if ($scope.activeCategories === $scope.homecategories2) {

        $scope.subcategories = [];
        $scope.selected.subcategory_ids = [];

        $scope.showSubCategoryMenu = false;
        $scope.isCheck = false;

        $scope.refreshMapMarkers();
        return;
    }


    categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {

        $scope.subcategories = data.subcats;
        $scope.selected.subcategory_ids = [];

        if (data.subcats && data.subcats.length > 0) {

            angular.forEach(data.subcats, function(v) {
                $scope.selected.subcategory_ids.push(v.category_id);
            });
        }

        $rootScope.showAllCategory = true;
        $scope.showSubCategoryMenu = true;
        $scope.isCheck = true;

        $scope.refreshMapMarkers();
        $scope.select = [];
    });
};   
     
   $scope.chactive = function($event) {

    var element = angular.element($event.currentTarget).parent();

    if (element.hasClass('active')) {
        element.removeClass('active');
    } else {
        element.addClass('active');
    }
};  
     
        $scope.selectSubCategory = function(id, name) {
           // traceLog("tn-mapctrl-catgenreselection", "called-> selectSubCategory(" + id + ",'" + name + "')");
            $scope.toggleChildCategory('', '');
            $scope.toggleSubCategory(id, name);
           // traceLog("mapctrl-querystring", " calling->updateQueryString(false," + name + ", null, null)");
            $scope.updateQueryString(false, name, null, null);
            delete $scope.selected.childcategory_id;
            delete $scope.selected.genre_id;
            angular.element(".master").remove();
            angular.element('.mapsection>map').find('b').remove();
            if ($state.$current.name != 'maps.world') {
                $scope.bool.selectCityPopup = true;
            }
            $scope.filteredIcons = {};
            if ($scope.selected.subcategory_id != id) {
                $scope.map_genres = [];
                $scope.childCategories = [];
                var currStateName = $state.$current.name;
                $scope.selected.subcategory_id = id;
                $scope.selected.subcategory_name = name;
                //$scope.bool.genremask = false;
               // traceLog("tn-mapctrl", "selectSubCategory()", $scope.selected);
                categoryfilter.getChildCatsOrGenresOfSubCategory(id).then(function(data) {
                   // traceLog("tn-mapctrl-showgenre", "response-> categoryfilter.getGenre()", data);
                    if (data.childcats.length > 0) {
                       // traceLog("tn-mapctrl-showgenre", "data.childCat.length > 0, calling $scope.childMapCategory()");
                        //$scope.childMapCategory(data.childCat);
                        $scope.childCategories = data.childcats;
                        $scope.showChildCategoryMenu = true;
                        $scope.showGenreMenu = false;
                        $scope.map_genres = [];
                    } else if (data.genres.length > 0) {
                        // as there are no child categories do not show child category menu
                        $scope.showChildCategoryMenu = false;
                       // traceLog("tn-mapctrl-showgenre", "$data.childCat has multiple values");
                        $scope.map_genres = data.genres;
                       // traceLog("tn-mapctrl-showgenre", "Last else of $data.childCat has multiple values");
                        $scope.showGenreMenu = true;
                        var checkboxes = document.getElementsByClassName('filters');
                        for (var i = 0; i < checkboxes.length; i++) {
                            checkboxes[i].checked = true;
                        }
                    }
                });
               // traceLog("mapctrl-refreshmarkers", "selectSubCategory(): called-> $scope.refreshMapMarkers()");
                $scope.refreshMapMarkers({
                    forceFetch: true
                });
            } else {
                if ($scope.childCategories && $scope.childCategories.length > 0) {
                    $scope.showChildCategoryMenu = true;
                    $scope.showGenreMenu = false;
                    $scope.map_genres = [];
                } else if ($scope.genres && $scope.genres.length > 0) {
                    $scope.showChildCategoryMenu = false;
                    $scope.showGenreMenu = true;
                }
               // traceLog("tn-mapctrl-siteload", "came inside this else -------------->", $scope.selected);
                $scope.selected.subcategory_id = id;
               // traceLog("mapctrl-refreshmarkers", "selectSubCategory(): called-> $scope.refreshMapMarkers()");
                $scope.refreshMapMarkers();
            }
        };
        /**
         * Toggles sub category - Change appearance of sub-categories items
         * @param id = '' -> all sub-categories would be shown as selected, otherwise item with subcategory id is shown as selected
         * @param name
         */
        $scope.toggleSubCategory = function(id, name) {
           // traceLog("tn-mapctrl-catgenreselection", "called-> toggleSubCategory(" + id + ", " + name + ")");
            if (id == '') {
               // traceLog("tn-mapctrl-catgenreselection", "Adding defaultActive styling to all subcategories");
                $('.topsubmenucat ul li').addClass('defaultActive');
            } else {
               // traceLog("tn-mapctrl-catgenreselection", "making #" + id + " as defaultActive");
               // traceLog("tn-mapctrl-querystring", " calling->updateQueryString(false, '" + name + "',null, null)");
                $('.topsubmenucat ul li').removeClass('defaultActive');
                $('#' + id).addClass('defaultActive');
            }
        };
        /**
         * Called when child category is selected
         * @param id
         * @param name
         */
        $scope.selectChildCategory = function(id, name) {
           // traceLog("tn-mapctrl-catgenreselection", "called-> selectChildCategory(" + id + ",'" + name + ")");
            // $scope.selected.genre_id = null;
            delete $scope.selected.genre_id;
            if ($state.$current.name != 'maps.world') {
                // remove from selection and call filterGenreIcon
                $scope.bool.selectCityPopup = true;
            }
            if (id != $scope.selected.childcategory_id) {
                $scope.selected.childcategory_id = id;
                $scope.selected.childcategory_name = name;
               // traceLog("mapctrl-catgenreselection", "Child category id is a number");
                $scope.map_genres = [];
                $scope.toggleChildCategory(id, name);
               // traceLog("tn-mapctrl-querystring", " calling->updateQueryString(false, false, '" + name + "' , false)");
                $scope.updateQueryString(false, false, name, null);
                categoryfilter.getGenresOfChildCategory(id).then(function(data) {
                    $scope.map_genres = data.genres;
                   // traceLog("mapctrl-refreshmarkers", "selectChildCategory(): called-> $scope.refreshMapMarkers()");
                    $scope.refreshMapMarkers({
                        forceFetch: true
                    });
                    $scope.showGenreMenu = true;
                    var checkboxes = document.getElementsByClassName('filters');
                    for (var i = 0; i < checkboxes.length; i++) {
                        checkboxes[i].checked = true;
                    }
                });
            } else {
               // traceLog("mapctrl-catgenreselection", "Child category id is an array");
               // traceLog("mapctrl-refreshmarkers", "selectSubCategory(): called-> $scope.refreshMapMarkers()");
                $scope.showGenreMenu = true;
                $scope.refreshMapMarkers({
                    forceFetch: true
                });
            }
        };
        /**
         * Toggles child categories
         * @param id
         * @param name
         */
        $scope.toggleChildCategory = function(id, name) {
           // traceLog("tn-mapctrl-catgenreselection", "called-> toggleChildCategory('" + id + "', '" + name + "')");
            if (id == '' || id.length > 0) {
                $('.childcategories ul li').addClass('defaultActive');
            } else {
                $scope.selected.childcategory_id = id;
                $('.childcategories ul li').removeClass('defaultActive');
                $('#child-cat-' + id).addClass('defaultActive');
            }
        };
        /**
         * Called when any genre is selected
         * @param id
         * @param name
         */
        $scope.selectGenre = function(id, name) {
           // traceLog("tn-mapctrl-catgenreselection", "called-> selectGenre(" + id + ", '" + name + "')");
           // traceLog("tn-mapctrl-querystring", " calling->updateQueryString(false, false , false , '" + name + "')");
            $scope.updateQueryString(false, false, false, name);
            $scope.selected.genre_id = id;
            $scope.selected.genre_name = name;
           // traceLog("mapctrl-refreshmarkers", "selectGenre(): called-> $scope.refreshMapMarkers()");
            $scope.refreshMapMarkers({
                forceFetch: true
            });
            $scope.showGenreMenu = true;
            $scope.toggleGenre();
            $scope.bool.selectCityPopup = false;
        };
       // traceLog("tn-mapctrl-siteload", "child categories is set to empty array");
        $scope.childCategories = [];
        /**
         * Styling changes when genre checkbox is selected/deseleccted
         */
        $scope.toggleGenre = function() {
           // traceLog("tn-mapctrl-catgenreselection", "called-> toggleGenre() with $scope.selected.genre_id = ", $scope.selected.genre_id);
            if ($scope.selected.genre_id) {
                $('.filters').prop('checked', false);
               // traceLog("tn-mapctrl-catgenreselection", "Setting #c_" + $scope.selected.genre_id + " prop to checked");
                $('#c_' + $scope.selected.genre_id).prop('checked', true);
            }
        };
        /**
         * When all categories button is clicked on desktop
         */

        $scope.selectAllCategories = function() {
           // traceLog("mapctrl-catgenreselection", "called-> selectAllCategories()");
            $rootScope.allCategoriesSelected = true;
            angular.element('#pst2').css('display', 'none');
            $scope.resetUpcomingSlider();
            $scope.selected = {};
            $scope.bool = {};
            $scope.showUpcomingEventSlider = false;
            $scope.keywordSearched = null;
            $scope.searchKeyword = null;
            $scope.showSubCategoryMenu = false;
            $rootScope.showAllCategory = false;
            if ($scope.bool.showUpcomingEvents) {
                $scope.bool.catMenuVisible = false;
            } else {
                $scope.bool.catMenuVisible = true;
            }
            // Reset keyword searched
            if (angular.element("#keyword_search_mobile").val() || angular.element("#keyword_search").val()) {
                angular.element("#keyword_search_mobile").val("");
                angular.element("#keyword_search").val("");
            }
            if (angular.element("#city_search").val()) {
                angular.element("#city_search").val("");
            }
            if (angular.element("#country_search").val()) {
                angular.element("#country_search").val("");
            }
            $scope.showEstaEventSlider = true;
           // traceLog("mapctrl-refreshmarkers", "selectAllCategories(): called-> $scope.refreshMapMarkers()");
            $scope.refreshMapMarkers();
        };
        /**
         * When different menus are hidden from mobile
         */
        $rootScope.allCategoriesSelectedMobile = function() {
           // traceLog("tn-mapctrl-catgenreselection", "called-> allCategoriesSelectedMobile()");
            $scope.$broadcast('toggleMapImage');
            $rootScope.allCategoriesSelected = true;
            $scope.resetUpcomingSlider();
            $scope.showChildCategoryMenu = false;
            $scope.showGenreMenu = false;
            $scope.showSubCategoryMenu = false;
            $rootScope.showAllCategory = false;
            delete $scope.selected.genre_id;
            delete $scope.selected.subcategory_id;
            delete $scope.selected.childcategory_id;
            delete $scope.selected.category_id;
            if ($scope.bool.showUpcomingEvents) {
                $scope.bool.catMenuVisible = false;
            } else {
                $scope.bool.catMenuVisible = true;
                $scope.resetFilters();
            }
           // traceLog("mapctrl-refreshmarkers", "allCategoriesSelectedMobile(): called-> $scope.refreshMapMarkers()");
            $scope.refreshMapMarkers();
        };
        $scope.hideAllCategoriesMobile = function() {
           // traceLog("tn-mapctrl-catgenreselection", "called-> hideAllCategoriesMobile()");
            $rootScope.allCategoriesSelected = true;
            delete $scope.selected.genre_id;
            delete $scope.selected.subcategory_id;
            delete $scope.selected.childcategory_id;
            delete $scope.selected.category_id;
            $scope.showChildCategoryMenu = false;
            $scope.showGenreMenu = false;
            $scope.showSubCategoryMenu = false;
           // traceLog("mapctrl-refreshmarkers", "called-> $scope.refreshMapMarkers()");
            $scope.resetFilters();
            $scope.refreshMapMarkers();
        };
        $scope.hideSubCategoryMenuMobile = function() {
           // traceLog("tn-mapctrl-catgenreselection", "called-> hideSubCategoryMenuMobile()");
            $scope.showSubCategoryMenu = false;
            $rootScope.allCategoriesSelected = true;
            $scope.resetUpcomingSlider();
            $scope.resetFilters();
            $scope.refreshMapMarkers();
            delete $scope.selected.genre_id;
            delete $scope.selected.childcategory_id;
            delete $scope.selected.subcategory_id;
            delete $scope.selected.category_id;
           // traceLog("mapctrl-refreshmarkers", "hideSubCategoryMenuMobile(): called-> $scope.refreshMapMarkers()");
        };
        $scope.hideChildCategoryMenuMobile = function() {
           // traceLog("tn-mapctrl-catgenreselection", "called-> hideChildCategoryMenuMobile()");
            $scope.showChildCategoryMenu = false;
            delete $scope.selected.genre_id;
            delete $scope.selected.childcategory_id;
           // traceLog("mapctrl-refreshmarkers", "hideChildCategoryMenuMobile(): called-> $scope.refreshMapMarkers()");
            $scope.refreshMapMarkers();
        };
        $scope.hideGenreMenu = function() {
           // traceLog("tn-mapctrl-catgenreselection", "called-> hideGenreMenu()");
            $scope.showGenreMenu = false;
            var currStateName = $state.$current.name;
            delete $scope.selected.genre_id;
           // traceLog("mapctrl-refreshmarkers", "hideGenreMenu(): called-> $scope.refreshMapMarkers()");
            $scope.refreshMapMarkers();
            if ($state.$current.name == 'maps.world') {} else {
                $scope.bool.selectCityPopup = true;
            }
        };
        $scope.refreshMapMarkers = function(options) {
            var currStateName = $state.$current.name;
            var params = $scope.selected;
            if (currStateName == "maps.world") {
               // traceLog("mapctrl-refreshmarkers", "$broadcast[refresh-markers]");
                $scope.$broadcast('refresh-markers', params, options);
            } else {
               // traceLog("mapctrl-refreshmarkers", "$broadcast[fitlerIcons.mapLayout]");
                $scope.$broadcast('fitlerIcons.mapLayout', params);
            }
        };
        $scope.$onRootScope('resetFilters', function() {
           // traceLog("mapctrl", "$onRootScope->resetFilters()");
            $scope.resetFilters();
        });
        $scope.resetFilters = function() {
           // traceLog("tn-mapctrl-siteload", "called-> resetFilters()");
            var currStateName = $state.$current.name;
           // traceLog("tn-mapctrl-querystring", " calling->updateQueryString(null, null, null, null)");
            $scope.updateQueryString(null, null, null, null);
            $scope.selected = {};
            $scope.bool = {};
            $scope.showUpcomingEventSlider = false;
            $scope.keywordSearched = null;
            $scope.searchKeyword = null;
            $scope.showSubCategoryMenu = false;
            var keywordSearched = false;
            $scope.showEstaEventSlider = true;
            $scope.loadMoreSlider();
            if (angular.element("#keyword_search_mobile").val() || angular.element("#keyword_search").val()) {
                keywordSearched = true;
                angular.element("#keyword_search_mobile").val("");
                angular.element("#keyword_search").val("");
            }
            if (angular.element("#city_search").val()) {
                angular.element("#city_search").val("");
            }
            if (angular.element("#country_search").val()) {
                angular.element("#country_search").val("");
            }
            angular.element("[lpa-keyword]").removeClass("errtxt");
            angular.element("[lpa-keyword]").siblings(".errormsg").hide();
            if (currStateName == "maps.world") {
               // traceLog("tn-mapctrl-siteload", "MapCtrl-> broadcasting[clearMarkers] to clear any marker on map");
                $scope.$broadcast('clearMarkers');
            } else {
                // broadcase map layout to perform
                $scope.$broadcast('resetIcons.mapLayout');
            }
            if (isMobile) {
                angular.element('.mobile-vert-menu').addClass('mobile-hor-menu').removeClass('mobile-vert-menu');
                angular.element(".touchpad-territories").addClass("close-territories");
            }
            $scope.searchedIcons = [];
            $scope.loadPromotionsCalledOnce = false;
            //loadPromotions();
        };
        $scope.$on('getUpcomingEvents', function() {
            $scope.getUpcomingEvents();
        });
        $scope.getUpcomingEvents = function() {
            var currStateName = $state.$current.name;
            $scope.bool.showUpcomingEvents = true;
            $scope.bool.catMenuVisible = false;
            $scope.selected.showUpcomingEvents = true;
            if (currStateName == "maps.world") {
                $scope.showUpcomingEventSlider = true;
                $scope.$broadcast('getUpcomingEventSlider');
            } else {
                $scope.$broadcast('toggleMapImage');
                $scope.bool.selectCityPopup = true;
                localStorageService.set('getUpcomingEvents', 1);
            }
        };
        $scope.mapSatellite = false;
        $scope.showKeywordPopup = function() {
            $scope.$broadcast('toggleMapImage');
            $scope.bool.locationKeywordPopup = true;
            angular.element('#kyloc').addClass('active');
            $('body#body').css('overflow-y', 'scroll');
        };
        $scope.showCatMenu = function() {
            $scope.$broadcast('toggleMapImage');
            $scope.bool.showCatMenu = true;
            if ($scope.bool.showUpcomingEvents) {
                $scope.bool.catMenuVisible = false;
            } else {
                $scope.bool.catMenuVisible = true;
            }
        };
        $scope.hideKeywordPopup = function() {
            $scope.bool.locationKeywordPopup = false;
            angular.element('#kyloc').removeClass('active');
            var inner_map = angular.element('.continental_cont');
            var hasMystyle = inner_map.hasClass('zoomsection');
            if (angular.element("#city_search").val()) {
                $scope.citySearched = angular.element("#city_search").val();
                if (hasMystyle === true) {
                    inner_map.removeClass('zoomsection');
                }
            }
            if (angular.element("#keyword_search_mobile").val()) {
                $scope.keywordSearched = angular.element("#keyword_search_mobile").val();
                if (hasMystyle === true) {
                    inner_map.removeClass('zoomsection');
                }
            }
            if (angular.element("#country_search").val() || angular.element("#country_search").val()) {
                $scope.countrySearched = angular.element("#country_search").val();
                if (hasMystyle === true) {
                    inner_map.removeClass('zoomsection');
                }
            }
        };
        $scope.$onRootScope('keywordSelected', function() {
           // traceLog("tn-mapctrl-siteload", '$scope.$onRootScope keyword selected ');
            var item = JSON.parse(localStorageService.get('selectedKeyword'));
            // console.log('item------->>>', item);
            $scope.keywordSelected(item);
        });
        $scope.keywordSelected = function(item) {
            var currStateName = $state.$current.name;
           // traceLog("mapctrl-keywordsearch", "keyword selected as ", item);
            $scope.selected = {
                keyword: item
            };
            $scope.showSubCategoryMenu = false;
            $scope.bool = {};
            if (currStateName == "maps.world") {
                //$scope.$broadcast('searchIcons', item);
                $scope.refreshMapMarkers({
                    keywordSearched: true
                });
            } else {
                var params = {
                    keyword: item.value
                };
                if (item.id) params.id = item.id;
                if (item.type) params.type = item.type;
                if (currStateName.split(".")[1] != "world") params.countryId = currStateName.split(".")[1];
                // console.log("MapCtrl->keywordSelected(): params is ", params);
                strategicSearch.getResults(params).then(function(res) {
                    $scope.searchedIcons = res;
                    // console.log("MapCtrl->$scope.keywordSelected(): $scope.searchedIcons:", $scope.searchedIcons);
                    $scope.searchedIcons.reverse();
                    if (currStateName == "maps.world") {
                        if ($scope.searchedIcons < 1 && $scope.bool.selectedKeyword) {
                            // console.log("MapCtrl->$scope.keywordSelected(): no results found flagging error:", $scope.searchedIcons);
                            angular.element("[lpa-keyword]").addClass("errtxt");
                            angular.element("[lpa-keyword]").siblings(".errormsg").show();
                            return;
                        }
                        angular.element(".master").remove();
                        // console.log("MapCtrl->$scope.keywordSelected(): placing search icons on maps.world ", $scope.searchedIcons);
                        angular.forEach($scope.searchedIcons, function(value, key) {
                            if (value.state_name == "Us-ak") {
                                value.state_name = "Alaska";
                            }
                            $scope.placeSearchIcons(value);
                        });
                    } else {
                        // console.log("MapCtrl->$scope.keywordSelected(): We are on country layout");
                        angular.element('.mapsection').find('b').remove();
                        if ($scope.searchedIcons.length < 1) {
                            // console.log("MapCtrl->keywordSelected(): As we have not found any data for keyword searched for country id [" + params.countryId + "], removed country id from params and searching again, redirecting to world map ", params);
                            delete params.countryId;
                            //// console.log(params2);
                            strategicSearch.getResults(params).then(function(res) {
                               // traceLog('strategic search response ', res)
                                $location.path('/');
                                $scope.onWideSearch(res);
                            }).catch(function(err) {});
                        }
                        angular.forEach($scope.searchedIcons, function(value, key) {
                            $scope.placeSearchRegionIcons(value);
                        });
                    }
                }).catch(function(err) {
                    // console.log(err);
                });
            }
            // Show all category button is shown just to make sure that user does not get confused with filtered icons and clicks 'All Categories' to remove all filters
            $rootScope.showAllCategory = true;
            $scope.bool.selectedKeyword = true;
            $scope.gotoRemoveclass = true;
        };
        $scope.countrySelected = function(coor) {
            var currStateName = $state.$current.name;
            if (currStateName == "maps.world") {
                var data = {
                    latitude: coor.lat,
                    longitude: coor.long,
                    zoom: coor.zoom_level
                };
                $scope.$broadcast('loadLocationMap', data);
            } else {
                $location.path('/').search({
                    'at': coor.long + "," + coor.lat
                });
            }
        };
        $scope.$on('widesearch', function(evt, args) {
            $scope.onWideSearch(args);
        });
        $scope.onWideSearch = function(args) {
            $scope.wideSearch = true;
            $scope.searchedIcons = args;
            $timeout(function() {
                $scope.$broadcast('toggleMapImage');
                $rootScope.showAllCategory = true;
                $scope.bool.selectedKeyword = true;
                $scope.wideSearch = false;
            }, 1000);
        };
        $rootScope.back = function() {
            $window.history.back();
        };
        $scope.$onRootScope('repositionSearchedIcons', function() {
            var currStateName = $state.$current.name;
            if ($scope.searchedIcons && $scope.searchedIcons.length > 0) {
                angular.element(".master").remove();
                angular.element('.mapsection>map').find('b').remove();
            }
            if (currStateName == "maps.world") {
                angular.forEach($scope.searchedIcons, function(value, key) {
                    if (value.state_name == "Us-ak") {
                        value.state_name = "Alaska";
                    }
                    $scope.placeSearchIcons(value);
                });
            } else {
                angular.forEach($scope.searchedIcons, function(value, key) {
                    $scope.placeSearchRegionIcons(value);
                });
            }
        });
        $rootScope.disableTooltip = false;
        $scope.placeSearchIcons = function(value) {
            var pathId;
            if (value.sector && value.sector != "") {
                pathId = value.sector;
            } else if (value.sector_code && value.sector_code != "") {
                pathId = value.sector_code;
            } else if (value.state_name == 'Hawaii') {
                pathId = 'Hawaii_2';
            } else if (value.state_name == 'Alaska') {
                pathId = 'Alaska';
            } else {
                if (value.country_name == 'Canada') {
                    value.country_name = 'canada';
                } else if (value.country_name == 'USA' || value.country_name == 'United States') {
                    value.country_name = 'us';
                } else if (value.country_name == 'China') {
                    value.country_name = 'china';
                } else if (value.country_name == 'Russia') {
                    value.country_name = 'rus';
                } else if (value.country_name == 'India') {
                    value.country_name = 'india';
                }
                pathId = value.country_name;
            }
            jQuery("#loadImage").css("display", "block");
            // console.log("path id is ", pathId);
            if (!pathId || pathId.length == 0) return;
            pathId = pathId.replace(new RegExp(' ', 'g'), "_");
            if (angular.element('.master').hasClass(pathId)) return;
            var genreId = 0;
            var shape = jQuery('#' + pathId).attr('shape');
            var coords = jQuery('#' + pathId).attr('coords');
            if (isMobile) {
                var shape = 'circle';
                var coords = countriesData.getCountryCoords(pathId);
                //// console.log(coords);
            }
            if (!coords) return;
            var center = $scope.getAreaCenter(shape, coords);
            if (isMobile) {
                // values for mobile
                var l = center[0] - 3.5;
                var t = center[1] - 12;
            } else {
                // values for desktop
                var l = center[0] - 11;
                var t = center[1] - 37;
            }
            var class_growIcon = "";
            if (value.image == undefined)
                value.image = 'event_center.png';
            var src = $rootScope.genreBaseUrl + value.image;
            if (value.use_personal_icon) {
                src = $rootScope.imageBaseUrl + value.image;
                // src = "//iconoglobe.com/i-i/" + value.image;
                class_growIcon = "grow-icon";
            }
            if (isMobile) {
                angular.element("#the_image").before("<a class='master continental' style='width:7px;position:absolute;left:" + l + "px;top:" + t + "px;'><img width='7' class='world_map' style='width:7px;'  src='" + src + "'/></a>");
                angular.element('.main_container').scrollLeft(l - 20);
                return;
            }
            if (value.state_name != "Alaska") {
                angular.element("#Map").parent().append($compile("<a icon-tool-tip class='master continental " + pathId + " " + genreId + " " + class_growIcon + "' href='javascript:void(0);' data-href='" + jQuery("#" + pathId).attr('data-href') + "' style='width:22px;position:absolute;left:" + l + "px;top:" + t + "px;'><img width='22' class='world_map' style='width:22px;'  src='" + src + "'/></a>")($scope));
            } else {
                angular.element("#Map").parent().append($compile("<a icon-tool-tip class='master continental " + pathId + " " + genreId + " " + class_growIcon + "' href='javascript:void(0);' data-href='" + jQuery("#" + pathId).attr('data-href') + "' style='width:22px;position:absolute;left:" + l + "px;top:" + t + "px;'><img width='22' class='world_map' style='width:22px;' src='" + src + "'/></a>")($scope));
            }
            /* if (value.state_name != "Alaska") {
            angular.element("#Map").parent().append($compile("<a class='master continental " + pathId + " " + genreId + " " + class_growIcon + "' href='javascript:void(0);' data-href='" + jQuery("#" + pathId).attr('data-href') + "' style='width:25px;position:absolute;left:" + l + "px;top:" + t + "px;'><img width='30' class='world_map' style='width:25px;'  src='" + src + "'/></a>")($scope));
            } else {
            angular.element("#Map").parent().append($compile("<a class='master continental " + pathId + " " + genreId + " " + class_growIcon + "' href='javascript:void(0);' data-href='" + jQuery("#" + pathId).attr('data-href') + "' style='width:25px;position:absolute;left:" + l + "px;top:" + t + "px;'><img width='30' class='world_map' style='width:25px;' src='" + src + "'/></a>")($scope));
            } */
            jQuery("#loadImage").css("display", "none");
            if (!$rootScope.disableTooltip) {
                $rootScope.disableTooltip = true;
            }
        };
       /* $scope.loadPromotionsOnHomePage = function(requestData) {
            // console.log("requestDatahomePage", requestData);
            var promotionSliderRequestID = (new Date()).getTime()
           // traceLog("slider-load-request", "loadPromotionsOnHomePage() ", promotionSliderRequestID);
            var sliderPromotions = localStorageService.get("sliderPromotionsForLocation");
            $scope.promotionSliderRequestID = promotionSliderRequestID;
            if (sliderPromotions && sliderPromotions.trim() !== '') {
                // console.log("<<<<<<<<<<<<<<<<<<<<<< loading promotion slider data from cache >>>>>>>>>>>>>>>>>>>>>>>" + new Date().getTime());
                sliderPromotions = JSON.parse(sliderPromotions);
                //// console.log(sliderPromotions);
                if (Array.isArray(sliderPromotions)) {
                    $scope.updateSliderPromotions(sliderPromotions, promotionSliderRequestID);
                }
            }
           // traceLog("tn-promotions", "request -> loadPromotionsOnDragMap", requestData);
            if (!requestData.lat || !requestData.long) {
                requestData.lat = 0;
                requestData.long = 0;
            }
           // traceLog("tn-promotions", "calling-> /data/ : data: ", requestData);
            // Promotion Search if for country
            requestData.locationType = 'homePage'
            // This would destroy existing promotion sliders so that only new promotions are shown
            $http.post("/data/sliderPromotionsForLocation", requestData).then(function(res) {
               // traceLog("tn-promotions", "/data/sliderPromotionsForLocation", res);
                var sliderPromotions = res.data;
                if (Array.isArray(sliderPromotions)) {
                    $scope.updateSliderPromotions(sliderPromotions, promotionSliderRequestID)
                }
            }, function(err) {});
        }
        $scope.updateSliderPromotions = function(sliderPromotions, promotionSliderRequestID) {
            localStorageService.set("sliderPromotionsForLocation", JSON.stringify(sliderPromotions));
            // Change promotion slider only for latest request to prevent simultaneous requests trying to update same slider
            if (!$scope.promotionSliderRequestID || $scope.promotionSliderRequestID == promotionSliderRequestID) {
               // traceLog("slider-load-request", "matched: ", promotionSliderRequestID)
                $scope.promotionsChanged = false;
                //$rootScope.loadPromoSlider.festivals = true;
                // $rootScope.loadPromoSlider.gaming = true;
                // $rootScope.loadPromoSlider.museums = true;
                // $rootScope.loadPromoSlider.music = true;
                // $rootScope.loadPromoSlider.nature = true;
                //  $rootScope.loadPromoSlider.sports = true;
                //  $rootScope.loadPromoSlider.children = true;
                $scope.slickAdventures = sliderPromotions[0].promotions;
                $scope.slickFestivals = sliderPromotions[1].promotions;
                $rootScope.loadPromoSlider.gaming ? $scope.slickGaming = sliderPromotions[2].promotions : $scope.slickSlider3 = sliderPromotions[2].promotions;
                $rootScope.loadPromoSlider.museums ? $scope.slickMuseums = sliderPromotions[3].promotions : $scope.slickSlider4 = sliderPromotions[3].promotions;
                $rootScope.loadPromoSlider.music ? $scope.slickMusic = sliderPromotions[4].promotions : $scope.slickSlider5 = sliderPromotions[4].promotions;
                $rootScope.loadPromoSlider.nature ? $scope.slickNature = sliderPromotions[5].promotions : $scope.slickSlider6 = sliderPromotions[5].promotions;
                $rootScope.loadPromoSlider.sports ? $scope.slickSports = sliderPromotions[6].promotions : $scope.slickSlider7 = sliderPromotions[6].promotions;
                $rootScope.loadPromoSlider.children ? $scope.slickChildrens = sliderPromotions[7].promotions : $scope.slickSlider8 = sliderPromotions[7].promotions;
                $scope.promotionsChanged = true;
            }
        }
       */
       
        $scope.placeSearchRegionIcons = function(value) {
            var i, x = [],
                y = [];
            var genreId = 0;
            if (value.genreId) {
                genreId = value.genreId;
            }
            var x_coord = 0,
                y_coord = 0,
                count = 0,
                j = 0;
            var pathId;
            if (value.sector && value.sector != "") {
                pathId = value.sector;
            } else {
                pathId = value.state_code;
            }
            if (!pathId) return;
            pathId = pathId.replace(new RegExp(' ', 'g'), "_");
            if (angular.element('.master').hasClass(pathId)) return;
            var pathHref = jQuery("#" + pathId).attr('data-href');
            var shape = jQuery('#' + pathId).attr('shape');
            var coords = jQuery('#' + pathId).attr('coords');
            if (isMobile) {
                var shape = 'circle';
                var ngState = $state.$current.name.split(".")[1];
                var coords = countriesData.getStateCoords(ngState, pathId);
            }
            if (!coords) return;
            var center = $scope.getAreaCenter(shape, coords);
            if (isMobile) {
                // values for mobile
                var l = center[0] - 3.5;
                var t = center[1] - 12;
            } else {
                // values for desktop
                var l = center[0] - 11;
                var t = center[1] - 37;
            }
            if (typeof(value.image) != 'undefined') {
                var src = $rootScope.genreBaseUrl + value.image;
                var class_growIcon = "";
                if (value.use_personal_icon) {
                    src = $rootScope.imageBaseUrl + value.image;
                    //src = "//iconoglobe.com/i-i/" + value.image;
                    class_growIcon = 'grow-icon';
                }
                if (isMobile) {
                    angular.element("#reg_map").before("<b class='" + pathId + " " + genreId + " " + class_growIcon + "'>" + '<a icon-tool-tip href="javascript:void(0)" data-href="' + pathHref + '" class="master" title="' + value.msg + '"><img width=7 class="world_map" style="width:7px;position:absolute;left:' + l + 'px;top:' + t + 'px" src=' + src + '>' + "</a></b>");
                    return;
                }
                angular.element('#Map').append($compile("<a icon-tool-tip class='master " + pathId + " " + genreId + " " + class_growIcon + "' href='javascript:void(0);' data-href='" + pathHref + "' style='width:22px;position:absolute;left:" + l + "px;top:" + t + "px;'><img width='22' class='world_map' style='width:22px;' src='" + src + "'/></a>")($scope));
            }
            if (!$rootScope.disableTooltip) {
                $rootScope.disableTooltip = true;
            }
        };
        $scope.getAreaCenter = function(shape, coords) {
            var coordsArray = coords.split(','),
                center = [];
            if (shape == 'circle' || coordsArray.length < 4) {
                // For circle areas the center is given by the first two values
                center = [parseInt(coordsArray[0]), parseInt(coordsArray[1])];
                if (isMobile) {
                    var img = angular.element("#the_image");
                    if ($state.$current.name != 'maps.world') {
                        var img = angular.element("#reg_map");
                    }
                    var iwidth = img.width();
                    var iheight = img.height();
                    var nwidth = img.get(0).naturalWidth;
                    var nheight = img.get(0).naturalHeight;
                    var x = parseInt(((coordsArray[0] / nwidth)) * iwidth);
                    var y = parseInt(((coordsArray[1] / nheight)) * iheight);
                    center = [x, y];
                }
            } else {
                // For rect and poly areas we need to loop through the coordinates
                var coord;
                var xCoords = [];
                var yCoords = [];
                for (var i = 0, l = coordsArray.length; i < l; i++) {
                    coord = parseInt(coordsArray[i], 10);
                    if (i % 2 == 0) { // Even values are X coordinates
                        xCoords.push(coord);
                    } else { // Odd values are Y coordinates
                        yCoords.push(coord);
                    }
                }
                var minX = Math.min.apply(null, xCoords);
                var maxX = Math.max.apply(null, xCoords);
                var minY = Math.min.apply(null, yCoords);
                var maxY = Math.max.apply(null, yCoords);
                center = [parseInt((minX + maxX) / 2, 10), parseInt((minY + maxY) / 2, 10), minX, minY, maxX, maxY];
                // var ptx = parseInt(xCoords.reduce(add, 0)/xCoords.length, 10);
                // var pty = parseInt(yCoords.reduce(add, 0)/yCoords.length, 10);
                // center = [ptx, pty];
            }
            return (center);
        };
        $scope.showMyLocation = function() {
            var currStateName = $state.$current.name;
            UserLocation.silently().then(function(user) {
                if (currStateName == "maps.world") {
                   // traceLog("tn-mapctrl-urlchange", "mapctrl->showMyLocation() current state name is 'maps.world', url parameters: ", {                        "at": user.long + "," + user.lat,                    });
                    $location.search({
                        "at": user.long + "," + user.lat,
                    });
                    localStorageService.set('city_lat', user.lat);
                    localStorageService.set('city_lng', user.long);
                    var coor = {
                        latitude: user.lat,
                        longitude: user.long,
                        zoom: 10
                    };
                    $scope.$broadcast('loadLocationMap', coor);
                } else {
                    localStorageService.set('geo_search', 1);
                    $location.path('/').search({
                        "at": user.long + "," + user.lat,
                    });
                }
            });
        };
        $scope.gotomap = function(path) {
            $scope.allIcons = [];
            angular.element('.tooltip').remove();
            var page = $location.path();
            page = page.split(",");
            if (page[0] != "/") {
                if (path.indexOf("st") > -1) {
                    path = path.split("/");
                    $location.search({
                        'sector_code': path[1]
                    });
                    return;
                } else {
                    $location.search({
                        'state_code': path
                    });
                }
            } else {
                if (path.indexOf("tn") > -1) {
                    path = path.split("/");
                    $location.search({
                        'state_code': path[1]
                    });
                } else if (path.indexOf("ot") > -1) {
                    path = path.split("/");
                    $location.search({
                        'country_code': path[1]
                    });
                } else {
                    $location.path(path);
                }
            }
        };
        $scope.toggleVerticalMenu = function() {
            $scope.bool.showVerticalMenu = !$scope.bool.showVerticalMenu;
        };
        $scope.closePromotionModal = function() {
            $scope.modalInstance.dismiss();
        };
        //  promotional carousel controller
        $rootScope.loadPromoSlider = {};
        var galleryImage, bannerImage, promotionInfo = false,
            clickPosition;
        $scope.bringInPromotion = function(data) {
            $('#promotion-detail .card__image').click();
            cash('#promotion-detail .card__image').trigger('click');
            $('body').css({
                height: '100vh',
                overflow: 'hidden'
            });
            $('#promotion-detail .card__container').css({
                display: "block"
            });
            $('#promotion-detail').css({
                'display': "block",
                'opacity': 1,
                'z-index': 999999999
            });
            $timeout(function() {
                $('#promotion-detail .card__image').click();
                cash('#promotion-detail .card__image').trigger('click');
            }, 1);
        };




        $scope.openBannerModal = function(item) {
            if (item.center_screen == "0") {
                $scope.modalInstance = $uibModal.open({
                    animation: false,
                    templateUrl: 'app/min/promotion-image.html',
                    scope: $scope,
                    windowClass: "lightbox-modal darker-backdrop zindexModal int117"
                });
            } else {
                $scope.modalInstance = $uibModal.open({
                    animation: false,
                    templateUrl: 'app/min/promotion-video.html',
                    scope: $scope,
                    windowClass: "lightbox-modal darker-backdrop zindexModal int118"
                });
            }
            $scope.modalInstance.result.then(function(selectedItem) {
                $scope.closePromotionModal();
            }, function() {});
        };
        // Promotion listings already include linked establishment records in ee/linkedTo.
        function igPromotionLinkedEstablishment(p) {
            function unpack(value) {
                if (!value) return [];
                if (typeof value === 'string') {
                    try { value = JSON.parse(value); }
                    catch (err) { console.warn('Invalid promotion link data:', err); return []; }
                }
                return Array.isArray(value) ? value : (typeof value === 'object' ? [value] : []);
            }
            var records = unpack(p.ee);
            if (!records.length) records = unpack(p.linkedTo);
            return records.find(function(item) {
                return item && typeof item === 'object' && item.id &&
                    (item.is_establish === 1 || item.is_establish === '1' ||
                     item.stream_type === 0 || item.stream_type === '0' ||
                     !!item.establish_name);
            }) || null;
        }

        $scope.getPromotionDetails = function(e, slideName, slideImages, id, p) { 
            console.log("getinfoP",p);
            $('body,html').animate({
                scrollTop: 0
            }, 'fast');
           
            if (p.on_click == '0') {
                return;
            }

            // Click type 1 opens the linked establishment's existing profile.
            // Do not load the legacy promotion-detail popup or navigate externally.
            if (p.on_click == '1') {
                if (e) { e.preventDefault(); e.stopPropagation(); }
                var linkedEstablishment = igPromotionLinkedEstablishment(p);
                if (!linkedEstablishment) {
                    console.warn('Promotion has no linked establishment:', id);
                    return;
                }
                $scope.igupOfflineOpen = false;
                return $scope.getEstaEEprofile(linkedEstablishment.id, null, false,
                    undefined, undefined, undefined, undefined, true);
            }

            if (p.on_click == '2') {
                if (slideName && slideImages && slideImages.length > 0) {
                    $scope.popupSlider = slideImages;
                    $scope.popupHeading = slideName;
                }
                clickPosition = {
                    pos: $(e.currentTarget).offset(),
                    width: $(e.currentTarget).width(),
                    height: $(e.currentTarget).height(),
                };
                $scope.promotionPos = {
                    "left": clickPosition.pos.left,
                    "top": clickPosition.pos.top
                };
                $scope.promotionCardStyle = {
                    "width": clickPosition.width,
                    "padding-bottom": clickPosition.height
                };
                $scope.loadingPromotionDetails = true;
                galleryImage = 0;
                bannerImage = 0;
                $http.get('/api/getpromotiondetails/' + id).then(function(res) {
                    $scope.sliderData = res.data;
                    // console.log('sliderData--', $scope.sliderData);
                    $('body').css({
                        height: '100vh',
                        overflow: 'hidden'
                    });
                    $('#promotion-detail .card__container').css({
                        display: "block"
                    });
                    $('#card-content').animate({
                        scrollTop: 0
                    }, 1);
                    $('#promotionwrap').animate({
                        scrollTop: 0
                    }, 1);
                    $('#promotion-detail').css({
                        'display': "block",
                        'opacity': 1,
                        'z-index': 999999999
                    });
                }, function(err) {});
            };
        };
        $scope.days = ['Sunday', "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        $scope.promotionImageLoaded = function(type) {
            // galleryImage = galleryImage + 1;
            // $scope.loadingPromotionDetails = false;
            // if(promotionInfo) {
            // $('#card-content').animate({
            // scrollTop: 0
            // }, 'slow');
            // $scope.$apply();
            // } else{
            //   promotionInfo = true;
            //   $scope.bringInPromotion(clickPosition);
            // }
        };
        //$scope.startAnimation = function() { $scope.loadingPromotionDetails = false; if (promotionInfo) { $('#card-content').animate({scrollTop: 0 }, 'fast'); $scope.$apply(); } else { promotionInfo = true; $scope.bringInPromotion(clickPosition); } };
        $scope.bodyScrollHide = function() {
            $('body').css({
                height: '100vh',
                overflow: 'hidden'
            });
            $timeout(function() {
                $('#promotion-detail .card__container').css({
                    display: "block"
                });
                $('.search-header').css({
                    'z-index': 9
                });
            }, 10);
        };
        $scope.bodyScrollShow = function() {
            if (angular.element('#promotion-detail').hasClass('poster')) {
                angular.element('#promotion-detail').removeClass('poster');
            }
            //// console.log('bodyscrollshow');
            promotionInfo = false;
            $('#promotion-detail').css({
                display: 'none'
            });
            $('#card-content').animate({
                scrollTop: 0
            }, 10);
            $('body').css({
                height: 'auto',
                overflow: 'auto'
            });
        };

        $scope.showEELocation = function(e, url, lat, lng) {
            $('#promotion-detail').css({
                'display': 'none',
                'z-index': -1
            });
            $scope.bodyScrollShow();
            $timeout(function() {
                $('body,html').animate({
                    scrollTop: 0
                }, 'fast');
                angular.element('.card__btn-close').trigger('click');
                var selectedKeyword = {
                    type: $scope.sliderData.type,
                    id: $scope.sliderData.event_id ? $scope.sliderData.event_id : $scope.sliderData.esta_id,
                    is_brand: $scope.sliderData.is_brand
                };
                var showProfile = {
                    type: $scope.sliderData.type,
                    event: $scope.sliderData.event_id,
                    esta: $scope.sliderData.esta_id,
                    mainEvent: $scope.sliderData.main_event_id,
                    is_brand: $scope.sliderData.is_brand
                };
                var currStateName = $state.$current.name;
                if (currStateName == "maps.world") {
                    $('.keyword_search').val($scope.sliderData.name);
                    $('.keyword_search_mobile').val($scope.sliderData.name);
                    selectedKeyword.url = url;
                    selectedKeyword.mainEvent = $scope.sliderData.main_event_id;
                    selectedKeyword.estaId = $scope.sliderData.esta_id;
                    selectedKeyword.name = $scope.sliderData.name;
                    selectedKeyword.geocode = $scope.sliderData.longitude + "," + $scope.sliderData.latitude;
                    $rootScope.$broadcast('showPromotionLocation', selectedKeyword);
                } else {
                    localStorageService.set('showProfile', JSON.stringify(showProfile));
                    localStorageService.set('selectedKeyword', JSON.stringify(selectedKeyword));
                    $('.keyword_search').val($scope.sliderData.name);
                    $('.keyword_search_mobile').val($scope.sliderData.name);
                    $location.path('/').search("at", lng + "," + lat);
                    $rootScope.$emit('keywordSelected');
                }
            });
        };
        $scope.showLocation = function(e, url, lat, lng) {

            $('#promotion-detail').css({
                'display': 'none',
                'z-index': -1
            });
            $scope.bodyScrollShow();
            $timeout(function() {
                $('body,html').animate({
                    scrollTop: 0
                }, 'fast');
                angular.element('.card__btn-close').trigger('click');
                var selectedKeyword = {
                    type: $scope.sliderData.type,
                    id: $scope.sliderData.event_id ? $scope.sliderData.event_id : $scope.sliderData.esta_id,
                    is_brand: $scope.sliderData.is_brand
                };
                var showProfile = {
                    type: $scope.sliderData.type,
                    event: $scope.sliderData.event_id,
                    esta: $scope.sliderData.esta_id,
                    mainEvent: $scope.sliderData.main_event_id,
                    is_brand: $scope.sliderData.is_brand
                };
                var currStateName = $state.$current.name;
                if (currStateName == "maps.world") {
                    $('.keyword_search').val($scope.sliderData.name);
                    $('.keyword_search_mobile').val($scope.sliderData.name);
                    selectedKeyword.url = url;
                    selectedKeyword.mainEvent = $scope.sliderData.main_event_id;
                    selectedKeyword.estaId = $scope.sliderData.esta_id;
                    selectedKeyword.name = $scope.sliderData.name;
                    selectedKeyword.geocode = $scope.sliderData.longitude + "," + $scope.sliderData.latitude;
                    $rootScope.$broadcast('showPromotionLocation', selectedKeyword);
                } else {
                    localStorageService.set('showProfile', JSON.stringify(showProfile));
                    localStorageService.set('selectedKeyword', JSON.stringify(selectedKeyword));
                    $('.keyword_search').val($scope.sliderData.name);
                    $('.keyword_search_mobile').val($scope.sliderData.name);
                    $location.path('/').search("at", lng + "," + lat);
                    $rootScope.$emit('keywordSelected');
                }
            });
        };
        $scope.sort_by = function(field, reverse, primer) {
            var key = primer ?
                function(x) {
                    return primer(x[field]);
                } :
                function(x) {
                    return x[field];
                };
            reverse = !reverse ? 1 : -1;
            return function(a, b) {
                //// console.log(key(a), key(b));
                return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
            };
        };
        $scope.sortPromotions = function(promotions) {
            var closest = []; // < 50
            var close = []; // < 100
            var far = []; // < 250
            var further = []; // < 500
            var furthermost = []; // > 500
            angular.forEach(promotions, function(v) {
                if (v.distance <= 50) {
                    closest.push(v);
                } else if (v.distance <= 100) {
                    close.push(v);
                } else if (v.distance <= 250) {
                    far.push(v);
                } else if (v.distance <= 500) {
                    further.push(v);
                } else {
                    furthermost.push(v);
                }
            });
            closest = $scope.shuffle(closest);
            close = $scope.shuffle(close);
            far = $scope.shuffle(far);
            further = $scope.shuffle(further);
            furthermost = $scope.shuffle(furthermost);
        };
        $scope.shuffle = function(array) {
            var currentIndex = array.length,
                temporaryValue, randomIndex;
            // While there remain elements to shuffle...
            while (0 !== currentIndex) {
                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;
                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            return array;
        };
        $scope.breakpoints = [{
            breakpoint: 9000,
            settings: {
                slidesToShow: 5,
                infinite: false,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 1500,
            settings: {
                slidesToShow: 4,
                infinite: false,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                infinite: false,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 1100,
            settings: {
                slidesToShow: 4,
                infinite: false,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 900,
            settings: {
                slidesToShow: 3,
                infinite: false,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 700,
            settings: {
                slidesToShow: 2,
                infinite: false,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                infinite: false,
                slidesToScroll: 2
            }
        }];
        // show msg
        $scope.openUserinfoModal = function(item) {
            $scope.userInfoInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/min/user-info.html',
                scope: $scope,
                windowClass: "lightbox-modal darker-backdrop zindexModal int119"
            });
            $scope.userInfoInstance.result.then(function(selectedItem) {
                $scope.closeUserinfoModal();
            }, function() {});
        };
        $scope.closeUserinfoModal = function() {
            $scope.userInfoInstance.dismiss();
        };
        $scope.resetUpcomingSlider = function() {
           // traceLog("mapctrl-resetUpcomingSlider start ")
            if ($scope.bool.showUpcomingEvents) {
               // traceLog("mapctrl-resetUpcomingSlider inside if ")
                $scope.$broadcast("resetUpcomingSlider");
            }
        }
        $scope.checkElementIdExits = function(itemArray, item) {
            if (itemArray.indexOf(item) > -1) {
                return true;
            } else {
                return false;
            }
        }
        $scope.checkObjectElementIdExits = function(itemArray, item) {
            var itemIndex = itemArray.map(function(singleObject) {
                return singleObject.genre_id;
            }).indexOf(item);
            if (itemIndex > -1)
                return true;
            else
                return false;
        }
        $scope.checkUpcomingEventVisibility = function(event) {
            //traceLog("mapctrl-checkUpcomingEventVisibility selected :- ",$scope.selected);
            //traceLog("mapctrl-checkUpcomingEventVisibility event :- ",event);
            if (!$scope.selected.subcategory_id || $scope.selected.subcategory_id == event.subcategory_id) {
                if (!$scope.selected.childcategory_id && !$scope.selected.genre_id)
                    return true;
                else {
                    if (!$scope.selected.childcategory_id || $scope.checkElementIdExits(event.childcategory_id, $scope.selected.childcategory_id)) {
                       // traceLog("mapctrl-checkUpcomingEventVisibility inside childcategory");
                        if (!$scope.selected.genre_id)
                            return true;
                        else {
                            if (!Array.isArray(event.genre)) {
                                event.genre = [event.genre];
                            }
                           // traceLog("mapctrl-checkUpcomingEventVisibility inside return method", $scope.checkObjectElementIdExits(event.genre, $scope.selected.genre_id));
                            if (!$scope.selected.genre_id || $scope.checkObjectElementIdExits(event.genre, $scope.selected.genre_id)) {
                               // traceLog("mapctrl-checkUpcomingEventVisibility inside genre");
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        }
        $scope.getNotifiedPromotion = function(estaId, eventId, event_linked_id) {
            if (estaId || eventId || event_linked_id) {
                if (!localStorageService.get('name')) {
                    $scope.modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'sign_in_modal.html',
                        windowClass: 'zindexModal int120',
                        scope: $scope,
						appendTo: angular.element(document.body)
                    });
                    $scope.modalInstance.result.then(function(selectedItem) {
                        $scope.closeModal();
                        $http.post('/establishment/saveNotificationIcon', {
                            estaId: estaId,
                            eventId: eventId,
                            event_linked_id: event_linked_id,
                        }).then(function(res) {
                            var response = res.data;
                            /*   $rootScope.message = $filter('translate')(response.message);
                            $rootScope.notification = true;*/
                            localStorage.setItem('notification', "true");
                            localStorage.setItem('msg', $rootScope.message);
                            $scope.message = $filter('translate')(response.message);
                        });
                    }, function() {
                        $scope.closeModal();
                        $http.post('/establishment/saveNotificationIcon', {
                            estaId: estaId,
                            eventId: eventId,
                            event_linked_id: event_linked_id,
                        }).then(function(res) {
                            var response = res.data;
                            /*$rootScope.message = $filter('translate')(response.message);
                            $rootScope.notification = true;*/
                            localStorage.setItem('notification', "true");
                            localStorage.setItem('msg', $rootScope.message);
                            $scope.message = $filter('translate')(response.message);
                        });
                    });
                } else {
                    $http.post('/establishment/saveNotificationIcon', {
                        estaId: estaId,
                        eventId: eventId,
                        event_linked_id: event_linked_id,
                    }).then(function(res) {
                        var response = res.data;
                        $scope.message = $filter('translate')(response.message);
                        // $("#pop_up_notification_modal").modal("show");
                        $scope.modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'pop_up_notification_modal.html',
                            windowClass: 'zindexModal int121',
                            scope: $scope,
                        });
                        $scope.modalInstance.result.then(function(selectedItem) {
                            $scope.closeModal();
                        }, function() {
                            $scope.closeModal();
                        });
                    });
                }
            }
        };
        $scope.closeModal = function() {
            $scope.modalInstance.dismiss();
			 $scope.PopupModal = false;
			 window.scrollTo(0, 0);
        };
  




  if (currStateName != "maps.world") {
            $rootScope.showFooter = true;
        }
        $scope.promotionSliderRequestID = undefined
       /* $scope.loadPromotionsOnCitySelection = function(requestData) {
            var promotionSliderRequestID = (new Date()).getTime()
            $scope.promotionSliderRequestID = promotionSliderRequestID
    
            if (!requestData.lat || !requestData.long) {
                requestData.lat = 0;
                requestData.long = 0;
            }
    
            requestData.locationType = 'city'
 
            $http.post("/data/sliderPromotionsForLocation", requestData).then(function(res) {
       
                var sliderPromotions = res.data;
                if (Array.isArray(sliderPromotions)) {
                    $scope.updateSliderPromotions(sliderPromotions, promotionSliderRequestID)
                }
            }, function(err) {});
        }




        $scope.loadPromotionsOnDragMap = function(requestData) {
            // console.log("requestDatadrag", requestData);
            var promotionSliderRequestID = (new Date()).getTime()
           // traceLog("slider-load-request", "loadPromotionsOnDragMap() ", promotionSliderRequestID)
            $scope.promotionSliderRequestID = promotionSliderRequestID
           // traceLog("tn-promotions", "request -> loadPromotionsOnDragMap", requestData);
            if (!requestData.lat || !requestData.long) {
                requestData.lat = 0;
                requestData.long = 0;
            }
            var element = document.getElementById('app-body');
            var position = element.getBoundingClientRect();
            var y = position.top;
            if (y > -1) {
                requestData.pgld = 0;
            } else {
                requestData.pgld = 1;
            }
            // console.log("##############requestData.pgld", requestData.pgld);
           // traceLog("tn-promotions", "calling-> /data/sliderPromotionsForLocation: data: ", requestData);
            // Promotion Search if for country
            requestData.locationType = 'drag'
            // This would destroy existing promotion sliders so that only new promotions are shown
            $http.post("/data/sliderPromotionsForLocation", requestData).then(function(res) {
               // traceLog("tn-promotions", "/data/sliderPromotionsForLocation", res);
                var sliderPromotions = res.data;
                if (Array.isArray(sliderPromotions)) {
                    $scope.updateSliderPromotions(sliderPromotions, promotionSliderRequestID)
                }
            }, function(err) {});
        }
     
        $scope.loadHangingOrSkyScrapperPromotionsOnCitySelection = function(requestData, promotionType) {




            var request = Object.assign({}, requestData, {
                promotionType: promotionType,
                locationType: 'city'
            });
            $http.post("/data/hangingOrSkyScrapperPromotionsForLocation", request).then(function(response) {

               // traceLog("tn-mapctrl-loadHangingOrSkyScrapperPromotionsOnCitySelection", "response -> /data/loadHangingOrSkyScrapperPromotionsOnCitySelection ", response);

                if (request.promotionType == 'is_hanging' && Array.isArray(response.data) && response.data.length > 0) {
                    var hangingPromotions = [];
                    angular.forEach(response.data, function(v) {
                        $scope.hangingPromotion = hangingPromotions
                        $scope.hangingPromotion.push(v);
                    });
                } else if (request.promotionType == 'is_skyscrapper' && Array.isArray(response.data) && response.data.length > 0) {
                    var skyscrappperPromotions = [];
                    angular.forEach(response.data, function(r) {
                        $scope.skyscrappperPromotion = skyscrappperPromotions
                        $scope.skyscrappperPromotion.push(r);
                    });
                }
            }, function(err) {
               // traceLog("tn-mapctrl-loadHangingOrSkyScrapperPromotionsOnCitySelection inside err", err);
            });
        }




        $scope.loadHangingOrSkyScrapperPromotionsOnHomePage = function(requestData, promotionType) {
            // console.log("#############SkyScrapperPromotionsOnHomePage", promotionType);

            if (!requestData.lat || !requestData.long) {
                requestData.lat = 0;
                requestData.long = 0;
            }

            var request = Object.assign({}, requestData, {
                promotionType: promotionType,
                locationType: 'homePage'
            });
            $http.post("/data/hangingOrSkyScrapperPromotionsForLocation", request).then(function(response) {

               // traceLog("tn-mapctrl-loadHangingOrSkyScrapperPromotionsOnHomePage", "response -> /data/loadHangingOrSkyScrapperPromotionsOnHomePage ", response);

                if (request.promotionType == 'is_hanging' && Array.isArray(response.data) && response.data.length > 0) {
                    var hangingPromotions = [];
                    angular.forEach(response.data, function(v) {
                        $scope.hangingPromotion = hangingPromotions
                        $scope.hangingPromotion.push(v);
                    });
                } else if (request.promotionType == 'is_skyscrapper' && Array.isArray(response.data) && response.data.length > 0) {
                    var skyscrappperPromotions = [];
                    angular.forEach(response.data, function(r) {
                        $scope.skyscrappperPromotion = skyscrappperPromotions
                        $scope.skyscrappperPromotion.push(r);
                    });
                }
            }, function(err) {
               // traceLog("tn-mapctrl-loadHangingOrSkyScrapperPromotionsOnHomePage inside err", err);
            });
        };*/




























    /*    $scope.loadHangingOrSkyScrapperPromotionsOnDragMap = function(requestData, promotionType) {
            // console.log("##########loadHangingOrSkyScrapperPromotionsOnDragMap", promotionType);
            if (!requestData.lat || !requestData.long) {
                requestData.lat = 0;
                requestData.long = 0;
            }
            var request = Object.assign({}, requestData, {
                promotionType: promotionType,
                locationType: 'drag'
            });
            $http.post("/data/hangingOrSkyScrapperPromotionsForLocation", request).then(function(response) {
               // traceLog("tn-mapctrl-loadHangingOrSkyScrapperPromotionsOnDragMap", "response -> /data/loadHangingOrSkyScrapperPromotionsOnDragMap ", response);
                if (request.promotionType == 'is_hanging' && Array.isArray(response.data) && response.data.length > 0) {
                    var hangingPromotions = [];
                    angular.forEach(response.data, function(v) {
                        $scope.hangingPromotion = hangingPromotions
                        $scope.hangingPromotion.push(v);
                    });
                } else if (request.promotionType == 'is_skyscrapper' && Array.isArray(response.data) && response.data.length > 0) {
                    var skyscrappperPromotions = [];
                    angular.forEach(response.data, function(r) {
                        $scope.skyscrappperPromotion = skyscrappperPromotions
                        $scope.skyscrappperPromotion.push(r);
                    });
                }
            }, function(err) {
               // traceLog("tn-mapctrl-loadHangingOrSkyScrapperPromotionsOnDragMap inside err", err);
            });
        }
        */
        /*end hanging or skyscrapper Promotion from here */
       // traceLog("tn-mapctrl-siteload", "MapCtrl-> ended loading");

        $rootScope.imgclass = function() {
            var images = document.getElementsByTagName('img');
            for (var i = 0; i < images.length; i++) {
                if (images[i].naturalWidth > images[i].naturalHeight) {
                    $(images[i]).addClass('landscape');

                } else {
                    if (images[i].naturalWidth < images[i].naturalHeight) {
                        $(images[i]).addClass('portrait');
                    }
                }
            }
        }
        $rootScope.resetInput = function(ev) {
            var elm = ev.target;
            angular.element(elm).val("");
        }
        if (angular.element('#logo').hasClass('logoadv')) {
            angular.element('#logo').removeClass('logoadv');
            angular.element('#logo').addClass('logozd');
        }
        if (angular.element('#cclear').hasClass('categoryclear')) {
            angular.element('#cclear').removeClass('categoryclear');
            angular.element('#cclear').addClass('categoryclear2');
        }
        if (angular.element('#satv').hasClass('map_view')) {
            angular.element('#satv').removeClass('map_view');
            angular.element('#satv').addClass('map_view2');
        }
        if (angular.element('#upeve').hasClass('pull-right22')) {
            angular.element('#upeve').removeClass('pull-right22');
            angular.element('#upeve').addClass('pull-right222');
        }
        if (angular.element('#cupeve').hasClass('cback11')) {
            angular.element('#cupeve').removeClass('cback11');
            angular.element('#cupeve').addClass('cback1');
        }
        if (angular.element('#lleve').hasClass('link-list1')) {
            angular.element('#lleve').removeClass('link-list1');
            angular.element('#lleve').addClass('link-list12');
        }
        if (angular.element('#upmbev').hasClass('even-block1')) {
            angular.element('#upmbev').removeClass('even-block1');
            angular.element('#upmbev').addClass('even-block');
        }
        if (angular.element('#glb').hasClass('glb2')) {
            angular.element('#glb').removeClass('glb2');
            angular.element('#glb').addClass('glb1');
        }
        if (angular.element('#cglb').hasClass('cback41')) {
            angular.element('#cglb').removeClass('cback41');
            angular.element('#cglb').addClass('cback4');
        }
        $scope.toggledPhoto = "initval";
        var langPref = cookieStore.getCookie('lang_pref');
        if (langPref) {
            var locale = LOCALES.locales[langPref];
        } else {
            var locale = LOCALES.locales['en_US'];
        };
        var accessToken = "pk.eyJ1IjoibG91aXNwIiwiYSI6ImNpeHVvd3ZxYzAwM2szMnQ5N2Q1cjB0Z2oifQ.1aIlYGHSc1LXrvhI2GXA9w";
        var mapBoxId = "louisp.n2o789p7";
        var directions, directionsLayer, directionsRoutesControl, directionsInstructionsControl, directionsErrorsControl;
        $rootScope.mapboxMap = 'mapbox-map';
        $rootScope.lessTransparent = 'less-transparent';
        $rootScope.transparencySet = 'transparency-set';
        $scope.mapBox = 'mapboxgl';
        $scope.bool.selectCityPopup = false;
        $scope.showEstaEventSlider = true;
        $scope.right_slider = true;
        $scope.mapDragged = false;

        $scope.activateEventSlider = false;

        $scope.keywordSearchedHere = false;
        $scope.filtered_temp_slider_data = [];
        var filterIcons = false;
        // This would prevent data fetch when zoom changes or drag changes until data is fetched once due to option selection
        $scope.dataFetchedOnce = false;
        $scope.mapMarkersCleared = false;
        /*
        dataAvailable object would keep information about selections (cat/sub-cat/child-cat/genre for which data is being fetched
        categoryId => id of category for which data is available or undefined
        subCategoryId => id of sub-category for which data is available or undefined
        childCategoryId => id of child category for which data is available or undefined
        genreId => id of genre for which data is available or undefined
        */
        // console.log("$window.inner height", $window.innerHeight);
        if (($window.innerWidth < 801) || ($window.innerWidth < 900 && window.innerHeight < 500)) {
            notify.config({
                startTop: 200
            });
        } else {
            notify.config({
                startTop: 200
            });
        }
        $rootScope.cancelCountriesLoadFromDebounce = false;
        $scope.currentSelection = {
            categoryId: undefined,
            subCategoryId: undefined,
            childCategoryId: undefined,
            genreId: undefined
        };
        $scope.renderHtml = function(html_code) {
            html_code = $filter('translate')(html_code);
            return $sce.trustAsHtml(html_code);
        };
        /*
        This variable would be used to decide if we wanted to make a server fetch to load markers or data is already available and can be filtered
        undefined = No data available, useful to force load specially in case when data needs to be loaded because of changes in bounds due to drag or zoom changes
        0 - All data available
        1 - Category data available for selected category
        2 - Sub category data available for selected sub category
        3 - Child category data available for selected child category
        4 - Genre data available for selected genre
        */
        $scope.dataAvailableAtLevel = undefined;
        $scope.zoomLevelForNonClusteredIcon = 6;
        $scope.defaultZoomLevel = 1.2;
        $scope.currentUserlocation;
        $scope.isClusterLevelZoom = function() {
            return $scope.map_map.getZoom() < $scope.zoomLevelForNonClusteredIcon;
        }
        $scope.constructUrl = function(url) {
            var dataAvailableAtLevel = 0;
            if ($scope.selected.category_id) {
                url += '&categoryId=' + $scope.selected.category_id;
                dataAvailableAtLevel = 1;
            }
            if ($scope.selected.subcategory_id) {
                url += '&subCategoryId=' + $scope.selected.subcategory_id;
                dataAvailableAtLevel = 2;
            }
            if ($scope.selected.childcategory_id) {
                url += '&childCategoryIds=' + $scope.selected.childcategory_id;
                dataAvailableAtLevel = 3;
            }
            if ($scope.selected.genre_id) {
                url += '&genreIds=' + $scope.selected.genre_id;
                dataAvailableAtLevel = 4;
            }
            if ($scope.selected.keyword && $scope.selected.keyword.id) {
                // console.log("scopekeyword################", $scope.selected.keyword);
                if ($scope.selected.keyword.type == "keyword") {
                    url = 'data/getIconsByKeyword/' + $scope.selected.keyword.value;
                } else {
                    url += '&id=' + $scope.selected.keyword.id;
                    url += '&type=' + $scope.selected.keyword.type;
                }
                dataAvailableAtLevel = 8;
                // A quite high number as id is the most specific criteria so left space between genre and id to be used by some other criteria
            }
           // traceLog('establishment-url', 'will load data from url ', url);
            $scope.dataAvailableAtLevel = dataAvailableAtLevel;
           // traceLog('establishment-url', 'now we have data of level  [' + dataAvailableAtLevel + "]");
            return url;
        }
        $scope.isSelectedEmpty = function() {
            return Object.keys($scope.selected).length === 0;
        }
        /**
         * Refresh markers on map, may reload data from server or filter data locally based on data availability
         */
        $scope.isMapGLIconMarkerLoaded = false;
        var canceller;
        $scope.refreshMarkers = function(options) {
           
            if (!options)
                options = {};
            $scope.closeCategoryPopup();
            if (options.keywordSearched) {
                $scope.keywordSearchedHere = true;
            }
            if ($scope.isFirstLoad) {
               // traceLog('discover-refreshmarkersc', $scope.currentMapGLGeoJson);
                $scope.isLoadCompleted = true;
                angular.element("#body").css("opacity", "1");
                $scope.loadMapGLIconMarker($scope.currentMapGLGeoJson);
                $scope.isFirstLoad = false;
                $scope.setFirstLoadFlag(false);
                // console.log("1sttisload", $scope.isLoadCompleted);
                if ($scope.isLoadCompleted == true) {
                    var userlocation = JSON.parse(localStorageService.get("userlocation"));
                    var requestInfo = {
                        lat: userlocation.lat,
                        long: userlocation.long,
                    };
                    // console.log("1sttisrequestInfo", requestInfo);
                   // $scope.loadPromotionsOnDragMap(requestInfo);
                };
                return;
            }
           // traceLog('discover-refreshmarkersd', 'called-> refreshMarkers(): $scope.options, $scope.selected ', options, $scope.selected);
            if (!$scope.map_map) { // || !$scope.map_map.getSource('markers-source')) {
               // traceLog('discover-refreshmarkerse', 'ERROR!!! either map or feature layer (marker) is null ', $scope.map_map, $scope.map_marker);
                return;
            }
            $scope.isMapGLIconMarkerLoaded = false;

            var changedAtLevel = selectionChangedAtLevel($scope.selected, $scope.currentSelection);
            // store selection to current selection for comparison later on
            $scope.currentSelection = Object.assign({}, $scope.selected);
            
            var url = $scope.getEstablishmentUrl($scope.centerForQuery);
            //'/api/establishmentsByQuery?neLat=' + northEast.lat + '&swLat=' + southWest.lat + '&neLng=' + northEast.lng + '&swLng=' + southWest.lng + '&minZoom=' + zoom;
            var fetchDataFromServer = false;
            if ((options && options.forceFetch) || $scope.selected.keyword) // Fetch even if data is available
                fetchDataFromServer = true;
            else if (changedAtLevel == 8) // keyword is selected hence force fetch
                fetchDataFromServer = true;
            else if ($scope.dataAvailableAtLevel == undefined) // No data is fetched till now hence fetch data
                fetchDataFromServer = true;
            else if ($scope.dataAvailableAtLevel != 0) {
                // dataAvailableAtLevel == 0 means that data of all categories is available hence no need to fetch, since it is not 0 try other conditions
                if (changedAtLevel >= 0 && $scope.dataAvailableAtLevel >= changedAtLevel) {
                    // Options are selected in normal direction
                    // fetch if data is available at same level as selection level as option must have changed at same level (+ selection) (different sub-category is selected
                    // for example) so need to fetch
                    // if data is available at lower levels, hence fetch from server as higher level means more data
                    fetchDataFromServer = true;
                } else if (changedAtLevel < 0 && $scope.dataAvailableAtLevel > -changedAtLevel) {
                    // since changed at level has negative value this indicates that some upper option was first selected and then child and then again some upper option
                    // This means that if data available is for same level as selection then we already have that data but if data available is for lower level fetch data
                    fetchDataFromServer = true;
                }
            }
            if ($scope.isIndividualStreamMode || $scope.isEstablishmentStreamMode) {
                if (!$scope.isSelectedEmpty()) {
                    fetchDataFromServer = false;
                   // traceLog('discover-refreshmarkers2', 'Live mode enabled & selection is available, hence enabling filter');
                } else {
                   // traceLog('discover-refreshmarkers3', 'Live mode enabled, hence no request to refresh');
                    return;
                }
            }
            if (fetchDataFromServer) {
                if (!$scope.dataFetchedOnce) {
                    $scope.dataFetchedOnce = true;
                }
                url = $scope.constructUrl(url);
                // clear icons
                //$scope.map_marker.setFilter(function() {
                //   return false;
                //});
                // $scope.map_marker.clearLayers();
                $scope.regionalLoading = true;
                // $scope.map_marker.loadURL(url);
                if (canceller) {

                    canceller.resolve();
                }
                canceller = $q.defer();
                $http.get(url, {
                    timeout: canceller.promise
                }).then(function(res) {
                   // traceLog('refresh marker', "adding image to map");
                    $scope.currentMapGLGeoJson = res.data.features;
                    $scope.loadMapGLIconMarker(res.data.features);
                });
                $scope.$emit('maploadingfinished');
            } else if (changedAtLevel != 10) {
                /*
                Markers available at client are enough to satisfy current selection and since selection is changed (changedAtLevel != 5) need to filter data on client side
                */
               // traceLog('discover-refreshmarkers4', 'will filter data with $scope.selected as ', JSON.parse(JSON.stringify($scope.selected)));
                // $scope.filterMapMarkerJS(); // filterMapMarkerJS commented by nick
                $scope.filterMapGLMarker();
            } else if ($scope.mapMarkersCleared) {
                // As markers are cleared causing filters to change we need to refilter even if not options are changed
               // traceLog('discover-refreshmarkers5', 'No changes to selection but markers were cleared by closing menu and hence we need to filter again');
                // $scope.filterMapMarkerJS(); // filterMapMarkerJS commented by nick
                $scope.filterMapGLMarker();
                $scope.mapMarkersCleared = false;
            } else {
                /*No selection changed hence no need to fetch is from server or filter it either */
               // traceLog('discover-refreshmarkers6', 'No changes to selection hence will not fetch or filter');
            }
        };
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
$scope.loadMapGLIconMarker = function(features) {
    /**
     * Clear data and map array registers cleanly
     */
    $scope.right_slider_data = [];
    $scope.temp_right_slider_data = [];
    $scope.added_id = [];
    $scope.filtered_temp_slider_data = [];
    
    // Wipe out existing custom DOM markers to prevent duplicates
    if ($scope.currentMapGLMarkers && $scope.currentMapGLMarkers.length > 0) {
        for (const currentMarker of $scope.currentMapGLMarkers) {
            currentMarker.remove();
        }
    }
    $scope.currentMapGLMarkers = []; // Reset array register

    if (features) {
        var currentZoomLevel = $scope.map_map.getZoom();
        var markerToLoad = features;

        // Update the points-source data if present
        const source = $scope.map_map.getSource('points-source');
        if (source) {
            source.setData({
                type: 'FeatureCollection',
                features: markerToLoad
            });
        }

        // Supercluster handling if cluster level zoom matches
        if ($scope.isClusterLevelZoom() &&
            !$scope.selected.genre_id && !$scope.selected.keyword &&
            !$scope.isIndividualStreamMode && !$scope.isEstablishmentStreamMode) {
            const index = new Supercluster({
                radius: $scope.isFirstLoad ? 30 : 60 / currentZoomLevel,
                reduce: (accumulated, props) => {}
            }).load(features);
            var cluster = index.getClusters([-180, -85, 180, 85], 2);
            markerToLoad = cluster;
        }

        for (const feature of markerToLoad) {
            // Restore original icon name parsing from feature properties
            feature.properties.iconName = '';
            if (feature.properties.icon && feature.properties.icon.image) {
                feature.properties.iconName = feature.properties.icon.image.replace('.svg', '');
            }
            
            $scope.activeStream = feature.properties;

            var customclass = ' g-' + Math.trunc(currentZoomLevel);
            
            // Rebuild the HTML structure from your database icon payload
            var icon = feature.properties.icon.html;
            console.log('MARKER ICON HTML:', icon);
            var eventId = feature.properties.icon.event_id;
            eventId = (eventId && eventId.indexOf('event_') > -1) ? eventId.replace('event_', "") : eventId;
            
            var res = icon.replace(">", " data-estaid='" + feature.properties.icon.esta_id + "' data-eventid='" + eventId + "' class='grow-icon-marker' >");
            feature.properties.icon.html = res;

            var mapbottom = "";
            var eventBottom = "";
            if (feature.properties.icon.event_type != 1 && feature.properties.icon.esta_id == feature.properties.icon.event_id && ((typeof(feature.properties.icon.upcomingEventsImages) != "undefined") && (feature.properties.icon.upcomingEventsImages.length > 0))) {
                mapbottom = '<div class="mapBottom"> <section >';
                mapbottom += '<a class="icon-left-map"><i class="fa fa-calendar" aria-hidden="true"></i></a>';
                for (let i = 0; i < feature.properties.icon.upcomingEventsImages.length; i++) {
                    eventBottom += '<div style="display:none;" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" id="event_bottom_' + feature.properties.icon.upcomingEventsImages[i].event_id + '" class="mapBottom-info on_click_event_pop"><section attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" class="on_click_event_pop">';
                    mapbottom += '<a href="javascript:void(0);"><img class="event_icon_up on_click_event_pop" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" src="' + $rootScope.genreBaseUrl + feature.properties.icon.upcomingEventsImages[i].genre_image + '"></a>';
                    eventBottom += '<span class="left-info on_click_event_pop" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" style="background-image:url(\'' + feature.properties.icon.upcomingEventsImages[i].profile_pic + '\');cursor:pointer"></span>';
                    
                    var start_date = new Date(feature.properties.icon.upcomingEventsImages[i].start_date);
                    var end_date = new Date(feature.properties.icon.upcomingEventsImages[i].end_date);
                    start_date = {
                        day: start_date.getDate(),
                        month: $filter('translate')($filter('date')(start_date, "MMMM")),
                        year: start_date.getFullYear()
                    };
                    start_date = start_date.day + " " + start_date.month + ',' + start_date.year;
                    end_date = {
                        day: end_date.getDate(),
                        month: $filter('translate')($filter('date')(end_date, "MMMM")),
                        year: end_date.getFullYear()
                    };
                    end_date = end_date.day + " " + end_date.month + ',' + end_date.year;
                    eventBottom += '<span class="right-info on_click_event_pop word_wrap" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '"> ' + $filter('translate')(feature.properties.icon.upcomingEventsImages[i].cat_name) + " - " + $filter('translate')(feature.properties.icon.upcomingEventsImages[i].genreName) + ' <br> <span style="color:red">' + feature.properties.icon.upcomingEventsImages[i].title + '</span> <br>' + start_date + " - " + end_date + '</span>';
                    eventBottom += '</section></div>';
                }
                mapbottom += '</section></div>';
            }

            var date_cond = "";
            var class_name = "on_click_pop";
            var id_select = feature.properties.icon.esta_id;
            var id_select_text = "esta_" + feature.properties.icon.esta_id;
            if (feature.properties.icon.start_date) {
                class_name = "on_click_event_pop";
                id_select = feature.properties.icon.event_id;
                id_select_text = "event_" + feature.properties.icon.esta_id;
            }

            var cate_name = (typeof(feature.properties.icon.cate_name) == 'undefined' || feature.properties.icon.cate_name == "") ? "" : $filter('translate')(feature.properties.icon.cate_name);
            var genre_name = (typeof(feature.properties.icon.genreName) == 'undefined' || feature.properties.icon.genreName == "") ? "" : " - " + $filter('translate')(feature.properties.icon.genreName);
            
            var cond_cate_genre = "";
            if (cate_name + genre_name == "brand") {
                cond_cate_genre = '<span class="' + class_name + ' word_wrap cate_part" data-attr="' + id_select + '" style="font-weight:bold;float:left; cursor:pointer;"></span>';
            } else if (cate_name + genre_name != "") {
                cond_cate_genre = '<span class="' + class_name + ' word_wrap cate_part" data-attr="' + id_select + '" style="font-weight:bold;float:left; cursor:pointer;">' + cate_name + genre_name + '</span>';
            } else {
                cond_cate_genre = '<span class="' + class_name + ' word_wrap cate_part" data-attr="' + id_select + '" style="font-weight:bold;float:left; cursor:pointer;">' + $filter('translate')("views.event_center") + '</span>';
            }

            if (feature.properties.establish_locale && locale[0] == feature.properties.establish_l9language) {
                $scope.eename = feature.properties.establish_locale.name;
                $scope.eeestablish_description = feature.properties.establish_locale.description;
            } else {
                $scope.eename = feature.properties.establish_name;
                $scope.eeestablish_description = feature.properties.description;
            }
            
            $scope.trgenre = $filter('translate')(feature.properties.icon.genreName);
            $scope.event_country_name = $filter('translate')('views.' + feature.properties.icon.event_country_name);
            $scope.country_name = $filter('translate')('views.' + feature.properties.country_name);

            var temp_right_slider = {
                address: feature.properties.address,
                title: feature.properties.title,
                stream_type: feature.properties.stream_type,
                stream_name: feature.properties.stream_name,
                is_live: feature.properties.is_live,
                liveUrl: feature.properties.liveUrl,
                profilePic: feature.properties.profilePic,
                event_type: feature.properties.event_type,
                image: feature.properties.images ? feature.properties.images.image : '',
                category: feature.properties.genre_name,
                description: $scope.eeestablish_description,
                streampic: feature.properties.streampic,
                streamCityName: feature.properties.streamCityName,
                streamCountryName: feature.properties.streamCountryName,
                lvlocal_title: feature.properties.icon.local_title,
                cate_name: feature.properties.icon.cate_name,
                incate_name: feature.properties.sub_category_name,
                ingenre_name: feature.properties.genre_name,
                first_name: feature.properties.icon.first_name,
                event_country_name: $scope.event_country_name,
                last_name: feature.properties.icon.last_name,
                event_city: feature.properties.icon.event_city,
                genre_name: $scope.trgenre,
                alias_name: feature.properties.alias_name,
                establishment_name: $scope.eename,
                sldtitle: feature.properties.title,
                sldgenre_name: feature.properties.genre_name,
                sldsub_category_name: feature.properties.sub_category_name,
                sldcity_name: feature.properties.city_name,
                sldcountry_name: $scope.country_name,
                sldestablish_name: feature.properties.establishment_name,
                sldalias_name: feature.properties.alias_name,
                establish_name: $scope.eename,
                id: feature.properties.id,
                class_name: class_name,
                data_attr: id_select,
                city: feature.properties.city,
                country_name: $scope.country_name
            };

            if ($scope.added_id.indexOf(id_select_text) === -1) {
                $scope.temp_right_slider_data.push(temp_right_slider);
                $scope.added_id.push(id_select_text);
            }

            var isLinked = feature.properties.icon.is_linked ? true : false;
            var relatedEventId = feature.properties.icon.related_id ? feature.properties.icon.related_id : null;
            var popupContent;

            // Compact IconoGlobe popup, scoped to the new popup design.
            function igPopupEscape(value) {
                return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch) {
                    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
                });
            }
            function igPopupCard(smallName, largeTitle, category, city, country, photo) {
                var loc = [city, country].filter(Boolean).map(igPopupEscape).join(' · ');
                var pic = photo ? (/^(https?:)?\/\//i.test(String(photo)) ? String(photo) : 'https://iconoglobe.com/i-i/' + encodeURIComponent(String(photo).replace(/^.*\//, ''))) : '';
                return '<div class="ig-map-popup-card ' + class_name + '" data-attr="' + igPopupEscape(id_select) + '" role="button" tabindex="0">' +
                    '<div class="ig-map-popup-photo"' + (pic ? ' style="background-image:url(&quot;' + igPopupEscape(pic) + '&quot;)"' : '') + '></div>' +
                    '<div class="ig-map-popup-info">' +
                    '<div class="ig-map-popup-eyebrow">' + igPopupEscape(smallName) + '</div>' +
                    '<div class="ig-map-popup-title">' + igPopupEscape(largeTitle || smallName) + '</div>' +
                    (category ? '<div class="ig-map-popup-category">' + igPopupEscape(category) + '</div>' : '') +
                    (loc ? '<div class="ig-map-popup-location">' + loc + '</div>' : '') +
                    '</div><span class="ig-map-popup-arrow" aria-hidden="true">›</span></div>';
            }

            // One visual design for individual streams, establishments, and events.
            // Keep class_name and data-attr from the original marker logic so
            // the existing delegated click handlers still open the correct entity.
            var igProps = feature.properties;
            var igIcon = igProps.icon || {};
            var igType = Number(igProps.stream_type);
            var igEvent = igType === 2 || !!igIcon.start_date;
            var igSmallName = igType === 1
                ? (igProps.stream_name || igProps.alias_name || '')
                : igEvent
                    ? (igProps.alias_name || igProps.event_name || igProps.stream_name || '')
                    : ($scope.eename || igProps.establishment_name || igProps.establish_name || '');
            var igLargeTitle = igIcon.local_title || igProps.local_title ||
                igProps.title || (igEvent ? igProps.event_name : '') || igSmallName;
            var igCategory = igType === 1
                ? (igProps.genre_name || $scope.trgenre || '')
                : (igEvent ? ($scope.trgenre || igProps.genre_name || '')
                    : ($scope.trgenre || igProps.genre_name || igProps.sub_category_name || ''));
            var igCity = igProps.streamCityName || igIcon.event_city || igProps.city_name || igProps.city || '';
            var igCountry = igProps.streamCountryName || igProps.country_name || igIcon.event_country_name || '';
            var igPhoto = igProps.streampic || igProps.pic34 || igProps.profilePic ||
                igProps.profile_pic || (igProps.images && igProps.images.image) || '';
            popupContent = igPopupCard(igSmallName, igLargeTitle, igCategory, igCity, igCountry, igPhoto);
            // Keep the original upcoming-event DOM, when supplied.
            if (mapbottom) popupContent += mapbottom;
            if (eventBottom) popupContent += eventBottom;
            feature.properties.popupContent = popupContent;

            // =============================================================
            // 🏗️ BUILD DOM ELEMENT FROM feature.properties.icon.html
            // =============================================================
                    const el = document.createElement('div');
            // Personalized icons are already complete transparent PNGs (back + photo + frame).
            // Genre icons still need the separate loopb and loop SVG layers.
            const markerIcon = feature.properties.icon || {};
            const personalFlag = markerIcon.use_personal_icon !== undefined
                ? markerIcon.use_personal_icon
                : feature.properties.use_personal_icon;
            const isIndividualPersonalIcon = Number(feature.properties.stream_type) === 1 &&
                typeof feature.properties.persicon === 'string' &&
                feature.properties.persicon.trim() !== '' &&
                feature.properties.persicon.trim().toLowerCase() !== 'null' &&
                feature.properties.persicon.trim().toLowerCase() !== 'undefined';
            const isPersonalIcon = isIndividualPersonalIcon ||
                personalFlag === true || personalFlag === 1 ||
                personalFlag === '1' || personalFlag === 'true';
            const personalMarkerHtml = isIndividualPersonalIcon
                ? '<img class="grow-icon-marker" src="https://iconoglobe.com/i-i/' +
                  encodeURIComponent(feature.properties.persicon.trim()) + '">'
                : markerIcon.html;

            el.innerHTML = isPersonalIcon
                ? '<div class="iconoglobe-marker iconoglobe-marker-personal">' +
                      '<div class="iconoglobe-marker-personal-inner">' + personalMarkerHtml + '</div>' +
                  '</div>'
                : '<div class="iconoglobe-marker">' +
                      '<img class="iconoglobe-marker-loopb" src="https://iconoglobe.com/i-i/loopb.svg">' +
                      '<div class="iconoglobe-marker-genre">' + markerIcon.html + '</div>' +
                      '<img class="iconoglobe-marker-loop" src="https://iconoglobe.com/i-i/loop.svg">' +
                  '</div>';

            const markerEl = el.firstElementChild;

            if (markerEl) {
                // Attach Popup using MapboxGL Popup API
                const popup = new mapboxgl.Popup({
                    offset: 25,
                    closeButton: false,
                    closeOnClick: true,
                    className: 'ig-map-popup'
                }).setHTML(popupContent);

                // Create the Mapbox marker with the 3D globe horizon fix (occludedOpacity: 0)
                const htmlMarkerInstance = new mapboxgl.Marker({
                    element: markerEl,
                    anchor: 'center',
                    occludedOpacity: 0 // Hides markers instantly when behind the 3D globe curve
                })
                .setLngLat(feature.geometry.coordinates)
                .addTo($scope.map_map);
                popup.setLngLat(feature.geometry.coordinates);
                // HTML Mapbox markers are separate from the points-layer click
                // handler. Route clicks through the same entry point as the slider.
                markerEl.addEventListener('click', function (ev) {
                    // Keep event markers on their established event-profile path.
                    var eventTarget = ev.target.closest('.on_click_event_pop');
             if (!feature.properties.is_live &&
                (eventTarget ||
                 (feature.properties.icon && feature.properties.icon.start_date))) {
                return;
            }  

                    ev.preventDefault();
                    ev.stopPropagation();
                    // Touch: first tap shows the card; card tap uses existing delegated click handler.
                    if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
                        if (!popup.isOpen()) popup.addTo($scope.map_map);
                        return;
                    }
                    var props = feature.properties || {};
                    var iconData = props.icon || {};
                    var isLive = props.is_live === true ||
             props.is_live === 1 ||
             props.is_live === 'true' ||
             props.is_live === '1';

var id = isLive
    ? (props.id || iconData.esta_id)
    : (iconData.esta_id || props.id);
                    if (!id) return;
                    $scope.$applyAsync(function () {
                        $scope.openEntityFromMapOrSlider(
                            angular.extend({}, props, { id: id }), null
                        );
                    });
                });
                markerEl.addEventListener('mouseenter', function () {
                    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
                    if (!popup.isOpen()) popup.addTo($scope.map_map);
                });
        markerEl.addEventListener('mouseleave', function () {
              popup.remove();
           }); 
                 // Push to array register for easy clearing later
                $scope.currentMapGLMarkers.push(htmlMarkerInstance);
            }

            $scope.addFilteredSlider(feature);
        }

        const source2 = $scope.map_map.getSource('points-source');
        if (source2) {
            source2.setData({
                type: 'FeatureCollection',
                features: markerToLoad
            });
        }
    }

    if ($scope.selected && $scope.selected.showUpcomingEvents) {
        $scope.right_slider = false;
    } else {
        $scope.right_slider = true;
        $scope.showEstaEventSlider = true;
        $scope.loadMoreSlider();
    }

    if (($scope.isIndividualStreamMode || $scope.isEstablishmentStreamMode) && features && features.length == 1) {
        $scope.map_map.flyTo({
            center: features[0].geometry.coordinates,
            bearing: 0,
            curve: 1,
            essential: true
        });
        $location.search({
            "at": features[0].geometry.coordinates[0] + "," + features[0].geometry.coordinates[1],
        });
    }

    $scope.isMapGLIconMarkerLoaded = true;
    $scope.centerForQuery = undefined;
    
    if (!$scope.$$phase) {
        $scope.$apply();
    }
};
 
 
 
 
 
 
 
 
 
 
 
 
      /*  $scope.loadPromotionsOnCitySearch = function(latitude, longitude) {
            var cityInfo = localStorageService.get('city_info');
            localStorageService.remove('city_info');
            // console.log("cityInfo ", typeof(cityInfo), JSON.parse(cityInfo));
            var citySearchResponse = JSON.parse(cityInfo);
            var passRequestDataForCity = {
                lat: latitude,
                long: longitude,
                city: citySearchResponse.locality,
                state: citySearchResponse.administrative_area_level_1,
                country: citySearchResponse.country
            };
           // traceLog("tn-discover-urlchange", "before  loadPromotionsOnCitySearch ", passRequestDataForCity);
            $scope.loadPromotionsOnCitySelection(passRequestDataForCity);
            $scope.loadHangingOrSkyScrapperPromotionsOnCitySelection(passRequestDataForCity, 'is_hanging');

            $scope.loadHangingOrSkyScrapperPromotionsOnCitySelection(passRequestDataForCity, 'is_skyscrapper');
        }
   */
       // 1. Force the container to be empty (Fixes the mapbox-gl.js:31 warning)
        // 1. Clear the container
        var mapContainer = document.getElementById('map');
        if (mapContainer) {
            mapContainer.innerHTML = '';
        }
        // ✅ Parse URL parameters for shared links
        function getUrlParams() {
            var params = {};
            window.location.search.substring(1).split("&").forEach(function(part) {
                if (!part) return;
                var item = part.split("=");
                params[decodeURIComponent(item[0])] = decodeURIComponent(item[1]);
            });
            return params;
        }
        var urlParams = getUrlParams();
        var urlZoom = parseFloat(urlParams.zoom);
        var urlLat = NaN;
        var urlLng = NaN;
        // ✅ FIXED: Correctly mapping URL [0] to Longitude and [1] to Latitude
        if (urlParams.at && urlParams.at.indexOf(",") !== -1) {
            var atParts = urlParams.at.split(",");
            urlLng = parseFloat(atParts[0]);
            urlLat = parseFloat(atParts[1]);
        }
        // ✅ Fix: normalize longitude to -180 → +180
        if (!isNaN(urlLng)) {
            while (urlLng < -180) urlLng += 360;
            while (urlLng > 180) urlLng -= 360;
        }
        // ✅ Detect mobile once
        var isMobile = window.innerWidth <= 768;
        // ✅ Determine initial center and zoom
        var initialCenter = (!isNaN(urlLat) && !isNaN(urlLng)) ? [urlLng, urlLat] : [180, 0];
        var initialZoom = (!isNaN(urlZoom)) ? urlZoom : (isMobile ? 0.75 : 1.1);
        // ✅ Mobile-aware flyTo zoom
        var flyZoom = isMobile ? .85 : 1.3;
 


  if ($scope.map_map && $scope.map_map.scrollZoom && typeof $scope.map_map.scrollZoom.setZoomRate === 'function') {
            $scope.map_map.scrollZoom.setZoomRate(5);
            $scope.map_map.scrollZoom.enable({
                around: 'cursor'
            });
        }
        // Terrain setup
  

$scope.runMapFlyAndLayoutSequence = function() {
            if (!$scope.map_map || typeof $scope.map_map.flyTo !== 'function') return;

            // console.log("Map Timeout: Forcing resize and tile fetch...");
            $scope.map_map.resize();
            $scope.map_map.setZoom(flyZoom);
             
            // Only fly if URL does NOT provide coordinates
            if (isNaN(urlLat) || isNaN(urlLng) || isNaN(urlZoom)) {
                var coords = {
                    lat: 20.9453056,
                    lng: -97.4061568
                };
                
                if (!$scope.map_map.isMoving()) {
                    // console.log("Flying to default coords:", coords);
                    $scope.map_map.flyTo({
                        center: [coords.lng, coords.lat],
                        zoom: flyZoom, 
                        bearing: 0,
                        curve: 1,
                        essential: true,
                        duration: 2000
                    });

                    $scope.map_map.once('moveend', function () {
                        setTimeout(function () {
                            var pst4 = document.getElementById('pst4');
                            if (pst4) pst4.classList.add('mini-map');

                        //    var elScenes = document.querySelectorAll('.stream//-card');
                        //    if (elScenes && elScenes.length) {
						//		elScenes.forEach(function(el) {
						//			el.classList.add('mini-map');
						//		});
						//	}

                            // desktop only
                            var pst5 = document.getElementById('pst5');
                          //  if (pst5) pst5.classList.add('mini-map');

                            // mobile only
                            var pst6 = document.getElementById('pst6');
                           // if (pst6) pst6.classList.add('mini-map');
                            
                            console.log('Layout classes successfully added to scene elements.');
                        }, 1000);
                    });
                }
            } else {
                // FALLBACK: If URL *does* have coords, the map won't fire flyTo / moveend.
                // We should add the mini-map class to scene1 immediately!
                setTimeout(function () {
                    var elScenes = document.querySelectorAll('.stream-card');
                    if (elScenes && elScenes.length) {
						elScenes.forEach(function(el) {
							//el.classList.add('mini-map');
						});
					}
                    
                    var pst4 = document.getElementById('pst4');
                    //if (pst4) pst4.classList.add('mini-map');
                    
                    var pst5 = document.getElementById('pst5');
                   // if (pst5) pst5.classList.add('mini-map');
                    
                    var pst6 = document.getElementById('pst6');
                   // if (pst6) pst6.classList.add('mini-map');
                }, 1000);
            }
        };

        // If called during boot up, check if map is ready, else mark it for queue execution
        if ($scope.mapReady) {
            $scope.runMapFlyAndLayoutSequence();
        } else {
            $scope.runLayoutWhenMapReady = true;
        }      
       
       
       
        $scope.activateAppropriateZoomIndicator = function(zoom) {
            var indicatorLevel = $scope.getZoomIndicatorLevel(zoom);
           // traceLog('discover-zoom', 'activateAppropriateZoomIndicator(): indicator level ', indicatorLevel);
            $(".zoom_level>span").removeClass('active');
            $(".zoom_level>span.zindicator" + indicatorLevel).addClass('active');
        };
        // Returns zoom level indicator based on zoom level passed starting from 1 for left indicator
        // Based on this appropriate zoom indicator would be selected on user interface
        $scope.getZoomIndicatorLevel = function(zoom) {
            if (zoom >= 20)
                return 11;
            else if (zoom >= 19)
                return 10;
            else if (zoom >= 18)
                return 9;
            else if (zoom >= 17)
                return 8;
            else if (zoom >= 16)
                return 7;
            else if (zoom >= 14)
                return 6;
            else if (zoom >= 12)
                return 5;
            else if (zoom >= 10)
                return 4;
            else if (zoom >= 8)
                return 3;
            else if (zoom >= 6)
                return 1;
            else
                return 1;
        };
        // Returns new zoom level based on current zoom level and direction (0 - in, 1 - out)
        $scope.getNewZoomLevel = function(zoom, direction) {
           // traceLog('discover-zoom', 'getNewZoomLevel(): zoom, direction ', zoom, direction);
            if (zoom >= 20)
                if (direction == 0)
                    return 20;
                else
                    return 19;
            else if (zoom >= 19)
                if (direction == 0)
                    return 20;
                else
                    return 18;
            else if (zoom >= 18)
                if (direction == 0)
                    return 19;
                else
                    return 17;
            else if (zoom >= 17)
                if (direction == 0)
                    return 18;
                else
                    return 16;
            else if (zoom >= 16)
                if (direction == 0)
                    return 17;
                else
                    return 14;
            else if (zoom >= 14)
                if (direction == 0)
                    return 16;
                else
                    return 12;
            else if (zoom >= 12)
                if (direction == 0)
                    return 14;
                else
                    return 10;
            else if (zoom >= 10)
                if (direction == 0)
                    return 12;
                else
                    return 8;
            else if (zoom >= 8)
                if (direction == 0)
                    return 10;
                else
                    return 6;
            else if (zoom >= 6)
                if (direction == 0)
                    return 8;
                else
                    return 4;
            else if (direction == 0)
                return 6;
            else
                return 4;
        };
        $scope.mapZoomOut = function(e) {
           // traceLog('discover-zoom', 'actual map zoom is ', $scope.map_map.getZoom());
            var existingZoom = Math.round($scope.map_map.getZoom());
           // traceLog('discover-zoom', 'Current map zoom is ', existingZoom);
            var newZoom = $scope.getNewZoomLevel(existingZoom, 1);
           // traceLog('discover-zoom', 'new zoom, old zoom ', newZoom, existingZoom);
            // console.log('discover-zoom', 'new zoom, old zoom ', newZoom, existingZoom);
            // $scope.isZoomedIn = false;
           // traceLog('discover-zoom', 'Setting new zoom into map as ', newZoom);
            $scope.map_map.setZoom(newZoom);
           // traceLog('discover-zoom', 'new map zoom is ', $scope.map_map.getZoom())
            $location.search("zoom", newZoom);
            // Get indicator value that should be selected
            // Change url to add new zoom parameter
            var indicatorLevel = $scope.getZoomIndicatorLevel(newZoom);
           // traceLog('discover-zoom', 'indicator level is ', indicatorLevel);
            if (existingZoom != newZoom) {
                // remove active class from next method and add active to this one
                $(".zoom_level>span.zindicator" + (indicatorLevel + 1)).removeClass('active');
            }
            $(".zoom_level>span.zindicator" + indicatorLevel).addClass('active');
            // if (indicatorLevel == 10)
            //     angular.element('#zoom_in').removeClass('disabled');
            // else if (indicatorLevel == 1)
            //     angular.element('#zoom_out').addClass('disabled');
        };
        $scope.mapZoomIn = function(e) {
            // console.log(">>>>>>>>>>>>>>> +Zoom In");
           // traceLog('discover-zoom', 'actual map zoom is ', $scope.map_map.getZoom());
            var existingZoom = Math.round($scope.map_map.getZoom());
           // traceLog('discover-zoom', 'Current map zoom is ', existingZoom);
            var newZoom = $scope.getNewZoomLevel(existingZoom, 0);
            // $scope.isZoomedIn = true;
           // traceLog('discover-zoom', 'Setting new zoom into map as ', newZoom);
            $scope.map_map.setZoom(newZoom);
           // traceLog('discover-zoom', 'new map zoom is ', $scope.map_map.getZoom())
            $location.search("zoom", newZoom);
            var indicatorLevel = $scope.getZoomIndicatorLevel(newZoom);
           // traceLog('discover-zoom', 'indicator level is ', indicatorLevel);
            if (existingZoom != newZoom) {
                // remove active class from previous indicator and add active to this one
                $(".zoom_level>span.zindicator" + (indicatorLevel - 1)).removeClass('active');
            }
            $(".zoom_level>span.zindicator" + indicatorLevel).addClass('active');
        };
        
        $scope.initMarkerJS = function() {
           // traceLog("discover-mapbox", "initMarkerJs Called ");
            var marker = L.mapbox.featureLayer();
            marker.on('layeradd', function(e) {
                var adjustLng = $scope.adjustCoordinate(e.layer.feature.geometry.coordinates[0], false);
                e.layer.feature.geometry.coordinates[0] = adjustLng;
                e.layer._latlng.lng = adjustLng;
                if ($window.innerWidth > 1024) {
                    e.layer.on("click", function(ev) {
                        if (e.layer.feature.properties.icon['esta_id'] == e.layer.feature.properties.icon['event_id']) {
                            $scope.estaId = e.layer.feature.properties.icon['esta_id'];
                            angular.element('#evtext2').addClass('hide');
                            angular.element('#lnkevt').addClass('hide');
                            $scope.getEstaEEprofile($scope.estaId, ev);
                        } else {
                            var esta_id = e.layer.feature.properties.icon['event_id'];
                            if (esta_id.indexOf("_") > -1) {
                                esta_id = esta_id.substr(esta_id.indexOf("_") + 1, esta_id.length);
                            }
                            if (typeof(e.layer.feature.properties.icon['is_linked']) != "undefined" && e.layer.feature.properties.icon['is_linked']) {
                                $scope.related_id = e.layer.feature.properties.icon['related_id'];
                                $scope.main_event_id = e.layer.feature.properties.icon['main_event_id'];
                                $scope.estaId = esta_id;
                                $scope.getAllLayers(e, $scope.estaId);
                            } else {
                                var eventId = esta_id;
                                var establishmentId = e.layer.feature.properties.icon.esta_id;
                                angular.element('#evtext2').addClass('hide');
                                angular.element('#lnkevt').addClass('hide');
                                $scope.getEventEEprofile(eventId, e, null, null, true, establishmentId);
                            }
                        }
                    });
                }
                var markers = e.layer,
                    feature = markers.feature;
                if (feature.properties.icon.html.indexOf('server/php') > 0) {
                    var icon = feature.properties.icon.html;
                    
                    
                    console.log('MARKER ICON HTML:', icon);
                    var eventId = feature.properties.icon.event_id;
                    eventId = (eventId.indexOf('event_') > -1) ? eventId.replace('event_', "") : eventId;
                    var res = icon.replace(">", "data-estaid='" + feature.properties.icon.esta_id + "' data-eventid='" + eventId + "' class='grow-icon-marker' >");
                    feature.properties.icon.html = res;
                }
                markers.setIcon(L.divIcon(feature.properties.icon));
                var date_cond = "";
                var class_name = "on_click_pop";
                var id_select = feature.properties.icon.esta_id;
                var id_select_text = "esta_" + feature.properties.icon.esta_id;
                if (feature.properties.icon.start_date) {
                    class_name = "on_click_event_pop";
                    id_select = feature.properties.icon.event_id;
                    id_select_text = "event_" + feature.properties.icon.esta_id;
                }
                var cate_name = (typeof(feature.properties.icon.cate_name) == 'undefined' || feature.properties.icon.cate_name == "") ? "" : $filter('translate')(feature.properties.icon.cate_name);
                var genre_name = (typeof(feature.properties.icon.genreName) == 'undefined' || feature.properties.icon.genreName == "") ? "" : " - " + $filter('translate')(feature.properties.icon.genreName);
                var cond_cate_genre = "";
                var cond_cate_genre = "";
                if (cate_name + genre_name == "brand") {
                    var cond_cate_genre = '<span class="' + class_name + ' word_wrap cate_part" data-attr="' + id_select + '" style="font-weight:bold;float:left; cursor:pointer;"></span>';
                    var category_name = "";
                } else if (cate_name + genre_name != "") {
                    var cond_cate_genre = '<span class="' + class_name + ' word_wrap cate_part" data-attr="' + id_select + '" style="font-weight:bold;float:left;cursor:pointer;">' + cate_name + genre_name + '</span>';
                    var category_name = "" + $filter('translate')(cate_name) + $filter('translate')(genre_name) + "";
                } else {
                    var cond_cate_genre = '<span class="' + class_name + ' word_wrap cate_part" data-attr="' + id_select + '" style="font-weight:bold;float:left;cursor:pointer;">' + $filter('translate')("views.event_center") + '</span>';
                    var category_name = $filter('translate')("views.event_center");
                }
                var mapbottom = "";
                var eventBottom = "";
                if (feature.properties.icon.esta_id == feature.properties.icon.event_id && ((typeof(feature.properties.icon.upcomingEventsImages) != "undefined") && (feature.properties.icon.upcomingEventsImages.length > 0))) {
                    var mapbottom = '<div class="mapBottom"> <section >';
                    mapbottom += '<a class="icon-left-map"><i class="fa fa-calendar" aria-hidden="true"></i></a>';
                    for (i = 0; i < feature.properties.icon.upcomingEventsImages.length; i++) {
                        eventBottom += '<div style="display:none;" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" id="event_bottom_' + feature.properties.icon.upcomingEventsImages[i].event_id + '" class="mapBottom-info on_click_event_pop"><section attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" class="on_click_event_pop">';
                        mapbottom += '<a href="javascript:void(0);"><img class="event_icon_up on_click_event_pop" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" src="' + $rootScope.genreBaseUrl + feature.properties.icon.upcomingEventsImages[i].genre_image + '"></a>';
                        eventBottom += '<span class="left-info on_click_event_pop" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '" style="background-image:url(\'' + feature.properties.icon.upcomingEventsImages[i].profile_pic + '\');cursor:pointer"></span>';
                        var start_date = new Date(feature.properties.icon.upcomingEventsImages[i].start_date);
                        var end_date = new Date(feature.properties.icon.upcomingEventsImages[i].end_date);
                        start_date = {
                            day: start_date.getDate(),
                            month: $filter('translate')($filter('date')(start_date, "MMMM")),
                            year: start_date.getFullYear()
                        };
                        start_date = start_date.day + " " + start_date.month + ',' + start_date.year;
                        end_date = {
                            day: end_date.getDate(),
                            month: $filter('translate')($filter('date')(end_date, "MMMM")),
                            year: end_date.getFullYear()
                        };
                        end_date = end_date.day + " " + end_date.month + ',' + end_date.year;
                        eventBottom += '<span class="right-info on_click_event_pop word_wrap" attr="' + feature.properties.icon.upcomingEventsImages[i].event_id + '"> ' + $filter('translate')(feature.properties.icon.upcomingEventsImages[i].cat_name) + " - " + $filter('translate')(feature.properties.icon.upcomingEventsImages[i].genreName) + ' <br> <span style="color:red">' + feature.properties.icon.upcomingEventsImages[i].title + '</span> <br>' + start_date + " - " + end_date + '</span>';
                        eventBottom += '</section></div>';
                    }
                    mapbottom += '</section></div>';
                }
                var temp_right_slider = {};
                if (feature.properties.establish_locale && locale[0] == feature.properties.establish_locale.language) {
                    $scope.eename = feature.properties.establish_locale.name;
                    $scope.eeestablish_description = feature.properties.establish_locale.description;
                } else {
                    $scope.eename = feature.properties.establish_name;
                    $scope.eeestablish_description = feature.properties.description;
                }
                $scope.trgenre = $filter('translate')(feature.properties.icon.genreName);
                $scope.event_country_name = $filter('translate')('views.' + feature.properties.icon.event_country_name);
                $scope.country_name = $filter('translate')('views.' + feature.properties.country_name);
                $scope.country_name = $filter('translate')('views.' + feature.properties.country_name);
                temp_right_slider = {
                    address: feature.properties.address,
                    stream_type: feature.properties.stream_type,
				 is_live: feature.properties.is_live,
				 liveUrl: feature.properties.liveUrl,
				 profilePic: feature.properties.profilePic,
                    title: feature.properties.title,
                    image: feature.properties.images.image,
                    cate_name: feature.properties.icon.cate_name,
                    sldtitle: feature.properties.title,
					local_title:feature.properties.local_title,
					local_description:feature.properties.local_description,
                    sldgenre_name: feature.properties.genre_name,
                    sldsub_category_name: feature.properties.sub_category_name,
                    sldcity_name: feature.properties.city_name,
                    sldcountry_name: feature.properties.country_name,
                    sldestablish_name: feature.properties.establishment_name,
                    sldalias_name: feature.properties.alias_name,
                    genre_name: feature.properties.icon.genreName,
                    incate_name: feature.properties.sub_category_name,
                    ingenre_name: feature.properties.genre_name,
                    streampic: feature.properties.streampic,
                     streamCityName: feature.properties.streamCityName,
                  streamCountryName: feature.properties.streamCountryName,
                  lvlocal_title: feature.properties.icon.local_title,
                    first_name: feature.properties.icon.first_name,
					stream_name: feature.properties.stream_name,
                    event_country_name: feature.properties.icon.event_country_name,
                    last_name: feature.properties.icon.last_name,
                    event_city: feature.properties.icon.event_city,
                    event_type: feature.properties.event_type,
                    alias_name: feature.properties.alias_name,
                    establishment_name: $scope.eename,
                    description: $scope.eeestablish_description,
                    establish_name: $scope.eename,
                    category: genre_name,
                    id: feature.properties.id,
                    class_name: class_name,
                    data_attr: id_select,
                    city: feature.properties.city,
                    country_name: $scope.country_name
                };
                if ($scope.added_id.indexOf(id_select_text) === -1) {
                    $scope.temp_right_slider_data.push(temp_right_slider);
                    $scope.added_id.push(id_select_text);
                }
                var isLinked = e.layer.feature.properties.icon.is_linked ? true : false;
                var estaEventId = e.layer.feature.properties.icon.main_event_id ? e.layer.feature.properties.icon.main_event_id : null;
                var relatedEventId = e.layer.feature.properties.icon.related_id ? e.layer.feature.properties.icon.related_id : null;
                var popupContent = mapbottom + '<div class="location_info ' + class_name + '" data-attr="' + id_select + '" tabIndex="1" data-is-related="' + isLinked + '" data-related-id="' + relatedEventId + '"><div class="iconbx" style="float:left;position:relative;height:82px;"><span class="img-map ' + class_name + '" data-attr="' + id_select + '" style="background-image:url(\'' + feature.properties.images.image + '\');cursor:pointer;background-size:cover !important;"></span></div><span style="font-weight:bold;color:red; float:left;cursor:pointer" class=" ' + class_name + ' word_wrap pop1u title_part" data-attr="' + id_select + '">' + feature.properties.alias_name + '</span><span style="font-weight:bold;color:red; float:left; cursor:pointer" class="' + class_name + ' word_wrap pop7u title_part" data-attr="' + id_select + '">' + feature.properties.title + '</span><span style="font-weight:bold;color:red; float:left; cursor:pointer" class="' + class_name + ' word_wrap pop2u title_part" data-attr="' + id_select + '">' + feature.properties.icon.cate_name + '-' + feature.properties.genre_name + '</span><span style="font-weight:bold;color:red; float:left; cursor:pointer" class="' + class_name + ' word_wrap pop31u title_part" data-attr="' + id_select + '">' + feature.properties.establishment_name + '</span><a href="javascript:void(0);" class="popup-location ' + class_name + '" style="float:left;margin-top:-6px;width: 100%;" data-attr="' + id_select + '"><span class="city_part" style="float:left;margin-top:3px;width: 100%">' + feature.properties.city + '</span>' + date_cond + '</a></div>';
                popupContent += eventBottom;
                var offsetAnchor = $window.innerWidth < 801 ? -130 : -10;
                var popup = L.popup()
                    .setLatLng(feature.geometry.coordinates)
                    .setContent(popupContent);
                markers.bindPopup(popup, {
                    closeButton: false,
                    minWidth: 320,
                    offset: new L.Point(0, offsetAnchor)
                });
                markers.on('mouseover', function(e) {
                    this.openPopup();
                    $('.leaflet-popup-pane').show();
                    $('.leaflet-popup').css('left', '-162px');
                });
                markers.on('mouseout', function(e) {
                    $('.leaflet-popup-pane').hide();
                });
                markers.on('click', function(e) {
                    this.openPopup();
                    $('.leaflet-popup-pane').show();
                    $('.leaflet-popup').css('left', '-162px');
                });
               
    });
            $scope.map_marker = marker;
            // Add these feature layer to map if map is initialized
            if ($scope.map_map) {
               // traceLog("discover-mapbox", "Adding feature layer to map");
                marker.addTo($scope.map_map);
            }
            marker.on('ready', function(e) {
                var features = e.target._geojson.features;
               // traceLog("discover-mapbox-refreshmarkers", 'marker.on[ready] called that has fetched [' + (features ? features.length : '0') + "] icons.");
                $scope.regionalLoading = false;
                // console.log("setting prerender to true")
                $window.prerenderReady = true
                /*
                This method will called when data is loaded from server (see refreshMarkers), we are resetting filter using below function to
                ensure that we clear any filters added previously and all icons loaded from server are shown
                */
                var widesearch = e.target._geojson.widesearch;
                if (!widesearch) {
                   // traceLog("discover-mapbox-refreshmarkers", 'No wide search hence returning');
                    /*
                    notify({
                    message:"No icons found.",   duration:3000,   position:'center'
                    })
                    */
                    $scope.$apply();
                    return;
                }
               // traceLog("discover-mapbox-refreshmarkers", 'wide search has length, keywordSearchedHere ', widesearch.length, $scope.keywordSearchedHere);
                if (widesearch.length > 0 && $scope.keywordSearchedHere) {
                    $scope.mapDragged = false;
                   // traceLog("discover-mapbox-refreshmarkers", 'wide search has length ', widesearch.length);
                    localStorageService.set('searchedval', angular.element('.keyword_search_mobile').val() || angular.element('.keyword_search').val());
                    localStorageService.set('widesearch', JSON.stringify(widesearch));
                    $location.path('/');
                    $scope.$emit('widesearch', widesearch);
                }
                $scope.keywordSearchedHere = false;
                if (widesearch.length < 1 && features && features.length < 1 && $scope.keywordSearchedHere) {
                    angular.element("[lpa-keyword]").addClass("errtxt");
                    angular.element("[lpa-keyword]").siblings(".errormsg").show();
                }
                $scope.filtered_temp_slider_data = [];
                $scope.right_slider_data = [];
                // Since currently backend returns all the event centers without filtering them based on criteria we have to call filter after fetching to filter those event centers
                // $scope.filterMapMarkerJS(); // filterMapMarkerJS commented by nick
                $scope.filterMapGLMarker();
                if ($scope.selected.showUpcomingEvents) {
                   // traceLog("discover-mapbox-refreshmarkers", 'As upcoming events option is selected, hence need to filter icons, calling filterMapMarkerJS()');
                    $scope.right_slider = false;
                } else {
                    $scope.right_slider = true;
                    $scope.showEstaEventSlider = true;
                    $scope.loadMoreSlider();
                }
                $scope.$apply();
            });
            return marker;
        };
        $scope.initMarkerGL = function() {
            if (!$scope.map_map || typeof $scope.map_map.on !== 'function') {
        console.log('initMarkerGL called too early. Postponing markers layout initialization.');
        $scope.runMarkersWhenMapReady = true;
        return;
    }
            var iconsDebounced = debounce($scope.refreshMarkers, 1000, false);
            //var promotionsDebounced = debounce($scope.loadPromotionsOnDragMap, 1500, false);
        //    var loadIsHangingDebounced = debounce($scope.loadHangingOrSkyScrapperPromotionsOnDragMap, 1500, false);
           // var loadSkyScrapperDebounced = debounce($scope.loadHangingOrSkyScrapperPromotionsOnDragMap, 1500, false);
            $scope.map_map.on("dragend", function(event) {
               // traceLog('tn-discover-dataondraga', 'on["dragend"]');
                var center = $scope.map_map.getCenter();
                if (center) {
                   // traceLog('tn-discover-dataondrag1', 'on["dragend"] center cordinate value is ', center);
                    //commented by nicklesh for temporary purpose
                    // var requestInfo = {
                    //     lat: center.lat,   //     long: center.lng,   // };
                    // var debouncedPromotionsDrag = promotionsDebounced(requestInfo);
                    // debouncedPromotionsDrag.then(function(res) {
                    //// console.log('promotions slider debounced');
                    // }).catch(function(e) {
                    //// console.log(e);
                    // });
                    // var loadIsHangingDebouncedDrag = loadIsHangingDebounced(requestInfo, 'is_hanging');
                    // loadIsHangingDebouncedDrag.then(function(res) {
                    //// console.log('is hanging promotions debounced');
                    // }).catch(function(e) {
                    //// console.log(e);
                    // });
                    // var loadSkyScrapperDebouncedDrag = loadSkyScrapperDebounced(requestInfo, 'is_skyscrapper');
                    // loadSkyScrapperDebouncedDrag.then(function(res) {
                    //// console.log('is skyscraper promotions debounced');
                    // }).catch(function(e) {
                    //// console.log(e);
                    // });
                }
                $location.search('at', center.lng + "," + center.lat);
                if (!$scope.dataFetchedOnce) { //temp comment by nick
                   // traceLog('tn-discover-load', 'on["dragend"]: since category is not clicked till now skipping load on drag end');
                    return;
                }
                var debouncedDrag = iconsDebounced({
                    forceFetch: true
                });
                debouncedDrag.then(function(res) {
                    // console.log('new icons');
                }).catch(function(e) {
                    // console.log(e);
                });
            });
            
            var previousZoom;
            $scope.map_map.on('zoomend', function() {
                if ($scope.blockZoomEvent) {
                    $scope.blockZoomEvent = false;
                    return;
                }
               // traceLog('discover-zoom', 'on["zoomend"]: calling $scope.refreshMarkers()');
                /*
                Don't try to load/draw icons on map until one of the categories are click
                [change-reason] - 15-May - Icons would only be loaded on category click
                */
                var currentZoomLevel = $scope.map_map.getZoom();
                $location.search("zoom", currentZoomLevel);
                // console.log("existingZoomnumberbeforefunction", currentZoomLevel);
                if (currentZoomLevel > 2.2) {
                    angular.element('#mpbxc').addClass('bradius');
                } else if (currentZoomLevel < 2.2) {
                    angular.element('#mpbxc').removeClass('bradius');
                };
                if (currentZoomLevel > 1.3) {
                    angular.element('#mpbxc').addClass('mobdius');
                } else if (currentZoomLevel < 1.3) {
                    angular.element('#mpbxc').removeClass('mobdius');
                }
                if (!$scope.dataFetchedOnce) {
                   // traceLog('discover-zoom', 'on["zoomend"]: since category is not clicked till now skipping load on zoom end');
                    return;
                }
                // if ($scope.isZoomedIn) {
                //    // traceLog('discover-zoom', 'on["zoomend"]: since map is zoomed in no need to fetch additional data as data is already available');
                //     return;
                // }
                //$scope.isFirstLoad = false; //because map flys to establishment
                // making icon query only when zoom transition stops completely
                setTimeout(function() {
                    if (currentZoomLevel === $scope.map_map.getZoom()) {
                        var debouncedZoom = iconsDebounced({
                            forceFetch: true
                        });
                        debouncedZoom.then(function(res) {
                                // console.log('new icons');
                            })
                            .catch(function(e) {
                                // console.log(e);
                            });
                    }
                }, 500);
            });
            $scope.dataFetchedOnce = true;
        };
  

 


// Default: show both worlds
$scope.igGlobalMode = 'all';
$scope.igAllClicked = false; // Initial all-visible view is not an explicit All selection.
$scope.activeSet = 'all';
$scope.activeCategories = ($scope.homecategories || []).concat($scope.homecategories2 || []);
$scope.lifeGenre = false;

$scope.setCategorySet = function(setName) {
    $scope.igAllClicked = false;

    if (setName === 'alt') {

        // NEWS / LIFE ONLY
        $scope.activeCategories = $scope.homecategories2;
        $scope.activeSet = 'alt';
        $scope.igGlobalMode = 'news';
        $scope.lifeGenre = true;

    } else if (setName === 'home') {

        // ENTERTAINMENT ONLY
        $scope.activeCategories = $scope.homecategories;
        $scope.activeSet = 'home';
        $scope.igGlobalMode = 'entertainment';
        $scope.lifeGenre = false;

    } else {

        // ALL: BOTH WORLDS
        $scope.activeCategories = ($scope.homecategories || []).concat($scope.homecategories2 || []);
        $scope.activeSet = 'all';
        $scope.igGlobalMode = 'all';
        $scope.lifeGenre = false;
    }
};

// Keep older toggle behavior
$scope.switchCategorySet = function() {
    if ($scope.activeSet === 'home') {
        $scope.setCategorySet('alt');
    } else {
        $scope.setCategorySet('home');
    }
};


















 
















  $scope.markerLoadUrlJS = function(map, marker, loadUrl) {
           // traceLog("tn-discover-reloadmapicons", "called-> marker.loadURL('" + loadUrl + "')");
            $scope.right_slider_data = [];
            $scope.temp_right_slider_data = [];
            $scope.added_id = [];
            $scope.filtered_temp_slider_data = [];
            // clear icons
            marker.clearLayers();
            marker.loadURL(loadUrl);
            $scope.$emit('maploadingfinished');
        };
        $scope.$on('refresh-markers', function(err, selected, options) {
           // traceLog('discover-refreshmarkers7', "on[load-markers]: selected, options ", selected, options);
            $scope.selected = selected;
            $scope.refreshMarkers(options);
        });
        $scope.$on('reloadHomePage', function(err, selected, options) {
           // traceLog('discover-reload-home-page', "on[reloadHomePage]");
            $scope.closeModal();
            if ($window.location.pathname !== '/') {
                $window.location.href = '/';
            } else {
                if (isMobile) {
                    var zoomLevel = 1.2
                }
                if (!isMobile) {
                    var zoomLevel = 1.2
                }
                $scope.map_map.setZoom(zoomLevel);
                $location.search("zoom", zoomLevel);
            }
        });
        
        function selectionChangedAtLevel(selected, old) {
           
            if ((selected.keyword && !old.keyword) || (selected.keyword && old.keyword && selected.keyword.id != old.keyword.id)) {
                return 8;
            } else if (selected.keyword && old.keyword && selected.keyword.id == old.keyword.id) {
                // keyword selection is not changed same keyword is selected again, return 10 to indicate no change to condition
                return 10;
            } else if ((selected.showUpcomingEvents != selected.showUpcomingEvents)) {
                return 9;
            } else if (selected.category_id != old.category_id) {
                if (!selected.category_id)
                    return 0;
                else
                    return 1;
            } else if (selected.subcategory_id != old.subcategory_id) {
                if (!selected.subcategory_id)
                    return -1; // - just indicates direction of selection being up-wards meaning category is selected again after selecting its children
                else
                    return 2;
            } else if (selected.childcategory_id != old.childcategory_id) {
                if (!selected.childcategory_id)
                    return -2; // - just indicates direction of selection being up-wards meaning sub-category is selected again after selecting its children
                else
                    return 3;
            } else if (selected.genre_id != old.genre_id) {
                if (!selected.genre_id) {
                    if (selected.childcategory_id)
                        return -3; // - just indicates direction of selection being upwards meaning child-category is selected again after selecting genre
                    else
                        return 2;
                } else
                    return 4;
            } else if (!selected.genre_id && !selected.childcategory_id && !selected.subcategory_id && !selected.category_id) {
                return 0; // initial stage
            } else
                return 10; // no changes to selection
        }
        /**
         * Called when user closes cat/gen menu
         */
        $scope.$on('clearMarkers', function(e, data) {
           // traceLog("discover-refreshmarkers12", "on[clearMarkers]");
            // set filter to return false to remove all markers from map
            if ($scope.map_marker)
                $scope.map_marker.setFilter(function() {
                    return false;
                });
            $scope.selected = {};
            $scope.filtered_temp_slider_data = [];
            $scope.right_slider_data = [];
            $scope.closeCategoryPopup();
            $scope.mapMarkersCleared = true;
        });
        /**
         * This filters markers that are already on map by changing conditions of filtering
         */
        $scope.filterMapMarkerJS = function() {
            filterIcons = true;
            $scope.filtered_temp_slider_data = [];
            $scope.right_slider_data = [];
            var filteredEEIDsUpcomingEvents = [];
            var filteredEvents;
            var marker = $scope.map_marker;
            if (!marker) return;
            if ($scope.selected.genre_id) {
                if ($scope.selected.showUpcomingEvents) {
                    // Show upcoming events is selected, filter events by selected child category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                   // traceLog("discover-filter-upcomingevents", "childcategory selected: eventsForCategory ", eventsForCategory);
                    if (eventsForCategory) {
                        // filter events by subcategory
                        filteredEvents = eventsForCategory.events.filter(function(event) {
                            if (Array.isArray(event.genre) && event.genre.findIndex(function(g) {
                                    return g.genre_id == $scope.selected.genre_id;
                                }) > -1)
                                return true;
                            else if (event.genre.genre_id == $scope.selected.genre_id)
                                return true;
                            return false;
                        });
                        $scope.filteredUpcomingEventsData = $scope.upcomingEventsData.map(function(cat) {
                            if ($scope.selected.category_id == cat.category_id) {
                                return Object.assign({}, cat, {
                                    events: filteredEvents
                                });
                            }
                            return cat;
                        });
                       // traceLog("discover-filter-upcomingevents", "filteredUpcomingEventsData ", JSON.parse(JSON.stringify($scope.filteredUpcomingEventsData)));
                       // traceLog("discover-filter-upcomingevents", "childcategory selected: filtered events", eventsForCategory);
                        if (filteredEvents.length)
                            filteredEEIDsUpcomingEvents = filteredEvents.map(function(e) {
                                return e.estaId;
                            });
                        else
                            filteredEEIDsUpcomingEvents = [];
                    }
                   // traceLog("discover-filter-upcomingevents", "childcategory selected: filteredEEIDsUpcomingEvents ", filteredEEIDsUpcomingEvents);
                }
               // traceLog("discover-filter", "selected: genre id is ", $scope.selected.genre_id);
                if ($scope.selected.subcategory_id === 336 || $scope.selected.subcategory_id === 337) {
                    // Genre selected - This is Children's category
                    /*
                    This is the special case of selecting Children's category and then selecting one of the sub-categories Designed for Children/Child Friendly
                    which would then show all the other categories (Adventures/Tours, Nature/Sites etc) to user, selecting any of the category would
                    make category_id go into genre_id above. So here genre_id is actually category_id of top level categories.
                    */
                    /* As establishments do not contain category_id but subcategory ids we need to filter using subcategory id,   for which each genre (actually a category contains subCategries information as well in subCatId) so extract that.
                     */
                    var subcategory_ids = $scope.map_genres.find(function(g) {
                        return g.genre_id == $scope.selected.genre_id;
                    }).subcategory_id;
                   // traceLog("discover-filter", "sub-categories of selected genre (a category actually) ", subcategory_ids);
                    var cond = ($scope.selected.subcategory_id == 336) ? 'designchild' : 'childfriendly';
                    marker.setFilter(function(f) {
                        var matchedTillNow = true;
                        var icon = f.properties.icon;
                       // traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                       // traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                       // traceLog("discover-filter", "" + f.properties.title + ": condition is : ($scope.selected.genre_id) && ($scope.selected.subcategory_id === 336 || $scope.selected.subcategory_id === 337) ARGS[$scope.selected.genre_id, $scope.selected.subcategory_id] ", $scope.selected.genre_id, $scope.selected.subcategory_id);
                        // Check child criteria
                        if ($scope.selected.subcategory_id == 336 && (icon.designchild || ((Array.isArray(icon.subCat) && icon.subCat.indexOf(336) > -1) || (!Array.isArray(icon.subCat) && icon.subCat == 336)))) {
                           // traceLog("discover-filter", "" + f.properties.title + "***MATCHED*** : ($scope.selected.subcategory_id == 336 && icon.designchild) [ARGS:$scope.selected.subcategory_id, icon.designchild] ", $scope.selected.subcategory_id, icon.designchild);
                            matchedTillNow = true;
                        } else if ($scope.selected.subcategory_id == 337 && (icon.childfriendly || ((Array.isArray(icon.subCat) && icon.subCat.indexOf(337) > -1) || (!Array.isArray(icon.subCat) && icon.subCat == 337)))) {
                           // traceLog("discover-filter", "" + f.properties.title + "***MATCHED*** : ($scope.selected.subcategory_id == 337 && icon.childfriendly) [ARGS:$scope.selected.subcategory_id, icon.childfriendly] ", $scope.selected.subcategory_id, icon.childfriendly);
                            matchedTillNow = true;
                        } else {
                           // traceLog("discover-filter", "" + f.properties.title + "!!!NOTMATCHED!!! : ($scope.selected.subcategory_id == 337 && icon.childfriendly) [ARGS:$scope.selected.subcategory_id, icon.childfriendly] ", $scope.selected.subcategory_id, icon.childfriendly);
                            matchedTillNow = false;
                        }
                        // See if icons subcategories matched selected genre (category) subcategories
                        if (matchedTillNow) {
                            if (!Array.isArray(icon.subCat) && subcategory_ids.indexOf(icon.subCat) > -1) {
                               // traceLog("discover-filter", "" + f.properties.title + "***MATCHED*** : (!Array.isArray(icon.subCat) && subcategory_ids.indexOf(icon.subCat) > -1) [ARGS:subcategory_ids, icon.subCat] ", subcategory_ids, icon.subCat);
                                matchedTillNow = true;
                            } else if (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function(result, subCat) {
                                    if (result || subcategory_ids.indexOf(subCat) > -1) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }, false)) {
                               // traceLog("discover-filter", "" + f.properties.title + "***MATCHED*** : (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function (result, subCat) [ARGS:subcategory_ids, icon.subCat] ", subcategory_ids, icon.subCat);
                                matchedTillNow = true;
                            } else {
                               // traceLog("discover-filter", "" + f.properties.title + "!!!NOTMATCHED!!! : (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function (result, subCat) [ARGS:subcategory_ids, icon.subCat] ", subcategory_ids, icon.subCat);
                                matchedTillNow = false;
                            }
                            if (matchedTillNow) {
                                $scope.addFilteredSlider(f);
                               // traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                                return true;
                            }
                            return false;
                        }
                    });
                } else {
                    // Genre selected - Other than children's category
                    marker.setFilter(function(f) {
                        var icon = f.properties.icon;
                        var matchedTillNow = true;
                       // traceLog("discover-filter", "" + f.properties.title + ": -------------------------- GENRE SELECTED ------------- ", $scope.selected);
                       // traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                       // traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                        if (!$scope.selected.showUpcomingEvents) {
                            if (icon.is_establish == 1) {
                                // Genre selected - Other than children's category - Icon is an establishment
                               // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 1)");
                                // Genre ids are not shared between two parents so if it matches we can safely consider that above hierarchy also matches
                                if (matchedTillNow && $scope.selected.genre_id) {
                                   // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** :((!Array.isArray(icon.subCat) && icon.subCat == $scope.selected.subcategory_id) || (Array.isArray(icon.subCat) && icon.subCat.indexOf($scope.selected.subcategory_id) > -1)) [ARGS:icon.subCat, $scope.selected.subcategory_id]  ", icon.subCat, $scope.selected.subcategory_id);
                                    if ((!Array.isArray(icon.genreId) && icon.genreId == $scope.selected.genre_id) || (Array.isArray(icon.genreId) && icon.genreId.indexOf($scope.selected.genre_id) > -1)) {
                                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** :(!Array.isArray(icon.genreId) && icon.genreId == $scope.selected.genre_id) || (Array.isArray(icon.genreId) && icon.genreId.indexOf($scope.selected.genre_id) > -1) [ARGS:icon.genreId, $scope.selected.genre_id] ", icon.genreId, $scope.selected.genre_id);
                                        matchedTillNow = true;
                                    } else {
                                       // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                        matchedTillNow = false;
                                    }
                                }
                                if (!matchedTillNow) {
                                    // check to see if events genre id matches if yes we can still show this establishment
                                    if (icon.upcomingEventGenreids) {
                                       // traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventGenreids) MATCHED: [ARGS:icon.upcomingEventGenreids] ", icon.upcomingEventGenreids);
                                        if ((typeof(icon.upcomingEventSubcatids) === 'number' && icon.upcomingEventSubcatids == $scope.selected.subcategory_id) || (typeof(icon.upcomingEventSubcatids) === 'object' && icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1)) {
                                           // traceLog("discover-filter", "" + f.properties.title + ": ((typeof(icon.upcomingEventSubcatids) === 'number' && icon.upcomingEventSubcatids == $scope.selected.subcategory_id) || (typeof(icon.upcomingEventSubcatids) === 'object' && icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1)) MATCHED: [ARGS:icon.upcomingEventSubcatids,$scope.selected.subcategory_id] ", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                            if ((typeof(icon.upcomingEventGenreids) === 'number' && icon.upcomingEventGenreids == $scope.selected.genre_id) || (typeof(icon.upcomingEventGenreids) === 'object' && icon.upcomingEventGenreids.indexOf($scope.selected.genre_id) > -1)) {
                                                matchedTillNow = true;
                                            } else {
                                               // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                                matchedTillNow = false;
                                            }
                                        } else {
                                           // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                            matchedTillNow = false;
                                        }
                                    }
                                }
                            }
                            if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                                // Genre selected - Other than children's category - Icon is an Event Center
                               // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 2)");
                                if (icon.upcomingEventGenreids) {
                                   // traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventGenreids) MATCHED: [ARGS:icon.upcomingEventGenreids] ", icon.upcomingEventGenreids);
                                    if ((typeof(icon.upcomingEventSubcatids) === 'number' && icon.upcomingEventSubcatids == $scope.selected.subcategory_id) || (typeof(icon.upcomingEventSubcatids) === 'object' && icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1)) {
                                       // traceLog("discover-filter", "" + f.properties.title + ": ((typeof(icon.upcomingEventSubcatids) === 'number' && icon.upcomingEventSubcatids == $scope.selected.subcategory_id) || (typeof(icon.upcomingEventSubcatids) === 'object' && icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1)) MATCHED: [ARGS:icon.upcomingEventSubcatids,$scope.selected.subcategory_id] ", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                        if ((typeof(icon.upcomingEventGenreids) === 'number' && icon.upcomingEventGenreids == $scope.selected.genre_id) || (typeof(icon.upcomingEventGenreids) === 'object' && icon.upcomingEventGenreids.indexOf($scope.selected.genre_id) > -1)) {
                                            matchedTillNow = true;
                                        } else {
                                           // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                            matchedTillNow = false;
                                        }
                                    } else {
                                       // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                        matchedTillNow = false;
                                    }
                                }
                            }
                        } else {
                            // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                            if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                               // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** (filteredEEIDsUpcomingEvents): ARGS:[filteredEE, icon.esta_id) ", filteredEEIDsUpcomingEvents, icon.esta_id);
                                matchedTillNow = true;
                            } else {
                               // traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                                matchedTillNow = false;
                            }
                        }
                        if (matchedTillNow) {
                            $scope.addFilteredSlider(f);
                           // traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                            return true;
                        }
                        return false;
                    });
                }
            } else if ($scope.selected.childcategory_id) {
                if ($scope.selected.showUpcomingEvents) {
                    // Show upcoming events is selected, filter events by selected child category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                   // traceLog("discover-filter-upcomingevents", "childcategory selected: eventsForCategory ", eventsForCategory);
                    if (eventsForCategory) {
                        // filter events by subcategory
                        var filteredEvents = eventsForCategory.events.filter(function(event) {
                            if (Array.isArray(event.childcat) && event.childcat.indexOf($scope.selected.childcategory_id) > -1)
                                return true;
                            else if (event.childcat == $scope.selected.childcategory_id)
                                return true;
                            return false;
                        });
                       // traceLog("discover-filter-upcomingevents", "childcategory selected: filtered events", eventsForCategory);
                        if (filteredEvents.length)
                            filteredEEIDsUpcomingEvents = filteredEvents.map(function(e) {
                                return e.estaId;
                            });
                        else
                            filteredEEIDsUpcomingEvents = [];
                        $scope.filteredUpcomingEventsData = $scope.upcomingEventsData.map(function(cat) {
                            if ($scope.selected.category_id == cat.category_id) {
                                return Object.assign({}, cat, {
                                    events: filteredEvents
                                });
                            }
                            return cat;
                        });
                    }
                   // traceLog("discover-filter-upcomingevents", "childcategory selected: filteredEEIDsUpcomingEvents ", filteredEEIDsUpcomingEvents);
                }
                // Child category selected
                marker.setFilter(function(f) {
                    var matchedTillNow = true;
                    var icon = f.properties.icon;
                   // traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                   // traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                   // traceLog("discover-filter", "" + f.properties.title + ": condition is : ($scope.selected.childcategory_id) ARGS[$scope.selected.childcategory_id] ", $scope.selected.childcategory_id);
                    if (!$scope.selected.showUpcomingEvents) {
                        if (icon.is_establish == 1) {
                            // Child category selected - Icon is an establishment
                           // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 1)");
                            // A child category is unique and associated with only one parent so matching child category means matching parent hierarchy
                            if (matchedTillNow) {
                                // An establishments can have multiple child categories or single as well, only one child category can be selected from menu so perform match accordingly
                                if (icon.childCat) {
                                   // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: (icon.childCat) : [ARGS:icon.childCat] ", icon.childCat);
                                    if ((!Array.isArray(icon.childCat) && icon.childCat == $scope.selected.childcategory_id) || (Array.isArray(icon.childCat) && icon.childCat.indexOf($scope.selected.childcategory_id) > -1)) {
                                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: ((!Array.isArray(icon.childCat) && icon.childCat == $scope.selected.childcategory_id) || (Array.isArray(icon.childCat) && icon.childCat.indexOf($scope.selected.childcategory_id) > -1)) : [ARGS:icon['childCat'], $scope.selected.childcategory_id] ", icon['childCat'], $scope.selected.childcategory_id);
                                        matchedTillNow = true;
                                    } else {
                                       // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!: ((!Array.isArray(icon.childCat) && icon.childCat == $scope.selected.childcategory_id) || (Array.isArray(icon.childCat) && icon.childCat.indexOf($scope.selected.childcategory_id) > -1)) : [ARGS:icon['childCat'], $scope.selected.childcategory_id] ", icon['childCat'], $scope.selected.childcategory_id);
                                        matchedTillNow = false;
                                    }
                                } else {
                                    // As child category is selected and this establishment don't have child categories so not matched
                                    matchedTillNow = false;
                                   // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!: (icon.childCat) : [ARGS:icon.childCat] ", icon.childCat);
                                }
                            }
                            if (!matchedTillNow) {
                                // establishment is not maching selected child category/sub category try to see if upcoming events matches condition
                                if (icon.upcomingEventChildcatids && icon.upcomingEventChildcatids.length > 0) {
                                    if (icon.upcomingEventChildcatids.indexOf($scope.selected.childcategory_id) > -1) {
                                       // traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) MATCHED: [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                        matchedTillNow = true;
                                    } else {
                                        matchedTillNow = false;
                                       // traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                    }
                                } else {
                                    matchedTillNow = false;
                                   // traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            }
                        }
                        if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                            // Child category selected - Icon is an event center
                           // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 2)");
                            if (icon.upcomingEventChildcatids && icon.upcomingEventChildcatids.length > 0) {
                                if (icon.upcomingEventChildcatids.indexOf($scope.selected.childcategory_id) > -1) {
                                   // traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) MATCHED: [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                    matchedTillNow = true;
                                } else {
                                    matchedTillNow = false;
                                   // traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            } else {
                                matchedTillNow = false;
                               // traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                            }
                        }
                    } else {
                        // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                        if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                           // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** (filteredEEIDsUpcomingEvents): ARGS:[filteredEE, icon.esta_id) ", filteredEEIDsUpcomingEvents, icon.esta_id);
                            matchedTillNow = true;
                        } else {
                           // traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                            matchedTillNow = false;
                        }
                    }
                    if (matchedTillNow) {
                        $scope.addFilteredSlider(f);
                       // traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                        return true;
                    }
                    return false;
                });
            } else if ($scope.selected.subcategory_id) {
                if ($scope.selected.showUpcomingEvents) {
                    // Show upcoming events is selected, filter events by sub category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                   // traceLog("discover-filter-upcomingevents", "subcategory selected: eventsForCategory ", eventsForCategory);
                    if (eventsForCategory) {
                        // filter events by subcategory
                        filteredEvents = eventsForCategory.events.filter(function(event) {
                            if (event.subcat && event.subcat.category_id == $scope.selected.subcategory_id)
                                return true;
                            return false;
                        });
                       // traceLog("discover-filter-upcomingevents", "subcategory selected: filtered events", eventsForCategory);
                        if (filteredEvents.length)
                            filteredEEIDsUpcomingEvents = filteredEvents.map(function(e) {
                                return e.estaId;
                            });
                        else
                            filteredEEIDsUpcomingEvents = [];
                        $scope.filteredUpcomingEventsData = $scope.upcomingEventsData.map(function(cat) {
                            if ($scope.selected.category_id == cat.category_id) {
                                return Object.assign({}, cat, {
                                    events: filteredEvents
                                });
                            }
                            return cat;
                        });
                    }
                   // traceLog("discover-filter-upcomingevents", "subcategory selected: filteredEEIDsUpcomingEvents ", filteredEEIDsUpcomingEvents);
                }
                // Sub category selected
                marker.setFilter(function(f) {
                    var matchedTillNow = true;
                    var icon = f.properties.icon;
                   // traceLog("discover-filter", "" + f.properties.title + ": ------------------- SUBCATEGORY SELECTED -------------  ", $scope.selected);
                   // traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                   // traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                    if (!$scope.selected.showUpcomingEvents) {
                        if (icon.is_establish == 1) {
                            // Sub category selected - Icon is an Establishment
                           // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 1)");
                            // this is an establishment, hence it would have cat/subcat so compare it with selected criteria
                            if ($scope.selected.subcategory_id == 336 && icon.designchild) {
                               // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  ($scope.selected.subcategory_id == 336 && icon.designchild) [ARGS:icon.designchild, $scope.selected.subcategory_id]  ", icon.designchild, $scope.selected.subcategory_id);
                                matchedTillNow = true;
                            } else if ($scope.selected.subcategory_id == 337 && icon.childfriendly) {
                               // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  ($scope.selected.subcategory_id == 336 && icon.childfriendly) [ARGS:icon.childfriendly, $scope.selected.subcategory_id]  ", icon.childfriendly, $scope.selected.subcategory_id);
                                matchedTillNow = true;
                            } else if ((!Array.isArray(icon.subCat) && icon.subCat == $scope.selected.subcategory_id) || (Array.isArray(icon.subCat) && icon.subCat.indexOf($scope.selected.subcategory_id) > -1)) {
                               // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  ((!Array.isArray(icon.subCat) && icon.subCat == $scope.selected.subcategory_id) || (Array.isArray(icon.subCat) && icon.subCat.indexOf($scope.selected.subcategory_id) > -1)) [ARGS:icon.subCat, $scope.selected.subcategory_id]  ", icon.subCat, $scope.selected.subcategory_id);
                                matchedTillNow = true;
                            } else if (icon.upcomingEventSubcatids && icon.upcomingEventSubcatids.length > 0) {
                                // establishment subcategory did not match try event sub categories to see if they matched
                                if (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) {
                                   // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]  ", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                    matchedTillNow = true;
                                }
                            } else {
                               // traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                                matchedTillNow = false;
                            }
                        }
                        if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                           // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 2)");
                            if (icon.upcomingEventSubcatids && icon.upcomingEventSubcatids.length > 0) {
                                // establishment subcategory did not match try event sub categories to see if they matched
                                if (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) {
                                   // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]  ", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                    matchedTillNow = true;
                                } else {
                                    matchedTillNow = false;
                                   // traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            } else {
                                matchedTillNow = false;
                               // traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                            }
                        }
                    } else {
                        // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                        if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                           // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** (filteredEEIDsUpcomingEvents): ARGS:[filteredEE, icon.esta_id) ", filteredEEIDsUpcomingEvents, icon.esta_id);
                            matchedTillNow = true;
                        } else {
                           // traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                            matchedTillNow = false;
                        }
                    }
                    if (matchedTillNow) {
                        $scope.addFilteredSlider(f);
                       // traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                        return true;
                    }
                    return false;
                });
            } else if (Array.isArray($scope.selected.subcategory_ids)) {
                // Category Selected
                if ($scope.selected.showUpcomingEvents) {
                    // Show upcoming events is selected, filter events by category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                   // traceLog("discover-filter-upcomingevents", "filtered upcoming events are ", eventsForCategory);
                    if (eventsForCategory) {
                        // iterate on events to fetch all event ids
                        if (eventsForCategory.events.length)
                            filteredEEIDsUpcomingEvents = eventsForCategory.events.map(function(e) {
                                return e.estaId;
                            });
                    }
                   // traceLog("discover-filter-upcomingevents", "filtered establishment ids for upcoming events ", filteredEEIDsUpcomingEvents);
                }
                if ($scope.selected.subcategory_ids.indexOf(336) > -1 && $scope.selected.subcategory_ids.indexOf(337) > -1) {
                    marker.setFilter(function(f) {
                        var matchedTillNow = true;
                        var icon = f.properties.icon;
                       // traceLog("discover-filter", "" + f.properties.title + "--------------- CHILDREN CATEGORY SELECTED -----------------------");
                       // traceLog("discover-filter", "" + f.properties.title + ": SELECTED ", $scope.selected);
                       // traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId + " child friendly:" + icon.childfriendly + " designchild:" + icon.designchild);
                        /*
                        if (icon.childfriendly == true || icon.designchild == true) {
                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: (icon.childfriendly === true || icon.designchild === true) : [ARGS:icon.childfriendly, icon.designchild]", icon.childfriendly, icon.designchild);
                        matchedTillNow = true;
                        } else {
                       // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!: (icon.childfriendly === true || icon.designchild === true) : [ARGS:icon.childfriendly, icon.designchild]", icon.childfriendly, icon.designchild);
                        matchedTillNow = false;
                        }
                        */
                        if (matchedTillNow) {
                            $scope.addFilteredSlider(f);
                           // traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                            return true;
                        }
                        return false;
                    });
                } else {
                    // Category Selected - Other than Children's
                    marker.setFilter(function(f) {
                        var matchedTillNow = true;
                        var icon = f.properties.icon;
                       // traceLog("discover-filter", "" + f.properties.title + "--------------- CATEGORY SELECTED -----------------------");
                       // traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                       // traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                        if (!$scope.selected.showUpcomingEvents) {
                            if (icon.is_establish == 1) {
                                // Category Selected - Other than children's -> Icon is an Establishment
                                // As establishment only has sub-category's and not category, sub categories of category would be used to match
                               // traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 1)");
                                if (icon.subCat) {
                                    if (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function(result, subCat) {
                                            if (result || $scope.selected.subcategory_ids.indexOf(subCat) > -1) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }, false)) {
                                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function (result, subCat) == true) : [ARGS:$scope.selected.subcategory_ids, icon.subCat]", $scope.selected.subcategory_ids, icon.subCat);
                                        matchedTillNow = true;
                                    } else if ($scope.selected.subcategory_ids.indexOf(icon.subCat) > -1) {
                                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: ($scope.selected.subcategory_ids.indexOf(icon.subCat) > -1) : [ARGS:$scope.selected.subcategory_ids, icon.subCat]", $scope.selected.subcategory_ids, icon.subCat);
                                        matchedTillNow = true;
                                    } else {
                                        matchedTillNow = false;
                                       // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                    }
                                } else {
                                   // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                    matchedTillNow = false;
                                }
                            }
                            if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                                // try to match using upcoming events cat/genre
                                // see if events sub category matches selected one
                                if (icon.upcomingEventSubcatids && icon.upcomingEventSubcatids.length > 0) {
                                    if (icon.upcomingEventSubcatids.reduce(function(result, subCat) {
                                            if (result || $scope.selected.subcategory_ids.indexOf(subCat) > -1) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }, false)) {
                                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: (icon.upcomingEventSubcatids && icon.upcomingEventSubcatids.length > 0 && icon.upcomingEventSubcatids.reduce()) : [ARGS:$scope.selected.subcategory_ids, icon.upcomingEventSubcatids]", $scope.selected.subcategory_ids, icon.upcomingEventSubcatids);
                                        matchedTillNow = true;
                                    } else {
                                        matchedTillNow = false;
                                       // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                    }
                                } else {
                                    matchedTillNow = false;
                                   // traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            }
                        } else {
                            // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                            if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                               // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** (filteredEEIDsUpcomingEvents): ARGS:[filteredEE, icon.esta_id) ", filteredEEIDsUpcomingEvents, icon.esta_id);
                                matchedTillNow = true;
                            } else {
                               // traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                                matchedTillNow = false;
                            }
                        }
                        if (matchedTillNow) {
                           // traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                            $scope.addFilteredSlider(f);
                            return true;
                        }
                        return false;
                    });
                }
            } else {
                // All Categories Selected
                marker.setFilter(function(f) {
                    var matchedTillNow = true;
                    var icon = f.properties.icon;
                   // traceLog("discover-filter", "" + f.properties.title + "--------------- ALL CATEGORIES SELECTED -----------------------");
                   // traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                   // traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                    if ($scope.selected.showUpcomingEvents) {
                        // Currently we are not showing any icons when upcoming events is selected and all categories is selected
                        /*
                        if ($scope.allEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** ($scope.allEEIDsUpcomingEvents.indexOf()): ARGS:[filteredEE, icon.esta_id) ", $scope.allEEIDsUpcomingEvents, icon.esta_id);
                        matchedTillNow = true;
                        } else {
                       // traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                        matchedTillNow = false;
                        }
                        */
                        matchedTillNow = false;
                    } else {
                       // traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!! $scope.selected.showUpcomingEvents is false");
                        matchedTillNow = true;
                    }
                    if (matchedTillNow) {
                       // traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                        $scope.addFilteredSlider(f);
                        return true;
                    }
                    return false;
                });
            }
            $scope.loadMoreSlider();
        };
        /**
         * Called when filter of map needs to be changed, calls js or gl implement based on which is available
         * @param selected
         */
        $scope.filterMapMarker = function(selected) {
            $scope.right_slider_data = [];
           // traceLog("tn-discover-filtermapmarker", "selected is ", selected);
            $scope.selected = selected;
            angular.element('.markers').remove();
            $scope.stopAudio();
            // $scope.filterMapMarkerJS(); // filterMapMarkerJS commented by nick
            $scope.filterMapGLMarker();
        };
        /**
         * Draw map using lat/long and zoom, adjust data as per selected criteria cat/gen options and upcoming events
         * @param latitude
         * @param longitude
         * @param zoom
         */
        $scope.drawMap = function(latitude, longitude, zoom, forceFetch) {
           // traceLog("discover-drawmap", "Redrawing map with latitude, longitude, zoom, fetchIcons as ", latitude, longitude, zoom, forceFetch);
            latitude = parseFloat(latitude);
            longitude = parseFloat(longitude);
            if (!$scope.map_map)
                return;
           // traceLog("discover-mapbox", "current zoom is ", $scope.map_map.getZoom(), ", new zoom is ", zoom);
            $scope.map_map.flyTo({
                center: [longitude, latitude],
                zoom: zoom,
                bearing: 0,
                duration: 0,
                curve: 1,
                essential: true
            }); // $scope.map_map.setView(, zoom);
            $location.search("zoom", zoom);
            $location.search('at', longitude + "," + latitude);
            $scope.activateAppropriateZoomIndicator(zoom);
            window.setTimeout(function() {
                $scope.map_map.resize();
            }, 2000);
            // angular.element("#map").css("opacity", 1);
           // traceLog("discover-refreshmarkers13", "Current selection is ", JSON.stringify($scope.selected));
            if ($scope.selected.keyword && $scope.selected.keyword.id) {
               // traceLog("discover-refreshmarkers14", "There is a keyword selected calling-> $scope.refreshMarkers()");
                // keyword was searched before this page is drawn
                $scope.keywordWasSearched = true;
                $scope.refreshMarkers({
                    forceFetch: forceFetch
                });
            } else if ($scope.selected.category_id) {
                // As category is selected which means that user has visited discover page with options selected in menu so trigger refresh markers
               // traceLog("discover-refreshmarkers15", "User has category id selected in options of as url params calling-> $scope.refreshMarkers()");
                $scope.refreshMarkers({
                    forceFetch: forceFetch
                });
                $scope.updateQueryString($scope.selected.category_name, $scope.selected.subcategory_name, $scope.selected.childcategory_name, $scope.selected.genre_name);
            } else {
                if (forceFetch)
                    $scope.refreshMarkers({
                        forceFetch: forceFetch
                    });
            }
            if ($scope.selected.showUpcomingEvents) {
               // traceLog("discover-upcomingevents", "$scope.selected.showUpcomingEvents is true");
                $scope.getUpcomingEventsDiscover();
                $scope.showEstaEventSlider = false;
                localStorageService.remove('getUpcomingEvents');
            }
            var citySearch = localStorageService.get('city_search');
           // traceLog("tn-discover-redraw map citySearch", citySearch)
            if (citySearch) {
                var location = $location.search().at;
                location = location.split(',');
                localStorageService.remove('city_search');
                //$scope.loadPromotionsOnCitySearch(location[1], location[0]);
            }
        };
        /** closes select category popup **/
        $scope.closeCategoryPopup = function() {
            $scope.selectCategoryPopup = false;
        };
        /**
         * Called when translations of language is over now we can perform tasks that needs translated text like creating meta for this page
         */
        $rootScope.$on('$translateChangeSuccess', function() {
           // traceLog("discover-meta", "translation change success called");
            metaService($location.search());
        });




        var metaService = function(query) {

           // traceLog("discover-meta", "called-> metaService with query as ", query);

            // 🔒 HARD STOP if shared view already active


            var pageDescription = '';
            var keyWords = "";
            var metaOgImage = "ogiconoglobe.png";
            var metaEEtitle = '';

            // ✅ HANDLE SHARED (BASE64) LINKS
            if (query.data) {
                try {
                    var sharedParams = new URLSearchParams(atob(query.data));
                    var sName = decodeURIComponent(sharedParams.get('name') || "");
                    var sTitle = decodeURIComponent(sharedParams.get('title') || "");
                    var sPic = sharedParams.get('pic') || "";

                    if (sName || sPic) {

                        // 🔥 SET GLOBAL LOCK
                        $rootScope.isSharedView = true;

                        var metaData = {
                            isBroadcast: true, // 🔥 REQUIRED FOR HARD LOCK
                            pageTitle: sName + " is Live!",
                            metaKeywords: "iconoglobe, Live Stream, " + sName,
                            metaDescription: sTitle || "Watch " + sName + " live on iconoglobe.",
                            metaOgImage: sPic ?
                                (sPic.startsWith('http') ? sPic : "https://iconoglobe.com/i-i/" + sPic) : "ogiconoglobe.png"
                        };

                       // traceLog("discover-load", "SHARED META DETECTED", metaData);

                        metadatautil.metaInformation(metaData);

                        // ✅ Tell prerender immediately
                        window.prerenderReady = true;

                        return; // 🚫 STOP execution here
                    }

                } catch (e) {
                    console.error("MetaService shared data decode failed", e);
                }
            }

            // ✅ NORMAL META FLOW (NON-SHARED)
            if (query.establishment) {
                metaOgImage = $scope.esta_main_photo;
                metaEEtitle = query.establishment + ' ' + query.cityId + ' ' + query.countryId;

                pageDescription = $filter('translate')('views.estameta_beforename');
                pageDescription += ' ' + query.establishment + ' ' + query.cityId + ' ' + query.countryId + ' ';
            } else {
                // format metaEEtitle based on query paramaters

                query.in ? metaEEtitle = query.in : '';
                query.cityId ? metaEEtitle += ' ' + query.cityId : '';
                query.countryId ? metaEEtitle += ' ' + query.countryId : '';
                query.cat ? metaEEtitle += ' ' + $filter('translate')(query.cat).replace('<br>', '') : '';
                query.genre ? metaEEtitle += ' ' + $filter('translate')('views.and') + ' ' + $filter('translate')(query.genre).replace('<br>', '') : '';
                // format page description based on query paramaters

                pageDescription = $filter('translate')('views.estameta_beforename');
                query.cat ? pageDescription += ' ' + $filter('translate')(query.cat).replace('<br>', '') : '';
                query.genre ? pageDescription += ' ' + $filter('translate')('views.and') + ' ' + $filter('translate')(query.genre).replace('<br>', '') : '';
                query.in ? pageDescription += ' ' + query.in : '';
                query.cityId ? pageDescription += ' ' + query.cityId : '';
                query.countryId ? pageDescription += ' ' + query.countryId : '';
            }


            if (query.establishment) {
                keyWords += query.establishment;
            }
            if (query.genre) {
                keyWords += $filter('translate')(query.genre) + ",";
            }
            if (query.cat) {
                keyWords += $filter('translate')(query.cat) + ",";
            }
            if (query.in) {
                keyWords += query.in;
            }
            var metaData = {
                pageTitle: metaEEtitle,
                metaKeywords: keyWords,
                metaDescription: pageDescription,
                metaOgImage: metaOgImage
            };




           // traceLog("discover-load", "metaData is ", metaData);

            metadatautil.metaInformation(metaData);
        };

        /** CRITERIA HANDLING ON LOAD START **/
        var query = $location.search();
       // traceLog("discover-load", "query on load ", JSON.parse(JSON.stringify(query)));
        var locationUrl;
       // traceLog("my location coordinates", (JSON.parse(JSON.stringify(query))).at)
        metaService($location.search());
        $scope.centerForQuery;
        $scope.initMarkerGL();
        if ($scope.selected.category_id || query.cat || $scope.selected.keyword) {
            $scope.closeCategoryPopup();
        } else {
            $scope.selectCategoryPopup = true;
            $rootScope.showAllCategory = true;
            $rootScope.allCategoriesSelected = true;
        }
        if ($scope.selected.category_id) {
            $scope.bool.bannerAds = true;
        }
       // traceLog("discover-load", "$sclope.selected.keyword is ", $scope.selected.keyword);
        if ($scope.selected.keyword) {
            // since keyword is selected, show all categories button so that user can click that to remove filters
           // traceLog("discover-load", "show all category is set to true");
            $rootScope.showAllCategory = true;
        }
        if (query.rD) {
           // traceLog("discover-seo", "query contains [rD] ", query.rD);
            $scope.selected = {
                keyword: {
                    id: query.rD
                }
            }
            if (query.at) {
                var coord = query.at.split(",");

                var lat_val = parseFloat(coord[1]);
                var lng_val = parseFloat(coord[0]);
                $scope.centerForQuery = {
                    lat: lat_val,
                    lng: lng_val
                };
                if ($scope.map_map) {
                    $scope.map_map.flyTo({
                        center: [lng_val, lat_val],
                        zoom: query.zoom ? parseFloat(query.zoom) : 7
                    });
                    var requestInfo = {

                        lat: lat_val,
                        lng: lng_val,
                        long: lng_val
                    };
                   /* $scope.loadPromotionsOnDragMap(requestInfo);

                    $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');
                    $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');*/
                }

                
                if (query.cat && $scope.homecategories) {
                    for (var i = 0; i < $scope.homecategories.length; i++) {
                        var checkName = $scope.homecategories[i].category_name.replace('<br>', ' ').toLowerCase();
                        var urlName = query.cat.replace(/%20/g, ' ').toLowerCase();
                        if (checkName === urlName) {
                            $scope.selected.category_id = $scope.homecategories[i].category_id;
                            break;
                        }
                    }
                }
            }
 
            if (query.cat) {
                $timeout(function() {
                    // Only run if categories have actually loaded from the server
                    if ($scope.homecategories && $scope.homecategories.length > 0) {
                        // console.log("Syncing menu highlight for: " + query.cat);

                        for (var i = 0; i < $scope.homecategories.length; i++) {
                            // Clean the name from DB (remove <br>)
                            var dbName = $scope.homecategories[i].category_name.replace('<br>', ' ').toLowerCase().trim();
                            // Clean the name from URL (%20 to space)
                            var urlName = decodeURIComponent(query.cat).replace('<br>', ' ').toLowerCase().trim();

                            if (dbName === urlName) {
                                $scope.selected.category_id = $scope.homecategories[i].category_id;
                                break;
                            }
                        }
                    }
                }, 4000); // 4 second delay ensures establishments load first
            }



            $scope.isLoadCompleted = true;
            angular.element("#body").css("opacity", "1");
            $scope.isFirstLoad = false;
            $scope.setFirstLoadFlag(false);
            if (query.establishment)
                $scope.selected.keyword.type = 'establishment'
            else if (query.event)
                $scope.selected.keyword.type = 'event'
            else if (query.related)
                $scope.selected.keyword.type = 'related' 
		   $scope.homecategories = [{

                "category_id": 7,
                "iconimg": "i-i/adventures.svg",
                "category_name": "Adventures/<br>Tours"
            }, {
                "category_id": 6,
                "iconimg": "i-i/Festivals.svg",
                "category_name": "Festivals/<br>Exhibitions"
            }, {
                "category_id": 5,
                "iconimg": "i-i/Gaming.svg",
                "category_name": "Gaming/<br>Amusement"
            }, {
                "category_id": 4,
                "iconimg": "i-i/Museums.svg",
                "category_name": "Museums/<br>Cinemas"
            }, {
                "category_id": 3,
                "iconimg": "i-i/Music.svg",
                "category_name": "Music/<br>Performances"
            }, {
                "category_id": 2,
                "iconimg": "i-i/Nature.svg",
                "category_name": "Nature/<br>Sites"
            }, {
                "category_id": 283,
                "iconimg": "i-i/Sports.svg",
                "category_name": "Sports/<br>Competitions"
            }, {
                "category_id": 147,
                "iconimg": "i-i/Children.svg",
                "category_name": "Children"
            }];
        } else if (query.genre) {
            if (query.genre == 'Local Parks' && query.subcat == 'Parks') {
                $scope.selected = {
                    keyword: {
                        id: '191',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Architecture' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '195',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Landmarks' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '199',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sports' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '53',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'R&B' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '172',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Reggae' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '815',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Festivals/Exhibitions' && query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '1006',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Magic' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '304',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Aquarium' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '726',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wedding Exposition' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '606',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Lounge/Chill' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '169',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Blues' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '834',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dance' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '303',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Roller Coaster' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '36',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Holiday Festivals' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '729',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Food & Drink' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '50',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Comedy' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '302',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Pendulum Rides' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '35',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Classical' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '161',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Disco' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '96',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Car Shows' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '24',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Amusement Parks' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '37',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Electronic' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '163',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Classical' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '819',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cliff Diving' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '808',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Planetarium' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '812',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Ferris Wheels' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '33',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Alternative' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '159',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Reggaeton' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '829',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'R&B' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '901',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Museum/Cinemas' && query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '1011',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Artillery' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '107',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Folk' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '821',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Poker/Card Games' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '65',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Nature/Sites' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '530',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dinner Theater' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '668',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dinosaur Museum' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '749',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Alternative' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '849',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Jazz' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '921',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Card Games' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '64',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sports/Competitions' && query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '529',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Parks' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '790',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Live Music/Performances' && query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '531',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cosplay' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '680',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Karaoke' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '824',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Pop' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '171',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Aquatic Reserves' && query.subcat == 'Parks') {
                $scope.selected = {
                    keyword: {
                        id: '190',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cultural' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '47',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Country' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '933',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Individual' && query.subcat == 'Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '547',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Television Shows' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '552',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sports Bars' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '585',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Carnivals/Parades' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '46',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Latin' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '168',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hip Hop/Rap' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '934',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'City/State/Country' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '546',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Reggae' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '551',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Darkrides' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '32',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wax  Museum' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '158',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Gaming/Amusement' && query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '1009',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Childrens Museum' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '706',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'War-Military Museum' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '759',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Haunted Attractions' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '34',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Blues' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '160',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Nature/Sites' && query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '1010',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Independent' && query.subcat == 'Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '548',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'History' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '129',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Culture/History' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '544',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Conventions' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '26',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Carnival/Circus' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '30',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Spiritual' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '175',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Consumer Exhibitions' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '25',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Arcades' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '29',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Art' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '858',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Museum/Cinemas' && query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '1013',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Festivals/Exhibitions' && query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '535',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Lounge/Chill' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '922',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sports/Competitions' && query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '1005',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Variety Show' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '308',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'All Genres' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '622',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Seasonal' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '52',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Jazz' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '166',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Live Music/Performances' && query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '1007',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Zoos' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '39',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hip Hop/Rap' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '165',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Adventures/Tours' && query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '1008',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Celebrity/Entertainment' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '543',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Childrens Play Area' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '711',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == '3D/7D Theaters' && query.subcat == 'Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '728',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Animals' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '45',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Karaoke' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '167',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Circus Arts' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '301',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Opera' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '305',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Science' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '147',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Electronic' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '837',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Art' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '23',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hobbies' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '27',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Carousels' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '31',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Gothic' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '919',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Supernatural' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '991',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Keno' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '89',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sports Betting' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '100',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'World Heritage Sites' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '200',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Nature/Sites' && query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '1012',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Air Shows' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '22',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Pachinko' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '98',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'IMAX' && query.subcat == 'Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '103',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Mahjong' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '94',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Drive-in' && query.subcat == 'Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '102',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wrestling' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '687',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Industrial/Metal Rock' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '931',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Disco' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '95',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bingo' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '59',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Electronic Games' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '77',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'National Reserves' && query.subcat == 'Parks') {
                $scope.selected = {
                    keyword: {
                        id: '194',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fashion Show' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '587',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Film' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '49',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Nationality' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '170',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Live Theater' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '307',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Casino' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '438',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Gothic' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '582',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Supernatural' && query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '306',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Industrial/Metal Rock' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '581',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Country' && query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '162',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Reggaeton' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '373',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Music' && query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '578',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Rides' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '38',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Folk' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '164',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Supernatural' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '12',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Transportation/technology' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '545',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Travel Exhibition' && query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '28',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Multiplex' && query.subcat == 'Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '105',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Latin' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '936',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Paintball' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '16',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Track Betting' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '101',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dice Games' && query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '74',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'National Parks' && query.subcat == 'Parks') {
                $scope.selected = {
                    keyword: {
                        id: '193',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cultural Monuments' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '197',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Gaming/Amusement' && query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '534',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wine Bars' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '701',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Marine Parks' && query.subcat == 'Parks') {
                $scope.selected = {
                    keyword: {
                        id: '192',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Celebrity' && query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '196',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Adventures/Tours' && query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '533',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Supernatural' && query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '696',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Arcades' && query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '876',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Art' && query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '957',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Caving' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '3',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Air Gliding' && query.subcat == 'Adventures' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '279',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bird Watching' && query.subcat == 'Adventures' && query.childcat == 'Animal Air') {
                $scope.selected = {
                    keyword: {
                        id: '832',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Scuba Diving' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '940',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Quad Bike' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '784',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wind Surfing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '977',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rodeo' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '997',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Submarine' && query.subcat == 'Adventures' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '908',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skydiving' && query.subcat == 'Adventures' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '214',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hovercraft' && query.subcat == 'Adventures' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '990',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Mule Riding' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '233',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Horse Riding' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '231',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rockets' && query.subcat == 'Adventures' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '527',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Kite Surfing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '978',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wildlife Safari' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '898',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Airplane Flying' && query.subcat == 'Adventures' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '881',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Whale Watching' && query.subcat == 'Adventures' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '864',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sailing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '900',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Jet Skiing' && query.subcat == 'Adventures' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '297',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hot Air Ballooning' && query.subcat == 'Adventures' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '838',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Off-Road Vehicles' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '291',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Jet Skiing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '956',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motorcycle Racing' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '290',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Auto Racing' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '894',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dog Sledding' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '225',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Swimming' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '273',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Jets' && query.subcat == 'Adventures' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '526',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Camel Riding' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '221',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Free Diving' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '267',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snorkeling' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '271',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hang Gliding' && query.subcat == 'Adventures' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '942',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Paragliding' && query.subcat == 'Adventures' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '943',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Kiteboarding' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '716',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cruise Ships' && query.subcat == 'Adventures' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '998',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bungee Jumping' && query.subcat == 'Adventures' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '208',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Boating' && query.subcat == 'Adventures' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '299',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Robot Fighting' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '292',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fishing' && query.subcat == 'Adventures' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '847',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Go Karting' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '883',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Diving' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '9',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Elephant Riding' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '939',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Boating' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '263',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cruise Ships' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '521',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dolphin Swimming' && query.subcat == 'Adventures' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '861',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Parasailing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '213',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fishing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '988',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Canoeing/Kayaking' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '265',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Ziplining/Omega' && query.subcat == 'Adventures' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '215',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Shark Diving' && query.subcat == 'Adventures' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '205',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snowmobiling' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '293',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Monster Trucking' && query.subcat == 'Adventures' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '288',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'White Water Rafting' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '964',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Surfing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '902',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Airplane Flying' && query.subcat == 'Adventures' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '280',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hunting' && query.subcat == 'Adventures' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '912',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Skiing' && query.subcat == 'Adventures' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '993',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Talent Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '496',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Off-Road Vehicles' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '868',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Elephant Riding' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '985',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Eating Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '489',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'American Football' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '851',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Remote Control Racing' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '896',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Boat Racing' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '932',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Stamina Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '960',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Climbing' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '10',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Remote Control Planes' && query.subcat == 'Competitions' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '555',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hovercraft' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '961',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snowboarding' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '872',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Ziplining/Omega' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '944',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rodeo' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '980',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Robot Fighting' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '855',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Skiing' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '891',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rugby' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '256',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Golf' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '250',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Lawn Mower Racing' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '866',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Horse Racing' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '230',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rat Racing' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '234',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Strength Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '494',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Style Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '885',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motorcycle Racing' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '966',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fishing' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '1002',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Skiing' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '276',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Stamina Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '493',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Remote Control Racing' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '744',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hot Air Ballooning' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '949',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Kite Surfing' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '268',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Surfing' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '272',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wind Surfing' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '278',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Beauty/Style Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '495',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Baseball' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '860',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rodeo' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '235',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Combat Sports/Martial Arts' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '491',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Buzkashi' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '218',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Pigeon Racing' && query.subcat == 'Competitions' && query.childcat == 'Animal Air') {
                $scope.selected = {
                    keyword: {
                        id: '879',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Boxing' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '387',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Shooting Range' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '721',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Swimming' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '970',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hang Gliding' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '209',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Pool/Billiards' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '254',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Jet Skiing' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '989',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Running' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '257',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Canoeing/Kayaking' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '828',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Ski Kiting' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '553',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Base Jumping' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '207',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hockey' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '251',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Goat Racing' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '910',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Ski Jumping' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '539',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fencing' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '247',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Lacrosse' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '839',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Boating' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '920',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snorkeling' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '1001',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Tricks Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '503',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Paragliding' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '822',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sailing' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '269',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Drinking Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '490',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Gymnastics' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '598',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Tricks Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '886',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Canoe Polo' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '264',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Design Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '483',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Polo' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '833',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Stamina Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '869',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snowmobiling' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '950',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Polo' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '275',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Drone Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '586',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Kite Flying' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '852',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Tennis/Raquet' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '906',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Scuba Diving' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '270',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Aerobics' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '274',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Tractor/Truck Pulling' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '871',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dog Racing' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '907',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hunting' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '979',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Camel Racing' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '926',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Synchronized Swimming' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '873',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Animal Beauty/Talent Competiti...' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '507',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fishing' && query.subcat == 'Competitions' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '204',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Sounds Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '505',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Stamina Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '501',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cricket' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '848',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Go Karting' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '965',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Style Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '500',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Turtle Racing' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '903',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Auto Racing' && query.subcat == 'Competitions' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '285',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Industry Trade Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '499',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Diving' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '859',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Style Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '967',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bird Beauty/Talent Competition...' && query.subcat == 'Competitions' && query.childcat == 'Animal Air') {
                $scope.selected = {
                    keyword: {
                        id: '525',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'White Water Rafting' && query.subcat == 'Competitions' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '878',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Buzkashi' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '923',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skydiving' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '951',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hunting' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '996',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Volleyball' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '262',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Martial Arts' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '415',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fish Beauty/Talent Competition...' && query.subcat == 'Competitions' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '487',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skating (Roller/Board/Ice)' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '826',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bowling' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '880',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Boating' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '952',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Table Tennis' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '260',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Tricks Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '484',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Horse Polo' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '899',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Parasailing' && query.subcat == 'Competitions' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '935',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Animal Sledding' && query.subcat == 'Competitions' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '508',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Football/Soccer' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '249',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'DodgeBall' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '882',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Falconry' && query.subcat == 'Competitions' && query.childcat == 'Animal Air') {
                $scope.selected = {
                    keyword: {
                        id: '201',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Design Competitions' && query.subcat == 'Competitions' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '502',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Basketball' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '892',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Precision Flying' && query.subcat == 'Competitions' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '282',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Gaming Competitions' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '498',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skiing' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '938',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cycling' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '8',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Archery' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '237',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Intelligence/Trivia Competitio...' && query.subcat == 'Competitions' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '497',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rowing' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '657',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fowling' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '20',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Goat Racing' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '228',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hunting' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '232',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Horse Riding' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '924',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snorkeling' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '925',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Paragliding' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '212',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Polo' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '542',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skating (Roller/Board/Ice)' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '945',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Kite Flying' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '210',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fencing' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '865',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Remote Control Racing' && query.subcat == 'Sports' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '973',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Synchronized Swimming' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '723',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hovercraft' && query.subcat == 'Sports' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '296',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Kite Surfing' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '911',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Animal Sledding' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '947',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Parasailing' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '983',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'White Water Rafting' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '277',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Combat Sports/Martial Arts' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '981',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Horse Polo' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '229',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skydiving' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '841',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Archery' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '877',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Camel Riding' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '913',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Remote Control Racing' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '994',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Boxing' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '386',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dog Racing' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '224',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wind Surfing' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '905',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Martial Arts' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '941',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Scuba Diving' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '986',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motor Boating' && query.subcat == 'Sports' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '843',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fishing' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '953',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cycling' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '874',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Canoeing/Kayaking' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '946',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Boating' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '982',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dolphin Swimming' && query.subcat == 'Sports' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '203',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Tractor/Truck Pulling' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '504',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rat Racing' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '875',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Pigeon Racing' && query.subcat == 'Sports' && query.childcat == 'Animal Air') {
                $scope.selected = {
                    keyword: {
                        id: '202',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'DodgeBall' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '246',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Surfing' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '975',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Table Tennis' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '814',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Base Jumping' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '850',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Diving' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '958',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fishing' && query.subcat == 'Sports' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '1003',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Tennis/Raquet' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '492',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Submarine' && query.subcat == 'Sports' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '528',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wind Surfing' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '995',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hot Air Ballooning' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '987',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Elephant Riding' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '226',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skiing' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '259',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Ski Kiting' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '845',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Swimming' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '890',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Lacrosse' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '252',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Canoe Polo' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '909',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Auto Racing' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '972',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'American Football' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '248',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Robot Fighting' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '955',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Climbing' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '243',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Lawn Mower Racing' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '287',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snowboarding' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '537',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Motorcycle Racing' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '884',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Shooting Range' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '929',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bowling' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '241',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Go Karting' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '286',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Football/Soccer' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '536',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Golf' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '867',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Basketball' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '240',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Pool/Billiards' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '823',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Gymnastics' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '895',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Turtle Racing' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '236',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Running' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '842',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Off-Road Vehicles' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '959',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Volleyball' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '1004',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Ziplining/Omega' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '825',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rodeo' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '915',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Polo' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '916',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Precision Flying' && query.subcat == 'Sports' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '863',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Water Skiing' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '971',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Falconry' && query.subcat == 'Sports' && query.childcat == 'Animal Air') {
                $scope.selected = {
                    keyword: {
                        id: '846',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cricket' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '244',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hang Gliding' && query.subcat == 'Sports' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '820',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Rugby' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '856',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Remote Control Planes' && query.subcat == 'Sports' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '928',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Buzkashi' && query.subcat == 'Sports' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '1000',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Baseball' && query.subcat == 'Sports' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '239',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Jet Skiing' && query.subcat == 'Sports' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '857',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Sailing' && query.subcat == 'Sports' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '974',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Snowmobiling' && query.subcat == 'Sports' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '840',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Boat Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '904',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Fish/Sea Life' && query.subcat == 'Tours' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '584',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Walking Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '733',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Architecture Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '514',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Segway Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '518',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'History/Culture Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '513',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bus/Van Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '517',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Submarine Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '844',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Factory Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '512',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Food/Drink Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '516',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wildlife Safari Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '520',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'MotorbikeTours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '764',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Dinner cruise' && query.subcat == 'Tours' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '727',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'City Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '937',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Off-road Motor Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '725',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Whale Watching' && query.subcat == 'Tours' && query.childcat == 'Animal Water') {
                $scope.selected = {
                    keyword: {
                        id: '206',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'City Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '510',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Supernatural' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '11',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cave Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '509',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cave Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Land') {
                $scope.selected = {
                    keyword: {
                        id: '818',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cruise Ships' && query.subcat == 'Tours' && query.childcat == 'Motor Water') {
                $scope.selected = {
                    keyword: {
                        id: '917',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Animal Riding Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '519',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hot Air Ballooning' && query.subcat == 'Tours' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '211',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Entertainment Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '511',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Helicopter Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '930',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Segway Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '914',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Airplane Tours' && query.subcat == 'Tours' && query.childcat == 'Motor Air') {
                $scope.selected = {
                    keyword: {
                        id: '524',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wildlife Safari Tours' && query.subcat == 'Tours' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '816',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Helicopter Tours' && query.subcat == 'Tours' && query.childcat == 'Human Air') {
                $scope.selected = {
                    keyword: {
                        id: '523',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cycling Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '769',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Art Tour' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '515',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Bird Watching' && query.subcat == 'Tours' && query.childcat == 'Animal Air') {
                $scope.selected = {
                    keyword: {
                        id: '554',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Animal Riding Tours' && query.subcat == 'Tours' && query.childcat == 'Animal Land') {
                $scope.selected = {
                    keyword: {
                        id: '831',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Nature Tours' && query.subcat == 'Tours' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '43',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Submarine Tours' && query.subcat == 'Tours' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '506',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cruise Ships' && query.subcat == 'Tours' && query.childcat == 'Human Water') {
                $scope.selected = {
                    keyword: {
                        id: '1014',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Hiking' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '567',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Caving' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '889',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skating (Roller/Board/Ice)' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '258',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Laser Tag' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '754',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Escape Rooms' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '724',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Climbing' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '862',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Archery' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '963',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Cycling' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '962',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Skiing' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '984',
                        type: 'genre'
                    }
                }
            }
            if (query.genre == 'Wildlife Safari' && query.subcat == 'Adventures' && query.childcat == 'Human Land') {
                $scope.selected = {
                    keyword: {
                        id: '21',
                        type: 'genre'
                    }
                }
            }
      
            $scope.makeMenuSelections(query.cat, query.subcat, query.childcat, query.genre, function() {});
            // We would now try to get appropriate data from backend based on cat/genre params
            if (query.at) {
                locationUrl = query.at;
                var coor = query.at.split(",");
                $scope.drawMap(coor[1], coor[0], query.zoom ? query.zoom : 7);
                // Load promotions based on location
                var requestInfo = {
                    lat: coor[1],
                    long: coor[0]
                };
                $scope.homecategories = [{

                    "category_id": 7,
                    "iconimg": "i-i/adventures.svg",
                    "category_name": "Adventures/<br>Tours"
                }, {
                    "category_id": 6,
                    "iconimg": "i-i/Festivals.svg",
                    "category_name": "Festivals/<br>Exhibitions"
                }, {
                    "category_id": 5,
                    "iconimg": "i-i/Gaming.svg",
                    "category_name": "Gaming/<br>Amusement"
                }, {
                    "category_id": 4,
                    "iconimg": "i-i/Museums.svg",
                    "category_name": "Museums/<br>Cinemas"
                }, {
                    "category_id": 3,
                    "iconimg": "i-i/Music.svg",
                    "category_name": "Music/<br>Performances"
                }, {
                    "category_id": 2,
                    "iconimg": "i-i/Nature.svg",
                    "category_name": "Nature/<br>Sites"
                }, {
                    "category_id": 283,
                    "iconimg": "i-i/Sports.svg",
                    "category_name": "Sports/<br>Competitions"
                }, {
                    "category_id": 147,
                    "iconimg": "i-i/Children.svg",
                    "category_name": "Children"
                }];
   $scope.homecategories2 = [{
                        "category_id": 329,
                        "iconimg": "i-i/news-politics.svg",
                        "category_name": "News/<br>Politics"
                    }, {
                        "category_id": 331,
                        "iconimg": "i-i/local-scene.svg",
                        "category_name": "Local Scene"
                    }, {
                     
						  "category_id": 332,
                        "iconimg": "i-i/nature-environment.svg",
                        "category_name": "Nature/<br>Environment"
                    }, {
                        "category_id": 333,
                        "iconimg": "i-i/education-exploration.svg",
                        "category_name": "Education/<br>Exploration"
                    }, {
                        "category_id": 328,
                        "iconimg": "i-i/personal-human-stories.svg",
                        "category_name": "Personal/<br>Human Stories"
                    }, {
                        "category_id": 330,
                        "iconimg": "i-i/conflicts.svg",
                        "category_name": "Conflicts"
                    }, {
                      
						                        "category_id": 327,
                        "iconimg": "i-i/spirituality-supernatural.svg",
                        "category_name": "Spirituality/<br>Supernatural"
                    }]; 

$scope.isLoadCompleted = true;
                angular.element("#body").css("opacity", "1");
                $scope.isFirstLoad = false;
                $scope.setFirstLoadFlag(false);
                /*$scope.loadPromotionsOnDragMap(requestInfo);
                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');

                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');*/
            }
        } else if (query.childcat) {
            if (query.childcat == 'Human Land' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '294',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Water' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '329',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Water' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '325',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Water' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '322',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Water' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '319',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Air' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '298',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Air' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '295',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Land' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '330',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Land' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '326',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Land' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '323',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Water' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '302',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Water' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '299',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Water' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '296',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Air' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '331',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Air' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '328',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Land' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '306',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Land' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '303',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Land' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '300',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Land' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '297',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Water' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '332',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Air' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '310',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Air' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '307',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Air' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '304',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Air' && query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '301',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Water' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '316',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Water' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '311',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Water' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '308',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Water' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '305',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Land' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '320',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Land' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '317',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Land' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '314',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Land' && query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '309',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Air' && query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '324',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Motor Air' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '321',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Animal Air' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '318',
                        type: 'childCat'
                    }
                }
            }
            if (query.childcat == 'Human Air' && query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '315',
                        type: 'childCat'
                    }
                }
            }
         
            $scope.makeMenuSelections(query.cat, query.subcat, query.childcat, query.genre, function() {});
            // We would now try to get appropriate data from backend based on cat/genre params
            if (query.at) {
                locationUrl = query.at;
                var coor = query.at.split(",");
                $scope.drawMap(coor[1], coor[0], query.zoom ? query.zoom : 7);
                // Load promotions based on location
                var requestInfo = {
                    lat: coor[1],
                    long: coor[0]
                }; 
		 $scope.homecategories = [{

                    "category_id": 7,
                    "iconimg": "i-i/adventures.svg",
                    "category_name": "Adventures/<br>Tours"
                }, {
                    "category_id": 6,
                    "iconimg": "i-i/Festivals.svg",
                    "category_name": "Festivals/<br>Exhibitions"
                }, {
                    "category_id": 5,
                    "iconimg": "i-i/Gaming.svg",
                    "category_name": "Gaming/<br>Amusement"
                }, {
                    "category_id": 4,
                    "iconimg": "i-i/Museums.svg",
                    "category_name": "Museums/<br>Cinemas"
                }, {
                    "category_id": 3,
                    "iconimg": "i-i/Music.svg",
                    "category_name": "Music/<br>Performances"
                }, {
                    "category_id": 2,
                    "iconimg": "i-i/Nature.svg",
                    "category_name": "Nature/<br>Sites"
                }, {
                    "category_id": 283,
                    "iconimg": "i-i/Sports.svg",
                    "category_name": "Sports/<br>Competitions"
                }, {
                    "category_id": 147,
                    "iconimg": "i-i/Children.svg",
                    "category_name": "Children"
                }];
                $scope.isLoadCompleted = true;
                angular.element("#body").css("opacity", "1");
                $scope.isFirstLoad = true;
                $scope.setFirstLoadFlag(true);
               /* $scope.loadPromotionsOnDragMap(requestInfo);
                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');

                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');*/
            }
        } else if (query.subcat) {
            if (query.subcat == 'Festivals') {
                $scope.selected = {
                    keyword: {
                        id: '10',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Designed For Children') {
                $scope.selected = {
                    keyword: {
                        id: '336',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Gaming') {
                $scope.selected = {
                    keyword: {
                        id: '12',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Tourist Sites') {
                $scope.selected = {
                    keyword: {
                        id: '16',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Night Clubs/Bars') {
                $scope.selected = {
                    keyword: {
                        id: '231',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Child Friendly') {
                $scope.selected = {
                    keyword: {
                        id: '337',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '11',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '15',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Live Music') {
                $scope.selected = {
                    keyword: {
                        id: '28',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Adventures') {
                $scope.selected = {
                    keyword: {
                        id: '323',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Museums') {
                $scope.selected = {
                    keyword: {
                        id: '14',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Performances') {
                $scope.selected = {
                    keyword: {
                        id: '27',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Sports') {
                $scope.selected = {
                    keyword: {
                        id: '285',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Tours') {
                $scope.selected = {
                    keyword: {
                        id: '313',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '13',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Parks') {
                $scope.selected = {
                    keyword: {
                        id: '17',
                        type: 'subCat'
                    }
                }
            }
            if (query.subcat == 'Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '284',
                        type: 'subCat'
                    }
                }
            }
       
            $scope.makeMenuSelections(query.cat, query.subcat, query.childcat, query.genre, function() {});
            // We would now try to get appropriate data from backend based on cat/genre params
            if (query.at) {
                locationUrl = query.at;
                var coor = query.at.split(",");
                $scope.drawMap(coor[1], coor[0], query.zoom ? query.zoom : 7);
                // Load promotions based on location
                var requestInfo = {
                    lat: coor[1],
                    long: coor[0]
                };
        
        $scope.homecategories = [{

                    "category_id": 7,
                    "iconimg": "i-i/adventures.svg",
                    "category_name": "Adventures/<br>Tours"
                }, {
                    "category_id": 6,
                    "iconimg": "i-i/Festivals.svg",
                    "category_name": "Festivals/<br>Exhibitions"
                }, {
                    "category_id": 5,
                    "iconimg": "i-i/Gaming.svg",
                    "category_name": "Gaming/<br>Amusement"
                }, {
                    "category_id": 4,
                    "iconimg": "i-i/Museums.svg",
                    "category_name": "Museums/<br>Cinemas"
                }, {
                    "category_id": 3,
                    "iconimg": "i-i/Music.svg",
                    "category_name": "Music/<br>Performances"
                }, {
                    "category_id": 2,
                    "iconimg": "i-i/Nature.svg",
                    "category_name": "Nature/<br>Sites"
                }, {
                    "category_id": 283,
                    "iconimg": "i-i/Sports.svg",
                    "category_name": "Sports/<br>Competitions"
                }, {
                    "category_id": 147,
                    "iconimg": "i-i/Children.svg",
                    "category_name": "Children"
                }];
               /* $scope.loadPromotionsOnDragMap(requestInfo);
                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');

                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');*/
            }
        } else if (query.cat) {
            if (query.cat == 'Nature/ Sites') {
                $scope.selected = {
                    keyword: {
                        id: '2',
                        type: 'categoryId'
                    }
                };
                var id = 2;
                var name = 'Nature/ Sites';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
            if (query.cat == 'Museums/ Cinemas') {
                $scope.selected = {
                    keyword: {
                        id: '4',
                        type: 'categoryId'
                    }
                };
                var id = 4;
                var name = 'Museums/ Cinemas';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
            if (query.cat == 'Festivals/ Exhibitions') {
                $scope.selected = {
                    keyword: {
                        id: '6',
                        type: 'categoryId'
                    }
                };
                var id = 6;
                var name = 'Festivals/ Exhibitions';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
            if (query.cat == 'Children') {
                $scope.selected = {
                    keyword: {
                        id: '147',
                        type: 'categoryId'
                    }
                };
                var id = 147;
                var name = 'Children';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
            if (query.cat == 'Music/ Performances') {
                $scope.selected = {
                    keyword: {
                        id: '3',
                        type: 'categoryId'
                    }
                };
                var id = 3;
                var name = 'Music/ Performances';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
            if (query.cat == 'Gaming/ Amusement') {
                $scope.selected = {
                    keyword: {
                        id: '5',
                        type: 'categoryId'
                    }
                };
                var id = 5;
                var name = 'Gaming/ Amusement';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
            if (query.cat == 'Adventures/ Tours') {
                $scope.selected = {
                    keyword: {
                        id: '7',
                        type: 'categoryId'
                    }
                };
                var id = 7;
                var name = 'Adventures/ Tours';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
            if (query.cat == 'Sports/ Competitions') {
                $scope.selected = {
                    keyword: {
                        id: '283',
                        type: 'categoryId'
                    }
                };
                var id = 283;
                var name = 'Sports/ Competitions';
                $scope.selected.category_id = id;
                $scope.childCategories = [];
                $scope.map_genres = [];
                $scope.selected.category_name = name;
                $rootScope.allCategoriesSelected = false;
                $scope.categoryName = name;
                categoryfilter.getSubcategoriesOfCategory(id).then(function(data) {
                   // traceLog("mapctrl-catgenreselection", "response-> getSubCat ", data);
                    $scope.subcategories = data.subcats;
                    $scope.selected.subcategory_ids = [];
                    if (data.subcats && data.subcats.length > 0) {
                       // traceLog("mapctrl-catgenreselection", "Category has sub categories ", data);
                        angular.forEach(data.subcats, function(v) {
                            /* [things-to-understand] - Need to see why parent_id is used in such a way I know it is used for filtering but why name parent_id*/
                            $scope.selected.subcategory_ids.push(v.category_id);
                        });
                    }
                });
                $scope.showSubCategoryMenu = true;
                $scope.isCheck = true;
            }
          
            $scope.makeMenuSelections(query.cat, query.subcat, query.childcat, query.genre, function() {});
            
            if (query.at) {
                locationUrl = query.at;
                var coor = query.at.split(",");
                $scope.drawMap(coor[1], coor[0], query.zoom ? query.zoom : 7);
                // Load promotions based on location
                var requestInfo = {
                    lat: coor[1],
                    long: coor[0]
                };
            }
          
		   $scope.homecategories = [{

                "category_id": 7,
                "iconimg": "i-i/adventures.svg",
                "category_name": "Adventures/<br>Tours"
            }, {
                "category_id": 6,
                "iconimg": "i-i/Festivals.svg",
                "category_name": "Festivals/<br>Exhibitions"
            }, {
                "category_id": 5,
                "iconimg": "i-i/Gaming.svg",
                "category_name": "Gaming/<br>Amusement"
            }, {
                "category_id": 4,
                "iconimg": "i-i/Museums.svg",
                "category_name": "Museums/<br>Cinemas"
            }, {
                "category_id": 3,
                "iconimg": "i-i/Music.svg",
                "category_name": "Music/<br>Performances"
            }, {
                "category_id": 2,
                "iconimg": "i-i/Nature.svg",
                "category_name": "Nature/<br>Sites"
            }, {
                "category_id": 283,
                "iconimg": "i-i/Sports.svg",
                "category_name": "Sports/<br>Competitions"
            }, {
                "category_id": 147,
                "iconimg": "i-i/Children.svg",
                "category_name": "Children"
            }];
   $scope.homecategories2 = [{
                        "category_id": 329,
                        "iconimg": "i-i/news-politics.svg",
                        "category_name": "News/<br>Politics"
                    }, {
                        "category_id": 331,
                        "iconimg": "i-i/local-scene.svg",
                        "category_name": "Local Scene"
                    }, {
                     
						  "category_id": 332,
                        "iconimg": "i-i/nature-environment.svg",
                        "category_name": "Nature/<br>Environment"
                    }, {
                        "category_id": 333,
                        "iconimg": "i-i/education-exploration.svg",
                        "category_name": "Education/<br>Exploration"
                    }, {
                        "category_id": 328,
                        "iconimg": "i-i/personal-human-stories.svg",
                        "category_name": "Personal/<br>Human Stories"
                    }, {
                        "category_id": 330,
                        "iconimg": "i-i/conflicts.svg",
                        "category_name": "Conflicts"
                    }, {
                      
						                        "category_id": 327,
                        "iconimg": "i-i/spirituality-supernatural.svg",
                        "category_name": "Spirituality/<br>Supernatural"
                    }];    

          /*$scope.loadPromotionsOnDragMap(requestInfo);
            $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');

            $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');*/
        } else if (query.at) {
           // traceLog("discover-seo", "query contains [at] ", query.at);
            locationUrl = query.at;
            var coor = locationUrl.split(",");
            var coor = {
                latitude: coor[1],
                longitude: coor[0],
                zoom: 7
            };
            var selectedProfile = JSON.parse(localStorageService.get('showProfile'));
            if (selectedProfile && selectedProfile.type) {
               // traceLog("tn-discover-localstorage", "selected profile has type ", selectedProfile.type, " setting zoom to 16");
                coor.zoom = 12;
            }
            var citySearch = localStorageService.get('city_search');
            localStorageService.remove('city_search');
            if (citySearch) {
               // traceLog("tn-discover-localstorage", "city search is part of local storage ", citySearch, " setting zoom to 9.5");
                coor.zoom = 9.5;
               // $scope.loadPromotionsOnCitySearch(coor.latitude, coor.longitude);
            }
            var geoTracker = localStorageService.get('geo_search');
            if (geoTracker) {
               // traceLog("tn-discover-localstorage", "geo search is part of local storage ", citySearch, " setting zoom to 9.5");
                coor.zoom = 9.5;
            }
            localStorageService.remove('geo_search');
            $scope.drawMap(coor.latitude, coor.longitude, query.zoom ? query.zoom : coor.zoom);
            //$scope.loadLocationMap(coor);
            mapboxgeocode.getAddress(locationUrl).then(function(res) {
                if (res.features.length > 0) {
                    $location.search('in', res.features[0].place_name);
                }
            });
            // Load promotions based on location
            var requestInfo = {
                lat: coor.latitude,
                long: coor.longitude,
            };
           /* if (!citySearch) {
                $scope.loadPromotionsOnDragMap(requestInfo);
                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_hanging');

                $scope.loadHangingOrSkyScrapperPromotionsOnDragMap(requestInfo, 'is_skyscrapper');
            }*/
        } else if (query.in) {
           // traceLog("discover-seo", "query contains [in] location ", query.in);
            var place = query.in.split(",");
            if (place.length == 1) {
                locationUrl = "/site/geolocationcountry/country/" + place[0].trim();
            } else if (place.length == 2) {
                locationUrl = "/site/geolocationstate/state/" + place[0].trim() + "/country/" + place[1].trim();
            } else if (place.length > 2) {
                locationUrl = "/site/geolocationcity/city/" + place[0].trim() + "/state/" + place[1].trim() + "/country/" + place[2].trim();
            }
           // traceLog("discover-load", "calling-> addressgeocode.get('" + locationUrl + "')");
            addressgeocode.get(locationUrl).then(function(res) {
               // traceLog("discover-load", "response-> addressgeocode.get('" + locationUrl + "')", res);
                if ((window.innerWidth < 801) || (window.innerWidth < 900 && window.innerHeight < 500)) {
                    res = {
                        latitude: res.latitude_xs,
                        longitude: res.longitude_xs,
                        zoom: res.zoom_xs
                    };
                }
                $location.search('at', res.longitude + "," + res.latitude);
                $scope.drawMap(res.latitude, res.longitude, query.zoom ? query.zoom : res.zoom ? res.zoom : 8);
            }, function(err) {
               // traceLog("discover-seo", "calling-> mapboxgeocode.getGeo('" + query.in + "')");
                mapboxgeocode.getGeo(query.in).then(function(res) {
                   // traceLog("discover-load", "response-> mapboxgeocode.getGeo('" + query.in + "')");
                    if (res.features.length > 0) {
                       // traceLog("tn-discover-urlchange", "Query contains [state_code]: url parameters: ", {                            'at': res.features[0].center[0] + "," + res.features[0].center[1]                        });
                        $location.search('at', res.features[0].center[0] + "," + res.features[0].center[1]);
                        var coor = {
                            latitude: res.features[0].center[1],
                            longitude: res.features[0].center[0],
                            zoom: 8
                        };
                        $scope.drawMap(coor.latitude, coor.longitude, query.zoom ? query.zoom : coor.zoom ? coor.zoom : 8);
                    }
                });
            });
        } else {
             
        }
  
        var getMoreIcons = true;
        $scope.loadMapIcons = function(northEast, southWest, center, zoom_level) {
             $scope.keyword = angular.element('.keyword_search_mobile').val() || angular.element('#keyword_search').val();
            var map = $scope.map_map;
            var center = $scope.map_map.getCenter();
             center.lng = $scope.adjustCoordinate(center.lng, true);
            $location.search('at', center.lng + "," + center.lat);
            var zoomLevel = $scope.map_map.getZoom();
            var url = $scope.getDataOnDragUrl(northEast.lat, southWest.lat, northEast.lng, southWest.lng, $scope.keyword, zoomLevel);
            if (!map) return false;
            var marker = $scope.map_marker;
            if (!marker) marker = $scope.initMarkerGL();
            $scope.markerLoadUrlJS(map, marker, url);
            $scope.map_map.resize();
            localStorageService.remove('categories');
            // $scope.zoomLevel_func(map);
            $scope.map_map = map;
            if ($scope.showUpcomingEventSlider) {
                $scope.getUpcomingEventsDiscover();
                //// console.log("getUpcomingEvents 1");
                $scope.showEstaEventSlider = false;
                localStorageService.remove('getUpcomingEvents');
            }
        };
    
        $scope.getIcons = function(map) {
            $scope.mapDragged = true;
            var zoomLevel = $scope.map_map.getZoom();
            var center = $scope.map_map.getCenter();
            var bounds = $scope.map_map.getBounds();
            var northEast = bounds.getNorthEast();
            var southWest = bounds.getSouthWest();
            center.lng = $scope.adjustCoordinate(center.lng, true);
           // traceLog("tn-discover-loadmapicons", '$scope.getIcons(): calling-> loadMapIcons()');
            $scope.loadMapIcons(northEast, southWest, center, zoomLevel);
            var geoloc = center.lng + "," + center.lat;
            // console.log("DiscoverPlaceCtrl-->geoloc =", geoloc);
            mapboxgeocode.getAddress(geoloc).then(function(res) {
                // console.log("DiscoverPlaceCtrl-->geoloc get address=", res);
                if (res.features.length > 0) {
                    $location.search('in', res.features[0].place_name);
                }
            });
        };
        $scope.getIconsonZoom = function(map) {
            var zoomLevel = $scope.map_map.getZoom();
            if ((zoomLevel >= 8 && getMoreIcons) || zoomLevel < previousZoom) {
                getMoreIcons = false;
                var bounds = $scope.map_map.getBounds();
                var center = $scope.map_map.getCenter();
                center.lng = $scope.adjustCoordinate(center.lng, true);
                var northEast = bounds.getNorthEast();
                var southWest = bounds.getSouthWest();
               // traceLog("tn-discover-loadmapicons", '$scope.getIconsonZoom(): calling-> loadMapIcons()');
                $scope.loadMapIcons(northEast, southWest, center, zoomLevel);
            }
            previousZoom = zoomLevel;
            if (zoomLevel < 8) {
                getMoreIcons = true;
            }
        };
        // profile tooltips
        $scope.showTime = false;
        $scope.weblink = false;
        $scope.number = false;
        $scope.address = false;
        $scope.showProfileTime = function() {
            $scope.showTime = true;
        };
        $scope.hideProfileTime = function() {
            $scope.showTime = false;
        };
        $scope.showProfileTooltip = function(txt) {
            $scope.profileTooltipText = txt;
            $scope.profileTooltip = true;
        };
        $scope.hideProfileTooltip = function() {
            $scope.profileTooltip = false;
            $scope.profileTooltipActive = false;
            $scope.profileAddress = false;
            $scope.profileWebsiteUrl = false;
            $scope.profilePhoneNumber = false;
        };
        $scope.showProfileAddress = function(type) {
            if (type == "event") {
                $scope.profileTooltipText = $scope.eventDetails.address1 + $scope.eventDetails.address2 + "," + ($scope.eventDetails.cityId || $scope.eventDetails.city_id) + "," + $scope.eventDetails.stateId + "," + $scope.eventDetails.countryId;
            } else {
                $scope.profileTooltipText = $scope.establishmentDetails.address1 + "," + $scope.establishmentDetails.cityId + "," + $scope.establishmentDetails.stateId + "," + $scope.establishmentDetails.countryId;
            }
            $scope.profileTooltip = true;
            $scope.profileAddress = true;
        };
        $scope.showProfileWebsiteUrl = function() {
            $scope.profileWebsiteUrl = true;
        };
        $scope.showPhoneNumber = function() {
            $scope.profilePhoneNumber = true;
        };
        $scope.profileLink = function(e) {
            if ((window.innerWidth < 801 && !$scope.profileTooltipActive) || (window.innerWidth < 900 && window.innerHeight < 500 && !$scope.profileTooltipActive)) {
                e.preventDefault();
            }
            $scope.profileTooltipActive = true;
        };
        $scope.right_slider_data = [];
        $scope.temp_right_slider_data = [];
        $scope.added_id = [];
        var rD = $stateParams.id;
        var establish_id = $stateParams.cid;
        $scope.selection = [];
        $scope.PopupModal = false;
        $scope.notclicksub = false;
        $scope.not_click_sub = true;
        $scope.is_linked_clicked = false;
        $scope.loginData = {};
        localStorageService.set('show_icon', false);
        var markers = {};
        var search_params = $location.search();
        $scope.show_upcoming = false;
        $scope.main_profile = false;
        $scope.changePopupModal = function() {
            $scope.PopupModal = false;
            var vid = document.getElementById("videoELP");
            if (vid)
                vid.pause();
        };
        // change map view
        $scope.mapSatellite = false;

        $scope.changeSatelliteView = function(changeView) {
            var map = $scope.map_map;
            if (!map) return;
            // console.log("=== Switching style ===");
            // console.log("Current style:", map.getStyle().name || map.getStyle().sprite);
            // 1️⃣ Save current camera (center, zoom, pitch, bearing)
            var camera = {
                center: map.getCenter(),
                zoom: map.getZoom(),
                pitch: map.getPitch(),
                bearing: map.getBearing()
            };
            // console.log("Saved camera:", camera);
            // Remove existing terrain safely
            try {
                map.setTerrain(null);
                // console.log("Terrain removed");
            } catch (e) {
                console.warn("Error removing terrain:", e);
            }
            // Pick the next style
            var styles = $scope.getStyleLayersByHost();
            var nextStyle = !changeView ? styles.satellite : styles.default;
            // console.log("Setting style to:", nextStyle);
            // Determine if this style requires 3D terrain setup
            var needs3D = (nextStyle === styles.satellite || nextStyle === styles.terrain);
            // 2️⃣ Apply the new style
            map.setStyle(nextStyle, {
                diff: false

            });
            // 3️⃣ Restore camera AFTER style data is ready
            map.once('styledata', function() {
                // console.log("Style loaded. Restoring camera...");



                map.jumpTo({
                    center: camera.center,
                    zoom: camera.zoom,
                    pitch: camera.pitch,
                    bearing: camera.bearing

                });
                // ✅ Apply terrain if needed
                if (needs3D) {
                    var style = map.getStyle();
                    // Add DEM source if missing
                    if (!map.getSource('mapbox-dem')) {
                        // console.log("Adding DEM source...");
                        map.addSource('mapbox-dem', {
                            type: 'raster-dem',
                            url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
                            tileSize: 512
                        });
                    } else {
                        // console.log("DEM source already exists");
                    }
                    // Apply terrain
                    // console.log("Applying terrain...");
                    map.setTerrain({
                        source: 'mapbox-dem',
                        exaggeration: 3
                    });
                    // Add hillshade layer if missing
                    if (!map.getLayer('hillshade')) {
                        // console.log("Adding hillshade layer...");
                        var firstLayerId = (style.layers.length > 0) ? style.layers[0].id : undefined;
                        if (firstLayerId) {
                            map.addLayer({
                                id: 'hillshade',
                                type: 'hillshade',
                                source: 'mapbox-dem'
                            }, firstLayerId);
                        } else {
                            map.addLayer({
                                id: 'hillshade',
                                type: 'hillshade',
                                source: 'mapbox-dem'
                            });
                        }
                    } else {
                          console.log("Hillshade layer already exists");
                    }
                } else {
                     console.log("Default style loaded, no 3D terrain applied");
                }
		    if (!map.getSource('points-source')) {
				map.addSource('points-source', {
					type: 'geojson',
					data: {
						type: 'FeatureCollection',
						features: []
					}
				});
			}

			/*if (!map.getLayer('points-layer')) {
				map.addLayer({
					id: 'points-layer',
					type: 'symbol',
					source: 'points-source',
					layout: {
						'icon-image': ['get', 'iconName'],
						'icon-allow-overlap': true,
						'icon-anchor': 'bottom',
						'icon-size': 0.5
					},
					paint: {
						'icon-opacity': 1
					}
				});
			}*/
  
map.once('idle', function () {
    $scope.refreshMarkers({
        forceFetch: true
    });
});
});
			
			
			
			
			
			
			
			
			
			
            // Update UI
            $scope.mapSatellite = !changeView;
            angular.element("#satv").toggleClass("active", !changeView);
        };

$scope.setLightMapMode = function() {

    var map = $scope.map_map;

    // LIGHT MODE ATMOSPHERE
    map.setFog({
        'vertical-range': [30, 120],

        'range': [
            'interpolate',
            ['linear'],
            ['zoom'],
            1, ['literal', [1, 20]],
            2, ['literal', [1, 4]]
        ],

        'color': 'rgba(198, 203, 209, 0.18)',

        'space-color': 'rgba(0, 0, 0, 0)',

        'horizon-blend': [
            'interpolate',
            ['exponential', 1.2],
            ['zoom'],
            0, 0.006,
            7, [
                'interpolate',
                ['exponential', 1.2],
                ['measure-light', 'brightness'],
                0.35, 0.012,
                0.4, 0.018,
                0.45, 0.012
            ]
        ],

        'star-intensity': 1,

        'high-color': [
            'step',
            ['zoom'],
            '#c5cbd1',
            22,
            'rgba(255, 255, 255, 0)'
        ]
    });


    // LIGHT MODE WATER
    if (map.getLayer('water')) {

        map.setPaintProperty(
            'water',
            'fill-color',
            '#ffffff'
        );

        map.setPaintProperty(
            'water',
            'fill-opacity',
            0.95
        );

        map.setPaintProperty(
            'water',
            'fill-outline-color',
            'hsl(302, 56%, 32.9%)'
        );

    }

};


$scope.setDarkMapMode = function() {

    var map = $scope.map_map;

    // ORIGINAL DARK MODE ATMOSPHERE
    map.setFog({
        'vertical-range': [30, 120],

        'range': [
            'interpolate',
            ['linear'],
            ['zoom'],
            13, ['literal', [1, 20]],
            15, ['literal', [1, 4]]
        ],

        'color': [
            'interpolate',
            ['exponential', 1.2],
            ['zoom'],
            5, 'hsla(0, 86%, 47%, 0.02)',
            7, [
                'interpolate',
                ['linear'],
                ['measure-light', 'brightness'],
                0.02, 'hsla(213, 63%, 20%, 0.9)',
                0.03, 'hsla(30, 65%, 60%, 0.5)',
                0.4, 'hsla(10, 79%, 88%, 0.8)',
                0.45, 'hsla(200, 60%, 98%, 0.9)'
            ]
        ],

        'space-color': 'rgba(0, 0, 0, 0)',

        'horizon-blend': [
            'interpolate',
            ['exponential', 1.2],
            ['zoom'],
            0, 0.014,
            7, [
                'interpolate',
                ['exponential', 1.2],
                ['measure-light', 'brightness'],
                0.35, 0.03,
                0.4, 0.07,
                0.45, 0.03
            ]
        ],

        'star-intensity': [
            'interpolate',
            ['exponential', 1.2],
            ['zoom'],
            5, 0.4,
            7, [
                'interpolate',
                ['exponential', 1.2],
                ['measure-light', 'brightness'],
                0.1, 0.2,
                0.3, 0
            ]
        ],

        'high-color': [
            'interpolate',
            ['linear'],
            ['zoom'],
            0, '#245cdf',
            22, '#245cdf'
        ]
    });


    // RESTORE ORIGINAL DARK WATER
    if (map.getLayer('water')) {

        map.setPaintProperty(
            'water',
            'fill-color',
            [
                'interpolate',
                ['linear'],
                ['zoom'],
                0, 'hsla(232, 97%, 0%, 0.89)',
                4.21, 'hsla(232, 94%, 16%, 0.89)',
                15, 'hsl(232, 97%, 12%)'
            ]
        );

        map.setPaintProperty(
            'water',
            'fill-opacity',
            1
        );

        map.setPaintProperty(
            'water',
            'fill-outline-color',
            'hsl(233, 99%, 2%)'
        );

    }

};




 $scope.mapNight = true;
        // Dark mode is the default on page load. Do not alter app-bodyactive.
        angular.element('#app-body').removeClass('light');

        $scope.changemapNight = function(nightView) {
            var elems = angular.element(document.querySelectorAll('.lividmod'));
            var appBody = angular.element('#app-body');

            if (nightView) {
                $scope.setLightMapMode();
                angular.element('#nightvbg').removeClass('active');
                angular.element('#nghtset').removeClass('active');
                angular.element('#nightv').removeClass('active');
                if (elems.length) angular.element(elems[0]).removeClass('active');
                appBody.addClass('light');
                $scope.mapNight = false;
            } else {
                $scope.setDarkMapMode();
                angular.element('#nghtset').addClass('active');
                angular.element('#satv').removeClass('active');
                angular.element('#nightv').addClass('active');
                if (elems.length) angular.element(elems[0]).addClass('active');
                appBody.removeClass('light');
                $scope.mapNight = true;
            }
        };

        $scope.lifeGenre = false
        $scope.changelifeGenre = function(lifeGenre) {
            // console.log('mapNight===========');
            var map = $scope.map_map;
            var elems = angular.element(document.querySelectorAll('.lividmod'));
            // console.log("map is ", map);
            if (lifeGenre) {
                $scope.lifeGenre = true;
                angular.element("#nghtset").addClass("lifeGenre");
                angular.element("#satv").removeClass("lifeGenre");
                angular.element("#nightv").addClass("lifeGenre");
                angular.element("#app-body").addClass("lifeGenre");
                   if (elems[0]) {
            angular.element(elems[0]).addClass('lifeGenre');
        }
            } else {
                $scope.lifeGenre = false;
                angular.element("#nightvbg").removeClass("lifeGenre");
                angular.element("#nghtset").removeClass("lifeGenre");
                angular.element("#nightv").removeClass("lifeGenre");
                angular.element("#app-body").removeClass("lifeGenre");
                  if (elems[0]) {
            angular.element(elems[0]).removeClass('lifeGenre');
        }
		$scope.changelifeGenre(lifeGenre)
            }
        };
        var myLocZoom;
        $scope.login = function(valid) {
			$scope.loadingLogin = true;
            // console.log("true", valid);
            $scope.submitted = true;
            if (valid == true) {
                angular.element('#loading').removeClass('hide');
                $http.post('/api/login', {
                        login: this.loginData
                    })
                    .then(function(res) {
                        var data = res.data;
                        if (data.status == 3 || data.status == 4 || data.status == 5 || data.status == 6) {
                            angular.element('#loading').addClass('hide');
                            angular.element('#error').html(data.msg);
                        } else {
                            // $("#sign_in").modal('hide');
                            $scope.closeModal();
                            angular.element('.signinup').addClass('hide');
                            angular.element('.login').removeClass('hide');
                            $scope.PopupModal = false;
                            angular.element('.username').html(data.msg);
                            angular.element('#loading').addClass('hide');
                            $http.get('/api/isloggedin').then(function(res) {
                                var data = res.data;
                                $rootScope.user = res.data;
                                if (data.user != 1) {
                                    if (data.status == 1) {
                                        localStorageService.set('name', data.name);
                                        localStorageService.set('usercategory', data.usercategory);
                                        $rootScope.usercategory = data.usercategory;
										if ($scope.pendingRedirect == 'entertainment') {
											$scope.handleEntertainmentRedirect();
											}
                                        $rootScope.loggedusername = data.name;
                                        angular.element('.signinup').addClass('hide');
                                        angular.element('.login').removeClass('hide');
                                        $("#topmenu").css('display', 'block');
                                    } else {
                                        angular.element('.login').addClass('hide');
                                        angular.element('.signinup').removeClass('hide');
                                        localStorageService.remove('name');
                                    }
                                } else {
                                    angular.element('.login').addClass('hide');
                                    angular.element('.signinup').removeClass('hide');
                                    localStorageService.remove('name');
									$scope.loadingLogin = false;
                                }
                            }, function(err) {
                                // console.log(err);
                            });
					 
                        }
                    }, function(err) {});
            }
        };
        $scope.comments_photos = [];
        $scope.doCommentPhoto = function(e, photo_id_d, pressed, type) {
            var id = photo_id_d;
            var code = (e.keyCode ? e.keyCode : e.which);
            if (pressed) {
                code = 13;
            }
            if (!localStorageService.get('name') && code == 13) {
                if (!$scope.PopupModal) {
                    $scope.modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'sign_in_modal.html',
                        windowClass: 'zindexModal int122',
                        scope: $scope,
						appendTo: angular.element(document.body)
                    });
                    $scope.modalInstance.result.then(function(selectedItem) {
                        $scope.closeModal();
                    }, function() {
                        $scope.closeModal();
                    });
                    $scope.PopupModal = !$scope.PopupModal;
                }
            } else if (localStorageService.get('name') && code == 13) {
                var comment_text = angular.element("#comment_text" + id).val();
                comment_text = comment_text.trim();
                angular.element("#comment_text" + id).val('');
                if (comment_text != "") {
                    $http.post('/establishment/postCommentPhoto', {
                        photo_id: id,
                        comment_text: comment_text,
                        type: type
                    }).then(function(res) {
                        var response = res.data;
                        var date = new Date();
                        var formattedDate = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
                        var comment = {
                            comment_date: formattedDate,
                            comment_text: comment_text,
                            comment_user: $rootScope.user.first_name + " " + $rootScope.user.last_name,
                            user_pic: $rootScope.user.profile_pic
                        };
                        if (type == 'establishment') {
                            $scope.esta_photo_comments.unshift(comment);
                        } else {
                            $scope.event_photo_comments.unshift(comment);
                        }
                    });
                }
            }
        };
        $scope.doComment = function(e, photo_id_d) {
            var id = photo_id_d;
            var code = (e.keyCode ? e.keyCode : e.which);
            if (!localStorageService.get('name') && code == 13) {
                if (!$scope.PopupModal) {
                    $scope.modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'sign_in_modal.html',
                        windowClass: 'zindexModal int123',
                        scope: $scope,
						appendTo: angular.element(document.body)
                    });
                    $scope.modalInstance.result.then(function(selectedItem) {
                        $scope.closeModal();
                    }, function() {
                        $scope.closeModal();
                    });
                    $scope.PopupModal = !$scope.PopupModal;
                }
            } else if (localStorageService.get('name') && code == 13) {
                var comment_text = angular.element("#comment_text" + id).val();
                comment_text = comment_text.trim();
                if (comment_text != "") {
                    $http.post('/establishment/postCommentPhoto', {
                        photo_id: id,
                        comment_text: comment_text,
                        type: "event"
                    }).then(function(res) {
                        var response = res.data;
                        if (response["status"]) {
                            angular.element("#list_old_" + id).remove();
                            $scope.photo_id_photo = id;
                            $scope.comments_photos[id] = response["comments"];
                            angular.element("#comment_text" + id).val("");
                        }
                    });
                }
            }
        };
        $scope.getLoggedinUserComments = function() {
            $http.post('/establishment/getCommentByUserID').then(function(res) {
                $scope.oldComments = res.data;
                // console.log(res);
            }, function(err) {});
        }
        $scope.user_id = '';
        $scope.getUserDetail = function() {
            $http.post('/establishment/getUserDetail').then(function(res) {
                // console.log(res.data);
                if (res.data && res.data.userid) {
                    var userid = res.data.userid
                    userid = userid.replaceAll('\"', '');
                    $scope.user_id = userid;
                }
            }, function(err) {});
        }
        $scope.openCommentSuggestion = function() {
            // console.log("focus")
            $scope.getLoggedinUserComments();
            if ($scope.comment_text.esta == '' || $scope.comment_text.esta == undefined) {
                $scope.showoldComment = true;
            } else {
                $scope.showoldComment = false;
            }
        }
        $scope.closeCommentSuggestion = function() {
            // setTimeout(function () {
            // $scope.showoldComment = false;
            // }, 300);
        }
        $scope.suggestComment = function($txt) {
            // console.log($txt);
            $scope.comment_text.esta = $txt;
        }
        $scope.OpenEditCommentModal = function($commentID) {
            $scope.id = $commentID;
            // console.log($scope.id);
            if (!$scope.PopupModal) {
                $scope.modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/min/editcommentmodal.html',
                    windowClass: 'zindexModal int124',
                    controller: 'EditCommentCtrl',
                    scope: $scope,
                    controllerAs: '$ctrl',
                    resolve: {
                        content: function() {
                            return {
                                commentID: $scope.id
                            }
                        }
                    }
                });
                $scope.modalInstance.result.then(function() {}, function(res) {
                    if (res == 'confirm') {
                        $scope.closeModal();
                    }
                });
                $scope.PopupModal = !$scope.PopupModal;
            }
        };
         
															
											   
										
														   
									  
			   
        $(document.body).on('click', '.close_modal_popup.closemodal', function() {
            $(this).parents('.overlay_').fadeOut();
            $(this).parents('.overlay_').find('.gallerySlide').fadeOut();
            $('body#body').css('overflow-y', 'auto');
        })
        $(document.body).on('click', '.showGalleryPopupForVideo', function() {
            var dataAttr = $(this).attr('ng-data-href');
            // dataAttr = dataAttr.replace('#','');
            $('.overlayvideo_').fadeIn();
            $('body#body').css('overflow-y', 'hidden');
            $(dataAttr).fadeIn();
            // console.log(dataAttr);
        });
        $(document.body).on('click', '.close_modal_popup.closemodal', function() {
            $(this).parents('.overlayvideo_').fadeOut();
            $(this).parents('.overlayvideo_').find('.gallerySlide').fadeOut();
            $('body#body').css('overflow-y', 'auto');
        })
        $scope.doCommentEsta = function(e, pressed) {
            // if ($scope.comment_text.esta != '') {
            //     $scope.showoldComment = false;
            // } else {
            //     $scope.showoldComment = true;
            // }
            var code = (e.keyCode ? e.keyCode : e.which);
            if (!localStorageService.get('name') && (code == 13 || pressed)) {
                if (!$scope.PopupModal) {
                    $scope.modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'sign_in_modal.html',
                        windowClass: 'zindexModal int125',
                        scope: $scope,
							appendTo: angular.element(document.body)
                    });
                    $scope.modalInstance.result.then(function(selectedItem) {
                        $scope.closeModal();
                    }, function() {
                        $scope.closeModal();
                    });
                    $scope.PopupModal = !$scope.PopupModal;
                }
            } else if (localStorageService.get('name') && (code == 13 || pressed)) {
                var esta_Id = angular.element("#esta_id").val();
                var comment_text_esta = angular.element("#comment_text_esta").val();
                comment_text_esta = comment_text_esta.trim();
                angular.element("#comment_text_esta").val("");
                if (comment_text_esta != "" && comment_text_esta != undefined) {
                    $http.post("/establishment/postCommentOnEstablishment", {
                        estaId: esta_Id,
                        comment_text_esta: comment_text_esta
                    }).then(function(res) {
                        var response = res.data;
                        var date = new Date;
                        var formattedDate = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
                        var commented = {
                            comment_text: comment_text_esta,
                            comment_user: $rootScope.user.first_name + " " + $rootScope.user.last_name,
                            user_pic: $rootScope.user.profile_pic,
                            comment_date: formattedDate,
                        };
                        $scope.getUserDetail();
                        $scope.comments_esta.unshift(commented);
                        // if (response["status"]) {
                        //     $scope.comments_esta = response["comments"];
                        // }
                    });
                }
            }
        };
        $scope.comment_text = {
            esta: "",
            event: "",
            linked_event: "",
        };
        $scope.doCommentEvent = function(e, eventId, comment, is_linked, submitted) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (!localStorageService.get('name') && (code == 13 || submitted)) {
                if (!$scope.PopupModal) {
                    $scope.modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'sign_in_modal.html',
                        windowClass: 'zindexModal int126',
                        scope: $scope,
							appendTo: angular.element(document.body)
                    });
                    $scope.modalInstance.result.then(function(selectedItem) {
                        $scope.closeModal();
                    }, function() {
                        $scope.closeModal();
                    });
                    $scope.PopupModal = !$scope.PopupModal;
                }
            } else if (localStorageService.get('name') && (code == 13 || submitted)) {
                var event_Id = eventId;
                var comment_text_event = comment;
                comment_text_event = comment_text_event.trim();
                if (is_linked) {
                    $scope.comment_text.linked_event = "";
                } else {
                    $scope.comment_text.event = "";
                }
                if (comment_text_event != "") {
                    $http.post("/establishment/postCommentEvent", {
                        eventId: event_Id,
                        comment_text_event: comment_text_event
                    }).then(function(res) {
                        var response = res.data;
                        var date = new Date();
                        var formattedDate = date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2);
                        var event_comment = {
                            comment_text: comment_text_event,
                            comment_user: $rootScope.user.first_name + " " + $rootScope.user.last_name,
                            user_pic: $rootScope.user.profile_pic,
                            comment_date: formattedDate,
                        };
                        if (is_linked) {
                            //// console.log('add comment to linked')
                            $scope.event_linked_comments.unshift(event_comment);
                        } else {
                            //// console.log('add comment to main')
                            $scope.event_comments.unshift(event_comment);
                        }
                    });
                }
            }
        };
        $scope.activePopup;
        $scope.popupHtml = [];
        $document.on('mouseover', '.mapboxgl-popup', function() {
            angular.element(this).show();
        });
        $document.on('mouseleave', '.mapboxgl-popup', function() {
            angular.element(this).hide();
        });
        $document.on('mouseleave', '.mapBottom-info', function() {
            angular.element(this).hide();
        });
        $(document.body).on('mouseover', '.leaflet-popup', function() {
            $('.leaflet-popup-pane').show();
        });
        $(document.body).on('mouseout', '.leaflet-popup', function() {
            $('.leaflet-popup-pane').hide();
        });
        $(".language-select select").change(function() {
            map = $scope.map_map;
            var center = $scope.map_map.getCenter();
            var zoom = $scope.map_map.getZoom();
            var bounds = $scope.map_map.getBounds();
            var northEast = bounds.getNorthEast();
            var southWest = bounds.getSouthWest();
           // traceLog("tn-discover-loadmapicons", '(.language-select select).change(): calling-> loadMapIcons()');
            $scope.loadMapIcons(northEast, southWest, center, zoom);
        });
        $(document.body).on('mouseover', '.event_icon_up', function(e) {
            var property_id = e.target.getAttribute('counter');
            var event_id = e.target.getAttribute('attr');
            $(".mapBottom-info").hide();
            $("#event_bottom_" + event_id).show();
        });
        $scope.setMaploadFalse = function() {
            $timeout(function() {
                $scope.maploading = false;
                $rootScope.maploading = false;
            }, 1);
        };
        $scope.adjustCoordinate = function(coor, isReal) {
            if (isReal) {
                //  fix longitude for api
                if (coor > 180) {
                    var adjustcoor = coor + 180;
                    var quo = Math.floor(adjustcoor / 360);
                    coor -= (quo * 360);
                } else if (coor < -180) {
                    var adjustcoor = coor - 180;
                    var quo = Math.floor(adjustcoor / -360);
                    coor += (quo * 360);
                } else {
                    // do nothing
                }
            } else {
                // fix longitude for icon to appear
                var map = $scope.map_map;
                var lng = $scope.map_map.getCenter().lng;
                if (lng > 180) {
                    var adjustcoor = lng + 180;
                    var quo = Math.floor(adjustcoor / 360);
                    coor += (quo * 360);
                } else if (lng < -180) {
                    var adjustcoor = lng - 180;
                    var quo = Math.floor(adjustcoor / -360);
                    coor -= (quo * 360);
                } else {
                    // do nothing
                }
            }
            return coor;
        };
        $scope.getDataOnDragUrl = function(neLat, swLat, neLong, swLong, keyword, zoom) {
           // traceLog("tn-discover-dataondrag2", "called-> getDataOnDragUrl ");
            neLong = $scope.adjustCoordinate(neLong, true);
            swLong = $scope.adjustCoordinate(swLong, true);
            if (swLong > neLong) neLong = 180;
            localStorageService.set('neLat', neLat);
            localStorageService.set('neLong', neLong);
            localStorageService.set('swLat', swLat);
            localStorageService.set('swLong', swLong);
            var keysearched = angular.element('.keyword_search_mobile').val() || angular.element('.keyword_search').val();
            if (keysearched) {
               // traceLog("discover-keyword", "key searched as ", keysearched);
                var searched = JSON.parse(localStorageService.get('selectedKeyword'));
               // traceLog("discover-keyword", "found searched in local storage service as  ", searched);
                var searchType = searched.type;
                var searchId = searched.id;
                var isBrand = (searched.is_brand == "1") ? true : false;
            } else {
                localStorageService.remove('selectedKeyword');
            }
            var encodeKeyword = "";
            if ($scope.keyword) {
                encodeKeyword = $scope.keyword.replace(/\//g, "-");
            }
           // traceLog("discover-keyword", "encode keyword is ", encodeKeyword);
            if (!zoom) {
                zoom = 4;
            }
            var url = '/data/getDataOnDrag/neLat/' + neLat + '/swLat/' + swLat + '/neLng/' + neLong + '/swLng/' + swLong + '/minZoom/' + zoom + '/keyword';
            if (encodeKeyword) {
                url += "/" + encodeKeyword;
            }
            if (isBrand && searchId && searchType) {
                url = url + "/type/" + searchType + "/id/" + searchId + "/isbrand/true";
            } else if (searchId && searchType) {
                var url = url + "/type/" + searchType + "/id/" + searchId;
            } else {
                url += "/0";
            }
           // traceLog("discover-dataondrag", "url -->  " + url);
            return url;
        };
        $scope.galleryPopup = function() {
            angular.element('#galleryPopup').show(0);
        };
        $scope.hideEEprofile = function() {
            $scope.ee_show = false;
            $scope.ee_for = null;
            angular.element(document.querySelector('.left_ad_r')).removeClass('ng-hide');
            angular.element(document.querySelector('.left_ad_r')).removeClass('hide');
            angular.element('.left_ad .sliderdiv').removeClass('hide');
            angular.element(document.querySelector('.left_ad_r')).show();
            document.getElementById("info").innerHTML = "";
        };
        $scope.ee_show = true;
        $(document.body).on("click", ".on_click_event_pop", function(e) {
            var eeId, esta_id, attr;
            attr = $(this).attr('attr');
            if (typeof attr !== typeof undefined && attr !== false) {
                esta_id = $(this).attr('attr');
            } else {
                esta_id = $(this).attr('data-attr');
            }
            if (esta_id.indexOf("_") > -1) {
                esta_id = esta_id.substr(esta_id.indexOf("_") + 1, esta_id.length);
            }
            if ($(this).parents('.mapBottom')) {
                eeId = $(this).parents('.mapBottom').siblings('.location_info').attr('data-attr');
            }
            if ($(this).parents(".mapBottom-info")) {
                eeId = $(this).parents(".mapBottom-info").siblings('.location_info').attr('data-attr');
            }
            var eventId = esta_id;
            var that = this;
            var requetObj = {
                event_id: eventId
            };
            var is_related = $(that).attr('data-is-related');
            if (is_related && is_related != "false") {
                var related_id = $(that).attr('data-related-id');
                // $http.post("/establishment/getrelateddetails", {
                //   related_id: related_id
                // }).then(function(res) {
                $scope.getAllLayers(e, eventId);
                // });
            } else {
                $http.post("/establishment/geteventestablishment", requetObj).then(function(res) {
                    var response = res.data;
                    angular.element('#evtext2').addClass('hide');
                    angular.element('#lnkevt').addClass('hide');
                    $scope.getEventEEprofile(eventId, e, null, null, false, response["establishment_id"]);
                });
            }
        });
        // Shared entry point for EE clicks from Mapbox HTML markers and the right slider.
        // Preserve the existing offline EE loader and live popup; the profile
        // presentation itself will be unified in the next stage.
        // All establishment states open in the SAME expanded showcase card.
        $scope.closeIgupOffline = function(event) {
            if (event) { event.preventDefault(); event.stopPropagation(); }
            if (typeof $scope.closeCard === 'function') $scope.closeCard();
        };

        $scope.openEntityFromMapOrSlider = function(entity, event) {
            entity = entity || {};
            if (event) { event.preventDefault(); event.stopPropagation(); }
            var id = entity.esta_id || entity.establishment_id || entity.id;
            if (!id) return;
            var live = entity.is_live === true || entity.is_live === 1 ||
                       entity.is_live === 'true' || entity.is_live === '1';
            // Load complete EE profile for BOTH live and offline establishment markers.
            return $scope.getEstaEEprofile(id, null, false, undefined, undefined, undefined, undefined, true, entity);
        };

        $(document.body).on("click", ".on_click_pop", function(e) {
            angular.element('#sbctsc').css('opacity', '0');
           // traceLog('discover-eeprofile', 'on[click][on_click_pop] esta_id ', e)
            var attr = $(this).attr('data-attr');
           // traceLog('discover-eeprofile', 'attr ', attr)
            if (typeof attr == 'undefined') {
                var esta_id = $(this).attr('attr');
                var attr = $(this).attr('attr');
            } else {
                var esta_id = $(this).attr('data-attr');
            }
            $scope.estaId = esta_id;
            // Keep the right-slider EE data, including live state, when available.
            var sliderEntity = null;
            if ($scope.right_slider_data) {
                sliderEntity = $scope.right_slider_data.find(function(item) {
                    return String(item.id) === String(esta_id) ||
                           String(item.esta_id) === String(esta_id);
                });
            }
            $scope.$applyAsync(function() {
                $scope.openEntityFromMapOrSlider(
                    angular.extend({}, sliderEntity || {}, { id: esta_id }), e
                );
            });
        });
         $scope.getEstaEEprofile = function(esta_id, ev, background, loadEvent, event_id, is_related, related_id, openInUnifiedCard, markerEntity) {
              
            angular.element('#sbctsc').css('opacity', '0');
           // traceLog('discover-seo', 'getEstaEEprofile() called with esta_id as', esta_id)
            $scope.maploading = true;
            $("html, body").animate({

                scrollTop: 0,
            }, "fast");
            delete $scope.estaId;
            $scope.estaId = esta_id;
            $scope.getUserDetail();
            return $http.post('/establishment/getEEProfile', {
                estaId: esta_id
            }).then(function(res) {
                var data = res.data;
                $rootScope.noScroll = 'no-scroll';
                $scope.establishmentDetails = data.data;
  
        var isMobileLive =
    $window.innerWidth < 801 &&
    $scope.establishmentDetails &&
    $scope.establishmentDetails.is_live === true;

if (!isMobileLive) {
    angular.element('#ee1pr').removeClass('lvmb');
}
if (isMobileLive) {
    angular.element('#ee1pr').addClass('lvmb');
}
 
                var estaname = $scope.establishmentDetails.name.replace(/\s+/g, '-');
                $location.search('establishment', estaname);
                if (!openInUnifiedCard) {
                    angular.element('#ee1pr').removeClass('hide');
                    document.getElementById('ee1pr').style.display = 'block';
                }
                $scope.name = data.data.name;
                $scope.establish_url = (data.data.establish_url != null) ? data.data.establish_url : "Not Available";
                $scope.establish_phone = data.data.establish_phone;
                $scope.address = (data.data.address1) ? data.data.address1 + ', ' : '' + (data.data.address2) ? data.data.address2 + ', ' : '';
                $scope.address_complete = data.data.cityId + ',' + data.data.countryId;
                $scope.up_events = data.data.up_events;
                for (var i = 0; i < $scope.up_events.length; i++) {
                    var start_date = new Date($scope.up_events[i].start_date);
                    $scope.up_events[i].date = start_date;
                    $scope.up_events[i].start_date = {
                        day: start_date.getDate(),
                        month: $filter('date')(start_date, "MMMM"),
                        year: start_date.getFullYear()
                    };
                    var event_locale = $scope.up_events[i].event_locale;
                    if (event_locale && locale[0] == event_locale.language) {
                        $scope.eventzname = event_locale.name;
                        $scope.eventzdescription = event_locale.cdesc;
                    } else {
                        $scope.eventzname = $scope.up_events[i].name;
                        $scope.eventzdescription = $scope.up_events[i].cdesc;
                    };
                }
                $scope.establish_description = data.data.establish_description;
                if ($scope.metaType && $scope.metaType == 'establishment') {
                    $rootScope.metaDescription = data.data.establish_description;
                    delete $scope.metaType;
                }
                if (data.data.establish_locale && locale[0] == data.data.establish_locale) {
                    $scope.name = data.data.location_i;
                    $scope.establish_description = data.data.establish_description_i;
                }
                $scope.first_hour = (data.data.first_start_day && data.data.first_end_day && data.data.first_open_time && data.data.first_close_time) ? (data.data.first_start_day + " - " + data.data.first_end_day + " " + data.data.first_open_time + " - " + data.data.first_close_time) : "Not Available";
                $scope.second_hour = (data.data.second_start_day && data.data.second_end_day && data.data.second_start_time && data.data.second_close_time) ? (data.data.second_start_day + " - " + data.data.second_end_day + " " + data.data.second_start_time + " - " + data.data.second_close_time) : "Not Available";
                $scope.estaPhotos = data.data.photos;
                $scope.estaAudios = data.data.audios;
                $scope.estaVideos = data.data.videos;
                $scope.comments_esta = data.esta_comments;
                // console.log("comments---->>>", $scope.comments_esta);
                if ($scope.comments_esta.length > 0) {
                    for (var i = 0; i < $scope.comments_esta.length; i++) {
                        var date = $scope.comments_esta[i].comment_date.split('T');
                        $scope.comments_esta[i].comment_date = date[0];
                    }
                }
                $scope.esta_main_photo = data.data.esta_main_photo;
                $scope.user_profile_pic = data.data.user_pic;
                var address = data.data.address1 + "," + data.data.cityId + "," + data.data.stateId + "," + data.data.countryId;
                var url_link = "https://" + window.location.host + "?in=" + $location.search().in + "&at=" + $location.search().at + "&rD=" + $location.search().rD + "&establishment=" + $location.search().establishment;
                //$scope.url_to_link = url_link.replace(/ /g, "%20");
                $scope.url_to_share = window.encodeURIComponent(url_link);
                $scope.share_img_src = angular.element(document.querySelector('.banImg img')).attr("src");
                $scope.host = location.hostname;
                angular.element("#li_old").show();
                angular.element("#li_new").hide();
                $scope.social = data.social;
                $scope.maploading = false;
                if (openInUnifiedCard) {
                    // Full establishment profile already loaded. Read its separate
                    // stream-only schedule fields before opening the standard card.
                    var profile = angular.extend({}, $scope.establishmentDetails, {
                        id: esta_id, esta_id: esta_id, establishment_id: esta_id,
                        stream_type: 0,
                        _igPublicChannel: true,
                        channelName: $scope.establishmentDetails.channelName || $scope.establishmentDetails.name,
                        local_title: $scope.name || $scope.establishmentDetails.name,
                        local_description: $scope.establish_description,
                        profilePic: data.data.profilePic || data.data.esta_main_photo,
                        photos: $scope.estaPhotos || [],
                        social_urls: data.data.social_urls || data.data.socials || data.social || [],
                        _igEEProfilePhotos: true,
                        up_events: $scope.up_events || [],
                        event_city_name: $scope.establishmentDetails.cityId,
                        event_country_name: $scope.establishmentDetails.countryId
                    });
                    function openEnrichedEECard(profile) {
                        // Marker data can contain the current live playback URL; retain it
                        // while using getEEProfile for complete social/gallery details.
                        var marker = markerEntity || {};
                        var playback = marker.liveUrl || marker.live_url || marker.playbackUrl ||
                            profile.liveUrl || profile.live_url || profile.playbackUrl || '';
                        var markerLive = marker.is_live === true || marker.is_live === 1 ||
                            marker.is_live === 'true' || marker.is_live === '1';
                        var savedLive = profile.is_live === true || profile.is_live === 1 ||
                            profile.is_live === 'true' || profile.is_live === '1';
                        profile.is_live = !!playback && (markerLive || savedLive);
                        profile.liveUrl = profile.is_live ? playback : null;
                        profile.photos = $scope.estaPhotos || [];
                        profile._igEEProfilePhotos = true;
                        profile.social_urls = data.data.social_urls || data.data.socials || data.social || [];
                        profile.up_events = $scope.up_events || [];
                        $scope.openLiveStreamPopup(0, esta_id, profile);
                    }
                    $http.get('/api/establishment/EstlastLiveData', {params: {id: esta_id}})
                        .then(function(response) {
                            var saved = response.data || {};
                            if (saved && !saved.error && typeof saved === 'object') {
                                angular.extend(profile, saved);
                                profile.photos = $scope.estaPhotos || [];
                                profile._igEEProfilePhotos = true;
                                profile.id = esta_id;
                                profile.esta_id = esta_id;
                                profile.stream_type = 0;
                                profile.scheduled = saved.scheduled === true || saved.scheduled === 1 ||
                                    saved.scheduled === 'true' || saved.scheduled === '1';
                                profile._igPublicChannel = true;
                                // Playback state is reconciled with marker data below.
                                profile.sliderImage = profile.persicon || saved.streampic || profile.profilePic || '';
                                profile.sliderImageClass = profile.persicon ? 'ig-slider-personal-icon' : 'ig-slider-stream-photo';
                            }
                            openEnrichedEECard(profile);
                        }, function(error) {
                            console.warn('Establishment schedule lookup failed:', error);
                            openEnrichedEECard(profile);
                        });
                }
            /*    if ($scope.establishmentDetails.is_live && !$scope.isLiveEvent) {
                    $scope.liveStreamButtonClicked($scope.activeStream, false);
                  
                }*/
                metaService(Object.assign($location.search(), {
                    cityId: data.data.cityId,
                    countryId: (data.data.countryId == 'United States' ? data.data.stateId : data.data.countryId)
                }));
                if (typeof(loadEvent) != "undefined") {
                    if (typeof(is_related) != "undefined" && typeof(related_id) != "undefined" && loadEvent) {
                        $http.post("/establishment/getrelateddetails", {
                            related_id: related_id
                        }).then(function(res) {
                            var relatedDetails = res.data;
                            if (relatedDetails['status']) {
                                var sendParam = {
                                    is_related: is_related,
                                    related_id: related_id,
                                    event_id: event_id
                                };
                                $scope.getEventEEprofile(relatedDetails['main_event_id'], ev, false, null, sendParam);
                            }
                        });
                    } else {
                        $scope.getEventEEprofile(event_id, ev);
                    }
                }
            });
        };
        $scope.isLiveEvent = false;
 

$scope.goEntertainment = function () {

    // not logged in
    if (!localStorageService.get('name')) {

        // Check category first to set the correct pending destination
        var userCategory = ($rootScope.usercategory && $rootScope.usercategory[0]);
        
        if (userCategory == 1) {
            $scope.pendingRedirect = 'indivevent';
        } else {
            $scope.pendingRedirect = 'entertainment';
        }

        $scope.openSigninModal();
        return;
    }

    $scope.handleEntertainmentRedirect();
};
$scope.handleEntertainmentRedirect = function () {

    if (window.socket && typeof window.socket.disconnect === 'function') { 
        window.socket.disconnect(); 
    }

    var userCategory = $rootScope.usercategory[0];
setTimeout(function() {
    if (userCategory == 2) {
        window.location.href = '/entertainment';
    } else if (userCategory == 1) {
        window.location.href = '/indivevent/';
    }
   }, 300);
};


$scope.loadingLogin = false;
$scope.openSigninModal = function () {
 
    if (!$scope.PopupModal) {

        $scope.modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'sign_in_modal.html',
            windowClass: 'zindexModal int125',
            scope: $scope,
				appendTo: angular.element(document.body)
        });

        $scope.modalInstance.result.then(function () {
            $scope.closeModal();
        }, function () {
            $scope.closeModal();
        });

        $scope.PopupModal = true;
    }
 
};
	 

		 
        $scope.getEventEEprofile = function(event_id, e, is_related, related_id, estaId, background) {
            $scope.maploading = true;
            delete $scope.eventId;
            $scope.eventId = event_id;
            var requetObj = {
                event_id: event_id,
                is_related: false,
                related_id: null
            };
            if (typeof(related_id) != 'undefined') {
                requetObj.related_id = related_id;
                requetObj.is_related = true;
            }
            $http.post("/establishment/getEventsEEProfile", requetObj).then(function(res) {
                var response = res.data;
                // console.log("#respomnsedateventdata", response);
                if (!response) return;
                $scope.establishment = response.data.establishment;
                if (response.data.establishment) estaId = response.data.establishment;
                $scope.eventDetails = response.data;
                var url = $scope.eventDetails.event_name.replace(/\s+/g, '-');
                var start_date = new Date(response.data.start_date);
                $scope.eventDetails.start_date = {
                    day: start_date.getDate(),
                    month: $filter('date')(start_date, "MMMM"),
                    year: start_date.getFullYear()
                };
                var end_date = new Date(response.data.end_date);
                $scope.eventDetails.end_date = {
                    day: end_date.getDate(),
                    month: $filter('date')(end_date, "MMMM"),
                    year: end_date.getFullYear()
                };
                $location.search('event', url);
                if (background) {
                    // console.log("firstbackground", background);
                    angular.element('#evtext2').removeClass('hide');
                    $rootScope.eventExtra = "gallery";
                    $scope.ee_for = "event";
                } else {
                    $scope.ee_for = "event";
                    // console.log("2ndbackeefor", $scope.ee_for);
                    $location.search('rD', event_id);
                    $location.search('related', null);
                    $rootScope.getEventProfile(e);
                }
                if ($scope.establishmentDetails && estaId && estaId != $scope.establishmentDetails.estaId)  $scope.getEstaEEprofile(estaId, e, true);
                if (!$scope.establishmentDetails)  $scope.getEstaEEprofile(estaId, e, true);
                $scope.event_main_photo = response.data.event_main_photo;
                $scope.eventPhotos = response.data.eventPhotos;
                $scope.eventAudios = response.data.audios;
                $scope.eventVideos = response.data.videos;
                if ($scope.metaType && $scope.metaType == 'event') {
                    $rootScope.metaDescription = response.data.event_description;
                    delete $scope.metaType;
                }
                if (response.data.event_locale && locale[0] == response.data.event_locale.language) {
                    $scope.event_name = response.data.event_locale.name;
                    $scope.event_description = response.data.event_locale.desc;
                    $scope.complete_event_description = response.data.event_locale.cdesc;
                    $scope.event_establish_name = response.data.establish_locale.name;
                } else {
                    $scope.event_name = response.data.event_name;
                    $scope.event_description = response.data.event_description;
                    $scope.complete_event_description = response.data.complete_desc;
                    $scope.event_establish_name = response.data.establish_name;
                };
                $scope.relateevent = response.data.related_events;
                if ($scope.relateevent.length > 0) {
                    for (var i = 0; i < $scope.relateevent.length; i++) {
                        var relatelocale = $scope.relateevent[i].event_locale;
                        if (relatelocale && locale[0] == relatelocale.language) {
                            $scope.eventrname = relatelocale.name;
                            $scope.eventrdescription = relatelocale.cdesc;
                        } else {
                            $scope.eventrname = $scope.relateevent[i].name;
                            $scope.eventrdescription = $scope.relateevent[i].description;
                        };
                    }
                }
                $scope.event_phone = response.data.event_phone;
                $scope.event_address = (response.data.address1) ? response.data.address1 + ', ' : '' + (response.data.address2) ? response.data.address2 + ', ' : '' + (response.data.cityId) ? response.data.cityId + ', ' : '' + (response.data.countryId) ? response.data.countryId + ', ' : '';
                $scope.event_address_complete = response.data.cityId + ',' + response.data.countryId;
                $scope.event_url = (response.data.event_url != null) ? response.data.event_url : "Not Available";
                $scope.event_comments = response.event_comments;
                var address = response.data.address1 + response.data.address2 + "," + (response.data.cityId || response.data.city_id) + "," + response.data.stateId + "," + response.data.countryId;
                $scope.eventDetails.location = address;
                var url_link = "https://" + window.location.host + "/ee/at/" + $location.search.at + "/" + address + "/event/" + response.data.event_name + "/" + response.data.event_id;
                $scope.event_url_to_link = url_link;
                $scope.event_url_to_share = window.encodeURIComponent(url_link);
                var email_link = "<!DOCTYPE html><html><head><meta name='viewport' content='width=device-width, initial-scale=1'><meta charset='UTF-8'></head><body>" + $filter('translate')('views.share_email') + ". \n <a href='" + url_link + "'>Know More</a></body></html>";
                $scope.event_email_link = window.encodeURIComponent(email_link);
                $scope.share_img_src = angular.element(document.querySelector('.banImg img')).attr("src");
                $(".left_event_profile").show();
                $scope.ee_show = false;
                $scope.social = response.data.social;
                $scope.maploading = false;
                $scope.related_events = response.data.related_events;
                $scope.up_events_pro = [];
                if ($scope.show_upcoming) {
                    $scope.up_events_pro = response.data.up_events;
                }
                $scope.isLiveEvent = false;
                if ($scope.eventDetails.is_live) {
                    $scope.isLiveEvent = true;
                    $scope.liveStreamButtonClicked($scope.activeStream, true);
                    // $scope.openLiveStreamPopup($scope.eventDetails.event_name, $scope.eventDetails.event_id);
                }
                if (typeof(param) != "undefined") {
                    $scope.getEventLinkedProfile(param.event_id, e, param.related_id, param.is_related);
                }
            });
        };
      
      
      
        $scope.related_events = [];
        $scope.getEventLinkedProfile = function(event_id, e, related_id, showUpcoming) {
            $(".linked_profile").scrollTop(0);
            var defer = $q;
            if (typeof(showUpcoming) != "undefined") {
                $scope.show_upcoming = true;
            }
            $scope.maploading = true;
            delete $scope.eventId;
            $scope.eventId = event_id;
            $scope.event_linked_id = related_id;
            var requetObj = {
                event_id: event_id,
                is_related: $scope.show_upcoming,
                related_id: related_id
            };
            return $http.post("/establishment/getEventsEEProfile", requetObj).then(function(res) {
                var response = res.data;
                defer.resolve();
                //$rootScope.getLinkedProfile(e);
                angular.element('#lnkevt').removeClass('hide');
                $rootScope.linkedExtra = "gallery";
                $scope.linkedEventDetails = response.data;
                var url = $scope.linkedEventDetails.event_name.replace(/\s+/g, '-');
                $location.search('related', url);
                $location.search('rD', event_id);
                var start_date = new Date(response.data.start_date);
                $scope.linkedEventDetails.start_date = {
                    day: start_date.getDate(),
                    month: $filter('date')(start_date, "MMMM"),
                    year: start_date.getFullYear()
                };
                var end_date = new Date(response.data.end_date);
                $scope.linkedEventDetails.end_date = {
                    day: end_date.getDate(),
                    month: $filter('date')(end_date, "MMMM"),
                    year: end_date.getFullYear()
                };
                $scope.establishment = response.data.establishment;
                $scope.event_linked_name = response.data.event_name;
                $scope.event_linked_first_hour = (response.data.event_first_start_day && response.data.event_first_end_day && response.data.event_first_open_time && response.data.event_first_close_time) ? (response.data.event_first_start_day + " - " + response.data.event_first_end_day + " " + response.data.event_first_open_time + " - " + response.data.event_first_close_time) : "Not Available";
                $scope.event_linked_second_hour = (response.data.event_second_start_day && response.data.event_second_end_day && response.data.event_second_start_time && response.data.event_second_close_time) ? (response.data.event_second_start_day + " - " + response.data.event_second_end_day + " " + response.data.event_second_start_time + " - " + response.data.event_second_close_time) : "Not Available";
                $scope.event_linked_main_photo = response.data.event_main_photo;
                $scope.event_linkedPhotos = response.data.eventPhotos;
                $scope.event_linkedAudios = response.data.audios;
                $scope.event_linkedVideos = response.data.videos;
                $scope.event_linked_description = response.data.event_description;
                if ($scope.metaType && $scope.metaType == 'relate') {
                    $rootScope.metaDescription = response.data.event_description;
                    delete $scope.metaType;
                }
                $scope.complete_event_linked_description = response.data.complete_desc;
                if (response.data.establish_locale && locale[0] == response.data.establish_locale) {
                    $scope.event_linked_name = response.data.eventname_i;
                    $scope.event_linked_description = response.data.desc_i;
                    $scope.complete_event_linked_description = response.data.cdesc_i;
                }
                $scope.event_linked_phone = response.data.event_phone;
                $scope.event_linked_address = null;
                (response.data.address1) ? response.data.address1 + ', ': '' + (response.data.address2) ? response.data.address2 + ', ' : '' + (response.data.cityId) ? response.data.cityId + ', ' : '' + (response.data.countryId) ? response.data.countryId + ', ' : '';
                $scope.event_linked_address_complete = response.data.cityId + ',' + response.data.countryId;
                $scope.event_linked_url = (response.data.event_url != null) ? response.data.event_url : "Not Available";
                $scope.event_linked_comments = response.event_comments;
                var address = response.data.address1 + response.data.address2 + "," + (response.data.cityId || response.data.city_id) + "," + response.data.stateId + "," + response.data.countryId;
                $scope.linkedEventDetails.location = address;
                // console.log("DiscoverPlaceCtrl params--", $location.search());
                metaService(Object.assign($location.search(), {
                    cityId: response.data.cityId,
                    countryId: (response.data.countryId == 'United States' ? response.data.stateId : response.data.countryId)
                }));
                //var url_link = "https://" + window.location.host + "/ee/at/"+ $location.search.at + "/" + address + "/event/" + response.data.event_name + "/" + response.data.event_id;
                // var url_link = "https://" + window.location.host + "/discover/" + address + "/related/" + response.data.event_name + "/" + response.data.event_id;
                var url_link = "https://" + window.location.host + "?in=" + $location.search().in + "&at=" + $location.search().at + "&related=" + $location.search().related + "&rD=" + $location.search().rD + "&event=" + $location.search().event + "&establishment=" + $location.search().establishment;
                $scope.related_url_to_link = url_link.replace(/ /g, "%20");
                $scope.related_url_to_share = window.encodeURIComponent(url_link);
                $scope.share_img_src_linked = angular.element(document.querySelector('.banImg img')).attr("src");
                $(".left_event_profile").show();
                $scope.ee_show = false;
                $scope.ee_for = "linkedicon";
                $scope.social = response.data.social;
                $scope.maploading = false;
                $scope.up_events_linked_pro = [];
                if ($scope.show_upcoming) {
                    $scope.up_events_linked_pro = response.data.up_events;
                    for (var i = 0; i < $scope.up_events_linked_pro.length; i++) {
                        var start_date = new Date($scope.up_events_linked_pro[i].start_date);
                        $scope.up_events_linked_pro[i].date = start_date;
                        $scope.up_events_linked_pro[i].start_date = {
                            day: start_date.getDate(),
                            month: $filter('date')(start_date, "MMMM"),
                            year: start_date.getFullYear()
                        };
                    }
                }
                return defer.promise;
            });
        };
        $scope.getAllLayers = function(e, eventId) {
            var requetObj = {
                'event_id': eventId
            };
            $http.post("/establishment/geteventestablishment", requetObj).then(function(res) {
                var response = res.data;
                $scope.getEventLinkedProfile(eventId, e, response.related_id, true).then(function(sucess) {
                    $scope.getEventEEprofile(response.main_event_id, e, null, null, true, response.establishment_id);
                });
            });
        };
        $scope.getEstaPhotoComments = function(id) {
            // console.log("photoidestab", id);
            $scope.esta_photo_comments = [];
            $http.get('/api/photocomments/establishment/' + id)
                .then(function(v) {
                    // console.log("thevafteresta", v)
                    $scope.esta_photo_comments = v.data;
                    $scope.toggledPhoto = id;
                })
                .catch(function(e) {
                    // console.log(e);
                });
            $('#egalphot img').each(function() {
                $(this).addClass(this.width > this.height ? 'landscape' : 'portrait');
            });
        };
        $scope.getEventPhotoComments = function(id) {
            // console.log("photoidev", id);
            $scope.event_photo_comments = [];
            $http.get('/api/photocomments/event/' + id)
                .then(function(v) {
                    // console.log("thevafterevent", v)
                    $scope.event_photo_comments = v.data;
                    $scope.toggledPhoto = id;
                })
                .catch(function(e) {
                    // console.log(e);
                });
            $('#egalphot img').each(function() {
                $(this).addClass(this.width > this.height ? 'landscape' : 'portrait');
            });
        };
        $scope.switchPhotoComments = function(photos, key, type) {
            var photoid;
            if (key < 0) {
                //// console.log(key, 'first', photos.length - 1);
                photoid = photos[photos.length - 1].id;
            } else if (key >= photos.length) {
                //// console.log(key, 'second');
                photoid = photos[0].id;
            } else {
                //// console.log(key, 'third');
                photoid = photos[key].id;
            }
            if (type == "establishment") {
                $scope.getEstaPhotoComments(photoid);
            } else {
                $scope.getEventPhotoComments(photoid);
            }
        };
        if (typeof(establish_id) != "undefined" && rD != "") {
            var the_arr = establish_id.split('-');
        }
        $scope.is_called = false;
        /** DIRECTIONS FROM USER LOCATION TO EE CODE **/
        $scope.getDirections = function(lng, lat) {
            if ((window.innerWidth < 801 && !$scope.profileTooltipActive) || (window.innerWidth < 900 && window.innerHeight < 500 && !$scope.profileTooltipActive)) {
                $scope.profileTooltipActive = true;
                return;
            }
            if ($window.innerWidth < 992) {
                $scope.openNavigation(lng, lat);
                return;
            }
            $scope.maploading = true;
            var map = $scope.map_map;
            directions = L.mapbox.directions();
            var opts = {
                routeStyle: {
                    color: '#f44336',
                    opacity: 0.90
                }
            };
            directionsLayer = L.mapbox.directions.layer(directions, opts)
                .addTo(map);
            directionsErrorsControl = L.mapbox.directions.errorsControl('errors', directions)
                .addTo(map);
            directionsRoutesControl = L.mapbox.directions.routesControl('routes', directions)
                .addTo(map);
            directionsInstructionsControl = L.mapbox.directions.instructionsControl('instructions', directions)
                .addTo(map);
            UserLocation.getLocation().then(function(user) {
                // var user = { lat: 31.6339793, long: 74.8722642 }
                localStorageService.set('city_lat', user.lat);
                localStorageService.set('city_lng', user.long);
                var origin = {
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [user.long, user.lat],
                    },
                    "properties": {}
                };
                var dest = {
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [lng, lat],
                    },
                    "properties": {}
                };
                directions.setOrigin(origin);
                directions.setDestination(dest);
                directions.query();
                $scope.directionHidden = false;
                $scope.maploading = false;
            }, function(err) {
                consoel.log(err);
            });
        };
        $scope.openNavigation = function(lng, lat) {
            if ((navigator.platform.indexOf("iPhone") != -1) ||
                (navigator.platform.indexOf("iPod") != -1) ||
                (navigator.platform.indexOf("iPad") != -1))
                window.open("maps://maps.google.com/maps?daddr=" + lat + "," + lng + "&ll=");
            else
                window.open("http://maps.google.com/maps?daddr=" + lat + "," + lng + "&ll=");
        };
        $scope.directionHidden = true;
        $scope.closeDirections = function() {
            $scope.directionHidden = true;
            var map = $scope.map_map;
            $scope.map_map.removeLayer(directionsLayer);
            angular.element('#directions-wrapper').addClass('hide');
        };
        $scope.printDirections = function(divName) {
            var printContents = document.getElementById(divName).innerHTML;
            var popupWin = window.open('', '_blank', 'width=300,height=300');
            popupWin.document.open();
            popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="app/libs/mapbox/mapbox.directions.css" /><link rel="stylesheet" type="text/css" href="app/libs/mapbox/print.directions.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        };
        /** END DIRECTIONS FROM USER LOCATION **/
        $scope.showPopuperror = function() {
            $("#errors_photos").modal("show");
        };
        $scope.message = "";
        $scope.saveToNotification = function(estaId, eventId, event_linked_id) {
            if (estaId) {
                if (!localStorageService.get('name')) {
                    $scope.modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'sign_in_modal.html',
                        windowClass: 'cnfpptModal',
                        scope: $scope,
								appendTo: angular.element(document.body)
                    });
                    $scope.modalInstance.result.then(function(selectedItem) {
                        $scope.closeModal();
                    }, function() {
                        $scope.closeModal();
                    });
                } else {
                    $http.post('/establishment/saveNotificationIcon', {
                        estaId: estaId,
                        eventId: eventId,
                        event_linked_id: event_linked_id,
                    }).then(function(res) {
                        var response = res.data;
                        $scope.message = $filter('translate')(response.message);
                        // $("#pop_up_notification_modal").modal("show");
                        $scope.modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'pop_up_notification_modal.html',
                            windowClass: 'cnfpptModal',
                            scope: $scope,
                        });
                        $scope.modalInstance.result.then(function(selectedItem) {
                            $scope.closeModal();
                        }, function() {
                            $scope.closeModal();
                        });
                    });
                }
            }
        };
        $scope.blockZoomEvent = false;
        $scope.showeefirst = function(layer_id) {
            if ($scope.webGl) {
               // traceLog("showeefirst", 'init', layer_id);
               // traceLog("allmarkers ", $scope.currentMapGLMarkers);
                var currMarker = $scope.getIndexOfMarker($scope.currentMapGLMarkers, layer_id);
               // traceLog("showeefirst", currMarker);
                if (currMarker) {
                    let latLng = currMarker.getLngLat();
                    let element = currMarker.getElement();
                   // traceLog("showeefirst", element);
                    element.classList.add('icon-hover');
                    currMarker.togglePopup();
                    $scope.blockZoomEvent = true;
                    $scope.map_map.flyTo({
                        center: [latLng.lng, latLng.lat],
                        bearing: 0,
                        duration: 0,
                        curve: 1,
                        essential: true
                    });
                }
            } else {
                var map = $scope.map_map;
                var marker = $scope.map_marker;
                marker.eachLayer(function(layer) {
                    layer.closePopup();
                    if (layer.feature.properties.id === layer_id) {
                        layer.openPopup();
                        $('.leaflet-popup-pane').show();
                        $('.leaflet-popup').css('left', '-162px');
                        $('.mapboxgl-marker img').css('height', '70px !important').css('width', '45px').css('margin-top', '-45px').css('margin-left', '-16px');
                        map = $scope.map_map;
                        $scope.map_map.panTo(layer.getLatLng(), {
                            zoom: 12,
                            duration: 1
                        });
                    }
                });
            }
        };
        $scope.hideeefirst = function(layer_id) {
            if ($scope.webGl) {
                var currMarker = $scope.getIndexOfMarker($scope.currentMapGLMarkers, layer_id);
                if (currMarker) {
                    currMarker.getElement().classList.remove('icon-hover');
                }
            }
        }
        $scope.getIndexOfMarker = function(allmarkers, val) {
            var marker;
            allmarkers.forEach(iconMarker => {
                iconMarker.getPopup().remove();
                var element = iconMarker.getElement();
                if (element.getAttribute("id") == val) {
                    let id = element.getAttribute("id")
                    let latLng = iconMarker.getLngLat();
                   // traceLog("current marker properties ", latLng, id, ($(element).data("feature")).properties.icon);
                    marker = iconMarker;
                }
            });
            return marker;
        };
        var enabled = {};
        $scope.getTransport = function(id) {
            $http.post('/site/gettransport', {
                id: id
            }).then(function(res) {
                var data = res.data;
                if (id == 1)
                    $scope.ground = data;
                else if (id == 2)
                    $scope.air = data;
                else if (id == 3)
                    $scope.travel = data;
            });
        };
        $scope.isLoggedInCheckForEvent = function() {
            if (!localStorageService.get('name')) {
                if (!$scope.PopupModal) {
                    $scope.modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'sign_in_modal.html',
                        scope: $scope,
								appendTo: angular.element(document.body)
                    });
                    $scope.modalInstance.result.then(function(selectedItem) {
                        $scope.closeModal();
                    }, function() {
                        $scope.closeModal();
                    });
                    $scope.PopupModal = !$scope.PopupModal;
                }
            } else {
                angular.element("#upload_event_photo").click();
            }
        };
        $scope.isLoggedInCheck = function() {
            if (!localStorageService.get('name')) {
                $scope.modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'sign_in_modal.html',
                    windowClass: 'zindexModal int127',
                    scope: $scope,
							appendTo: angular.element(document.body)
                });
                $scope.modalInstance.result.then(function(selectedItem) {
                    $scope.closeModal();
                }, function() {
                    $scope.closeModal();
                });
            } else {
                angular.element("#upload_esta_photo").click();
            }
        };
        $scope.closeModal = function() {
            if ($scope.modalInstance) {
                $scope.modalInstance.dismiss();
                $scope.lastStreamRawUrl = '';
				 $scope.PopupModal = false;
				 window.scrollTo(0, 0);
            }
        };
        $scope.closeModalStream = function() {
            if ($scope.streamModalInstance) {
                $scope.streamModalInstance.dismiss();
                $scope.lastStreamRawUrl = '';
                angular.element('#indnfd').addClass('hide');
            }
        };
        $scope.controller_name = "mapcontroller";
        $rootScope.getProfile = function(e) {
            $scope.stopAudio();
            $("#clipPath1").find('circle').attr("r", 1).css('transition', "all 0s");
            $rootScope.eeView = false;
            $rootScope.eeExtra = "gallery";
            var cards = $(".new_ee_profile_container");
            cards.map(function(i, c) {
                var visibility = $(c).is(":visible");
                if (visibility && i > 0) {
                    $(c).addClass('hide');
                    eePopUpClose(i);
                }
            });
            $rootScope.closeEEExtra();
            if (window.innerWidth <= 1024 && window.innerWidth >= 801) {
                $scope.activateEventSlider = false;
            }
            eePopUp(e, 0);
        };
        $rootScope.getProfileInBackground = function(e) {
            $rootScope.closeEEExtra();
            eePopUp(e, 0);
        };
        $rootScope.getExtra = function(ex, ev) {
            $scope.stopAudio();
            $rootScope.eeView = ev;
            $rootScope.eeExtra = ex;
        };
        $rootScope.getEventExtra = function(ex, ev) {
            $scope.stopAudio();
            $rootScope.eventView = ev;
            $rootScope.eventExtra = ex;
        };
        $rootScope.getLinkedExtra = function(ex, ev) {
            $scope.stopAudio();
            $rootScope.linkedView = ev;
            $rootScope.linkedExtra = ex;
        };
        $rootScope.eeExtra = "gallery";
        $rootScope.eeView = false;
        $rootScope.closeEEExtra = function() {
            $scope.stopAudio();
            $rootScope.eeView = false;
            $rootScope.eeExtra = "gallery";
        };
        $rootScope.closeEventExtra = function() {
            $scope.stopAudio();
            $rootScope.eventView = false;
            $rootScope.eventExtra = "gallery";
        };
        $rootScope.closeEventLinkedExtra = function() {
            $scope.stopAudio();
            $rootScope.linkedView = false;
            $rootScope.linkedExtra = "gallery";
        };
        $rootScope.getEventProfile = function(e) {
            $scope.stopAudio();
            angular.element('#evtext2').removeClass('hide');

            $rootScope.closeEventExtra();
            if (window.innerWidth <= 1024 && window.innerWidth >= 801) {
                $scope.activateEventSlider = false;
            }
            eePopUp(e, 1);
        };
        $rootScope.getEventProfileBackground = function(e) {
            // console.log('event profile')
            $rootScope.closeEventExtra();
            eePopUp(e, 1);
        };
        $rootScope.getLinkedProfile = function(e) {
            $scope.stopAudio();
            $rootScope.closeEventLinkedExtra();
            $("#clipPath3").find('circle').attr("r", 1).css('transition', "all 0s");
            if (window.innerWidth <= 1024 && window.innerWidth >= 801) {
                $scope.activateEventSlider = false;
            }
            eePopUp(e, 2);
        };
        $scope.$onRootScope('closeProfileCards', function(event, mass) {
            //// console.log('close profile')
            $rootScope.closeCards();
        });
        $rootScope.closeCards = function() {
            //// console.log('close profile')
            angular.element('#sbctsc').css('opacity', '1');
            if (window.innerWidth <= 10000 && window.innerWidth >= 801) {
                $scope.activateEventSlider = true;
            }
            var cards = $(".new_ee_profile_container");
            $scope.related_events = [];
            $location.search('establishment', null);
            $location.search('event', null);
            $location.search('related', null);
            cards.map(function(i, c) {
                var visibility = $(c).is(":visible");
                if (visibility) {
                    $rootScope.closeCard(i);
                    $(c).addClass('hide');
                }
            });
        };
  
  
  
  
  
  /*
  
        $scope.closeCard = function(id) {
		 
			document.getElementById('ee1pr').style.display = 'none';
            angular.element('#sbctsc').css('opacity', '1');
            $scope.stopAudio();
            $scope.show_upcoming = false;
            eePopUpClose(id);
            if (id == 2) {
				document.getElementById('evtext2').style.display = 'none';
                $scope.ee_for = "event";
                $location.search('related', null);
                $scope.linkedEventDetails = null;
                $location.search('rD', $scope.eventDetails.event_id);
            }
            if (id == 1) {
				document.getElementById('evtext2').style.display = 'none';
                $scope.related_events = [];
                $scope.ee_for = "esta";
                $location.search('event', null);
                $scope.eventDetails = null;
                $location.search('rD', $scope.establishmentDetails.estaId);
            }
            if (id == 0) {
					document.getElementById('ee1pr').style.display = 'none';
                $scope.ee_for = null;
                $rootScope.noScroll = '';
                $location.search('establishment', null);
                $location.search('rD', null);
                $scope.establishmentDetails = null;
                if (window.innerWidth <= 10000 && window.innerWidth >= 801) {
                    $scope.activateEventSlider = true;
                }
            }
        };
*/


$scope.closeCard = function (id) {
    var expandedCard = document.querySelector('.stream-card.expand');

    if (expandedCard) {
        var video = expandedCard.querySelector('video');

        if (video) {
            video.pause();
            video.muted = true;
            video.currentTime = 0;
        }

        expandedCard.classList.remove('expand');
        var closedId = expandedCard.id.replace(/^card_/, '');
        var wasTemporary = ($scope.streams || []).some(function(item) {
            return String(item.id) === String(closedId) && item._igTemporaryCard;
        });
        if (wasTemporary) {
            var closedIndex = ($scope.streams || []).findIndex(function(item) {
                return String(item.id) === String(closedId);
            });
            if (closedIndex >= 0 && window.hlsInstances && window.hlsInstances[closedIndex]) {
                try { window.hlsInstances[closedIndex].destroy(); } catch (e) {}
                window.hlsInstances[closedIndex] = null;
            }
            // Angular's ng-repeat removes the temporary card and its child scope.
            $scope.streams.splice(closedIndex, 1);
        }
        if (typeof socket !== 'undefined') socket.emit('leaveStream', closedId);

        if (!wasTemporary && expandedCard._originalParent) {
            expandedCard._originalParent.insertBefore(
                expandedCard,
                expandedCard._originalNextSibling
            );
        }

        expandedCard._originalParent = null;
        expandedCard._originalNextSibling = null;
    }

    document.body.classList.remove('expand');

    var sky = document.getElementById('sky');

    if (sky) {
        sky.style.display = '';
    }

    // Closing a live video is not the same as closing an establishment profile.
    if (id === undefined || id === null) return;
    var eePanel = document.getElementById('ee1pr');
    if (eePanel) eePanel.style.display = 'none';
    angular.element('#sbctsc').css('opacity', '1');

    if (typeof $scope.stopAudio === 'function') $scope.stopAudio();
    $scope.show_upcoming = false;

    eePopUpClose(id);

    if (id == 2) {
        document.getElementById('evtext2').style.display = 'none';
        $scope.ee_for = 'event';
        $location.search('related', null);
        $scope.linkedEventDetails = null;
        $location.search('rD', $scope.eventDetails.event_id);
    }

    if (id == 1) {
        document.getElementById('evtext2').style.display = 'none';
        $scope.related_events = [];
        $scope.ee_for = 'esta';
        $location.search('event', null);
        $scope.eventDetails = null;
        $location.search('rD', $scope.establishmentDetails.estaId);
    }

    if (id == 0) {
        $scope.ee_for = null;
        $rootScope.noScroll = '';
        $location.search('establishment', null);
        $location.search('rD', null);
        $scope.establishmentDetails = null;

        if (window.innerWidth <= 10000 && window.innerWidth >= 801) {
            $scope.activateEventSlider = true;
        }
    }
}; 






        $scope.showLinkedPopover = function(e, r) {
            var lleft = e.target.x || e.pageX - e.offsetX;
            var ltop = e.clientY;
            var bbox = e.target.getBoundingClientRect();
            $scope.activeLinkedProfile = r;
            if (window.innerWidth > 801) {
                $('.xs_gt_popover').css({
                    left: bbox.left + bbox.width + 15,
                    top: bbox.top + (bbox.height / 2) - 41.50,
                }).show();
            } else {
                $('.xs_popover').css({
                    left: bbox.left + bbox.width + 15,
                    top: bbox.top + (bbox.height / 2) - 41.50,
                }).show();
            }
        };
        $scope.hideLinkedPopover = function(e) {
            $timeout(function() {
                $('.linked_popover').hide();
            }, 200);
        };
        $scope.getLinkedPopover = function(event_id, e, related_id, showUpcoming) {
            if (window.innerWidth > 101) {
                $scope.getEventLinkedProfile(event_id, e, related_id, showUpcoming);
            }
        };
        $timeout(function() {
            if (window.innerWidth >= 801 && window.innerWidth <= 1024) {
                $scope.adjustTabHeight();
            } else {
                $scope.mapMinHeight = angular.element('.main_container').height() - 50;
            }
        });
        $scope.$onRootScope('windowResized', function(event) {
            if (window.innerWidth >= 801 && window.innerWidth <= 1024) {
                $scope.adjustTabHeight();
                $scope.$apply();
            } else {
                $scope.mapMinHeight = angular.element('.main_container').height() - 50;
                $scope.$apply();
            }
        });
        $scope.adjustTabHeight = function() {
            if (window.innerHeight >= 801 && window.innerHeight <= 991) {
                $scope.mapMinHeight = window.innerHeight - 200;
            } else if (window.innerHeight >= 992 && window.innerHeight <= 1200) {
                $scope.mapMinHeight = window.innerHeight - 300;
            } else {
                $scope.mapMinHeight = window.innerHeight - 500;
            }
        };
        $scope.$onRootScope('setMapview', function(event, args) {
            var location = $location.search().at;
            location = location.split(',');
            if (args.location == 'country') {
                var zoom = 7;
            } else if (args.location == 'city') {
                var zoom = 10;
            } else {
                var zoom = 10;
            }
            $scope.setMapview(location[0], location[1], zoom);
        });
        $scope.setMapview = function(lng, lat, zoom) {
           // traceLog("discover-map", "set map view called");
            var coor = {
                latitude: lat,
                longitude: lng,
                zoom: zoom
            };
            $scope.drawMap(coor.latitude, coor.longitude, coor.zoom, $scope.dataFetchedOnce ? true : false);
            //$scope.loadLocationMap(coor);
        };
        $scope.$on('loadLocationMap', function(e, coor) {
           // traceLog("on.loadLocationMap -> load location map ");
            if (!isMobile) {
                $scope.activateEventSlider = true;
            };
            if (isMobile) {
                $scope.activateEventSlider = false;
            };
            // draw map as per coordinates, zoom leavel and draw icons as well
            // setTimeout(() => {
            //    // traceLog("on.loadLocationMap -> fly to my location ");
            //     $scope.map_map.flyTo({
            //     center: [
            //         coor.longitude, coor.latitude
            //             ],   //     essential: true
            //     })}, 1000);
            $scope.drawMap(coor.latitude, coor.longitude, coor.zoom, $scope.dataFetchedOnce ? true : false);
            //$scope.loadLocationMap(coor);
        });
       
		  
					  
						 
						 
		   
        $scope.loadLocationMap = function(coor, timeout, loadUrl) {
           // traceLog("tn-discover-mapadjust", "loading location on map for coordinates ", coor, " with timeout as ", timeout);
            if (!timeout) timeout = 0;
            coor.latitude = parseFloat(coor.latitude);
            coor.longitude = parseFloat(coor.longitude);
            getMoreIcons = true;
            // $scope.maploading = true;
            $scope.maploading = false;
            if (!isMobile) {
                $scope.activateEventSlider = true;
            };
            if (isMobile) {
                $scope.activateEventSlider = false;
            };
            if ($scope.webGl) {
               // traceLog("tn-discover-mapadjust", "webgl environment setting center as ", coor.longitude, coor.latitude, " setting zoom ", coor.zoom);
                //$scope.map_map.setCenter([coor.longitude, coor.latitude]);
                $scope.map_map.flyTo({
                    center: [coor.longitude, coor.latitude],
                    zoom: coor.zoom,
                    bearing: 0,
                    duration: 0,
                    curve: 1,
                    essential: true
                });
                $scope.map_map.resize();
            } else {
               // traceLog("tn-discover-mapadjust", "no webgl: using js setting view as ", coor.longitude, coor.latitude, "setting zoom ", coor.zoom);
                $scope.map_map.setView([coor.latitude, coor.longitude], coor.zoom);
                $scope.activateAppropriateZoomIndicator(coor.zoom)
                $scope.map_map.resize();
            }
            angular.element("#map").css("opacity", 1);
            // $timeout(function(){
            $scope.keyword = angular.element('#keyword_search_mobile').val() || angular.element('.keyword_search').val();
            var bounds = $scope.map_map.getBounds();
            var center = $scope.map_map.getCenter();
            var northEast = bounds.getNorthEast();
            var southWest = bounds.getSouthWest();
            var zoomLevel = $scope.map_map.getZoom();
           // traceLog("tn-discover-dataondrag3", "get data on drag (center, northEast, southWest, coor, zoomLevel)", center, northEast, southWest, coor, zoomLevel);
            if (!loadUrl) {
                loadUrl = $scope.getDataOnDragUrl(northEast.lat, southWest.lat, northEast.lng, southWest.lng, $scope.keyword, zoomLevel);
            }
           // traceLog("tn-discover-dataondrag4", "url formed as ", loadUrl);
            $scope.estaId = [];
            if ($scope.webGl) {
               // traceLog("tn-discover-dataondrag5", "webgl environment ", loadUrl);
                $scope.markerLoadUrlGL(loadUrl);
            } else {
                var marker = $scope.map_marker;
                if (!marker) marker = $scope.initMarkerGL();
               // traceLog("tn-discover-dataondrag6", "no webgl environment using js ", loadUrl);
                $scope.markerLoadUrlJS(map, marker, loadUrl);
            }
            if (localStorageService.get('upcoming') != null) {
                $(".upcomingevts").trigger("click");
            }
            localStorageService.remove('categories');
            if ($scope.showUpcomingEventSlider || localStorageService.get('getUpcomingEvents')) {
                $scope.getUpcomingEventsDiscover();
                $scope.showEstaEventSlider = false;
                localStorageService.remove('getUpcomingEvents');
            }
        };
    
							  
        $scope.active = 0;
        $scope.activeSlide = 0;
        $scope.$watch('active', function(n, o) {
            $scope.activeSlide = n;
            // console.log("getUpcomingEvents 3", $scope.active, ' ', n, o);
            if (n != o) {
                $scope.getUpcomingEventsDiscover();
                //// console.log("getUpcomingEvents 3");
            }
        });
        $scope.increSlide = function() {
            $scope.active++;
            $scope.$apply();
        };
        $scope.decreSlide = function() {
            $scope.active--;
            $scope.$apply();
        };
        $document.on('click', '.right.carousel-control', function() {
            var that = this;
            angular.element(this).prop('disabled', true);
            $scope.increSlide();
            $timeout(function() {
                angular.element(that).prop('disabled', null);
            }, 250);
        });
        $document.on('click', '.left.carousel-control', function() {
            var that = this;
            angular.element(this).prop('disabled', true);
            $scope.decreSlide();
            $timeout(function() {
                angular.element(that).prop('disabled', null);
            }, 250);
        });
        $document.on('click', '.closeicon', function() {
            // Reset bootstrap carousel slider index to current month
            $scope.resetUpcomingEventsSliderIndex();
        });
        $scope.resetUpcomingEventsSliderIndex = function() {
            // Reset bootstrap carousel slider index to current month
            var el = angular.element(document.querySelector('div.item.active'));
            el.removeClass("active");
            angular.element(document.getElementById('carousel-slide-0')).addClass('active');
            // console.log("closeicon clicked, active is ", el);
            $scope.active = 0;
            $scope.activeSlide = 0;
        };
        $scope.months = [];
        $scope.uibstate = {};
        var categories = [{
            category_id: 7,
            category_name: "Adventures/Tours",
            events: []
        }, {
            category_id: 6,
            category_name: "Festivals/Exhibitions",
            events: []
        }, {
            category_id: 5,
            category_name: "Gaming/Amusement",
            events: []
        }, {
            category_id: 4,
            category_name: "Museums/Cinemas",
            events: []
        }, {
            category_id: 3,
            category_name: "Music/Performances",
            events: []
        }, {
            category_id: 2,
            category_name: "Nature/Sites",
            events: []
        }, {
            category_id: 283,
            category_name: "Sports/Competitions",
            events: []
        }, {
            category_id: 147,
            category_name: "Children",
            events: []
        }];
        for (var i = 0; i < 12; i++) {
            var currDate = new Date();
            currDate.setDate(1);
            currDate.setMonth(currDate.getMonth() + i);
            var months = {
                month: $filter('date')(currDate, "MMMM"),
                year: $filter('date')(currDate, "yyyy"), // category: categories
            };
            $scope.months.push(months);
        }
        for (var i = 0; i < categories.length; i += 1) {
            $scope.uibstate[categories[i].category_id] = {
                open: false,
                close: false
            };
        }
        $scope.$on('toggleUpcomingCategory', function(e, data) {
           // traceLog("discover-toggleUpcomingCategory on selected index =", data);
            $scope.toggleUpcomingCategory(data.index, true);
        });
        $scope.$on('resetUpcomingSlider', function() {
           // traceLog("discover-resetUpcomingSlider start ");
            $scope.uibstate = {};
            $scope.resetUpcomingEventsSliderIndex();
        });
        $scope.toggleUpcomingCategory = function(id, selectOnly) {
           // traceLog("discover-upcomingevents", "select only is ", selectOnly);
           // traceLog("discover-upcomingevents", "category id is ", i);
            var catId = id;
            var leng = $scope.filteredUpcomingEventsData.length;
            for (var i = 0; i < leng; i++) {
                if (catId == $scope.filteredUpcomingEventsData[i].category_id) {
                    $scope.filteredUpcomingEventsData.splice(0, 0, $scope.filteredUpcomingEventsData.splice(i, 1)[0]);
                    // console.log("new filteredUpcomingEventsData arr is ...", $scope.filteredUpcomingEventsData);
                    // $scope.uibstate[catId].open = true;
                }
            }
            // console.log("uibstate is ", $scope.uibstate);
        };




        $scope.getUpcomingEventsDiscover = function() {
           // traceLog("discover-upcomingevents", "called-> $scope.getUpcomingEventsDiscover() ");
            $scope.showUpcominEventSlider = true;
            var location = $location.search().at,
                map = $scope.map_map,
                bounds = $scope.map_map.getBounds(),
                northEast = bounds.getNorthEast(),
                southWest = bounds.getSouthWest();
            location = location ? location.split(",") : location;
            if ($scope.activeSlide > 11) {
                $scope.activeSlide = 0;
                $scope.active = 0;
            }
            if ($scope.activeSlide < 0) {
                $scope.activeSlide = 11;
                $scope.active = 11;
            }
            var params = {
                latitude: parseFloat(location[1]),
                longitude: parseFloat(location[0]),
                neLat: northEast.lat,
                neLng: northEast.lng,
                swLat: southWest.lat,
                swLng: southWest.lng,
                month: $scope.activeSlide
            };
           // traceLog("discover-upcomingevents", "calling-> /api/events/upcomingevents");
            $http.post('/api/events/upcomingevents', params)
                .then(function(res) {
                   // traceLog("discover-upcomingevents", "response-> /api/events/upcomingevents", res);
                    var data = res.data;
                    for (var i = 0; i < data.length; i++) {
                        var upevcat = data[i].events;
                        for (var j = 0; j < upevcat.length; j++) {
                            var upevcated = upevcat[j];
                            if (upevcated.event_locale && locale[0] == upevcated.event_locale.language) {
                                $scope.eventpzname = upevcated.event_locale.name;
                                $scope.eventpzdescription = upevcated.event_locale.cdesc;
                                $scope.eventpzestab = upevcated.establish_locale && upevcated.establish_locale.length > 0 && upevcated.establish_locale[0] != null ? upevcated.establish_locale[0].name : "";
                            } else {
                                $scope.eventpzname = upevcated.event_name;
                                $scope.eventpzdescription = upevcated.complete_desc;
                                $scope.eventpzestab = upevcated.establish_name;
                            };
                        }
                    }
                    $scope.allEEIDsUpcomingEvents = [];
                    data.forEach(function(cat) {
                        cat.events.forEach(function(event) {
                            $scope.allEEIDsUpcomingEvents.push(event.estaId);
                        });
                    });
                   // traceLog("discover-upcomingevents", "response-> $scope.allEEIDsUpcomingEvents ", $scope.allEEIDsUpcomingEvents);
                    var currMonth = $scope.activeSlide;
                    if (!currMonth) currMonth = 0;
                    if (currMonth < 0) currMonth = 12 + $scope.activeSlide;
                    // $scope.months[currMonth].category = data;
                    $scope.upcomingEventsData = data;
                    $scope.filteredUpcomingEventsData = $scope.upcomingEventsData.map(function(u) {
                        return u;
                    });
                    // $scope.filterMapMarkerJS(); // filterMapMarkerJS commented by nick
                    $scope.filterMapGLMarker();
                }, function(err) {});
        };
        $scope.$on('getUpcomingEventSlider', function() {
           // traceLog("getUpcomingEventSlider ", "DiscoverCtrl--> 'on' triggered");
            $scope.showEstaEventSlider = false;
            $scope.closeCategoryPopup();
            $scope.selected.showUpcomingEvents = true;
            $scope.getUpcomingEventsDiscover();
            if (!$scope.selected.category_id) {
                $scope.uibstate = {};
                $scope.months = [];
                for (var i = 0; i < 12; i++) {
                    var currDate = new Date();
                    currDate.setDate(1);
                    currDate.setMonth(currDate.getMonth() + i);
                    var months = {
                        month: $filter('date')(currDate, "MMMM"),
                        year: $filter('date')(currDate, "yyyy"), // category: categories
                    };
                    $scope.months.push(months);
                }
                for (var i = 0; i < categories.length; i += 1) {
                    $scope.uibstate[categories[i].category_id] = {
                        open: false,
                        close: false
                    };
                }
               // traceLog("getUpcomingEventSlider ", "DiscoverCtrl--> selected category inside if");
            } else {
               // traceLog("getUpcomingEventSlider ", "DiscoverCtrl--> selected category inside else", $scope.selected);
               // traceLog("getUpcomingEventSlider ", "DiscoverCtrl--> selected category home cate ", $scope.homecategories);
               // traceLog("getUpcomingEventSlider ", "DiscoverCtrl--> selected category home cat id ", $scope.selected.category_id);
                $scope.toggleUpcomingCategory($scope.selected.category_id, true);
            }
            // console.log("getUpcomingEvents 4");
        });
        $scope.$on('resetIcons.apimapping', function(e, data) {
            // console.log("DiscoverPlaceCtrl-> on[resetIcons.apimapping]");
            $scope.mapDragged = false;
            //// console.log('resetIcons.apimapping')
            $scope.resetMapMarkers(data);
        });
        $scope.resetMapMarkers = function(data) {
           // traceLog("tn-discover-resetmarkers", "called-> resetMapMarkers() ", data);
            $scope.showEstaEventSlider = true;
            $location.search("cat", null);
            $location.search("subcat", null);
            $location.search("childcat", null);
            $location.search("genre", null);
            var map = $scope.map_map;
            if (data.keywordSearched) {
                var bounds = $scope.map_map.getBounds();
                var center = $scope.map_map.getCenter();
                var northEast = bounds.getNorthEast();
                var southWest = bounds.getSouthWest();
                var zoomLevel = $scope.map_map.getZoom();
               // traceLog("tn-discover-loadmapicons", 'data.keyworkdSearched has value');
                $scope.loadMapIcons(northEast, southWest, center, zoomLevel);
            } else {
                $rootScope.closeCards();
            }
            if ($scope.webGl) {
                $scope.added_id = [];
                $scope.temp_right_slider_data = [];
                $scope.right_slider_data = [];
                $scope.markers.features.forEach(function(marker) {
                    //$scope.initMarkerGL(marker); commented by  nicklesh
                });
            } else {
                var startime = new Date();
                $timeout(function() {
                    filterIcons = false;
                    $scope.filtered_temp_slider_data = [];
                    $scope.right_slider_data = [];
                    $scope.map_marker.setFilter(function(f) {
                        return true;
                    }).addTo(map);
                    $scope.loadMoreSlider();
                    // console.log('Time Taken', new Date() - startime);
                }, 200);
            }
            if (window.innerWidth < 801) {
                $('.mobile-vert-menu').addClass('mobile-hor-menu').removeClass('mobile-vert-menu');
            }
        };
        $scope.$on('searchIcons', function(keyword) {
           // traceLog("discover-keywordsearch", "keyword searched as ", keyword);
            $scope.keywordSearchedHere = true;
            var data = {
                keywordSearched: true
            };
            $scope.resetMapMarkers(data);
        });
        $scope.$on('fitlerIcons.mapMarkers', function(err, data) {
           // traceLog("tn-discover-event", "$on[fitlerIcons.mapMarkers]", data);
           // traceLog("tn-discover-filtermapmarker", "calling-> $scope.filterMapMarker(data) ", data);
            $scope.filterMapMarker(data);
            $rootScope.closeCards();
        });
        $scope.setFile = function(element) {
            var file = element.files[0];
            var imagefile = file.type;
            var match = ["image/jpeg", "image/png", "image/jpg"];
            if (!((imagefile == match[0]) || (imagefile == match[1]) || (imagefile == match[2]))) {
                $scope.$apply(function() {
                    $scope.message = "Please Select A valid Image File. Only jpeg, jpg and png Images type allowed";
                    $scope.message_test = "Please Select A valid Image File. Only jpeg, jpg and png Images type allowed";
                    $scope.PopupnotificationModal = true;
                });
            } else {
                var reader = new FileReader();
                reader.onload = imageIsLoaded;
                reader.readAsDataURL(element.files[0]);
                var fd = new FormData();
                fd.append("file", file);
                if ($scope.estaId == null) {
                    var url = "/establishment/uploadEventPhoto";
                    fd.append("event", $scope.eventId);
                } else {
                    var url = "/establishment/uploadEstaPhoto";
                    fd.append("establish", $scope.estaId);
                }
                $http.post(url, fd, {
                    withCredentials: true,
                    headers: {
                        'Content-Type': undefined
                    },
                    transformRequest: angular.identity
                }).then(function() {
                    if ($scope.estaId == null) {
                        $http.post("/establishment/getPhotosEvents", {
                            eventId: $scope.eventId
                        }).then(function(res) {
                            var response = res.data;
                            $scope.eventPhotos = response.photos;
                            $scope.event_main_photo = response.main_image;
                        }, function(err) {});
                    } else {
                        $http.post("/establishment/getPhotosEstablishment", {
                            estaId: $scope.estaId
                        }).then(function(res) {
                            var response = res.data;
                            $scope.estaPhotos = response.photos;
                            $scope.esta_main_photo = response.main_image;
                        }, function(err) {});
                    }
                }, function(err) {});
            }

            function imageIsLoaded(e) {}
        };
        $scope.$on('updateEstaImages', function(err, data) {
            $scope.estaPhotos = data.photos;
            $scope.esta_main_photo = data.main_image;
        });
        $scope.$on('updateEventImages', function(err, data) {
            $scope.eventPhotos = data.photos;
            $scope.event_main_photo = data.main_image;
        });
        // Show Location is clicked on promotion
        $scope.$on('showPromotionLocation', function(e, args) {
           // traceLog("discover-load-location", "on[showPromotionLocation] called");
            var selectedKeyword = {
                type: args.type,
                id: args.id,
                is_brand: args.is_brand
            };
            localStorageService.set('selectedKeyword', JSON.stringify(selectedKeyword));
            if (window.innerWidth > 801) {
                $('.keyword_search').val(args.name);
            } else {
                $('.keyword_search_mobile').val(args.name);
            }
            // if (!$scope.mapSatellite)
            //     $scope.changeSatelliteView()
            if (args.geocode) {
                var geocode = args.geocode.split(",");
                var coor = {
                    latitude: geocode[1],
                    longitude: geocode[0],
                    zoom: 16
                };
                mapboxgeocode.getAddress(args.geocode).then(function(res) {
                    // console.log("DiscoverPlaceCtrl-->inside if mapboxgeocode getaddress ", res);
                    if (res.features.length > 0) {
                        $location.search('in', res.features[0].place_name);
                    }
                });
                $scope.loadLocationMap(coor, 1500);
            } else {
                mapboxgeocode.getGeo(args.url).then(function(res) {
                    // console.log("DiscoverPlaceCtrl-->inside else mapboxgeocode getGeo ", res);
                    if (res.features.length > 0) {
                        $location.search('at', res.features[0].center[0] + "," + res.features[0].center[1]);
                        $location.search('in', args.url);
                        var coor = {
                            latitude: res.features[0].center[1],
                            longitude: res.features[0].center[0],
                            zoom: 16
                        };
                        $scope.loadLocationMap(coor, 1500);
                    }
                });
            }
            if (window.innerWidth > 801) {
                if (args.type == "esta") {
                    if (args.is_brand != "1") {
                        angular.element('#evtext2').addClass('hide');
                        angular.element('#lnkevt').addClass('hide');
                       $scope.getEstaEEprofile(args.id, null);
                    }
                } else if (args.type == "event") {
                    //// console.log('initial event profile')
                    angular.element('#evtext2').addClass('hide');
                    angular.element('#lnkevt').addClass('hide');
                    $scope.getEventEEprofile(args.id, null, null, null, false, args.estaId);
                } else {
                    angular.element('#evtext2').addClass('hide');
                    angular.element('#lnkevt').addClass('hide');
                    $scope.getEventLinkedProfile(args.id, null, args.mainEvent);
                    $scope.getEventEEprofile(args.mainEvent, null, null, null, true, args.estaId);
                }
            }
            $rootScope.$emit('keywordSelected');
        });
        $scope.getSelectedProfile = function() {
           // traceLog("discover-seo", "getSelectedProfile() called", query.rD);
            var selectedProfile = JSON.parse(localStorageService.get('showProfile'));
            localStorageService.remove('showProfile');
            if (!selectedProfile) $scope.showUrlProfile();
            if (!selectedProfile || window.innerWidth < 801 || selectedProfile.is_brand == "1") return;
            $timeout(function() {
                if (window.innerWidth > 201) {
                    if (selectedProfile.type == "esta") {
                        angular.element('#evtext2').addClass('hide');
                        angular.element('#lnkevt').addClass('hide');
                         $scope.getEstaEEprofile(selectedProfile.esta, null);
                    } else if (selectedProfile.type == "event") {
                        //// console.log('initial event profile')
                        angular.element('#evtext2').addClass('hide');
                        angular.element('#lnkevt').addClass('hide');
                        $scope.getEventEEprofile(selectedProfile.event, null, null, null, false, selectedProfile.esta);
                    } else {
                        angular.element('#evtext2').addClass('hide');
                        angular.element('#lnkevt').addClass('hide');
                        $scope.getEventLinkedProfile(selectedProfile.event, null, selectedProfile.mainEvent);
                        $scope.getEventEEprofile(selectedProfile.mainEvent, null, null, null, true, selectedProfile.esta);
                    }
                }
                localStorageService.remove('showProfile');
            }, 1000);
        };
        $scope.toggleCategorySlider = function(e) {
            $scope.activateEventSlider = !$scope.activateEventSlider; 
        };
 $scope.toggleComments = function(e) { 
            if (angular.element('.cht270').hasClass('active')) {
                angular.element('.cht270').removeClass('active');
            } else {
                angular.element('.cht270').addClass('active');
            };
        };
        $scope.showUrlProfile = function() {
           // traceLog('discover-seo', 'showUrlProfile() called')
            if (query.rD) {
                var id = query.rD;
                // As refer id is present will will use its latitude/longitude to draw map
                $timeout(function() {
                    if (query.related) {
                        $scope.getAllLayers(null, id);
                    } else if (query.event) {
                        var params = {
                            event_id: id
                        };
                        $http.post("/establishment/geteventestablishment", params).then(function(res) {
                            var data = res.data;
                            $scope.getEventEEprofile(id, null, null, null, false, data.establishment_id);
                        });
                    } else {
                        $scope.getEstaEEprofile(id, null);
                    }
                }, 1000);
            }
        };
        $scope.stopVideo = function(e) {
            var videos = angular.element('video');
            angular.forEach(videos, function(v) {
                if (!v.paused) v.pause();
            });
        };
        $scope.stopAudio = function() {
            $scope.$broadcast('stop audio');
        };
        $scope.addFilteredSlider = function(feature) {
            //// traceLog("discover-filterslider", "adding [" + feature.properties.title + "] into filter slider");
            var cate_name = (typeof(feature.properties.icon.cate_name) == 'undefined' || feature.properties.icon.cate_name == "") ? "" : $filter('translate')(feature.properties.icon.cate_name);
            var genre_name = (typeof(feature.properties.icon.genreName) == 'undefined' || feature.properties.icon.genreName == "") ? "" : " - " + $filter('translate')(feature.properties.icon.genreName);
            var category_name = "" + $filter('translate')(cate_name) + $filter('translate')(genre_name) + "";
            var class_name = "on_click_pop";
            var id_select = feature.properties.icon.esta_id;
            if (feature.properties.icon.start_date) {
                class_name = "on_click_event_pop";
                id_select = feature.properties.icon.event_id;
            }
            if (feature.properties.establish_locale && locale[0] == feature.properties.establish_locale) {
                $scope.eename = feature.properties.location_i;
                $scope.eeestablish_description = feature.properties.establish_description_i;
            } else {
                $scope.eename = feature.properties.establish_name;
                $scope.eeestablish_description = feature.properties.description;
            }
            $scope.trgenre = $filter('translate')(feature.properties.icon.genreName);
            $scope.event_country_name = $filter('translate')('views.' + feature.properties.icon.event_country_name);
            $scope.country_name = $filter('translate')('views.' + feature.properties.country_name);
            $scope.country_name = $filter('translate')('views.' + feature.properties.country_name);
            var rightSliderData = {
                address: feature.properties.address,
                stream_type: feature.properties.stream_type,
                title: feature.properties.title,
				local_title:feature.properties.local_title,
					local_description:feature.properties.local_description,
		 is_live: feature.properties.is_live,
		 liveUrl: feature.properties.liveUrl,
		 profilePic: feature.properties.profilePic,
                event_type: feature.properties.event_type,
                genre_name: feature.properties.icon.genreName,
                alias_name: feature.properties.alias_name,
                sldtitle: feature.properties.title,
                sldgenre_name: feature.properties.genre_name,
                sldsub_category_name: feature.properties.sub_category_name,
                sldcity_name: feature.properties.city_name,
                sldcountry_name: $scope.country_name,
                sldestablish_name: feature.properties.establishment_name,
                sldalias_name: feature.properties.alias_name,
                incate_name: feature.properties.sub_category_name,
                streampic: feature.properties.streampic,
                 streamCityName: feature.properties.streamCityName,
             streamCountryName: feature.properties.streamCountryName,
             lvlocal_title: feature.properties.icon.local_title,
                ingenre_name: feature.properties.genre_name,
				stream_name: feature.properties.stream_name,
                first_name: feature.properties.icon.first_name,
                event_country_name: feature.properties.icon.event_country_name,
                last_name: feature.properties.icon.last_name,
                event_city: feature.properties.icon.event_city,
                image: feature.properties.images.image,
                category: feature.properties.genre_name,
                cate_name: feature.properties.icon.cate_name,
                establish_name: $scope.eename,
                establishment_name: $scope.eename,
                description: $scope.eeestablish_description,
                id: feature.properties.id,
                class_name: class_name,
                data_attr: id_select,
                city: feature.properties.city,
                country_name: $scope.country_name
            };
            $scope.filtered_temp_slider_data.push(rightSliderData);
        };

        $scope.filterMapGLMarker = function() {
            filterIcons = true;
            $scope.filtered_temp_slider_data = [];
            $scope.right_slider_data = [];
            var filteredEEIDsUpcomingEvents = [];
            var filteredEvents;
            let zoomLevel = $scope.map_map.getZoom();
            let geojsonData = $scope.currentMapGLGeoJson;
           // traceLog("discover-new-filter-mapgl");
            if (geojsonData.length === 0) return;
            var filteredMapGlMarker = [];
            if ($scope.isIndividualStreamMode) {
               // traceLog("discover-filter", "is Individual Stream Mode", $scope.isSelectedEmpty(), geojsonData);
                geojsonData.forEach(marker => {
                    var f = marker;
                    var icon = f.properties.icon;
                    var matchedTillNow = true;
                    if ($scope.isSelectedEmpty()) {
                        matchedTillNow = true;

                    } else if ($scope.selected.genre_id) {
                        matchedTillNow = icon.genre_id && $scope.selected.genre_id == icon.genre_id;

                    } else if ($scope.selected.childcategory_id) {
                        matchedTillNow = icon.childCat && $scope.selected.childcategory_id == icon.childCat;

                    } else if ($scope.selected.subcategory_id) {
                        matchedTillNow = icon.subCat && $scope.selected.subcategory_id == icon.subCat;
                    } else if ($scope.selected.category_id) {
                        matchedTillNow = icon.parentCat && $scope.selected.category_id == icon.parentCat;

                    } else {
                        matchedTillNow = false;
                    }
                    if (matchedTillNow) {
                        $scope.addFilteredSlider(f);
                        //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                        filteredMapGlMarker.push(f);
                    }
                });

            } else if ($scope.selected.genre_id) {
               // traceLog("discover-filter", "1st");
                if ($scope.selected.showUpcomingEvents) {
                    // Show upcoming events is selected, filter events by selected child category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                    //// traceLog("discover-filter-upcomingevents", "childcategory selected: eventsForCategory ", eventsForCategory);
                    if (eventsForCategory) {
                        // filter events by subcategory
                        filteredEvents = eventsForCategory.events.filter(function(event) {
                            if (Array.isArray(event.genre) && event.genre.findIndex(function(g) {
                                    return g.genre_id == $scope.selected.genre_id;
                                }) > -1)
                                return true;
                            else if (event.genre.genre_id == $scope.selected.genre_id)
                                return true;
                            return false;
                        });
                        $scope.filteredUpcomingEventsData = $scope.upcomingEventsData.map(function(cat) {
                            if ($scope.selected.category_id == cat.category_id) {
                                return Object.assign({}, cat, {
                                    events: filteredEvents
                                });
                            }
                            return cat;
                        });
                        //// traceLog("discover-filter-upcomingevents", "filteredUpcomingEventsData ", JSON.parse(JSON.stringify($scope.filteredUpcomingEventsData)));
                        //// traceLog("discover-filter-upcomingevents", "childcategory selected: filtered events", eventsForCategory);
                        if (filteredEvents.length)
                            filteredEEIDsUpcomingEvents = filteredEvents.map(function(e) {
                                return e.estaId;
                            });
                        else
                            filteredEEIDsUpcomingEvents = [];
                    }
                    //// traceLog("discover-filter-upcomingevents", "childcategory selected: filteredEEIDsUpcomingEvents ", filteredEEIDsUpcomingEvents);
                }
                //// traceLog("discover-filter", "selected: genre id is ", $scope.selected.genre_id);
                if ($scope.selected.subcategory_id === 336 || $scope.selected.subcategory_id === 337) {
                    // Genre selected - This is Children's category
                    /*
                    This is the special case of selecting Children's category and then selecting one of the sub-categories Designed for Children/Child Friendly
                    which would then show all the other categories (Adventures/Tours, Nature/Sites etc) to user, selecting any of the category would
                    make category_id go into genre_id above. So here genre_id is actually category_id of top level categories.
                    */
                    /* As establishments do not contain category_id but subcategory ids we need to filter using subcategory id,   for which each genre (actually a category contains subCategries information as well in subCatId) so extract that.
                     */
                    var subcategory_ids = $scope.map_genres.find(function(g) {
                        return g.genre_id == $scope.selected.genre_id;
                    }).subcategory_id;
                    //// traceLog("discover-filter", "sub-categories of selected genre (a category actually) ", subcategory_ids);
                    var cond = ($scope.selected.subcategory_id == 336) ? 'designchild' : 'childfriendly';
                    geojsonData.forEach(marker => {
                        var matchedTillNow = true;
                        var f = marker;
                        var icon = f.properties.icon;
                        if ($scope.selected.subcategory_id == 336 && (icon.designchild || ((Array.isArray(icon.subCat) && icon.subCat.indexOf(336) > -1) || (!Array.isArray(icon.subCat) && icon.subCat == 336)))) {
                            matchedTillNow = true;
                        } else if ($scope.selected.subcategory_id == 337 && (icon.childfriendly || ((Array.isArray(icon.subCat) && icon.subCat.indexOf(337) > -1) || (!Array.isArray(icon.subCat) && icon.subCat == 337)))) {
                            matchedTillNow = true;
                        } else {
                            matchedTillNow = false;
                        }
                        // See if icons subcategories matched selected genre (category) subcategories
                        if (matchedTillNow) {
                            if (!Array.isArray(icon.subCat) && subcategory_ids.indexOf(icon.subCat) > -1) {
                                matchedTillNow = true;
                            } else if (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function(result, subCat) {
                                    if (result || subcategory_ids.indexOf(subCat) > -1) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }, false)) {
                                matchedTillNow = true;
                            } else {
                                matchedTillNow = false;
                            }
                            if (matchedTillNow) {
                                $scope.addFilteredSlider(f);
                                //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                                filteredMapGlMarker.push(f);
                            }
                        }
                    });
                } else {
                    // Genre selected - Other than children's category
                    geojsonData.forEach(marker => {
                        var f = marker;
                        var icon = f.properties.icon;
                        var matchedTillNow = true;
                        if (!$scope.selected.showUpcomingEvents) {
                            if (icon.is_establish == 1) {
                                if (matchedTillNow && $scope.selected.genre_id) {
                                    if ((!Array.isArray(icon.genreId) && icon.genreId == $scope.selected.genre_id) || (Array.isArray(icon.genreId) && icon.genreId.indexOf($scope.selected.genre_id) > -1)) {
                                        matchedTillNow = true;
                                    } else {
                                        //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                        matchedTillNow = false;
                                    }
                                }
                                if (!matchedTillNow) {
                                    // check to see if events genre id matches if yes we can still show this establishment
                                    if (icon.upcomingEventGenreids) {
                                        //// traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventGenreids) MATCHED: [ARGS:icon.upcomingEventGenreids] ", icon.upcomingEventGenreids);
                                        if ((typeof(icon.upcomingEventSubcatids) === 'number' && icon.upcomingEventSubcatids == $scope.selected.subcategory_id) || (typeof(icon.upcomingEventSubcatids) === 'object' && icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1)) {
                                            if ((typeof(icon.upcomingEventGenreids) === 'number' && icon.upcomingEventGenreids == $scope.selected.genre_id) || (typeof(icon.upcomingEventGenreids) === 'object' && icon.upcomingEventGenreids.indexOf($scope.selected.genre_id) > -1)) {
                                                matchedTillNow = true;
                                            } else {
                                                //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                                matchedTillNow = false;
                                            }
                                        } else {
                                            //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                            matchedTillNow = false;
                                        }
                                    }
                                }
                            }
                            if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                                if (icon.upcomingEventGenreids) {
                                    //// traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventGenreids) MATCHED: [ARGS:icon.upcomingEventGenreids] ", icon.upcomingEventGenreids);
                                    if ((typeof(icon.upcomingEventSubcatids) === 'number' && icon.upcomingEventSubcatids == $scope.selected.subcategory_id) || (typeof(icon.upcomingEventSubcatids) === 'object' && icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1)) {
                                        if ((typeof(icon.upcomingEventGenreids) === 'number' && icon.upcomingEventGenreids == $scope.selected.genre_id) || (typeof(icon.upcomingEventGenreids) === 'object' && icon.upcomingEventGenreids.indexOf($scope.selected.genre_id) > -1)) {
                                            matchedTillNow = true;
                                        } else {
                                            //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                            matchedTillNow = false;
                                        }
                                    } else {
                                        //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                        matchedTillNow = false;
                                    }
                                }
                            }
                        } else {
                            // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                            if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                                matchedTillNow = true;
                            } else {
                                matchedTillNow = false;
                            }
                        }
                        if (matchedTillNow) {
                            $scope.addFilteredSlider(f);
                            //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                            filteredMapGlMarker.push(f);
                        }
                    });
                }
            } else if ($scope.selected.childcategory_id) {
               // traceLog("discover-filter", "2nd");
                if ($scope.selected.showUpcomingEvents) {
                    // Show upcoming events is selected, filter events by selected child category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                    //// traceLog("discover-filter-upcomingevents", "childcategory selected: eventsForCategory ", eventsForCategory);
                    if (eventsForCategory) {
                        // filter events by subcategory
                        var filteredEvents = eventsForCategory.events.filter(function(event) {
                            if (Array.isArray(event.childcat) && event.childcat.indexOf($scope.selected.childcategory_id) > -1)
                                return true;
                            else if (event.childcat == $scope.selected.childcategory_id)
                                return true;
                            return false;
                        });
                        //// traceLog("discover-filter-upcomingevents", "childcategory selected: filtered events", eventsForCategory);
                        if (filteredEvents.length)
                            filteredEEIDsUpcomingEvents = filteredEvents.map(function(e) {
                                return e.estaId;
                            });
                        else
                            filteredEEIDsUpcomingEvents = [];
                        $scope.filteredUpcomingEventsData = $scope.upcomingEventsData.map(function(cat) {
                            if ($scope.selected.category_id == cat.category_id) {
                                return Object.assign({}, cat, {
                                    events: filteredEvents
                                });
                            }
                            return cat;
                        });
                    }
                    //// traceLog("discover-filter-upcomingevents", "childcategory selected: filteredEEIDsUpcomingEvents ", filteredEEIDsUpcomingEvents);
                }
                // Child category selected
                geojsonData.forEach(marker => {
                    var f = marker;
                    var matchedTillNow = true;
                    var icon = f.properties.icon;
                    //// traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                    //// traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                    //// traceLog("discover-filter", "" + f.properties.title + ": condition is : ($scope.selected.childcategory_id) ARGS[$scope.selected.childcategory_id] ", $scope.selected.childcategory_id);
                    if (!$scope.selected.showUpcomingEvents) {
                        if (icon.is_establish == 1) {
                            // Child category selected - Icon is an establishment
                            //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 1)");
                            // A child category is unique and associated with only one parent so matching child category means matching parent hierarchy
                            if (matchedTillNow) {
                                // An establishments can have multiple child categories or single as well, only one child category can be selected from menu so perform match accordingly
                                if (icon.childCat) {
                                    //// traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: (icon.childCat) : [ARGS:icon.childCat] ", icon.childCat);
                                    if ((!Array.isArray(icon.childCat) && icon.childCat == $scope.selected.childcategory_id) || (Array.isArray(icon.childCat) && icon.childCat.indexOf($scope.selected.childcategory_id) > -1)) {
                                        //// traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: ((!Array.isArray(icon.childCat) && icon.childCat == $scope.selected.childcategory_id) || (Array.isArray(icon.childCat) && icon.childCat.indexOf($scope.selected.childcategory_id) > -1)) : [ARGS:icon['childCat'], $scope.selected.childcategory_id] ", icon['childCat'], $scope.selected.childcategory_id);
                                        matchedTillNow = true;
                                    } else {
                                        //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!: ((!Array.isArray(icon.childCat) && icon.childCat == $scope.selected.childcategory_id) || (Array.isArray(icon.childCat) && icon.childCat.indexOf($scope.selected.childcategory_id) > -1)) : [ARGS:icon['childCat'], $scope.selected.childcategory_id] ", icon['childCat'], $scope.selected.childcategory_id);
                                        matchedTillNow = false;
                                    }
                                } else {
                                    // As child category is selected and this establishment don't have child categories so not matched
                                    matchedTillNow = false;
                                    //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!: (icon.childCat) : [ARGS:icon.childCat] ", icon.childCat);
                                }
                            }
                            if (!matchedTillNow) {
                                // establishment is not maching selected child category/sub category try to see if upcoming events matches condition
                                if (icon.upcomingEventChildcatids && icon.upcomingEventChildcatids.length > 0) {
                                    if (icon.upcomingEventChildcatids.indexOf($scope.selected.childcategory_id) > -1) {
                                        //// traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) MATCHED: [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                        matchedTillNow = true;
                                    } else {
                                        matchedTillNow = false;
                                        //// traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                    }
                                } else {
                                    matchedTillNow = false;
                                    //// traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            }
                        }
                        if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                            // Child category selected - Icon is an event center
                            //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 2)");
                            if (icon.upcomingEventChildcatids && icon.upcomingEventChildcatids.length > 0) {
                                if (icon.upcomingEventChildcatids.indexOf($scope.selected.childcategory_id) > -1) {
                                    //// traceLog("discover-filter", "" + f.properties.title + ": (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) MATCHED: [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                    matchedTillNow = true;
                                } else {
                                    matchedTillNow = false;
                                    //// traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            } else {
                                matchedTillNow = false;
                                //// traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                            }
                        }
                    } else {
                        // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                        if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                            //// traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** (filteredEEIDsUpcomingEvents): ARGS:[filteredEE, icon.esta_id) ", filteredEEIDsUpcomingEvents, icon.esta_id);
                            matchedTillNow = true;
                        } else {
                            //// traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                            matchedTillNow = false;
                        }
                    }
                    if (matchedTillNow) {
                        $scope.addFilteredSlider(f);
                        //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                        filteredMapGlMarker.push(f);
                    }
                });
            } else if ($scope.selected.subcategory_id) {
               // traceLog("discover-filter", "3rd");
                if ($scope.selected.showUpcomingEvents) {
                    // Show upcoming events is selected, filter events by sub category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                    //// traceLog("discover-filter-upcomingevents", "subcategory selected: eventsForCategory ", eventsForCategory);
                    if (eventsForCategory) {
                        // filter events by subcategory
                        filteredEvents = eventsForCategory.events.filter(function(event) {
                            if (event.subcat && event.subcat.category_id == $scope.selected.subcategory_id)
                                return true;
                            return false;
                        });
                        //// traceLog("discover-filter-upcomingevents", "subcategory selected: filtered events", eventsForCategory);
                        if (filteredEvents.length)
                            filteredEEIDsUpcomingEvents = filteredEvents.map(function(e) {
                                return e.estaId;
                            });
                        else
                            filteredEEIDsUpcomingEvents = [];
                        $scope.filteredUpcomingEventsData = $scope.upcomingEventsData.map(function(cat) {
                            if ($scope.selected.category_id == cat.category_id) {
                                return Object.assign({}, cat, {
                                    events: filteredEvents
                                });
                            }
                            return cat;
                        });
                    }
                    //// traceLog("discover-filter-upcomingevents", "subcategory selected: filteredEEIDsUpcomingEvents ", filteredEEIDsUpcomingEvents);
                }
                // Sub category selected
                geojsonData.forEach(marker => {
                    var f = marker;
                    var matchedTillNow = true;
                    var icon = f.properties.icon;
                    //// traceLog("discover-filter", "" + f.properties.title + ": ------------------- SUBCATEGORY SELECTED -------------  ", $scope.selected);
                    //// traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                    //// traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                    if (!$scope.selected.showUpcomingEvents) {
                        if (icon.is_establish == 1) {
                            // Sub category selected - Icon is an Establishment
                            //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 1)");
                            // this is an establishment, hence it would have cat/subcat so compare it with selected criteria
                            if ($scope.selected.subcategory_id == 336 && icon.designchild) {
                                //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  ($scope.selected.subcategory_id == 336 && icon.designchild) [ARGS:icon.designchild, $scope.selected.subcategory_id]  ", icon.designchild, $scope.selected.subcategory_id);
                                matchedTillNow = true;
                            } else if ($scope.selected.subcategory_id == 337 && icon.childfriendly) {
                                //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  ($scope.selected.subcategory_id == 336 && icon.childfriendly) [ARGS:icon.childfriendly, $scope.selected.subcategory_id]  ", icon.childfriendly, $scope.selected.subcategory_id);
                                matchedTillNow = true;
                            } else if ((!Array.isArray(icon.subCat) && icon.subCat == $scope.selected.subcategory_id) || (Array.isArray(icon.subCat) && icon.subCat.indexOf($scope.selected.subcategory_id) > -1)) {
                                //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  ((!Array.isArray(icon.subCat) && icon.subCat == $scope.selected.subcategory_id) || (Array.isArray(icon.subCat) && icon.subCat.indexOf($scope.selected.subcategory_id) > -1)) [ARGS:icon.subCat, $scope.selected.subcategory_id]  ", icon.subCat, $scope.selected.subcategory_id);
                                matchedTillNow = true;
                            } else if (icon.upcomingEventSubcatids && icon.upcomingEventSubcatids.length > 0) {
                                // establishment subcategory did not match try event sub categories to see if they matched
                                if (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) {
                                    //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]  ", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                    matchedTillNow = true;
                                }
                            } else {
                                //// traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                                matchedTillNow = false;
                            }
                        }
                        if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                            //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 2)");
                            if (icon.upcomingEventSubcatids && icon.upcomingEventSubcatids.length > 0) {
                                // establishment subcategory did not match try event sub categories to see if they matched
                                if (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) {
                                    //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.upcomingEventSubcatids.indexOf($scope.selected.subcategory_id) > -1) [ARGS:icon.upcomingEventSubcatids, $scope.selected.subcategory_id]  ", icon.upcomingEventSubcatids, $scope.selected.subcategory_id);
                                    matchedTillNow = true;
                                } else {
                                    matchedTillNow = false;
                                    //// traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            } else {
                                matchedTillNow = false;
                                //// traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                            }
                        }
                    } else {
                        // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                        if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                            //// traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** (filteredEEIDsUpcomingEvents): ARGS:[filteredEE, icon.esta_id) ", filteredEEIDsUpcomingEvents, icon.esta_id);
                            matchedTillNow = true;
                        } else {
                            //// traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                            matchedTillNow = false;
                        }
                    }
                    if (matchedTillNow) {
                        $scope.addFilteredSlider(f);
                        //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                        filteredMapGlMarker.push(f);
                    }
                });
            } else if (Array.isArray($scope.selected.subcategory_ids)) {
               // traceLog("discover-filter", "4th");
                // Category Selected
                if ($scope.selected.showUpcomingEvents) {
                   // traceLog("discover-filter-inner", "first");
                    // Show upcoming events is selected, filter events by category and extract their establishment id so that they can be used to filter establishments
                    var eventsForCategory = $scope.upcomingEventsData.find(function(e) {
                        return $scope.selected.category_id == e.category_id;
                    });
                    //// traceLog("discover-filter-upcomingevents", "filtered upcoming events are ", eventsForCategory);
                    if (eventsForCategory) {
                        // iterate on events to fetch all event ids
                        if (eventsForCategory.events.length)
                            filteredEEIDsUpcomingEvents = eventsForCategory.events.map(function(e) {
                                return e.estaId;
                            });
                    }
                    //// traceLog("discover-filter-upcomingevents", "filtered establishment ids for upcoming events ", filteredEEIDsUpcomingEvents);
                }
                if ($scope.selected.subcategory_ids.indexOf(336) > -1 && $scope.selected.subcategory_ids.indexOf(337) > -1) {
                   // traceLog("discover-filter-inner", "second");
                    geojsonData.forEach(marker => {
                        var f = marker;
                        var matchedTillNow = true;
                        var icon = f.properties.icon;
                        //// traceLog("discover-filter", "" + f.properties.title + "--------------- CHILDREN CATEGORY SELECTED -----------------------");
                        //// traceLog("discover-filter", "" + f.properties.title + ": SELECTED ", $scope.selected);
                        //// traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId + " child friendly:" + icon.childfriendly + " designchild:" + icon.designchild);
                        /*
                        if (icon.childfriendly == true || icon.designchild == true) {
                       // traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: (icon.childfriendly === true || icon.designchild === true) : [ARGS:icon.childfriendly, icon.designchild]", icon.childfriendly, icon.designchild);
                        matchedTillNow = true;
                        } else {
                       // traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!: (icon.childfriendly === true || icon.designchild === true) : [ARGS:icon.childfriendly, icon.designchild]", icon.childfriendly, icon.designchild);
                        matchedTillNow = false;
                        }
                        */
                        if (matchedTillNow) {
                            $scope.addFilteredSlider(f);
                            //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                            filteredMapGlMarker.push(f);
                        }
                    });
                } else {
                   // traceLog("discover-filter-inner", "third");
                    // Category Selected - Other than Children's
                    geojsonData.forEach(marker => {
                        var f = marker;
                        var matchedTillNow = true;
                        var icon = f.properties.icon;
                        //// traceLog("discover-filter", "" + f.properties.title + "--------------- CATEGORY SELECTED -----------------------");
                        //// traceLog("discover-filter", "" + f.properties.title + ": Criteria [$scope.selected] ", $scope.selected);
                        //// traceLog("discover-filter", "" + f.properties.title + ": parent-cat:" + icon.parentCat + " sub-cat:" + icon.subCat + " child-cat:" + icon.childCat + " genre:" + icon.genreId);
                        if (!$scope.selected.showUpcomingEvents) {
                            //// traceLog("discover-filter-inner", "fourth");
                            if (icon.is_establish == 1) {
                                // Category Selected - Other than children's -> Icon is an Establishment
                                // As establishment only has sub-category's and not category, sub categories of category would be used to match
                                //// traceLog("discover-filter", "" + f.properties.title + ": ***MATCHED***  (icon.is_establish == 1)");
                                if (icon.subCat) {
                                    if (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function(result, subCat) {
                                            if (result || $scope.selected.subcategory_ids.indexOf(subCat) > -1) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }, false)) {
                                        //// traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: (Array.isArray(icon.subCat) && icon.subCat.length > 0 && icon.subCat.reduce(function (result, subCat) == true) : [ARGS:$scope.selected.subcategory_ids, icon.subCat]", $scope.selected.subcategory_ids, icon.subCat);
                                        matchedTillNow = true;
                                    } else if ($scope.selected.subcategory_ids.indexOf(icon.subCat) > -1) {
                                        //// traceLog("discover-filter", "" + f.properties.title + " ***MATCHED***: ($scope.selected.subcategory_ids.indexOf(icon.subCat) > -1) : [ARGS:$scope.selected.subcategory_ids, icon.subCat]", $scope.selected.subcategory_ids, icon.subCat);
                                        matchedTillNow = true;
                                    } else {
                                        matchedTillNow = false;
                                        //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                    }
                                } else {
                                    //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                    matchedTillNow = false;
                                }
                            }
                            if ((icon.is_establish == 1 && !matchedTillNow) || icon.is_establish == 2) {
                                if (icon.upcomingEventSubcatids && icon.upcomingEventSubcatids.length > 0) {
                                    if (icon.upcomingEventSubcatids.reduce(function(result, subCat) {
                                            if (result || $scope.selected.subcategory_ids.indexOf(subCat) > -1) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }, false)) {
                                        matchedTillNow = true;
                                    } else {
                                        matchedTillNow = false;
                                        //// traceLog("discover-filter", "" + f.properties.title + " !!!NOTMATCHED!!!");
                                    }
                                } else {
                                    matchedTillNow = false;
                                    //// traceLog("discover-filter", "" + f.properties.title + ": ***NOTMATCHED***");
                                }
                            }
                        } else {
                            //// traceLog("discover-filter-inner", "fifth");
                            // show upcoming events is true show establishment if it is part of filtered  Establishment/event center IDs upcoming events
                            if (filteredEEIDsUpcomingEvents.indexOf(icon.esta_id) > -1) {
                                //// traceLog("discover-filter", "" + f.properties.title + " ***MATCHED*** (filteredEEIDsUpcomingEvents): ARGS:[filteredEE, icon.esta_id) ", filteredEEIDsUpcomingEvents, icon.esta_id);
                                matchedTillNow = true;
                            } else {
                                //// traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!!");
                                matchedTillNow = false;
                            }
                        }
                        //// traceLog("discover-filter-inner, matched :", matchedTillNow);
                        if (matchedTillNow) {
                            //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                            $scope.addFilteredSlider(f);
                            filteredMapGlMarker.push(f);
                        }
                    });
                }
            } else {
               // traceLog("discover-filter", "last");
                // All Categories Selected
                geojsonData.forEach(marker => {
                    var f = marker;
                    var matchedTillNow = true;
                    var icon = f.properties.icon;
                    if ($scope.selected.showUpcomingEvents) {
                        matchedTillNow = false;
                    } else {
                        //// traceLog("discover-filter", "" + f.properties.title + ": !!!NOTMATCHED!!! $scope.selected.showUpcomingEvents is false");
                        matchedTillNow = true;
                    }
                    if (matchedTillNow) {
                        //// traceLog("discover-filter", "" + f.properties.title + " ### WOULD BE VISIBLE ON MAP ###");
                        $scope.addFilteredSlider(f);
                        filteredMapGlMarker.push(f);
                    }
                });
            }
           // traceLog("discover-filtered-markers-gl", filteredMapGlMarker);
            if (!$scope.isMapGLIconMarkerLoaded) {

                //// traceLog("discover-filtered-markers-gl", "loading markers based on filter");
                $scope.loadMapGLIconMarker(filteredMapGlMarker);
            }
            $scope.loadMoreSlider();
        };
        $scope.isIndividualStreamMode = false;
        $scope.isEstablishmentStreamMode = false;
$scope.loadIndividualEntities = function() {
    $scope.isIndividualStreamMode = !$scope.isIndividualStreamMode;
    $scope.isEstablishmentStreamMode = false;

    if (canceller) {
        canceller.resolve();
    }

    if ($scope.isIndividualStreamMode) {

        var url = '/api/liveIndividual';
        canceller = $q.defer();

        $http.get(url, {
            timeout: canceller.promise
        })
        .then(function(res) {

            $scope.currentMapGLGeoJson = res.data.features;
            $scope.loadMapGLIconMarker(res.data.features);

        })
        .catch(function(err) {
            // THIS is the important fix
            // ignore aborted requests (-1 is Angular "cancelled request")
            if (err && err.status === -1) return;

            console.error('liveIndividual error:', err);
        });

    } else {
        $scope.refreshMarkers({
            forceFetch: true
        });
    }
};
$scope.loadEstablishmentEntities = function() {
    $scope.isEstablishmentStreamMode = !$scope.isEstablishmentStreamMode;
    $scope.isIndividualStreamMode = false;

    if (canceller) {
        canceller.resolve();
    }

    if ($scope.isEstablishmentStreamMode) {

        var url = '/api/liveEstablishmentsAndEvents';
        canceller = $q.defer();

        $http.get(url, {
            timeout: canceller.promise
        })
        .then(function(res) {

            $scope.currentMapGLGeoJson = res.data.features;
            $scope.loadMapGLIconMarker(res.data.features);

        })
        .catch(function(err) {
            // ignore cancelled requests
            if (err && err.status === -1) return;

            console.error('liveEstablishments error:', err);
        });

    } else {
        $scope.refreshMarkers({
            forceFetch: true
        });
    }
};












        if (isMobile) {
            $(document.body).on('click', '.event_catergory_slider.active .toggle_slider', function() {
                $('body#body').css('overflow-y', 'scroll');
            });
        };
        if (isMobile) {
            $(document.body).on('click', 'span.event_catergory_slider:not(.active) .toggle_slider', function() {
                $('body,html').animate({
                    scrollTop: 0
                }, 'fast');
                $('body#body').css('overflow-y', 'hidden');
            });
        }

        $scope.loadEstablishmentEntities = function() {
            $scope.isEstablishmentStreamMode = !$scope.isEstablishmentStreamMode;
            $scope.isIndividualStreamMode = false;
            if (canceller) {

                canceller.resolve();
            }
            if ($scope.isEstablishmentStreamMode) {
                var url = '/api/liveEstablishmentsAndEvents'; //?neLat=' + northEast.lat + '&swLat=' + southWest.lat + '&neLng=' + northEast.lng + '&swLng=' + southWest.lng + '&minZoom=' + zoom;
                canceller = $q.defer();
                $http.get(url, {
                    timeout: canceller.promise
                }).then(function(res) {
                   // traceLog('stream-mode', "liveEstablishments");
                    $scope.currentMapGLGeoJson = res.data.features;
                    $scope.loadMapGLIconMarker(res.data.features);
                });

            } else {
                $scope.refreshMarkers({
                    forceFetch: true
                });
            }
        }
   
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
        $scope.liveStreamUrl;
        $scope.liveUrl;
        $scope.liveStreamData;
        $scope.lastStreamRawUrl;
        // ==========================================
        // 1. THE MAIN FUNCTION (Original Logic + Shared Link Bypass)
        // ==========================================
 
        $scope.openLiveStreamPopup = function(stream_type, id, liveData) {
            // Unified player: use the SAME AngularJS ng-repeat card as the bottom showcase.
            // A clicked marker need not already be in the limited showcase dataset.
            var source = liveData || {};
            var existing = ($scope.streams || []).find(function(item) {
                return String(item.id) === String(id);
            });
            var stream = angular.extend({}, existing || {}, source, {
                id: id,
                stream_type: stream_type == null ? source.stream_type : stream_type,
                liveUrl: source.is_live === false ? null : (source.liveUrl || source.live_url || source.playbackUrl),
                local_title: source.local_title || source.stream_name || source.establish_name || source.name || '',
                event_city_name: source.event_city_name || source.streamCityName || source.city_name || source.cityId || '',
                event_country_name: source.event_country_name || source.streamCountryName || source.country_name || source.countryId || '',
                category: source.category || source.genre_name || source.sub_category_name || source.incate_name || ''
            });

            // Profiles always open; only playable streams require a playback URL.
            if (!stream.liveUrl) {
                stream.is_live = false;
                stream._igPublicChannel = true;
                console.info('Opening channel profile without playback URL:', id);
            }
            if (document.getElementById('card_' + id) &&
                document.getElementById('card_' + id).classList.contains('expand')) return;

            // Close another expanded card before switching streams.
            if (document.querySelector('.stream-showcase > .stream-card.expand, body > .stream-card.expand')) {
                $scope.closeCard();
            }
            $scope.stream = stream;
            $scope.liveStreamData = stream;
            $scope.messages = [];
            // Give marker/slider streams a share URL, just like showcase streams.
            $scope.url_to_link = $scope.igStreamShareUrl(stream);


            if (existing) {
                angular.extend(existing, stream);
                $scope.stream = existing;
                $scope.liveStreamData = existing;
                $scope.expandStream(id);
                return;
            }

            // Push into the existing ng-repeat so Angular compiles every chat/profile binding.
            // This temporary card is moved into body as soon as it is rendered.
            $scope.streams = $scope.streams || [];
            stream._igTemporaryCard = true;
            $scope.streams.push(stream);
            $timeout(function() {
                var card = document.getElementById('card_' + id);
                if (!card) {
                    console.error('Angular did not render temporary stream card:', id);
                    return;
                }
                // Initialize ONLY the new card, without resetting existing HLS players.
                window.buildStreamCards([stream], true);
                $scope.expandStream(id);
            }, 0);
        };

        /* Old marker-player implementation retained below for rollback only.
           It is no longer called by globe markers or right-slider clicks. */
        $scope._legacyOpenLiveStreamPopup = function(stream_type, id, liveData) {  
		applyvideoPlayerOrientation(markerVideo);
		$scope.messages = []; 
		$scope.stream = liveData || {};
        $scope.stream.id = id; 
        socket.emit('joinStream', $scope.stream.id);
		const card = document.getElementById('stream_Card');
		const sky = document.getElementById('sky'); 
		const video = document.getElementById('markerVideo');
		applyvideoPlayerOrientation(markerVideo);
        const VidControls = document.querySelector('#stream_Card #VidControls'); 
 			angular.element("#pst3").removeClass('active');
			  const body = document.querySelector("body#body");  
    body.classList.add("expand");  
	card.classList.add('expand');
	if (sky) {
    sky.classList.add('expand');
}
 
	VidControls.classList.add('expand');
            if ($scope.currentStreamId === id) {
                    return;
                }
                $scope.currentStreamId = id;
 
            if (liveData && liveData.liveUrl) { 
                var url = liveData.liveUrl;
  console.log("Using Shared URL after:", url); 
                $scope.liveStreamData = liveData;
				
				

 if (!$scope.liveStreamData.establishmentDetails) {




                    $scope.liveStreamData = liveData;

                    if (!$scope.liveStreamData.establishmentDetails) {
                        $scope.liveStreamData.establishmentDetails = {
                            name: liveData.establish_name || liveData.stream_name || "Unknown",

                            genre: liveData.genre_name || liveData.ingenre_name || "",

                            streampic: liveData.streampic || "",

                            category: liveData.sub_category_name || liveData.incate_name || "",

                            city: liveData.streamCityName || liveData.city_name || "",

                            country: liveData.streamCountryName || liveData.countries || ""
                        };
                    }
                }
     applyvideoPlayerOrientation(markerVideo);
 $scope.liveStreamUrl = $sce.trustAsResourceUrl(url); // This renders the URL
 
                startThePlayer(url);
                return;
            }
            // --- SHARED LINK BYPASS END ---
            var cleanName = name.replace(/\s+/g, '-');
            var url = liveData.liveUrl;
          

if (!url) {
    console.error("No liveUrl found in liveData:", liveData);
 
    return;
}




            function startThePlayer(url) {
                // --- SHARE URL GENERATION START ---
                var ivsId = "";
                if (url.includes("playback.live-video.net")) {
                    ivsId = url.split('//')[1].split('.')[0];
                }
                var lat = (liveData && liveData.latitude) ? liveData.latitude : (liveData && liveData.lat ? liveData.lat : 0);
                var lng = (liveData && liveData.longitude) ? liveData.longitude : (liveData && liveData.lng ? liveData.lng : 0);
                
                // ==========================================
                // GRABBING ACTUAL NAMES & STREAMPIC
                // ==========================================
                var sName = encodeURIComponent(liveData.alias || liveData.stream_name || name || liveData.streamname || "iconoglobe ICON");
                var sTitle = "";
				var stream_type = encodeURIComponent(liveData.stream_type);
                if (liveData.local_title) {
                    sTitle = encodeURIComponent(liveData.local_title);
                } else if (liveData.icon && liveData.icon.local_title) {
                    sTitle = encodeURIComponent(liveData.icon.local_title);
                }
                var sPic = "";
                if (liveData.streampic) {
                    sPic = liveData.streampic;
                } else if (liveData.images && liveData.images.image) {
                    sPic = liveData.images.image.split('/').pop();
                }

                var rawData = "sType=" + stream_type + "&id=" + id + "&lat=" + lat + "&lng=" + lng + "&v=1" +
                    "&name=" + sName + "&title=" + sTitle + "&pic=" + sPic +
                    "&liveUrl=" + encodeURIComponent(url);
                var encodedData = btoa(rawData);
                var baseUrl = window.location.origin + window.location.pathname;

                $scope.url_to_link = baseUrl + "?data=" + encodedData;
                $("#ip").val($scope.url_to_link);

             applyvideoPlayerOrientation(markerVideo);
                var video = document.getElementById('markerVideo');
                 

                if (video) {
                    video.onpause = null;
                    video.onplay = null;
                }
                  
                
                if (window.Hls && window.Hls.isSupported()) {
                    if ($scope.hls) {
                        $scope.hls.destroy();
                    }
                    $scope.hls = new window.Hls({
                        enableWorker: true,
                        lowLatencyMode: false,
                        liveSyncDuration: 10,
                        maxBufferLength:30,
                        capLevelToPlayerSize: false,
                        autoStartLoad: true,  
						maxBufferSize: 60 * 1000 * 1000,   
						maxBufferHole: 5,
						fragLoadingTimeOut: 5000, // Timeout before retrying a fragment
					    fragLoadingMaxRetry: 5,  // Retry loading up to 5 times
				        fragLoadingRetryDelay: 2000 // Delay retry by 2 seconds						
                    });
                    $scope.hls.loadSource(getHlsUrl(url));
                    $scope.hls.attachMedia(video);
					

 
        if (VidControls) { 
            const playBtn = VidControls.querySelector('.cc-play');
			playBtn.style.border = "5px solid red"
            const timeDisplay = VidControls.querySelector('.cc-time');
            const muteBtn = VidControls.querySelector('.cc-mute');
            const fullBtn = VidControls.querySelector('.cc-full');

            /* FIXED: optional chaining removed */
            if (playBtn) { 
                playBtn.addEventListener('click', (e) => {
                    e.stopPropagation();

                    if (video.paused) {
                        video.play().catch(() => {});
                        playBtn.textContent = '⏸';
                    } else {
                        video.pause();
                        playBtn.textContent = '▶';
                    }
                });
            }
var video = document.getElementById('markerVideo'); 
            video.addEventListener('timeupdate', () => {
                const t = Math.floor(video.currentTime);
                const m = Math.floor(t / 60);
                const s = t % 60;
                timeDisplay.textContent = `${m}:${s < 10 ? '0' + s : s}`;
            });
 
            /* FIXED */
            if (fullBtn) {
                fullBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (video.requestFullscreen) video.requestFullscreen();
                });
            }

            /* FIXED */
            if (muteBtn) {
                muteBtn.addEventListener('click', (e) => {
                    e.stopPropagation();

                    video.muted = !video.muted;

                    muteBtn.innerHTML = video.muted
                        ? `<svg viewBox="0 0 24 24" fill="white">
                            <polygon points="3,9 7,9 12,5 12,19 7,15 3,15"></polygon>
                            <line x1="14" y1="9" x2="20" y2="15" stroke="white"></line>
                            <line x1="20" y1="9" x2="14" y2="15" stroke="white"></line>
                           </svg>`
                        : `<svg viewBox="0 0 24 24" fill="white">
                            <polygon points="3,9 7,9 12,5 12,19 7,15 3,15"></polygon>
                           </svg>`;
                });
            }
        }















                    video.onpause = function() {
                        // console.log("⏸️ Paused → stopping HLS download");
                        if ($scope.hls) $scope.hls.stopLoad();
                    };
                    video.onplay = function() {
                        // console.log("▶️ Play → resuming HLS download");
                        if ($scope.hls) $scope.hls.startLoad();
                    };

		    
// Listening for errors on the video element itself
video.onerror = function() {
  const error = video.error;
  console.error("Video Error Code:", error.code);
  // call showStreamEndedOverlay method
  showStreamEndedOverlay();
};

                    $scope.hls.on(window.Hls.Events.MANIFEST_PARSED, function() {   const levels = $scope.hls.levels;
                        let index720 = -1;
                        for (let i = 0; i < levels.length; i++) {
                            if (levels[i].height <= 720) index720 = i;
                        }
                        if (index720 !== -1) {
                            $scope.hls.currentLevel = index720;
                            $scope.hls.loadLevel = index720;
                        }
                        if (video._updateOrientation) {
                         video._updateOrientation();
                            }
                       safePlay(video);
                    });

                    $scope.hls.on(window.Hls.Events.ERROR, function(event, data) {
                        // console.log("HLS ERROR:", data);
                        if (data.fatal) {
                            switch (data.type) {
                              case window.Hls.ErrorTypes.NETWORK_ERROR:
                                    // console.log("🌐 Network error → recovering...");
                                   setTimeout(() => {
                    $scope.hls.startLoad();
                }, 1000);  // Retry after 1 second
                                break;
                                case window.Hls.ErrorTypes.MEDIA_ERROR:
                                    // console.log("📺 Media error");
                                    $scope.hls.recoverMediaError();
                                    break;
                                default:
                                    // console.log("💀 Fatal error → destroying + overlay");
                                     setTimeout(() => {
                    // console.log("🔄 Attempting to reload stream...");
                    reloadStream();
                }, 2000);  // Retry after 2 seconds
               
				                  showStreamEndedOverlay();
                                    $scope.hls.destroy();
                                    break;
                            }
                     
                    }
					});

// ==========================================
// AUTOMATIC FROZEN STREAM RECOVERY
// ==========================================

let lastTime = video.currentTime;
let freezeCount = 0;
let freezeCheckInterval = null;
let recoveringFrozenStream = false;

function startFreezeDetection() {

    if (freezeCheckInterval) {
        clearInterval(freezeCheckInterval);
    }

    lastTime = video.currentTime;
    freezeCount = 0;

    freezeCheckInterval = setInterval(function() {

        if (!video || video.paused || video.ended) {
            freezeCount = 0;
            lastTime = video ? video.currentTime : 0;
            return;
        }

        const currentTime = video.currentTime;

        // Stream is not advancing
        if (Math.abs(currentTime - lastTime) < 0.01) {

            freezeCount++;

            console.log(
                "Freeze check:",
                freezeCount,
                "time:",
                currentTime
            );

            // 3 checks × 5 seconds = about 15 seconds frozen
            if (freezeCount >= 3 && !recoveringFrozenStream) {

                console.warn(
                    "IconoGlobe: frozen stream detected - rebuilding player"
                );

                recoveringFrozenStream = true;
                freezeCount = 0;

                reloadStream();

                setTimeout(function() {
                    recoveringFrozenStream = false;
                    lastTime = video.currentTime;
                }, 5000);
            }

        } else {

            freezeCount = 0;
            lastTime = currentTime;
        }

    }, 5000);
}


// Start one detector only
startFreezeDetection();


video.onpause = function() {

    // Do not stop downloading a live broadcast just because
    // the browser temporarily pauses/stalls playback.
    if (
        $scope.hls &&
        !($scope.liveStreamData && $scope.liveStreamData.is_live)
    ) {
        $scope.hls.stopLoad();
    }
};


video.onplay = function() {

    if ($scope.hls) {
        $scope.hls.startLoad();
    }

    freezeCount = 0;
    lastTime = video.currentTime;
};       
              
              
              
                } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                    video.src = url;
                    video.onpause = function() { 
                        video.removeAttribute("src");
                        video.load();
                    };
                    safePlay(video);
                }
let retryCount = 0;
const maxRetries = 5;

function reloadStream() {

    const video = document.getElementById('videoPlayer');
    const url = $scope.lastStreamRawUrl;

    if (!video || !url) {
        console.error("Unable to reload stream - missing video or URL");
        return;
    }

    console.warn("IconoGlobe: rebuilding HLS player");

    try {

        // Completely destroy the frozen HLS session
        if ($scope.hls) {
            try {
                $scope.hls.stopLoad();
            } catch (e) {}

            try {
                $scope.hls.detachMedia();
            } catch (e) {}

            try {
                $scope.hls.destroy();
            } catch (e) {}

            $scope.hls = null;
        }


        // Clear the video decoder/buffer
        video.pause();
        video.removeAttribute('src');
        video.load();


        // Create a completely fresh HLS session
        $scope.hls = new window.Hls({
            enableWorker: true,
            lowLatencyMode: false,

            liveSyncDuration: 10,
            maxBufferLength: 30,

            capLevelToPlayerSize: true,
            autoStartLoad: true,

            maxBufferHole: 5
        });


        $scope.hls.attachMedia(video);


        $scope.hls.on(
            window.Hls.Events.MEDIA_ATTACHED,
            function() {

                console.log(
                    "IconoGlobe: fresh player attached"
                );

                $scope.hls.loadSource(
                    getHlsUrl(url)
                );
            }
        );


        $scope.hls.on(
            window.Hls.Events.MANIFEST_PARSED,
            function() {

                const levels = $scope.hls.levels;
                let index720 = -1;

                for (let i = 0; i < levels.length; i++) {
                    if (levels[i].height <= 720) {
                        index720 = i;
                    }
                }

                if (index720 !== -1) {
                    $scope.hls.currentLevel = index720;
                    $scope.hls.loadLevel = index720;
                }

                safePlay(video);

                console.log(
                    "IconoGlobe: stream recovered"
                );
            }
        );


        $scope.hls.on(
            window.Hls.Events.ERROR,
            function(event, data) {

                if (!data.fatal) return;

                if (
                    data.type ===
                    window.Hls.ErrorTypes.NETWORK_ERROR
                ) {

                    console.warn(
                        "Recovery player network error"
                    );

                    $scope.hls.startLoad();

                } else if (
                    data.type ===
                    window.Hls.ErrorTypes.MEDIA_ERROR
                ) {

                    console.warn(
                        "Recovery player media error"
                    );

                    $scope.hls.recoverMediaError();

                } else {

                    console.error(
                        "Recovery player fatal error:",
                        data
                    );
                }
            }
        );

    } catch (err) {

        console.error(
            "IconoGlobe stream recovery failed:",
            err
        );
    }
}
 
                $scope.liveStreamData = liveData;
                $scope.lastStreamRawUrl = url;
                $scope.liveStreamUrl = $sce.trustAsResourceUrl(url);

                if (liveData &&    (
                        liveData.stream_type == 1 ||
                        liveData.stream_type == 0 ||
                        liveData.stream_type == 2
                                 )
                    )
                        {
                    angular.element('#indnfd').removeClass('hide');
                }
            }

applyvideoPlayerOrientation(markerVideo);
 
        };
 


$scope.debugStreamClick = function(slider_data) {
    if (!slider_data) return;

    console.log('RIGHT SLIDER CLICK:', slider_data);

    $scope.openEntityFromMapOrSlider(slider_data, null);
};
        // ==========================================
        // 3. THE MASTER RECEIVER (Cleaned & Approved)
        // ==========================================
        (function processSharedDataFromURL() {
            var urlParams = new URLSearchParams(window.location.search);
            var sharedData = urlParams.get('data');
            if (sharedData) {
                setTimeout(function() {
                    try {
                        var decoded = atob(sharedData);
                        var params = new URLSearchParams(decoded);
					 
 
                        // 1. EXTRACT DATA (New metadata fields included)
                        var id = params.get('id');
                        var lat = parseFloat(params.get('lat')) || 0;
                        var lng = parseFloat(params.get('lng')) || 0;
                        var liveUrl = decodeURIComponent(params.get('liveUrl'));
 
                        // New meta fields
                        var sName = decodeURIComponent(params.get('name') || "");
                        var sTitle = decodeURIComponent(params.get('title') || "");
                        var sPic = params.get('pic') || "";
						var sType = decodeURIComponent(params.get('sType') || "");
 
                        if (id && liveUrl) {
                            // console.log("Found Shared Data for:", sName);

                            // 2. INJECT METADATA (For Social Media & Browser Tab)
                            if (sName) {
                                document.title = sName + " is Live!";
                                $('meta[property="og:title"], meta[name="title"]').attr('content', sName + " - " + sTitle);
                            }
                            if (sPic) {
                                var fullPicPath = sPic;
                                $('meta[property="og:image"], meta[name="image"], meta[property="og:image:secure_url"]').attr('content', fullPicPath);
                            }
                            if (sTitle) {
                                $('meta[property="og:description"], meta[name="description"]').attr('content', sTitle);
                            }

                            // 3. ORIGINAL LOGIC (100% Preserved)
                            $scope.sliderData = {
                                type: "1",
                                event_id: id,
                                esta_id: id,
                                main_event_id: id,
                                is_brand: false
                            };

                            var sharedLiveData = {
                                id: id,
								sType: sType,
                                latitude: lat,
                                longitude: lng,
                                stream_type: sType,
                                liveUrl: liveUrl,
                                alias: sName,
                                local_title: sTitle,
                                streampic: sPic // Pass meta to popup
                            };




                            if (typeof $scope.flyTo === "function") {
                                $scope.flyTo(lat, lng);
                            }

                            // Load Profile for full DB details
                            $scope.loadProfileDirect(id, sType);

                            if (typeof $scope.getBanners === "function") {
                                $scope.getBanners(id);
                            }




                            // Open the Player
                            $scope.openLiveStreamPopup('Shared-Stream', id, sharedLiveData);

                            if (!$scope.$$phase) {
                                $scope.$apply();
                            }

                            // 4. SIGNAL PRERENDER (The "Snapshot" trigger)
                            window.prerenderReady = true;
                        }
                    } catch (e) {
                        console.error("Shared link deciphering failed:", e);
                        window.prerenderReady = true; // Still trigger so Prerender doesn't hang
                    }
                }, 2500);
            }
        })();


        function showStreamEndedOverlay() {
            // console.log("🚨 Stream ended → showing overlay");

            var overlay = document.getElementById('streamEndedOverlay');
            if (overlay) {
                overlay.style.display = 'grid';

            }

            var video = document.getElementById('markerVideo');
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        } 
   
       $scope.loadProfileDirect = function(id, sType) {
		   // console.log("12741getsharedprofile",sType);
            // We send the videoUrl so the server returns it in the data object
            $http.get('/api/getshprofile/' + id + '/' + sType)
                .then(function(res) {
                    var data = res.data;
					// console.log("12745sharedprreturn",data);
                    if (data && !data.error) {

                        // 1. DATA PREP
                        var streamTitle = data.alias + " is Live!";
                        var streamDesc = data.local_title || "Streaming the World's ICONs!";
                        var streamPic = data.streampic;

                        // 2. UI UPDATE (For the User)
                        $scope.liveStreamData = {
                            stream_name: data.stream_name || data.streamname,
                            liveUrl: data.liveUrl,
                            streampic: data.streampic,
							  local_title: data.local_title,
                                local_description: data.local_description,
                                streamCityName: data.streamCityName,
                                streamCountryName: data.streamCountryName,
                            icon: {
                                local_title: data.local_title,
                                local_description: data.local_description,
                                streamCityName: data.streamCityName,
                                streamCountryName: data.streamCountryName
                            }
                        };

                        // 3. METADATA UPDATE (For Social Media/Prerender)
                        // We update the standard tags and the Open Graph tags
                        document.title = streamTitle;

                        // Title Tags
                        $('meta[name="title"], meta[property="og:title"]').attr('content', streamTitle);

                        // Description Tags
                        $('meta[name="description"], meta[property="og:description"]').attr('content', streamDesc);

                        // Image Tags (Critically important for the thumbnail)
                        $('meta[name="image"], meta[property="og:image"], meta[property="og:image:secure_url"]').attr('content', streamPic);

                        // 4. DISPLAY THE PLAYER
                        angular.element('#playerContainer').show();

                        // 5. NOTIFY PRERENDER
                        // This tells the crawler "The Pic, Title, and Name are ready. Take the snapshot!"
                        window.prerenderReady = true;

                        // console.log("Profile, Meta, and Stream Loaded for: " + data.alias);
                    }
                });
        }; 
// Channel identity is independent of the current broadcast.
function igChannelSlug(name) {
    return String(name || 'channel').normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '').toLowerCase()
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'channel';
}
function igChannelUrl(data) {
    data = data || {};
    var id = data.channelId || data.channel_id ||
        (data.channel && (data.channel.channelId || data.channel.channel_id));
    var name = data.channelName || data.channel_name ||
        (data.channel && data.channel.channelName) ||
        data.alias || data.establish_name || data.stream_name || data.name;
    if (id && /^[a-f0-9]{6}$/i.test(String(id))) {
        return window.location.origin + '/channel/' + igChannelSlug(name) + '-' + String(id).toLowerCase();
    }
    var supplied = data.channel_url || data.channelUrl;
    if (supplied) {
        try {
            var parsed = new URL(supplied, window.location.origin);
            if (parsed.origin === window.location.origin &&
                /^\/channel\/[a-z0-9_.-]+-[a-f0-9]{6}\/?$/i.test(parsed.pathname)) {
                return parsed.origin + parsed.pathname;
            }
        } catch (e) {}
    }
    // A channel page itself has a validated ID in its path.
    var match = /^\/channel\/[a-z0-9_.-]+-([a-f0-9]{6})\/?$/i.exec(window.location.pathname);
    if (match && (!data || !Object.keys(data).length)) return window.location.origin + window.location.pathname;
    return '';
}
$scope.igStreamShareUrl = function(stream) {
    return igChannelUrl(stream);
};
$scope.shareChannel = function(data, event) {
    if (event) { event.preventDefault(); event.stopPropagation(); }
    var active = data || $scope.stream || $scope.liveStreamData || $scope.publicChannel;
    var url = igChannelUrl(active);
    if (!url && $scope.publicChannel && active === $scope.publicChannel) url = $scope.channelPermanentUrl;
    if (!url) {
        window.alert('This broadcaster does not have a permanent channel link yet.');
        return;
    }
    $scope.url_to_link = url;
    if (navigator.share) {
        return navigator.share({title: (active && (active.channelName || active.channel_name || active.name || active.alias)) || 'iconoGlobe', url: url})
            .catch(function(err) { if (err && err.name !== 'AbortError') console.warn('Channel share failed:', err); });
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(url).then(function() {
            $scope.$applyAsync(function() { $scope.igupShareNotice = 'Channel link copied'; });
        }).catch(function() { window.prompt('Copy channel link:', url); });
    }
    window.prompt('Copy channel link:', url);
};
$scope.copyIp = function(stream) { return $scope.shareChannel(stream); };
$scope.copyChannelLink = function() { return $scope.shareChannel($scope.publicChannel || {}); };

// Countdown for a scheduled permanent channel (UTC timestamp from OrientDB).
var igChannelCountdownInterval = null;
$scope.igChannelCountdown = '';
function igUpdateChannelCountdown() {
    var channel = $scope.publicChannel;
    if (!channel || !channel.scheduled || !channel.scheduledStart) return;
    var target = Date.parse(channel.scheduledStart);
    if (!Number.isFinite(target)) return;
    var seconds = Math.max(0, Math.ceil((target - Date.now()) / 1000));
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var secs = seconds % 60;
    function pad(n) { return String(n).padStart(2, '0'); }
    $scope.igChannelCountdown = (days ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(secs);
    $scope.igChannelTimeReached = seconds === 0;
}
$scope.$on('$destroy', function() { if (igChannelCountdownInterval) $window.clearInterval(igChannelCountdownInterval); });
// Permanent broadcaster channels: /channel/name_abcdef (legacy hyphen slugs still resolve).
(function initializePermanentChannel() {
    var slug = $stateParams.slug;
    if ($state.current.name !== 'maps.channel' || !slug) return;
    var match = /(?:^|-)([a-f0-9]{6})$/i.exec(slug);
    if (!match) { $scope.channelError = 'Invalid channel address.'; return; }
    var channelId = match[1].toLowerCase();
    $scope.channelLoading = true;
    $http.get('/api/channel/' + channelId).then(function(response) {
        var channel = response.data && response.data.channel;
        if (!response.data || !response.data.success || !channel) {
            $scope.channelError = 'Channel not found.'; return;
        }
        $scope.publicChannel = channel;
        if (channel.scheduled === true || channel.scheduled === 'true' || channel.scheduled === 1) {
            channel.scheduled = true;
            igUpdateChannelCountdown();
            igChannelCountdownInterval = $window.setInterval(function() { $scope.$applyAsync(igUpdateChannelCountdown); }, 1000);
        }
        $scope.channelId = channelId;
        var channelName = channel.channelName || channel.channel_name || channel.alias || channel.name || 'channel';
        $scope.channelPermanentUrl = window.location.origin + '/channel/' + igChannelSlug(channelName) + '-' + channelId;
        $scope.channelOffline = false;
        var channelIsLive = channel.is_live === true && !!channel.liveUrl;
        var type = channel.stream_type == null ? 1 : Number(channel.stream_type);
        var broadcasterId = type === 0
            ? (channel.esta_id || channel.establishment_id || channel.id)
            : (channel.user_id || channel.userId || channel.id);
        var liveData = angular.extend({}, channel, {
            id: broadcasterId,
            channelId: channelId,
            channelName: channelName,
            stream_type: type,
            stream_name: channel.alias || channelName,
            liveUrl: channel.liveUrl,
            is_live: channelIsLive,
            _igPublicChannel: true,
            scheduled: channel.scheduled === true || channel.scheduled === 'true' || channel.scheduled === 1,
            scheduledStart: channel.scheduledStart,
            sliderImage: channel.persicon || channel.streampic || channel.profilePic || channel.esta_main_photo || channel.profile_pic || '',
            sliderImageClass: channel.persicon ? 'ig-slider-personal-icon' : 'ig-slider-stream-photo'
        });
        var attempts = 0;
        function openWhenReady() {
            if ($scope.$$destroyed) return;
            if (document.querySelector('.stream-showcase') &&
                typeof $scope.openLiveStreamPopup === 'function') {
                try {
                    // Permanent establishment URLs use the same complete EE-profile
                    // path as map markers, including offline and scheduled channels.
                    if (type === 0 && broadcasterId && typeof $scope.getEstaEEprofile === 'function') {
                        $scope.getEstaEEprofile(broadcasterId, null, false,
                            undefined, undefined, undefined, undefined, true, liveData);
                    } else {
                        $scope.openLiveStreamPopup(type, broadcasterId, liveData);
                    }
                    $scope.url_to_link = $scope.channelPermanentUrl;
                    angular.element('#ip').val($scope.channelPermanentUrl);
                } catch (err) {
                    console.error('Permanent channel player failed:', err);
                    $scope.channelError = 'Unable to open this live stream.';
                }
            } else if (++attempts < 40) {
                $timeout(openWhenReady, 250);
            } else {
                $scope.channelError = 'The stream player did not load.';
            }
        }
        $timeout(openWhenReady, 0);
    }, function(error) {
        $scope.channelError = error.status === 404 ? 'Channel not found.' : 'Unable to load this channel.';
    }).finally(function() { $scope.channelLoading = false; });
})();

$scope.closeLiveStreamPopup = function() {
// The unified showcase player is closed by closeCard(). Never pause a random video.
if (!document.querySelector('#stream_Card.expand')) {
    if (document.querySelector('.stream-card.expand')) $scope.closeCard();
    return;
}
var video = document.getElementById('markerVideo');
    console.log("Closing stream popup...");
 if (video) {
        video.pause();          // stop playback
        video.muted = true;     // force mute

    }
	if (window.hls) {
    window.hls.destroy();
    window.hls = null;
}
 
const sky = document.getElementById('sky');

if (sky) {
    sky.classList.remove('expand');
}

 const bodyElement = document.querySelector('body#body');
	if (bodyElement) { 
    bodyElement.classList.remove("expand"); 
}

        

    if ($scope.streamId) {
        socket.emit('leaveStream', $scope.streamId);
        $scope.streamId = null;
    }
	if (sky) {
    sky.style.display = 'block';
} 
     const card = document.querySelector(".stream-card.expand");
	 const cards = document.querySelector(".stream_Card.expand");

if (card) {   card.classList.remove("expand"); 
}
if (cards) {   cards.classList.remove("expand"); 
}
};



























window.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
/*window.toggleExpand = function(element) {
    const cards = document.querySelectorAll('.stream-card');
    const video = element.querySelector('video');
    const index = Array.from(cards).indexOf(element);
    const body = document.querySelector("body#body");
    body.classList.remove("expand");
    if (element.classList.contains('expand')) {
							  
        // --- CLOSING ---
																															  
        element.classList.remove('expand');
		 
     document.querySelector("body#body").classList.remove("expand");
 					   
        video.muted = true;
        video.controls = false;
							  

        const stopBtn = element.querySelector('.stream-stop-btn');
        if (stopBtn) {
            stopBtn.style.display = 'none';
                 
        }
							

        // ✅ ADDED (hide custom controls)
        const customControls = element.querySelector('.stream-custom-controls');
        if (customControls) {
            customControls.style.display = 'none';
        }

        if (window.hlsInstances && window.hlsInstances[index]) {
            window.hlsInstances[index].pauseBuffering();
																				 
													   
											
															
			  
        }
 

        video.pause();
    } else {
        // --- OPENING ---
        document.querySelectorAll('.stream-card.expand').forEach((el) => {
            el.classList.remove('expand');
            const v = el.querySelector('video');
            v.muted = true;
            v.controls = false;
            v.pause();

            const stopBtn = el.querySelector('.stream-stop-btn');
            if (stopBtn) {
                stopBtn.style.display = 'none'; 
            }
		  
																			 
 
 
												 
										  
										  
															
											   
																										  
					 
 
 
 
 
									  
																				   

            // ✅ ADDED (hide custom controls)
																												   
																 
            const cc = el.querySelector('.stream-custom-controls');
            if (cc) {
                cc.style.display = 'none';
									 
            }
        });
	 

								  
													 

						
																	  
									  

											
					   
						   
				  

															 
													

															   
										  
	   

        element.classList.add('expand'); 
      
    document.querySelector("body#body").classList.add("expand");
 
			  video.muted = false;																													 
															

        // 🔁 MODIFIED (mobile only)
        if (window.isMobile) {
            video.controls = false;
        } else {
            video.controls = false;
        }

        const stopBtn = element.querySelector('.stream-stop-btn');
        if (stopBtn) {
            stopBtn.style.display = 'block'; 
        }
 
         
      if (window.hlsInstances && window.hlsInstances[index] && !element.dataset.stopped) {
    const hls = window.hlsInstances[index];

    hls.startLoad(-1);
}

        setTimeout(() => {
   safePlay(video).catch(() => {});
}, 0);
											
											  

																 

											  
										  
		   

											   
										 
    }
};
*/





document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {

        const expanded = document.querySelector('.stream-card.expand');
        if (!expanded) return; // nothing to do

        // remove chat if it exists
        const chat = expanded.querySelector('.cht270');
        if (chat) chat.remove();

        // collapse the stream
        window.toggleExpand(expanded);
    }
});

 


function applyOrientation(video) {
  function update() {
    if (!video.videoWidth || !video.videoHeight) return;

    const streamCard = angular.element(video).closest(".stream-card");

    if (video.videoHeight > video.videoWidth) {
      video.classList.add("portrait");
      video.classList.remove("landscape");

      streamCard.addClass("portrait");
      streamCard.removeClass("landscape");

    } else {
      video.classList.add("landscape");
      video.classList.remove("portrait");

      streamCard.addClass("landscape");
      streamCard.removeClass("portrait");
    }
  }

  video.addEventListener("loadedmetadata", update);
  video.addEventListener("playing", update);

  // expose update so HLS can call it later
  video._updateOrientation = update;
}

$scope.$watch('streams', function(newVal) {
    if (newVal && newVal.length > 0) {
        // $timeout(..., 0) waits for the current digest cycle to finish
        // rendering the HTML via ng-repeat
        $timeout(function() {
            window.buildStreamCards(newVal);
        }, 0);
    }
});


 
function applyvideoPlayerOrientation(markerVideo) {

    function update() {

        if (!markerVideo.videoWidth || !markerVideo.videoHeight) {
            return;
        }

        const playerContainer = document.getElementById('stream_Card');

        if (markerVideo.videoHeight > markerVideo.videoWidth) {

            markerVideo.classList.add("portrait");
            markerVideo.classList.remove("landscape");

            playerContainer.classList.add("portrait");
            playerContainer.classList.remove("landscape");

        } else {

            markerVideo.classList.add("landscape");
            markerVideo.classList.remove("portrait");

            playerContainer.classList.add("landscape");
            playerContainer.classList.remove("portrait");
        }
    }

    update();

    markerVideo.removeEventListener('loadedmetadata', update);
    markerVideo.addEventListener('loadedmetadata', update);
}













/*

$scope.cardClick = function($event, id) { 
    if ($event.currentTarget.classList.contains('expand')) {
        return;
    }
 var pst3 = document.getElementById('pst3');
    if (pst3) {
        pst3.classList.remove('active');
    }
    $scope.expandStream(id);
};

$scope.expandStream = function(id) { 
socket.emit('joinStream', id); 
  var element = document.getElementById('card_' + id); 
if (element && element.classList.contains('expand')) {
    return;
}

    window.currentStreamId = id;

    // Remove expand from all cards
    document.querySelectorAll('.stream-card.expand').forEach(function(card) {
        card.classList.remove('expand');
    });
	  const bodyElement = document.querySelector("body#body"); 
 
	if (bodyElement) { 
    bodyElement.classList.remove("expand");
 
}


    if (!element) {
        console.error('Card not found:', id);
        return;
    }

    // Expand selected card
    element.classList.add('expand');

    // Expand body
    document.body.classList.add('expand');
	const sky = document.querySelector('#sky');

if (sky) {
    sky.style.display = 'none';
}

    // Get video inside card
    var video = element.querySelector('video');

    if (video && !publicChannelCard) {
        video.muted = false;
        video.controls = false;

        setTimeout(function() {
            safePlay(video).catch(function() {});
        }, 0);
    }

    // Show stop button
    var stopBtn = element.querySelector('.stream-stop-btn');

    if (stopBtn) {
        stopBtn.style.display = 'block';
    }

    // ===========================
    // CHAT SCOPE ASSIGNMENT
    // ===========================

    var chatScope = null;
    var activeChats = document.querySelectorAll('#chatDiv');

    for (var i = 0; i < activeChats.length; i++) {

        var rect = activeChats[i].getBoundingClientRect();

        if (rect.height > 0 && rect.width > 0) {
            chatScope = angular.element(activeChats[i]).scope();
            break;
        }
    }

    if (chatScope) {

        chatScope.streamId = id;

        chatScope.$applyAsync();

        console.log("Scope assignment triggered. New streamId:", chatScope.streamId);
        console.log("Chat Scope streamId:", chatScope.streamId);
        console.log("Chat Scope User:", chatScope.user);
    }

    // ===========================
    // CARD SCOPE ASSIGNMENT
    // ===========================

    var el = angular.element(element);

    var scope =
        (el.isolateScope && el.isolateScope()) ||
        (el.scope && el.scope());

    if (scope && scope.$applyAsync) {

        scope.$applyAsync(function() {

            scope.streamId = id;
            scope.messages = scope.messages || [];

        });
    }

  
};
*/



$scope.cardClick = function ($event, id) {
    $event.preventDefault();
    $event.stopPropagation();

    var card = document.getElementById('card_' + id);

    if (!card || card.classList.contains('expand')) {
        return;
    }

    var pst3 = document.getElementById('pst3');

    if (pst3) {
        pst3.classList.remove('active');
    }

    $scope.expandStream(id);
};
$scope.expandStream = function (id) {
    var element = document.getElementById('card_' + id);

    if (!element || element.classList.contains('expand')) {
        return;
    }

    function selectedChatRoomId(cardId) {
        var item = ($scope.streams || []).find(function(s) { return String(s.id) === String(cardId); });
        return item && item.stream_id ? item.stream_id : cardId;
    }
    var publicChannelCard = ($scope.streams || []).some(function(s) { return String(s.id) === String(id) && (!s.liveUrl || ((s._igPublicChannel || s._igScheduledDiscovery) && !s.is_live)); });
    // Scheduled/offline public channels have a persistent chat room too.
    // Keep live-stream rooms unchanged.
    var chatRoomId = selectedChatRoomId(id);
    if (chatRoomId) socket.emit('joinStream', chatRoomId);

    // Covers bottom slider, right slider, and Mapbox markers via expandStream().
    var selectedStream = ($scope.streams || []).find(function(item) {
        return String(item.id) === String(id);
    });
    if (selectedStream) $scope.igupLoadGallery(selectedStream);

    window.currentStreamId = id;

    // Save its original position inside .stream-showcase.
    element._originalParent = element.parentNode;
    element._originalNextSibling = element.nextSibling;

    // Move it OUT of #scene1 and .stream-showcase.
    document.body.appendChild(element);

    // Now expand it as a body-level overlay.
    element.classList.add('expand');
    document.body.classList.add('expand');

    var sky = document.getElementById('sky');

    if (sky) {
        sky.style.display = 'none';
    }

    var video = element.querySelector('video');

    if (video && !publicChannelCard && selectedStream && selectedStream.liveUrl) {
        video.muted = false;
        video.controls = false;

        setTimeout(function () {
            safePlay(video).catch(function () {});
        }, 0);
    }
};
















window.buildStreamCards = function(streams, appendOnly) {
        if (igMapDisposed) return;
        if (!appendOnly) window.streams = streams;
        if (!appendOnly || !window.hlsInstances) window.hlsInstances = []; 
		const container = document.querySelector('.stream-showcase');
        streams.forEach((stream, localIndex) => {
            // Keep HLS indices aligned with $scope.streams, including temporary cards.
            const i = ($scope.streams || []).findIndex(s => String(s.id) === String(stream.id));
            if (i < 0) return;
			const card = document.getElementById(`card_${stream.id}`);
			const video = document.getElementById(`video_${stream.id}`);
			const vidWrapper = document.getElementById(`vidwrp_${stream.id}`);
			const customControls = document.getElementById(`customControls_${stream.id}`); 
			const stopBtn = document.getElementById(`stopBtn_${stream.id}`);
     
        if (!card || !video || card.dataset.igPlayerInitialized === '1') return;
        card.dataset.igPlayerInitialized = '1';
        video.addEventListener('fullscreenchange', () => {
            if (vidWrapper) vidWrapper.classList.toggle('is-fullscreen', !!document.fullscreenElement);
        });

        applyOrientation(video);
 
        if (customControls) {

            const playBtn = customControls.querySelector('.cc-play');
            const timeDisplay = customControls.querySelector('.cc-time');
            const muteBtn = customControls.querySelector('.cc-mute');
            const fullBtn = customControls.querySelector('.cc-full');

            /* FIXED: optional chaining removed */
            if (playBtn) {
                playBtn.addEventListener('click', (e) => {
                    e.stopPropagation();

                    if (video.paused) {
                        video.play().catch(() => {});
                        playBtn.textContent = '⏸';
                    } else {
                        video.pause();
                        playBtn.textContent = '▶';
                    }
                });
            }

            video.addEventListener('timeupdate', () => {
                const t = Math.floor(video.currentTime);
                const m = Math.floor(t / 60);
                const s = t % 60;
                timeDisplay.textContent = `${m}:${s < 10 ? '0' + s : s}`;
            });

            /* FIXED */
            if (fullBtn) {
                fullBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    if (video.requestFullscreen) video.requestFullscreen();
                });
            }

            /* FIXED */
            if (muteBtn) {
                muteBtn.addEventListener('click', (e) => {
                    e.stopPropagation();

                    video.muted = !video.muted;

                    muteBtn.innerHTML = video.muted
                        ? `<svg viewBox="0 0 24 24" fill="white">
                            <polygon points="3,9 7,9 12,5 12,19 7,15 3,15"></polygon>
                            <line x1="14" y1="9" x2="20" y2="15" stroke="white"></line>
                            <line x1="20" y1="9" x2="14" y2="15" stroke="white"></line>
                           </svg>`
                        : `<svg viewBox="0 0 24 24" fill="white">
                            <polygon points="3,9 7,9 12,5 12,19 7,15 3,15"></polygon>
                           </svg>`;
                });
            }
        }

        /* =========================
           STOP BUTTON (RESTORED)
        ========================= */
        if (stopBtn) {
            stopBtn.addEventListener('click', function(e) {
                e.stopPropagation();

                const body = document.querySelector("body#body");
                if (body) body.classList.remove("expand");

                video.pause();
                video.muted = true;

                const hls = window.hlsInstances[i];
                if (hls) {
                    hls.pauseBuffering();
                }

                card.dataset.stopped = "1";
                card.classList.remove('expand');

                stopBtn.style.display = 'none';
            });
        }

        /* =========================
           HLS SETUP (RESTORED EVENTS)
        ========================= */
/* =========================
   HLS SETUP + FREEZE RECOVERY
========================= */
if (Hls.isSupported() && stream.liveUrl) {

    let freezeTimer = null;
    let freezeCount = 0;
    let lastPlaybackTime = 0;
    let rebuilding = false;

    function createCardHls() {
        if (igMapDisposed) return;

        // Destroy any old instance for this card
        if (window.hlsInstances[i]) {
            try {
                window.hlsInstances[i].stopLoad();
            } catch (e) {}

            try {
                window.hlsInstances[i].detachMedia();
            } catch (e) {}

            try {
                window.hlsInstances[i].destroy();
            } catch (e) {}
        }

        const hls = new Hls();

        window.hlsInstances[i] = hls;

        hls.attachMedia(video);

        hls.on(Hls.Events.MEDIA_ATTACHED, function() {
            if (igMapDisposed) return;
            hls.loadSource(getHlsUrl(stream.liveUrl));
        });

        hls.on(Hls.Events.MANIFEST_PARSED, function() {

            if (card.classList.contains('expand')) {
                safePlay(video).catch(() => {});
            }

            console.log(
                'IconoGlobe card player ready:',
                stream.id
            );
        });

        hls.on(Hls.Events.FRAG_BUFFERED, function() {

            if (
                (!window.$scope ||
                 !window.$scope.liveStreamData ||
                 !window.$scope.liveStreamData.is_live) &&
                !card.classList.contains('expand')
            ) {
                if (hls.pauseBuffering) {
                    hls.pauseBuffering();
                }
            }
        });

        hls.on(Hls.Events.ERROR, function(event, data) {
            if (igMapDisposed) return;
            if (!data.fatal) return;

            if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {

                console.warn(
                    'IconoGlobe card network error:',
                    stream.id
                );

                hls.startLoad();

            } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {

                console.warn(
                    'IconoGlobe card media error:',
                    stream.id
                );

                hls.recoverMediaError();

            } else {

                console.warn(
                    'IconoGlobe card fatal error - rebuilding:',
                    stream.id
                );

                rebuildCardPlayer();
            }
        });
    }


    function rebuildCardPlayer() {
        if (igMapDisposed) return;
        if (rebuilding) return;

        rebuilding = true;

        console.warn(
            'IconoGlobe: frozen card detected - rebuilding player:',
            stream.id
        );

        try {
            video.pause();
            video.removeAttribute('src');
            video.load();
        } catch (e) {}

        createCardHls();

        setTimeout(function() {
            if (igMapDisposed) return;
            rebuilding = false;
            freezeCount = 0;
            lastPlaybackTime = video.currentTime;

            if (card.classList.contains('expand')) {
                safePlay(video).catch(() => {});
            }

        }, 3000);
    }


    createCardHls();


    // Check only the expanded/live viewing card
    freezeTimer = setInterval(function() {
        if (igMapDisposed) return;
        if (!card.classList.contains('expand')) {
            freezeCount = 0;
            lastPlaybackTime = video.currentTime;
            return;
        }

        if (video.paused || video.ended) {
            freezeCount = 0;
            lastPlaybackTime = video.currentTime;
            return;
        }

        const current = video.currentTime;

        if (Math.abs(current - lastPlaybackTime) < 0.01) {

            freezeCount++;

            console.log(
                'IconoGlobe freeze check:',
                stream.id,
                freezeCount,
                current
            );

            // 3 checks x 5 seconds = approximately 15 seconds
            if (freezeCount >= 3) {
                rebuildCardPlayer();
            }

        } else {

            freezeCount = 0;
            lastPlaybackTime = current;
        }

    }, 5000);
    igCardCleanup.push(function() { clearInterval(freezeTimer); });
}

        /* =========================
           HOVER PLAY / PAUSE (RESTORED)
        ========================= */
        card.addEventListener('mouseenter', () => {
            if (card.classList.contains('expand')) return;

            const hls = window.hlsInstances[i];
            if (hls) {
                hls.resumeBuffering();
                safePlay(video).catch(() => {});
            }
        });

        card.addEventListener('mouseleave', () => {
            if (card.classList.contains('expand')) return;

            const hls = window.hlsInstances[i];
            if (hls) {
                video.pause();
                hls.pauseBuffering();
            }
        });

        // Cleanup is registered once on the real MapCtrl scope above.
    });

    const spacer = document.createElement('div');
    spacer.className = 'scroll-spacer';
 
if (container && !appendOnly && !container.querySelector('.scroll-spacer')) {
    container.appendChild(spacer);
}
};
















// Discovery v2: live streams plus schedules in the -10/+5 minute map window.
// Keep the existing card objects where possible so expanded cards are not destroyed.
var igDiscoveryTimer = null;
var igDiscoveryInFlight = false;
$scope.igScheduleCountdown = function(stream) {
    if (!stream || !stream.scheduledStart) return '';
    var target = Date.parse(stream.scheduledStart);
    if (!Number.isFinite(target)) return '';
    var seconds = Math.max(0, Math.ceil((target - ($scope.igScheduleNow || Date.now())) / 1000));
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var secs = seconds % 60;
    function pad(n) { return String(n).padStart(2, '0'); }
    return (days ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(secs);
};
$scope.igScheduleHasStarted = function(stream) {
    return !!(stream && stream.scheduledStart && Date.parse(stream.scheduledStart) <= ($scope.igScheduleNow || Date.now()));
};
// Hanging promotions use the existing livestream schedule clock.
// goLiveTime is optional and does not affect promotion eligibility.
$scope.igPromoHasUpcomingLive = function(promo) {
    if (!promo || !promo.goLiveTime) return false;
    var target = Date.parse(promo.goLiveTime);
    return Number.isFinite(target) && target > ($scope.igScheduleNow || Date.now());
};
$scope.igPromoLiveCountdown = function(promo) {
    return $scope.igScheduleCountdown({ scheduledStart: promo.goLiveTime });
};
$scope.igScheduleNow = Date.now();
var igScheduleTick = $window.setInterval(function() {
    if (igMapDisposed) return;
    $scope.$applyAsync(function() { $scope.igScheduleNow = Date.now(); });
}, 1000);
function igDiscoveryRefresh() {
    if (igMapDisposed || igDiscoveryInFlight) return;
    igDiscoveryInFlight = true;
    fetch('/api/getLiveStreams2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({})
    }).then(function(res) {
        if (!res.ok) throw new Error('Discovery HTTP ' + res.status);
        return res.json();
    }).then(function(rows) {
        if (!Array.isArray(rows) || igMapDisposed) return;
        $scope.$applyAsync(function() {
            var previous = $scope.streams || [];
            var byId = Object.create(null);
            previous.forEach(function(s) { byId[String(s.id)] = s; });
            var seen = Object.create(null);
            var next = [];
            rows.forEach(function(incoming) {
                if (!incoming || incoming.id == null) return;
                var key = String(incoming.id);
                if (seen[key]) return;
                seen[key] = true;
                var stream = byId[key] || {};
                var wasScheduled = !!stream._igScheduledDiscovery;
                var nowLive = incoming.is_live === true || incoming.is_live === 1 || incoming.is_live === 'true';
                angular.extend(stream, incoming);
                stream.is_live = nowLive;
                stream._igScheduledDiscovery = !nowLive && !!incoming.scheduled;
                stream._igPublicChannel = stream._igScheduledDiscovery || !!(stream._igPublicChannel && !wasScheduled);
                var hasPersonalIcon = typeof stream.persicon === 'string' && stream.persicon.trim() !== '';
                stream.sliderImage = hasPersonalIcon ? stream.persicon : stream.streampic;
                stream.sliderImageClass = hasPersonalIcon ? 'ig-slider-personal-icon' : 'ig-slider-stream-photo';
                // A scheduled card becoming live needs a real video element, so recreate it.
                if (wasScheduled && nowLive) {
                    var oldCard = document.getElementById('card_' + key);
                    if (oldCard && oldCard.classList.contains('expand')) {
                        // Avoid destroying an open card mid-render; reload the new player on next refresh.
                        stream._igPublicChannel = true;
                    } else if (oldCard) {
                        oldCard.remove();
                    }
                }
                next.push(stream);
            });
            previous.forEach(function(s) {
                var key = String(s.id);
                var card = document.getElementById('card_' + key);
                if (!seen[key] && (s._igTemporaryCard || (card && card.classList.contains('expand')))) next.push(s);
            });
            $scope.streams = next;
        });
    }).catch(function(err) {
        console.error('getLiveStreams2 discovery error:', err);
    }).finally(function() { igDiscoveryInFlight = false; });
}
igDiscoveryRefresh();
igDiscoveryTimer = $window.setInterval(igDiscoveryRefresh, 5 * 60 * 1000);
$scope.$on('$destroy', function() {
    if (igDiscoveryTimer) $window.clearInterval(igDiscoveryTimer);
    if (igScheduleTick) $window.clearInterval(igScheduleTick);
});


function safePlay(video) {
    if (!video) return Promise.resolve();

    const playPromise = video.play().catch(() => {});;

    if (!playPromise) return Promise.resolve();

    return playPromise.catch(err => {
        console.warn("Video play blocked:", err);
    });
}
$scope.liveStreamButtonClicked = function(data, isEvent) {
            // console.log("5084liveStreamButtonClicked", data);
            // console.log("5084liisEvent", isEvent);
            var streamData = {
                id: isEvent ? data.event_id : data.id,
                description: isEvent ? data.complete_desc : data.establish_description,
                streampic: data.streampic,
                establish_name: isEvent ? data.event_name : data.name,
                stream_name: data.stream_name,
                city_name: data.cityId,
                stream_type: data.stream_type,
                event_type: isEvent ? data.event_type : data.name,
                icon: {
                    country_name: data.countryId
                },
            }
            $scope.openLiveStreamPopup(data.stream_type, data.id, data);
        }
        
 
$scope.exitChannelOverlay = function ($event) {

    if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
    }

    // Close the channel popup
    $scope.channelOffline = false;
    $scope.channelError = null;
    $scope.channelLoading = false;
    $scope.publicChannel = null;

    // Keep zoom and coordinates, but remove the channel URL
    var mapParams = window.location.search;

    window.history.replaceState(
        window.history.state,
        '',
        '/' + mapParams
    );
};

        
        $rootScope.showFooter = true;
    }]);
angular.module('iconoglobe').directive('orientationclass', function() {
    // console.log("<<<<<<<<<<<<<<<<<<<<< - orientationclass loaded - >>>>>>>>>>>>>>>>>>>>>>")
    return {
        link: function(scope, element) {
            element.bind("load", function(e) {
                if (element.context.naturalWidth > element.context.naturalHeight) {
                    element.addClass('landscape');
                    // console.log('applied landscape class')
                } else if (element.context.naturalWidth < element.context.naturalHeight) {
                    element.addClass('portrait');
                    // console.log('applied portrait class')
                }
            });
        }
    }
});
